
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire570d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire570d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iq6Qi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9L4Kl"));

});
parcelRegister("9L4Kl", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $71ac2f62ed87cba2$export$ffb0004e005737fa, (v) => $71ac2f62ed87cba2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $71ac2f62ed87cba2$export$34b9dba7ce09269b, (v) => $71ac2f62ed87cba2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $71ac2f62ed87cba2$export$25062201e9e25d76, (v) => $71ac2f62ed87cba2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $71ac2f62ed87cba2$export$ffb0004e005737fa;
var $71ac2f62ed87cba2$export$34b9dba7ce09269b;
var $71ac2f62ed87cba2$export$25062201e9e25d76;
"use strict";

var $50vd1 = parcelRequire("50vd1");
var $71ac2f62ed87cba2$var$k = Symbol.for("react.element"), $71ac2f62ed87cba2$var$l = Symbol.for("react.fragment"), $71ac2f62ed87cba2$var$m = Object.prototype.hasOwnProperty, $71ac2f62ed87cba2$var$n = $50vd1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $71ac2f62ed87cba2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $71ac2f62ed87cba2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$71ac2f62ed87cba2$var$m.call(a, b) && !$71ac2f62ed87cba2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $71ac2f62ed87cba2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $71ac2f62ed87cba2$var$n.current
    };
}
$71ac2f62ed87cba2$export$ffb0004e005737fa = $71ac2f62ed87cba2$var$l;
$71ac2f62ed87cba2$export$34b9dba7ce09269b = $71ac2f62ed87cba2$var$q;
$71ac2f62ed87cba2$export$25062201e9e25d76 = $71ac2f62ed87cba2$var$q;

});
parcelRegister("50vd1", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jkILI"));

});
parcelRegister("jkILI", function(module, exports) {

$parcel$export(module.exports, "Children", () => $e1329cb314076905$export$dca3b0875bd9a954, (v) => $e1329cb314076905$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e1329cb314076905$export$16fa2f45be04daa8, (v) => $e1329cb314076905$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e1329cb314076905$export$ffb0004e005737fa, (v) => $e1329cb314076905$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e1329cb314076905$export$e2c29f18771995cb, (v) => $e1329cb314076905$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e1329cb314076905$export$221d75b3f55bb0bd, (v) => $e1329cb314076905$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e1329cb314076905$export$5f8d39834fd61797, (v) => $e1329cb314076905$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e1329cb314076905$export$74bf444e3cd11ea5, (v) => $e1329cb314076905$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e1329cb314076905$export$ae55be85d98224ed, (v) => $e1329cb314076905$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $e1329cb314076905$export$e530037191fcd5d7, (v) => $e1329cb314076905$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e1329cb314076905$export$fd42f52fd3ae1109, (v) => $e1329cb314076905$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e1329cb314076905$export$c8a8987d4410bf2d, (v) => $e1329cb314076905$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e1329cb314076905$export$d38cd72104c1f0e9, (v) => $e1329cb314076905$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e1329cb314076905$export$7d1e3a5e95ceca43, (v) => $e1329cb314076905$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e1329cb314076905$export$257a8862b851cb5b, (v) => $e1329cb314076905$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e1329cb314076905$export$a8257692ac88316c, (v) => $e1329cb314076905$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e1329cb314076905$export$488013bae63b21da, (v) => $e1329cb314076905$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e1329cb314076905$export$7c73462e0d25e514, (v) => $e1329cb314076905$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e1329cb314076905$export$7568632d0d33d16d, (v) => $e1329cb314076905$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $e1329cb314076905$export$88948ce120ea2619, (v) => $e1329cb314076905$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $e1329cb314076905$export$35808ee640e87ca7, (v) => $e1329cb314076905$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e1329cb314076905$export$fae74005e78b1a27, (v) => $e1329cb314076905$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e1329cb314076905$export$dc8fbce3eb94dc1e, (v) => $e1329cb314076905$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e1329cb314076905$export$6a7bc4e911dc01cf, (v) => $e1329cb314076905$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e1329cb314076905$export$6d9c69b0de29b591, (v) => $e1329cb314076905$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $e1329cb314076905$export$f680877a34711e37, (v) => $e1329cb314076905$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e1329cb314076905$export$d5a552a76deda3c2, (v) => $e1329cb314076905$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e1329cb314076905$export$aaabe4eda9ed9969, (v) => $e1329cb314076905$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e1329cb314076905$export$e5c5a5f917a5871c, (v) => $e1329cb314076905$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e1329cb314076905$export$1538c33de8887b59, (v) => $e1329cb314076905$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e1329cb314076905$export$13e3392192263954, (v) => $e1329cb314076905$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e1329cb314076905$export$b8f5890fc79d6aca, (v) => $e1329cb314076905$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e1329cb314076905$export$60241385465d0a34, (v) => $e1329cb314076905$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e1329cb314076905$export$306c0aa65ff9ec16, (v) => $e1329cb314076905$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e1329cb314076905$export$7b286972b8d8ccbf, (v) => $e1329cb314076905$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e1329cb314076905$export$83d89fbfd8236492, (v) => $e1329cb314076905$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e1329cb314076905$export$dca3b0875bd9a954;
var $e1329cb314076905$export$16fa2f45be04daa8;
var $e1329cb314076905$export$ffb0004e005737fa;
var $e1329cb314076905$export$e2c29f18771995cb;
var $e1329cb314076905$export$221d75b3f55bb0bd;
var $e1329cb314076905$export$5f8d39834fd61797;
var $e1329cb314076905$export$74bf444e3cd11ea5;
var $e1329cb314076905$export$ae55be85d98224ed;
var $e1329cb314076905$export$e530037191fcd5d7;
var $e1329cb314076905$export$fd42f52fd3ae1109;
var $e1329cb314076905$export$c8a8987d4410bf2d;
var $e1329cb314076905$export$d38cd72104c1f0e9;
var $e1329cb314076905$export$7d1e3a5e95ceca43;
var $e1329cb314076905$export$257a8862b851cb5b;
var $e1329cb314076905$export$a8257692ac88316c;
var $e1329cb314076905$export$488013bae63b21da;
var $e1329cb314076905$export$7c73462e0d25e514;
var $e1329cb314076905$export$7568632d0d33d16d;
var $e1329cb314076905$export$88948ce120ea2619;
var $e1329cb314076905$export$35808ee640e87ca7;
var $e1329cb314076905$export$fae74005e78b1a27;
var $e1329cb314076905$export$dc8fbce3eb94dc1e;
var $e1329cb314076905$export$6a7bc4e911dc01cf;
var $e1329cb314076905$export$6d9c69b0de29b591;
var $e1329cb314076905$export$f680877a34711e37;
var $e1329cb314076905$export$d5a552a76deda3c2;
var $e1329cb314076905$export$aaabe4eda9ed9969;
var $e1329cb314076905$export$e5c5a5f917a5871c;
var $e1329cb314076905$export$1538c33de8887b59;
var $e1329cb314076905$export$13e3392192263954;
var $e1329cb314076905$export$b8f5890fc79d6aca;
var $e1329cb314076905$export$60241385465d0a34;
var $e1329cb314076905$export$306c0aa65ff9ec16;
var $e1329cb314076905$export$7b286972b8d8ccbf;
var $e1329cb314076905$export$83d89fbfd8236492;
"use strict";
var $e1329cb314076905$var$l = Symbol.for("react.element"), $e1329cb314076905$var$n = Symbol.for("react.portal"), $e1329cb314076905$var$p = Symbol.for("react.fragment"), $e1329cb314076905$var$q = Symbol.for("react.strict_mode"), $e1329cb314076905$var$r = Symbol.for("react.profiler"), $e1329cb314076905$var$t = Symbol.for("react.provider"), $e1329cb314076905$var$u = Symbol.for("react.context"), $e1329cb314076905$var$v = Symbol.for("react.forward_ref"), $e1329cb314076905$var$w = Symbol.for("react.suspense"), $e1329cb314076905$var$x = Symbol.for("react.memo"), $e1329cb314076905$var$y = Symbol.for("react.lazy"), $e1329cb314076905$var$z = Symbol.iterator;
function $e1329cb314076905$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e1329cb314076905$var$z && a[$e1329cb314076905$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1329cb314076905$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e1329cb314076905$var$C = Object.assign, $e1329cb314076905$var$D = {};
function $e1329cb314076905$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1329cb314076905$var$D;
    this.updater = e || $e1329cb314076905$var$B;
}
$e1329cb314076905$var$E.prototype.isReactComponent = {};
$e1329cb314076905$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e1329cb314076905$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e1329cb314076905$var$F() {}
$e1329cb314076905$var$F.prototype = $e1329cb314076905$var$E.prototype;
function $e1329cb314076905$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1329cb314076905$var$D;
    this.updater = e || $e1329cb314076905$var$B;
}
var $e1329cb314076905$var$H = $e1329cb314076905$var$G.prototype = new $e1329cb314076905$var$F;
$e1329cb314076905$var$H.constructor = $e1329cb314076905$var$G;
$e1329cb314076905$var$C($e1329cb314076905$var$H, $e1329cb314076905$var$E.prototype);
$e1329cb314076905$var$H.isPureReactComponent = !0;
var $e1329cb314076905$var$I = Array.isArray, $e1329cb314076905$var$J = Object.prototype.hasOwnProperty, $e1329cb314076905$var$K = {
    current: null
}, $e1329cb314076905$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e1329cb314076905$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e1329cb314076905$var$J.call(b, d) && !$e1329cb314076905$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e1329cb314076905$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e1329cb314076905$var$K.current
    };
}
function $e1329cb314076905$var$N(a, b) {
    return {
        $$typeof: $e1329cb314076905$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e1329cb314076905$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e1329cb314076905$var$l;
}
function $e1329cb314076905$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e1329cb314076905$var$P = /\/+/g;
function $e1329cb314076905$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e1329cb314076905$var$escape("" + a.key) : b.toString(36);
}
function $e1329cb314076905$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e1329cb314076905$var$l:
                case $e1329cb314076905$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e1329cb314076905$var$Q(h, 0) : d, $e1329cb314076905$var$I(c) ? (e = "", null != a && (e = a.replace($e1329cb314076905$var$P, "$&/") + "/"), $e1329cb314076905$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e1329cb314076905$var$O(c) && (c = $e1329cb314076905$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e1329cb314076905$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e1329cb314076905$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e1329cb314076905$var$Q(k, g);
        h += $e1329cb314076905$var$R(k, b, e, f, c);
    }
    else if (f = $e1329cb314076905$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e1329cb314076905$var$Q(k, g++), h += $e1329cb314076905$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e1329cb314076905$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e1329cb314076905$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e1329cb314076905$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e1329cb314076905$var$U = {
    current: null
}, $e1329cb314076905$var$V = {
    transition: null
}, $e1329cb314076905$var$W = {
    ReactCurrentDispatcher: $e1329cb314076905$var$U,
    ReactCurrentBatchConfig: $e1329cb314076905$var$V,
    ReactCurrentOwner: $e1329cb314076905$var$K
};
$e1329cb314076905$export$dca3b0875bd9a954 = {
    map: $e1329cb314076905$var$S,
    forEach: function(a, b, e) {
        $e1329cb314076905$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e1329cb314076905$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e1329cb314076905$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e1329cb314076905$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e1329cb314076905$export$16fa2f45be04daa8 = $e1329cb314076905$var$E;
$e1329cb314076905$export$ffb0004e005737fa = $e1329cb314076905$var$p;
$e1329cb314076905$export$e2c29f18771995cb = $e1329cb314076905$var$r;
$e1329cb314076905$export$221d75b3f55bb0bd = $e1329cb314076905$var$G;
$e1329cb314076905$export$5f8d39834fd61797 = $e1329cb314076905$var$q;
$e1329cb314076905$export$74bf444e3cd11ea5 = $e1329cb314076905$var$w;
$e1329cb314076905$export$ae55be85d98224ed = $e1329cb314076905$var$W;
$e1329cb314076905$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e1329cb314076905$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e1329cb314076905$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e1329cb314076905$var$J.call(b, f) && !$e1329cb314076905$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e1329cb314076905$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e1329cb314076905$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e1329cb314076905$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e1329cb314076905$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e1329cb314076905$export$c8a8987d4410bf2d = $e1329cb314076905$var$M;
$e1329cb314076905$export$d38cd72104c1f0e9 = function(a) {
    var b = $e1329cb314076905$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e1329cb314076905$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e1329cb314076905$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e1329cb314076905$var$v,
        render: a
    };
};
$e1329cb314076905$export$a8257692ac88316c = $e1329cb314076905$var$O;
$e1329cb314076905$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e1329cb314076905$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e1329cb314076905$var$T
    };
};
$e1329cb314076905$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e1329cb314076905$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e1329cb314076905$export$7568632d0d33d16d = function(a) {
    var b = $e1329cb314076905$var$V.transition;
    $e1329cb314076905$var$V.transition = {};
    try {
        a();
    } finally{
        $e1329cb314076905$var$V.transition = b;
    }
};
$e1329cb314076905$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$e1329cb314076905$export$35808ee640e87ca7 = function(a, b) {
    return $e1329cb314076905$var$U.current.useCallback(a, b);
};
$e1329cb314076905$export$fae74005e78b1a27 = function(a) {
    return $e1329cb314076905$var$U.current.useContext(a);
};
$e1329cb314076905$export$dc8fbce3eb94dc1e = function() {};
$e1329cb314076905$export$6a7bc4e911dc01cf = function(a) {
    return $e1329cb314076905$var$U.current.useDeferredValue(a);
};
$e1329cb314076905$export$6d9c69b0de29b591 = function(a, b) {
    return $e1329cb314076905$var$U.current.useEffect(a, b);
};
$e1329cb314076905$export$f680877a34711e37 = function() {
    return $e1329cb314076905$var$U.current.useId();
};
$e1329cb314076905$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e1329cb314076905$var$U.current.useImperativeHandle(a, b, e);
};
$e1329cb314076905$export$aaabe4eda9ed9969 = function(a, b) {
    return $e1329cb314076905$var$U.current.useInsertionEffect(a, b);
};
$e1329cb314076905$export$e5c5a5f917a5871c = function(a, b) {
    return $e1329cb314076905$var$U.current.useLayoutEffect(a, b);
};
$e1329cb314076905$export$1538c33de8887b59 = function(a, b) {
    return $e1329cb314076905$var$U.current.useMemo(a, b);
};
$e1329cb314076905$export$13e3392192263954 = function(a, b, e) {
    return $e1329cb314076905$var$U.current.useReducer(a, b, e);
};
$e1329cb314076905$export$b8f5890fc79d6aca = function(a) {
    return $e1329cb314076905$var$U.current.useRef(a);
};
$e1329cb314076905$export$60241385465d0a34 = function(a) {
    return $e1329cb314076905$var$U.current.useState(a);
};
$e1329cb314076905$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e1329cb314076905$var$U.current.useSyncExternalStore(a, b, e);
};
$e1329cb314076905$export$7b286972b8d8ccbf = function() {
    return $e1329cb314076905$var$U.current.useTransition();
};
$e1329cb314076905$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("aXsFt", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $020f0f14624a1d9c$export$ae55be85d98224ed, (v) => $020f0f14624a1d9c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $020f0f14624a1d9c$export$d39a5bbd09211389, (v) => $020f0f14624a1d9c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $020f0f14624a1d9c$export$882461b6382ed46c, (v) => $020f0f14624a1d9c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $020f0f14624a1d9c$export$466bfc07425424d5, (v) => $020f0f14624a1d9c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $020f0f14624a1d9c$export$cd75ccfd720a3cd4, (v) => $020f0f14624a1d9c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $020f0f14624a1d9c$export$fa8d919ba61d84db, (v) => $020f0f14624a1d9c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $020f0f14624a1d9c$export$757ceba2d55c277e, (v) => $020f0f14624a1d9c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $020f0f14624a1d9c$export$b3890eb0ae9dca99, (v) => $020f0f14624a1d9c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $020f0f14624a1d9c$export$502457920280e6be, (v) => $020f0f14624a1d9c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $020f0f14624a1d9c$export$c78a37762a8d58e1, (v) => $020f0f14624a1d9c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $020f0f14624a1d9c$export$dc54d992c10e8a18, (v) => $020f0f14624a1d9c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $020f0f14624a1d9c$export$83d89fbfd8236492, (v) => $020f0f14624a1d9c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $020f0f14624a1d9c$export$ae55be85d98224ed;
var $020f0f14624a1d9c$export$d39a5bbd09211389;
var $020f0f14624a1d9c$export$882461b6382ed46c;
var $020f0f14624a1d9c$export$466bfc07425424d5;
var $020f0f14624a1d9c$export$cd75ccfd720a3cd4;
var $020f0f14624a1d9c$export$fa8d919ba61d84db;
var $020f0f14624a1d9c$export$757ceba2d55c277e;
var $020f0f14624a1d9c$export$b3890eb0ae9dca99;
var $020f0f14624a1d9c$export$502457920280e6be;
var $020f0f14624a1d9c$export$c78a37762a8d58e1;
var $020f0f14624a1d9c$export$dc54d992c10e8a18;
var $020f0f14624a1d9c$export$83d89fbfd8236492;
"use strict";

var $50vd1 = parcelRequire("50vd1");

var $SIuCF = parcelRequire("SIuCF");
function $020f0f14624a1d9c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $020f0f14624a1d9c$var$da = new Set, $020f0f14624a1d9c$var$ea = {};
function $020f0f14624a1d9c$var$fa(a, b) {
    $020f0f14624a1d9c$var$ha(a, b);
    $020f0f14624a1d9c$var$ha(a + "Capture", b);
}
function $020f0f14624a1d9c$var$ha(a, b) {
    $020f0f14624a1d9c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$020f0f14624a1d9c$var$da.add(b[a]);
}
var $020f0f14624a1d9c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $020f0f14624a1d9c$var$ja = Object.prototype.hasOwnProperty, $020f0f14624a1d9c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $020f0f14624a1d9c$var$la = {}, $020f0f14624a1d9c$var$ma = {};
function $020f0f14624a1d9c$var$oa(a) {
    if ($020f0f14624a1d9c$var$ja.call($020f0f14624a1d9c$var$ma, a)) return !0;
    if ($020f0f14624a1d9c$var$ja.call($020f0f14624a1d9c$var$la, a)) return !1;
    if ($020f0f14624a1d9c$var$ka.test(a)) return $020f0f14624a1d9c$var$ma[a] = !0;
    $020f0f14624a1d9c$var$la[a] = !0;
    return !1;
}
function $020f0f14624a1d9c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $020f0f14624a1d9c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $020f0f14624a1d9c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $020f0f14624a1d9c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $020f0f14624a1d9c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $020f0f14624a1d9c$var$z[b] = new $020f0f14624a1d9c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $020f0f14624a1d9c$var$ra = /[\-:]([a-z])/g;
function $020f0f14624a1d9c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($020f0f14624a1d9c$var$ra, $020f0f14624a1d9c$var$sa);
    $020f0f14624a1d9c$var$z[b] = new $020f0f14624a1d9c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($020f0f14624a1d9c$var$ra, $020f0f14624a1d9c$var$sa);
    $020f0f14624a1d9c$var$z[b] = new $020f0f14624a1d9c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($020f0f14624a1d9c$var$ra, $020f0f14624a1d9c$var$sa);
    $020f0f14624a1d9c$var$z[b] = new $020f0f14624a1d9c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$020f0f14624a1d9c$var$z.xlinkHref = new $020f0f14624a1d9c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $020f0f14624a1d9c$var$z[a] = new $020f0f14624a1d9c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $020f0f14624a1d9c$var$ta(a, b, c, d) {
    var e = $020f0f14624a1d9c$var$z.hasOwnProperty(b) ? $020f0f14624a1d9c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $020f0f14624a1d9c$var$qa(b, c, e, d) && (c = null), d || null === e ? $020f0f14624a1d9c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $020f0f14624a1d9c$var$ua = $50vd1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $020f0f14624a1d9c$var$va = Symbol.for("react.element"), $020f0f14624a1d9c$var$wa = Symbol.for("react.portal"), $020f0f14624a1d9c$var$ya = Symbol.for("react.fragment"), $020f0f14624a1d9c$var$za = Symbol.for("react.strict_mode"), $020f0f14624a1d9c$var$Aa = Symbol.for("react.profiler"), $020f0f14624a1d9c$var$Ba = Symbol.for("react.provider"), $020f0f14624a1d9c$var$Ca = Symbol.for("react.context"), $020f0f14624a1d9c$var$Da = Symbol.for("react.forward_ref"), $020f0f14624a1d9c$var$Ea = Symbol.for("react.suspense"), $020f0f14624a1d9c$var$Fa = Symbol.for("react.suspense_list"), $020f0f14624a1d9c$var$Ga = Symbol.for("react.memo"), $020f0f14624a1d9c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $020f0f14624a1d9c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $020f0f14624a1d9c$var$Ja = Symbol.iterator;
function $020f0f14624a1d9c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $020f0f14624a1d9c$var$Ja && a[$020f0f14624a1d9c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $020f0f14624a1d9c$var$A = Object.assign, $020f0f14624a1d9c$var$La;
function $020f0f14624a1d9c$var$Ma(a) {
    if (void 0 === $020f0f14624a1d9c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $020f0f14624a1d9c$var$La = b && b[1] || "";
    }
    return "\n" + $020f0f14624a1d9c$var$La + a;
}
var $020f0f14624a1d9c$var$Na = !1;
function $020f0f14624a1d9c$var$Oa(a, b) {
    if (!a || $020f0f14624a1d9c$var$Na) return "";
    $020f0f14624a1d9c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $020f0f14624a1d9c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $020f0f14624a1d9c$var$Ma(a) : "";
}
function $020f0f14624a1d9c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $020f0f14624a1d9c$var$Ma(a.type);
        case 16:
            return $020f0f14624a1d9c$var$Ma("Lazy");
        case 13:
            return $020f0f14624a1d9c$var$Ma("Suspense");
        case 19:
            return $020f0f14624a1d9c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $020f0f14624a1d9c$var$Oa(a.type, !1), a;
        case 11:
            return a = $020f0f14624a1d9c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $020f0f14624a1d9c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $020f0f14624a1d9c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $020f0f14624a1d9c$var$ya:
            return "Fragment";
        case $020f0f14624a1d9c$var$wa:
            return "Portal";
        case $020f0f14624a1d9c$var$Aa:
            return "Profiler";
        case $020f0f14624a1d9c$var$za:
            return "StrictMode";
        case $020f0f14624a1d9c$var$Ea:
            return "Suspense";
        case $020f0f14624a1d9c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $020f0f14624a1d9c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $020f0f14624a1d9c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $020f0f14624a1d9c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $020f0f14624a1d9c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $020f0f14624a1d9c$var$Qa(a.type) || "Memo";
        case $020f0f14624a1d9c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $020f0f14624a1d9c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $020f0f14624a1d9c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $020f0f14624a1d9c$var$Qa(b);
        case 8:
            return b === $020f0f14624a1d9c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $020f0f14624a1d9c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $020f0f14624a1d9c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $020f0f14624a1d9c$var$Ua(a) {
    var b = $020f0f14624a1d9c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $020f0f14624a1d9c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $020f0f14624a1d9c$var$Ua(a));
}
function $020f0f14624a1d9c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $020f0f14624a1d9c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $020f0f14624a1d9c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $020f0f14624a1d9c$var$Ya(a, b) {
    var c = b.checked;
    return $020f0f14624a1d9c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $020f0f14624a1d9c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $020f0f14624a1d9c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $020f0f14624a1d9c$var$ab(a, b) {
    b = b.checked;
    null != b && $020f0f14624a1d9c$var$ta(a, "checked", b, !1);
}
function $020f0f14624a1d9c$var$bb(a, b) {
    $020f0f14624a1d9c$var$ab(a, b);
    var c = $020f0f14624a1d9c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $020f0f14624a1d9c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $020f0f14624a1d9c$var$cb(a, b.type, $020f0f14624a1d9c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $020f0f14624a1d9c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $020f0f14624a1d9c$var$cb(a, b, c) {
    if ("number" !== b || $020f0f14624a1d9c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $020f0f14624a1d9c$var$eb = Array.isArray;
function $020f0f14624a1d9c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $020f0f14624a1d9c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $020f0f14624a1d9c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($020f0f14624a1d9c$var$p(91));
    return $020f0f14624a1d9c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $020f0f14624a1d9c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($020f0f14624a1d9c$var$p(92));
            if ($020f0f14624a1d9c$var$eb(c)) {
                if (1 < c.length) throw Error($020f0f14624a1d9c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $020f0f14624a1d9c$var$Sa(c)
    };
}
function $020f0f14624a1d9c$var$ib(a, b) {
    var c = $020f0f14624a1d9c$var$Sa(b.value), d = $020f0f14624a1d9c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $020f0f14624a1d9c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $020f0f14624a1d9c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $020f0f14624a1d9c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $020f0f14624a1d9c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $020f0f14624a1d9c$var$mb, $020f0f14624a1d9c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $020f0f14624a1d9c$var$mb = $020f0f14624a1d9c$var$mb || document.createElement("div");
        $020f0f14624a1d9c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $020f0f14624a1d9c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $020f0f14624a1d9c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $020f0f14624a1d9c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $020f0f14624a1d9c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($020f0f14624a1d9c$var$pb).forEach(function(a) {
    $020f0f14624a1d9c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $020f0f14624a1d9c$var$pb[b] = $020f0f14624a1d9c$var$pb[a];
    });
});
function $020f0f14624a1d9c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $020f0f14624a1d9c$var$pb.hasOwnProperty(a) && $020f0f14624a1d9c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $020f0f14624a1d9c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $020f0f14624a1d9c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $020f0f14624a1d9c$var$tb = $020f0f14624a1d9c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $020f0f14624a1d9c$var$ub(a, b) {
    if (b) {
        if ($020f0f14624a1d9c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($020f0f14624a1d9c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($020f0f14624a1d9c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($020f0f14624a1d9c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($020f0f14624a1d9c$var$p(62));
    }
}
function $020f0f14624a1d9c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $020f0f14624a1d9c$var$wb = null;
function $020f0f14624a1d9c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $020f0f14624a1d9c$var$yb = null, $020f0f14624a1d9c$var$zb = null, $020f0f14624a1d9c$var$Ab = null;
function $020f0f14624a1d9c$var$Bb(a) {
    if (a = $020f0f14624a1d9c$var$Cb(a)) {
        if ("function" !== typeof $020f0f14624a1d9c$var$yb) throw Error($020f0f14624a1d9c$var$p(280));
        var b = a.stateNode;
        b && (b = $020f0f14624a1d9c$var$Db(b), $020f0f14624a1d9c$var$yb(a.stateNode, a.type, b));
    }
}
function $020f0f14624a1d9c$var$Eb(a) {
    $020f0f14624a1d9c$var$zb ? $020f0f14624a1d9c$var$Ab ? $020f0f14624a1d9c$var$Ab.push(a) : $020f0f14624a1d9c$var$Ab = [
        a
    ] : $020f0f14624a1d9c$var$zb = a;
}
function $020f0f14624a1d9c$var$Fb() {
    if ($020f0f14624a1d9c$var$zb) {
        var a = $020f0f14624a1d9c$var$zb, b = $020f0f14624a1d9c$var$Ab;
        $020f0f14624a1d9c$var$Ab = $020f0f14624a1d9c$var$zb = null;
        $020f0f14624a1d9c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$020f0f14624a1d9c$var$Bb(b[a]);
    }
}
function $020f0f14624a1d9c$var$Gb(a, b) {
    return a(b);
}
function $020f0f14624a1d9c$var$Hb() {}
var $020f0f14624a1d9c$var$Ib = !1;
function $020f0f14624a1d9c$var$Jb(a, b, c) {
    if ($020f0f14624a1d9c$var$Ib) return a(b, c);
    $020f0f14624a1d9c$var$Ib = !0;
    try {
        return $020f0f14624a1d9c$var$Gb(a, b, c);
    } finally{
        if ($020f0f14624a1d9c$var$Ib = !1, null !== $020f0f14624a1d9c$var$zb || null !== $020f0f14624a1d9c$var$Ab) $020f0f14624a1d9c$var$Hb(), $020f0f14624a1d9c$var$Fb();
    }
}
function $020f0f14624a1d9c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $020f0f14624a1d9c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($020f0f14624a1d9c$var$p(231, b, typeof c));
    return c;
}
var $020f0f14624a1d9c$var$Lb = !1;
if ($020f0f14624a1d9c$var$ia) try {
    var $020f0f14624a1d9c$var$Mb = {};
    Object.defineProperty($020f0f14624a1d9c$var$Mb, "passive", {
        get: function() {
            $020f0f14624a1d9c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $020f0f14624a1d9c$var$Mb, $020f0f14624a1d9c$var$Mb);
    window.removeEventListener("test", $020f0f14624a1d9c$var$Mb, $020f0f14624a1d9c$var$Mb);
} catch (a) {
    $020f0f14624a1d9c$var$Lb = !1;
}
function $020f0f14624a1d9c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $020f0f14624a1d9c$var$Ob = !1, $020f0f14624a1d9c$var$Pb = null, $020f0f14624a1d9c$var$Qb = !1, $020f0f14624a1d9c$var$Rb = null, $020f0f14624a1d9c$var$Sb = {
    onError: function(a) {
        $020f0f14624a1d9c$var$Ob = !0;
        $020f0f14624a1d9c$var$Pb = a;
    }
};
function $020f0f14624a1d9c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $020f0f14624a1d9c$var$Ob = !1;
    $020f0f14624a1d9c$var$Pb = null;
    $020f0f14624a1d9c$var$Nb.apply($020f0f14624a1d9c$var$Sb, arguments);
}
function $020f0f14624a1d9c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $020f0f14624a1d9c$var$Tb.apply(this, arguments);
    if ($020f0f14624a1d9c$var$Ob) {
        if ($020f0f14624a1d9c$var$Ob) {
            var l = $020f0f14624a1d9c$var$Pb;
            $020f0f14624a1d9c$var$Ob = !1;
            $020f0f14624a1d9c$var$Pb = null;
        } else throw Error($020f0f14624a1d9c$var$p(198));
        $020f0f14624a1d9c$var$Qb || ($020f0f14624a1d9c$var$Qb = !0, $020f0f14624a1d9c$var$Rb = l);
    }
}
function $020f0f14624a1d9c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $020f0f14624a1d9c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $020f0f14624a1d9c$var$Xb(a) {
    if ($020f0f14624a1d9c$var$Vb(a) !== a) throw Error($020f0f14624a1d9c$var$p(188));
}
function $020f0f14624a1d9c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $020f0f14624a1d9c$var$Vb(a);
        if (null === b) throw Error($020f0f14624a1d9c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $020f0f14624a1d9c$var$Xb(e), a;
                if (f === d) return $020f0f14624a1d9c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($020f0f14624a1d9c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($020f0f14624a1d9c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($020f0f14624a1d9c$var$p(190));
    }
    if (3 !== c.tag) throw Error($020f0f14624a1d9c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $020f0f14624a1d9c$var$Zb(a) {
    a = $020f0f14624a1d9c$var$Yb(a);
    return null !== a ? $020f0f14624a1d9c$var$$b(a) : null;
}
function $020f0f14624a1d9c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $020f0f14624a1d9c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $020f0f14624a1d9c$var$ac = $SIuCF.unstable_scheduleCallback, $020f0f14624a1d9c$var$bc = $SIuCF.unstable_cancelCallback, $020f0f14624a1d9c$var$cc = $SIuCF.unstable_shouldYield, $020f0f14624a1d9c$var$dc = $SIuCF.unstable_requestPaint, $020f0f14624a1d9c$var$B = $SIuCF.unstable_now, $020f0f14624a1d9c$var$ec = $SIuCF.unstable_getCurrentPriorityLevel, $020f0f14624a1d9c$var$fc = $SIuCF.unstable_ImmediatePriority, $020f0f14624a1d9c$var$gc = $SIuCF.unstable_UserBlockingPriority, $020f0f14624a1d9c$var$hc = $SIuCF.unstable_NormalPriority, $020f0f14624a1d9c$var$ic = $SIuCF.unstable_LowPriority, $020f0f14624a1d9c$var$jc = $SIuCF.unstable_IdlePriority, $020f0f14624a1d9c$var$kc = null, $020f0f14624a1d9c$var$lc = null;
function $020f0f14624a1d9c$var$mc(a) {
    if ($020f0f14624a1d9c$var$lc && "function" === typeof $020f0f14624a1d9c$var$lc.onCommitFiberRoot) try {
        $020f0f14624a1d9c$var$lc.onCommitFiberRoot($020f0f14624a1d9c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $020f0f14624a1d9c$var$oc = Math.clz32 ? Math.clz32 : $020f0f14624a1d9c$var$nc, $020f0f14624a1d9c$var$pc = Math.log, $020f0f14624a1d9c$var$qc = Math.LN2;
function $020f0f14624a1d9c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($020f0f14624a1d9c$var$pc(a) / $020f0f14624a1d9c$var$qc | 0) | 0;
}
var $020f0f14624a1d9c$var$rc = 64, $020f0f14624a1d9c$var$sc = 4194304;
function $020f0f14624a1d9c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $020f0f14624a1d9c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $020f0f14624a1d9c$var$tc(h) : (f &= g, 0 !== f && (d = $020f0f14624a1d9c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $020f0f14624a1d9c$var$tc(g) : 0 !== f && (d = $020f0f14624a1d9c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $020f0f14624a1d9c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $020f0f14624a1d9c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $020f0f14624a1d9c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $020f0f14624a1d9c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $020f0f14624a1d9c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $020f0f14624a1d9c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $020f0f14624a1d9c$var$yc() {
    var a = $020f0f14624a1d9c$var$rc;
    $020f0f14624a1d9c$var$rc <<= 1;
    0 === ($020f0f14624a1d9c$var$rc & 4194240) && ($020f0f14624a1d9c$var$rc = 64);
    return a;
}
function $020f0f14624a1d9c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $020f0f14624a1d9c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $020f0f14624a1d9c$var$oc(b);
    a[b] = c;
}
function $020f0f14624a1d9c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $020f0f14624a1d9c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $020f0f14624a1d9c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $020f0f14624a1d9c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $020f0f14624a1d9c$var$C = 0;
function $020f0f14624a1d9c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $020f0f14624a1d9c$var$Ec, $020f0f14624a1d9c$var$Fc, $020f0f14624a1d9c$var$Gc, $020f0f14624a1d9c$var$Hc, $020f0f14624a1d9c$var$Ic, $020f0f14624a1d9c$var$Jc = !1, $020f0f14624a1d9c$var$Kc = [], $020f0f14624a1d9c$var$Lc = null, $020f0f14624a1d9c$var$Mc = null, $020f0f14624a1d9c$var$Nc = null, $020f0f14624a1d9c$var$Oc = new Map, $020f0f14624a1d9c$var$Pc = new Map, $020f0f14624a1d9c$var$Qc = [], $020f0f14624a1d9c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $020f0f14624a1d9c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $020f0f14624a1d9c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $020f0f14624a1d9c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $020f0f14624a1d9c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $020f0f14624a1d9c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $020f0f14624a1d9c$var$Pc.delete(b.pointerId);
    }
}
function $020f0f14624a1d9c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $020f0f14624a1d9c$var$Cb(b), null !== b && $020f0f14624a1d9c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $020f0f14624a1d9c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $020f0f14624a1d9c$var$Lc = $020f0f14624a1d9c$var$Tc($020f0f14624a1d9c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $020f0f14624a1d9c$var$Mc = $020f0f14624a1d9c$var$Tc($020f0f14624a1d9c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $020f0f14624a1d9c$var$Nc = $020f0f14624a1d9c$var$Tc($020f0f14624a1d9c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $020f0f14624a1d9c$var$Oc.set(f, $020f0f14624a1d9c$var$Tc($020f0f14624a1d9c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $020f0f14624a1d9c$var$Pc.set(f, $020f0f14624a1d9c$var$Tc($020f0f14624a1d9c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $020f0f14624a1d9c$var$Vc(a) {
    var b = $020f0f14624a1d9c$var$Wc(a.target);
    if (null !== b) {
        var c = $020f0f14624a1d9c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $020f0f14624a1d9c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $020f0f14624a1d9c$var$Ic(a.priority, function() {
                        $020f0f14624a1d9c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $020f0f14624a1d9c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $020f0f14624a1d9c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $020f0f14624a1d9c$var$wb = d;
            c.target.dispatchEvent(d);
            $020f0f14624a1d9c$var$wb = null;
        } else return b = $020f0f14624a1d9c$var$Cb(c), null !== b && $020f0f14624a1d9c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $020f0f14624a1d9c$var$Zc(a, b, c) {
    $020f0f14624a1d9c$var$Xc(a) && c.delete(b);
}
function $020f0f14624a1d9c$var$$c() {
    $020f0f14624a1d9c$var$Jc = !1;
    null !== $020f0f14624a1d9c$var$Lc && $020f0f14624a1d9c$var$Xc($020f0f14624a1d9c$var$Lc) && ($020f0f14624a1d9c$var$Lc = null);
    null !== $020f0f14624a1d9c$var$Mc && $020f0f14624a1d9c$var$Xc($020f0f14624a1d9c$var$Mc) && ($020f0f14624a1d9c$var$Mc = null);
    null !== $020f0f14624a1d9c$var$Nc && $020f0f14624a1d9c$var$Xc($020f0f14624a1d9c$var$Nc) && ($020f0f14624a1d9c$var$Nc = null);
    $020f0f14624a1d9c$var$Oc.forEach($020f0f14624a1d9c$var$Zc);
    $020f0f14624a1d9c$var$Pc.forEach($020f0f14624a1d9c$var$Zc);
}
function $020f0f14624a1d9c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $020f0f14624a1d9c$var$Jc || ($020f0f14624a1d9c$var$Jc = !0, $SIuCF.unstable_scheduleCallback($SIuCF.unstable_NormalPriority, $020f0f14624a1d9c$var$$c)));
}
function $020f0f14624a1d9c$var$bd(a) {
    function b(b) {
        return $020f0f14624a1d9c$var$ad(b, a);
    }
    if (0 < $020f0f14624a1d9c$var$Kc.length) {
        $020f0f14624a1d9c$var$ad($020f0f14624a1d9c$var$Kc[0], a);
        for(var c = 1; c < $020f0f14624a1d9c$var$Kc.length; c++){
            var d = $020f0f14624a1d9c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $020f0f14624a1d9c$var$Lc && $020f0f14624a1d9c$var$ad($020f0f14624a1d9c$var$Lc, a);
    null !== $020f0f14624a1d9c$var$Mc && $020f0f14624a1d9c$var$ad($020f0f14624a1d9c$var$Mc, a);
    null !== $020f0f14624a1d9c$var$Nc && $020f0f14624a1d9c$var$ad($020f0f14624a1d9c$var$Nc, a);
    $020f0f14624a1d9c$var$Oc.forEach(b);
    $020f0f14624a1d9c$var$Pc.forEach(b);
    for(c = 0; c < $020f0f14624a1d9c$var$Qc.length; c++)d = $020f0f14624a1d9c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $020f0f14624a1d9c$var$Qc.length && (c = $020f0f14624a1d9c$var$Qc[0], null === c.blockedOn);)$020f0f14624a1d9c$var$Vc(c), null === c.blockedOn && $020f0f14624a1d9c$var$Qc.shift();
}
var $020f0f14624a1d9c$var$cd = $020f0f14624a1d9c$var$ua.ReactCurrentBatchConfig, $020f0f14624a1d9c$var$dd = !0;
function $020f0f14624a1d9c$var$ed(a, b, c, d) {
    var e = $020f0f14624a1d9c$var$C, f = $020f0f14624a1d9c$var$cd.transition;
    $020f0f14624a1d9c$var$cd.transition = null;
    try {
        $020f0f14624a1d9c$var$C = 1, $020f0f14624a1d9c$var$fd(a, b, c, d);
    } finally{
        $020f0f14624a1d9c$var$C = e, $020f0f14624a1d9c$var$cd.transition = f;
    }
}
function $020f0f14624a1d9c$var$gd(a, b, c, d) {
    var e = $020f0f14624a1d9c$var$C, f = $020f0f14624a1d9c$var$cd.transition;
    $020f0f14624a1d9c$var$cd.transition = null;
    try {
        $020f0f14624a1d9c$var$C = 4, $020f0f14624a1d9c$var$fd(a, b, c, d);
    } finally{
        $020f0f14624a1d9c$var$C = e, $020f0f14624a1d9c$var$cd.transition = f;
    }
}
function $020f0f14624a1d9c$var$fd(a, b, c, d) {
    if ($020f0f14624a1d9c$var$dd) {
        var e = $020f0f14624a1d9c$var$Yc(a, b, c, d);
        if (null === e) $020f0f14624a1d9c$var$hd(a, b, d, $020f0f14624a1d9c$var$id, c), $020f0f14624a1d9c$var$Sc(a, d);
        else if ($020f0f14624a1d9c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($020f0f14624a1d9c$var$Sc(a, d), b & 4 && -1 < $020f0f14624a1d9c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $020f0f14624a1d9c$var$Cb(e);
                null !== f && $020f0f14624a1d9c$var$Ec(f);
                f = $020f0f14624a1d9c$var$Yc(a, b, c, d);
                null === f && $020f0f14624a1d9c$var$hd(a, b, d, $020f0f14624a1d9c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $020f0f14624a1d9c$var$hd(a, b, d, null, c);
    }
}
var $020f0f14624a1d9c$var$id = null;
function $020f0f14624a1d9c$var$Yc(a, b, c, d) {
    $020f0f14624a1d9c$var$id = null;
    a = $020f0f14624a1d9c$var$xb(d);
    a = $020f0f14624a1d9c$var$Wc(a);
    if (null !== a) {
        if (b = $020f0f14624a1d9c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $020f0f14624a1d9c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $020f0f14624a1d9c$var$id = a;
    return null;
}
function $020f0f14624a1d9c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($020f0f14624a1d9c$var$ec()){
                case $020f0f14624a1d9c$var$fc:
                    return 1;
                case $020f0f14624a1d9c$var$gc:
                    return 4;
                case $020f0f14624a1d9c$var$hc:
                case $020f0f14624a1d9c$var$ic:
                    return 16;
                case $020f0f14624a1d9c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $020f0f14624a1d9c$var$kd = null, $020f0f14624a1d9c$var$ld = null, $020f0f14624a1d9c$var$md = null;
function $020f0f14624a1d9c$var$nd() {
    if ($020f0f14624a1d9c$var$md) return $020f0f14624a1d9c$var$md;
    var a, b = $020f0f14624a1d9c$var$ld, c = b.length, d, e = "value" in $020f0f14624a1d9c$var$kd ? $020f0f14624a1d9c$var$kd.value : $020f0f14624a1d9c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $020f0f14624a1d9c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $020f0f14624a1d9c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $020f0f14624a1d9c$var$pd() {
    return !0;
}
function $020f0f14624a1d9c$var$qd() {
    return !1;
}
function $020f0f14624a1d9c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $020f0f14624a1d9c$var$pd : $020f0f14624a1d9c$var$qd;
        this.isPropagationStopped = $020f0f14624a1d9c$var$qd;
        return this;
    }
    $020f0f14624a1d9c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $020f0f14624a1d9c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $020f0f14624a1d9c$var$pd);
        },
        persist: function() {},
        isPersistent: $020f0f14624a1d9c$var$pd
    });
    return b;
}
var $020f0f14624a1d9c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $020f0f14624a1d9c$var$td = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$sd), $020f0f14624a1d9c$var$ud = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$sd, {
    view: 0,
    detail: 0
}), $020f0f14624a1d9c$var$vd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$ud), $020f0f14624a1d9c$var$wd, $020f0f14624a1d9c$var$xd, $020f0f14624a1d9c$var$yd, $020f0f14624a1d9c$var$Ad = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $020f0f14624a1d9c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $020f0f14624a1d9c$var$yd && ($020f0f14624a1d9c$var$yd && "mousemove" === a.type ? ($020f0f14624a1d9c$var$wd = a.screenX - $020f0f14624a1d9c$var$yd.screenX, $020f0f14624a1d9c$var$xd = a.screenY - $020f0f14624a1d9c$var$yd.screenY) : $020f0f14624a1d9c$var$xd = $020f0f14624a1d9c$var$wd = 0, $020f0f14624a1d9c$var$yd = a);
        return $020f0f14624a1d9c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $020f0f14624a1d9c$var$xd;
    }
}), $020f0f14624a1d9c$var$Bd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Ad), $020f0f14624a1d9c$var$Cd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$Ad, {
    dataTransfer: 0
}), $020f0f14624a1d9c$var$Dd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Cd), $020f0f14624a1d9c$var$Ed = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$ud, {
    relatedTarget: 0
}), $020f0f14624a1d9c$var$Fd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Ed), $020f0f14624a1d9c$var$Gd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $020f0f14624a1d9c$var$Hd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Gd), $020f0f14624a1d9c$var$Id = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $020f0f14624a1d9c$var$Jd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Id), $020f0f14624a1d9c$var$Kd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$sd, {
    data: 0
}), $020f0f14624a1d9c$var$Ld = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Kd), $020f0f14624a1d9c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $020f0f14624a1d9c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $020f0f14624a1d9c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $020f0f14624a1d9c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $020f0f14624a1d9c$var$Od[a]) ? !!b[a] : !1;
}
function $020f0f14624a1d9c$var$zd() {
    return $020f0f14624a1d9c$var$Pd;
}
var $020f0f14624a1d9c$var$Qd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $020f0f14624a1d9c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $020f0f14624a1d9c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $020f0f14624a1d9c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $020f0f14624a1d9c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $020f0f14624a1d9c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $020f0f14624a1d9c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $020f0f14624a1d9c$var$Rd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Qd), $020f0f14624a1d9c$var$Sd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $020f0f14624a1d9c$var$Td = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Sd), $020f0f14624a1d9c$var$Ud = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $020f0f14624a1d9c$var$zd
}), $020f0f14624a1d9c$var$Vd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Ud), $020f0f14624a1d9c$var$Wd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $020f0f14624a1d9c$var$Xd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Wd), $020f0f14624a1d9c$var$Yd = $020f0f14624a1d9c$var$A({}, $020f0f14624a1d9c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $020f0f14624a1d9c$var$Zd = $020f0f14624a1d9c$var$rd($020f0f14624a1d9c$var$Yd), $020f0f14624a1d9c$var$$d = [
    9,
    13,
    27,
    32
], $020f0f14624a1d9c$var$ae = $020f0f14624a1d9c$var$ia && "CompositionEvent" in window, $020f0f14624a1d9c$var$be = null;
$020f0f14624a1d9c$var$ia && "documentMode" in document && ($020f0f14624a1d9c$var$be = document.documentMode);
var $020f0f14624a1d9c$var$ce = $020f0f14624a1d9c$var$ia && "TextEvent" in window && !$020f0f14624a1d9c$var$be, $020f0f14624a1d9c$var$de = $020f0f14624a1d9c$var$ia && (!$020f0f14624a1d9c$var$ae || $020f0f14624a1d9c$var$be && 8 < $020f0f14624a1d9c$var$be && 11 >= $020f0f14624a1d9c$var$be), $020f0f14624a1d9c$var$ee = String.fromCharCode(32), $020f0f14624a1d9c$var$fe = !1;
function $020f0f14624a1d9c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $020f0f14624a1d9c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $020f0f14624a1d9c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $020f0f14624a1d9c$var$ie = !1;
function $020f0f14624a1d9c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $020f0f14624a1d9c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $020f0f14624a1d9c$var$fe = !0;
            return $020f0f14624a1d9c$var$ee;
        case "textInput":
            return a = b.data, a === $020f0f14624a1d9c$var$ee && $020f0f14624a1d9c$var$fe ? null : a;
        default:
            return null;
    }
}
function $020f0f14624a1d9c$var$ke(a, b) {
    if ($020f0f14624a1d9c$var$ie) return "compositionend" === a || !$020f0f14624a1d9c$var$ae && $020f0f14624a1d9c$var$ge(a, b) ? (a = $020f0f14624a1d9c$var$nd(), $020f0f14624a1d9c$var$md = $020f0f14624a1d9c$var$ld = $020f0f14624a1d9c$var$kd = null, $020f0f14624a1d9c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $020f0f14624a1d9c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $020f0f14624a1d9c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $020f0f14624a1d9c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$020f0f14624a1d9c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $020f0f14624a1d9c$var$ne(a, b, c, d) {
    $020f0f14624a1d9c$var$Eb(d);
    b = $020f0f14624a1d9c$var$oe(b, "onChange");
    0 < b.length && (c = new $020f0f14624a1d9c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $020f0f14624a1d9c$var$pe = null, $020f0f14624a1d9c$var$qe = null;
function $020f0f14624a1d9c$var$re(a) {
    $020f0f14624a1d9c$var$se(a, 0);
}
function $020f0f14624a1d9c$var$te(a) {
    var b = $020f0f14624a1d9c$var$ue(a);
    if ($020f0f14624a1d9c$var$Wa(b)) return a;
}
function $020f0f14624a1d9c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $020f0f14624a1d9c$var$we = !1;
if ($020f0f14624a1d9c$var$ia) {
    var $020f0f14624a1d9c$var$xe;
    if ($020f0f14624a1d9c$var$ia) {
        var $020f0f14624a1d9c$var$ye = "oninput" in document;
        if (!$020f0f14624a1d9c$var$ye) {
            var $020f0f14624a1d9c$var$ze = document.createElement("div");
            $020f0f14624a1d9c$var$ze.setAttribute("oninput", "return;");
            $020f0f14624a1d9c$var$ye = "function" === typeof $020f0f14624a1d9c$var$ze.oninput;
        }
        $020f0f14624a1d9c$var$xe = $020f0f14624a1d9c$var$ye;
    } else $020f0f14624a1d9c$var$xe = !1;
    $020f0f14624a1d9c$var$we = $020f0f14624a1d9c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $020f0f14624a1d9c$var$Ae() {
    $020f0f14624a1d9c$var$pe && ($020f0f14624a1d9c$var$pe.detachEvent("onpropertychange", $020f0f14624a1d9c$var$Be), $020f0f14624a1d9c$var$qe = $020f0f14624a1d9c$var$pe = null);
}
function $020f0f14624a1d9c$var$Be(a) {
    if ("value" === a.propertyName && $020f0f14624a1d9c$var$te($020f0f14624a1d9c$var$qe)) {
        var b = [];
        $020f0f14624a1d9c$var$ne(b, $020f0f14624a1d9c$var$qe, a, $020f0f14624a1d9c$var$xb(a));
        $020f0f14624a1d9c$var$Jb($020f0f14624a1d9c$var$re, b);
    }
}
function $020f0f14624a1d9c$var$Ce(a, b, c) {
    "focusin" === a ? ($020f0f14624a1d9c$var$Ae(), $020f0f14624a1d9c$var$pe = b, $020f0f14624a1d9c$var$qe = c, $020f0f14624a1d9c$var$pe.attachEvent("onpropertychange", $020f0f14624a1d9c$var$Be)) : "focusout" === a && $020f0f14624a1d9c$var$Ae();
}
function $020f0f14624a1d9c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $020f0f14624a1d9c$var$te($020f0f14624a1d9c$var$qe);
}
function $020f0f14624a1d9c$var$Ee(a, b) {
    if ("click" === a) return $020f0f14624a1d9c$var$te(b);
}
function $020f0f14624a1d9c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $020f0f14624a1d9c$var$te(b);
}
function $020f0f14624a1d9c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $020f0f14624a1d9c$var$He = "function" === typeof Object.is ? Object.is : $020f0f14624a1d9c$var$Ge;
function $020f0f14624a1d9c$var$Ie(a, b) {
    if ($020f0f14624a1d9c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$020f0f14624a1d9c$var$ja.call(b, e) || !$020f0f14624a1d9c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $020f0f14624a1d9c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $020f0f14624a1d9c$var$Ke(a, b) {
    var c = $020f0f14624a1d9c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $020f0f14624a1d9c$var$Je(c);
    }
}
function $020f0f14624a1d9c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $020f0f14624a1d9c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $020f0f14624a1d9c$var$Me() {
    for(var a = window, b = $020f0f14624a1d9c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $020f0f14624a1d9c$var$Xa(a.document);
    }
    return b;
}
function $020f0f14624a1d9c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $020f0f14624a1d9c$var$Oe(a) {
    var b = $020f0f14624a1d9c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $020f0f14624a1d9c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $020f0f14624a1d9c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $020f0f14624a1d9c$var$Ke(c, f);
                var g = $020f0f14624a1d9c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $020f0f14624a1d9c$var$Pe = $020f0f14624a1d9c$var$ia && "documentMode" in document && 11 >= document.documentMode, $020f0f14624a1d9c$var$Qe = null, $020f0f14624a1d9c$var$Re = null, $020f0f14624a1d9c$var$Se = null, $020f0f14624a1d9c$var$Te = !1;
function $020f0f14624a1d9c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $020f0f14624a1d9c$var$Te || null == $020f0f14624a1d9c$var$Qe || $020f0f14624a1d9c$var$Qe !== $020f0f14624a1d9c$var$Xa(d) || (d = $020f0f14624a1d9c$var$Qe, "selectionStart" in d && $020f0f14624a1d9c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $020f0f14624a1d9c$var$Se && $020f0f14624a1d9c$var$Ie($020f0f14624a1d9c$var$Se, d) || ($020f0f14624a1d9c$var$Se = d, d = $020f0f14624a1d9c$var$oe($020f0f14624a1d9c$var$Re, "onSelect"), 0 < d.length && (b = new $020f0f14624a1d9c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $020f0f14624a1d9c$var$Qe)));
}
function $020f0f14624a1d9c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $020f0f14624a1d9c$var$We = {
    animationend: $020f0f14624a1d9c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $020f0f14624a1d9c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $020f0f14624a1d9c$var$Ve("Animation", "AnimationStart"),
    transitionend: $020f0f14624a1d9c$var$Ve("Transition", "TransitionEnd")
}, $020f0f14624a1d9c$var$Xe = {}, $020f0f14624a1d9c$var$Ye = {};
$020f0f14624a1d9c$var$ia && ($020f0f14624a1d9c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $020f0f14624a1d9c$var$We.animationend.animation, delete $020f0f14624a1d9c$var$We.animationiteration.animation, delete $020f0f14624a1d9c$var$We.animationstart.animation), "TransitionEvent" in window || delete $020f0f14624a1d9c$var$We.transitionend.transition);
function $020f0f14624a1d9c$var$Ze(a) {
    if ($020f0f14624a1d9c$var$Xe[a]) return $020f0f14624a1d9c$var$Xe[a];
    if (!$020f0f14624a1d9c$var$We[a]) return a;
    var b = $020f0f14624a1d9c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $020f0f14624a1d9c$var$Ye) return $020f0f14624a1d9c$var$Xe[a] = b[c];
    return a;
}
var $020f0f14624a1d9c$var$$e = $020f0f14624a1d9c$var$Ze("animationend"), $020f0f14624a1d9c$var$af = $020f0f14624a1d9c$var$Ze("animationiteration"), $020f0f14624a1d9c$var$bf = $020f0f14624a1d9c$var$Ze("animationstart"), $020f0f14624a1d9c$var$cf = $020f0f14624a1d9c$var$Ze("transitionend"), $020f0f14624a1d9c$var$df = new Map, $020f0f14624a1d9c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $020f0f14624a1d9c$var$ff(a, b) {
    $020f0f14624a1d9c$var$df.set(a, b);
    $020f0f14624a1d9c$var$fa(b, [
        a
    ]);
}
for(var $020f0f14624a1d9c$var$gf = 0; $020f0f14624a1d9c$var$gf < $020f0f14624a1d9c$var$ef.length; $020f0f14624a1d9c$var$gf++){
    var $020f0f14624a1d9c$var$hf = $020f0f14624a1d9c$var$ef[$020f0f14624a1d9c$var$gf], $020f0f14624a1d9c$var$jf = $020f0f14624a1d9c$var$hf.toLowerCase(), $020f0f14624a1d9c$var$kf = $020f0f14624a1d9c$var$hf[0].toUpperCase() + $020f0f14624a1d9c$var$hf.slice(1);
    $020f0f14624a1d9c$var$ff($020f0f14624a1d9c$var$jf, "on" + $020f0f14624a1d9c$var$kf);
}
$020f0f14624a1d9c$var$ff($020f0f14624a1d9c$var$$e, "onAnimationEnd");
$020f0f14624a1d9c$var$ff($020f0f14624a1d9c$var$af, "onAnimationIteration");
$020f0f14624a1d9c$var$ff($020f0f14624a1d9c$var$bf, "onAnimationStart");
$020f0f14624a1d9c$var$ff("dblclick", "onDoubleClick");
$020f0f14624a1d9c$var$ff("focusin", "onFocus");
$020f0f14624a1d9c$var$ff("focusout", "onBlur");
$020f0f14624a1d9c$var$ff($020f0f14624a1d9c$var$cf, "onTransitionEnd");
$020f0f14624a1d9c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$020f0f14624a1d9c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$020f0f14624a1d9c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$020f0f14624a1d9c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$020f0f14624a1d9c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$020f0f14624a1d9c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$020f0f14624a1d9c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$020f0f14624a1d9c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$020f0f14624a1d9c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$020f0f14624a1d9c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $020f0f14624a1d9c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $020f0f14624a1d9c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($020f0f14624a1d9c$var$lf));
function $020f0f14624a1d9c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $020f0f14624a1d9c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $020f0f14624a1d9c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $020f0f14624a1d9c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $020f0f14624a1d9c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($020f0f14624a1d9c$var$Qb) throw a = $020f0f14624a1d9c$var$Rb, $020f0f14624a1d9c$var$Qb = !1, $020f0f14624a1d9c$var$Rb = null, a;
}
function $020f0f14624a1d9c$var$D(a, b) {
    var c = b[$020f0f14624a1d9c$var$of];
    void 0 === c && (c = b[$020f0f14624a1d9c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($020f0f14624a1d9c$var$pf(b, a, 2, !1), c.add(d));
}
function $020f0f14624a1d9c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $020f0f14624a1d9c$var$pf(c, a, d, b);
}
var $020f0f14624a1d9c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $020f0f14624a1d9c$var$sf(a) {
    if (!a[$020f0f14624a1d9c$var$rf]) {
        a[$020f0f14624a1d9c$var$rf] = !0;
        $020f0f14624a1d9c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($020f0f14624a1d9c$var$mf.has(b) || $020f0f14624a1d9c$var$qf(b, !1, a), $020f0f14624a1d9c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$020f0f14624a1d9c$var$rf] || (b[$020f0f14624a1d9c$var$rf] = !0, $020f0f14624a1d9c$var$qf("selectionchange", !1, b));
    }
}
function $020f0f14624a1d9c$var$pf(a, b, c, d) {
    switch($020f0f14624a1d9c$var$jd(b)){
        case 1:
            var e = $020f0f14624a1d9c$var$ed;
            break;
        case 4:
            e = $020f0f14624a1d9c$var$gd;
            break;
        default:
            e = $020f0f14624a1d9c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$020f0f14624a1d9c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $020f0f14624a1d9c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $020f0f14624a1d9c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $020f0f14624a1d9c$var$Jb(function() {
        var d = f, e = $020f0f14624a1d9c$var$xb(c), g = [];
        a: {
            var h = $020f0f14624a1d9c$var$df.get(a);
            if (void 0 !== h) {
                var k = $020f0f14624a1d9c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $020f0f14624a1d9c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $020f0f14624a1d9c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $020f0f14624a1d9c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $020f0f14624a1d9c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $020f0f14624a1d9c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $020f0f14624a1d9c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $020f0f14624a1d9c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $020f0f14624a1d9c$var$Vd;
                        break;
                    case $020f0f14624a1d9c$var$$e:
                    case $020f0f14624a1d9c$var$af:
                    case $020f0f14624a1d9c$var$bf:
                        k = $020f0f14624a1d9c$var$Hd;
                        break;
                    case $020f0f14624a1d9c$var$cf:
                        k = $020f0f14624a1d9c$var$Xd;
                        break;
                    case "scroll":
                        k = $020f0f14624a1d9c$var$vd;
                        break;
                    case "wheel":
                        k = $020f0f14624a1d9c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $020f0f14624a1d9c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $020f0f14624a1d9c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $020f0f14624a1d9c$var$Kb(w, x), null != F && t.push($020f0f14624a1d9c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $020f0f14624a1d9c$var$wb && (n = c.relatedTarget || c.fromElement) && ($020f0f14624a1d9c$var$Wc(n) || n[$020f0f14624a1d9c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $020f0f14624a1d9c$var$Wc(n) : null, null !== n && (J = $020f0f14624a1d9c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $020f0f14624a1d9c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $020f0f14624a1d9c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $020f0f14624a1d9c$var$ue(k);
                        u = null == n ? h : $020f0f14624a1d9c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $020f0f14624a1d9c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $020f0f14624a1d9c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $020f0f14624a1d9c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $020f0f14624a1d9c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $020f0f14624a1d9c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $020f0f14624a1d9c$var$vf(t);
                                x = $020f0f14624a1d9c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $020f0f14624a1d9c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $020f0f14624a1d9c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $020f0f14624a1d9c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $020f0f14624a1d9c$var$ve;
                else if ($020f0f14624a1d9c$var$me(h)) {
                    if ($020f0f14624a1d9c$var$we) na = $020f0f14624a1d9c$var$Fe;
                    else {
                        na = $020f0f14624a1d9c$var$De;
                        var xa = $020f0f14624a1d9c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $020f0f14624a1d9c$var$Ee);
                if (na && (na = na(a, d))) {
                    $020f0f14624a1d9c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $020f0f14624a1d9c$var$cb(h, "number", h.value);
            }
            xa = d ? $020f0f14624a1d9c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($020f0f14624a1d9c$var$me(xa) || "true" === xa.contentEditable) $020f0f14624a1d9c$var$Qe = xa, $020f0f14624a1d9c$var$Re = d, $020f0f14624a1d9c$var$Se = null;
                    break;
                case "focusout":
                    $020f0f14624a1d9c$var$Se = $020f0f14624a1d9c$var$Re = $020f0f14624a1d9c$var$Qe = null;
                    break;
                case "mousedown":
                    $020f0f14624a1d9c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $020f0f14624a1d9c$var$Te = !1;
                    $020f0f14624a1d9c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($020f0f14624a1d9c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $020f0f14624a1d9c$var$Ue(g, c, e);
            }
            var $a;
            if ($020f0f14624a1d9c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $020f0f14624a1d9c$var$ie ? $020f0f14624a1d9c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($020f0f14624a1d9c$var$de && "ko" !== c.locale && ($020f0f14624a1d9c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $020f0f14624a1d9c$var$ie && ($a = $020f0f14624a1d9c$var$nd()) : ($020f0f14624a1d9c$var$kd = e, $020f0f14624a1d9c$var$ld = "value" in $020f0f14624a1d9c$var$kd ? $020f0f14624a1d9c$var$kd.value : $020f0f14624a1d9c$var$kd.textContent, $020f0f14624a1d9c$var$ie = !0)), xa = $020f0f14624a1d9c$var$oe(d, ba), 0 < xa.length && (ba = new $020f0f14624a1d9c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $020f0f14624a1d9c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $020f0f14624a1d9c$var$ce ? $020f0f14624a1d9c$var$je(a, c) : $020f0f14624a1d9c$var$ke(a, c)) d = $020f0f14624a1d9c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $020f0f14624a1d9c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $020f0f14624a1d9c$var$se(g, b);
    });
}
function $020f0f14624a1d9c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $020f0f14624a1d9c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $020f0f14624a1d9c$var$Kb(a, c), null != f && d.unshift($020f0f14624a1d9c$var$tf(a, f, e)), f = $020f0f14624a1d9c$var$Kb(a, b), null != f && d.push($020f0f14624a1d9c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $020f0f14624a1d9c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $020f0f14624a1d9c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $020f0f14624a1d9c$var$Kb(c, f), null != k && g.unshift($020f0f14624a1d9c$var$tf(c, k, h))) : e || (k = $020f0f14624a1d9c$var$Kb(c, f), null != k && g.push($020f0f14624a1d9c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $020f0f14624a1d9c$var$xf = /\r\n?/g, $020f0f14624a1d9c$var$yf = /\u0000|\uFFFD/g;
function $020f0f14624a1d9c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($020f0f14624a1d9c$var$xf, "\n").replace($020f0f14624a1d9c$var$yf, "");
}
function $020f0f14624a1d9c$var$Af(a, b, c) {
    b = $020f0f14624a1d9c$var$zf(b);
    if ($020f0f14624a1d9c$var$zf(a) !== b && c) throw Error($020f0f14624a1d9c$var$p(425));
}
function $020f0f14624a1d9c$var$Bf() {}
var $020f0f14624a1d9c$var$Cf = null, $020f0f14624a1d9c$var$Df = null;
function $020f0f14624a1d9c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $020f0f14624a1d9c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $020f0f14624a1d9c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $020f0f14624a1d9c$var$Hf = "function" === typeof Promise ? Promise : void 0, $020f0f14624a1d9c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $020f0f14624a1d9c$var$Hf ? function(a) {
    return $020f0f14624a1d9c$var$Hf.resolve(null).then(a).catch($020f0f14624a1d9c$var$If);
} : $020f0f14624a1d9c$var$Ff;
function $020f0f14624a1d9c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $020f0f14624a1d9c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $020f0f14624a1d9c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $020f0f14624a1d9c$var$bd(b);
}
function $020f0f14624a1d9c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $020f0f14624a1d9c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $020f0f14624a1d9c$var$Nf = Math.random().toString(36).slice(2), $020f0f14624a1d9c$var$Of = "__reactFiber$" + $020f0f14624a1d9c$var$Nf, $020f0f14624a1d9c$var$Pf = "__reactProps$" + $020f0f14624a1d9c$var$Nf, $020f0f14624a1d9c$var$uf = "__reactContainer$" + $020f0f14624a1d9c$var$Nf, $020f0f14624a1d9c$var$of = "__reactEvents$" + $020f0f14624a1d9c$var$Nf, $020f0f14624a1d9c$var$Qf = "__reactListeners$" + $020f0f14624a1d9c$var$Nf, $020f0f14624a1d9c$var$Rf = "__reactHandles$" + $020f0f14624a1d9c$var$Nf;
function $020f0f14624a1d9c$var$Wc(a) {
    var b = a[$020f0f14624a1d9c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$020f0f14624a1d9c$var$uf] || c[$020f0f14624a1d9c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $020f0f14624a1d9c$var$Mf(a); null !== a;){
                if (c = a[$020f0f14624a1d9c$var$Of]) return c;
                a = $020f0f14624a1d9c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $020f0f14624a1d9c$var$Cb(a) {
    a = a[$020f0f14624a1d9c$var$Of] || a[$020f0f14624a1d9c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $020f0f14624a1d9c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($020f0f14624a1d9c$var$p(33));
}
function $020f0f14624a1d9c$var$Db(a) {
    return a[$020f0f14624a1d9c$var$Pf] || null;
}
var $020f0f14624a1d9c$var$Sf = [], $020f0f14624a1d9c$var$Tf = -1;
function $020f0f14624a1d9c$var$Uf(a) {
    return {
        current: a
    };
}
function $020f0f14624a1d9c$var$E(a) {
    0 > $020f0f14624a1d9c$var$Tf || (a.current = $020f0f14624a1d9c$var$Sf[$020f0f14624a1d9c$var$Tf], $020f0f14624a1d9c$var$Sf[$020f0f14624a1d9c$var$Tf] = null, $020f0f14624a1d9c$var$Tf--);
}
function $020f0f14624a1d9c$var$G(a, b) {
    $020f0f14624a1d9c$var$Tf++;
    $020f0f14624a1d9c$var$Sf[$020f0f14624a1d9c$var$Tf] = a.current;
    a.current = b;
}
var $020f0f14624a1d9c$var$Vf = {}, $020f0f14624a1d9c$var$H = $020f0f14624a1d9c$var$Uf($020f0f14624a1d9c$var$Vf), $020f0f14624a1d9c$var$Wf = $020f0f14624a1d9c$var$Uf(!1), $020f0f14624a1d9c$var$Xf = $020f0f14624a1d9c$var$Vf;
function $020f0f14624a1d9c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $020f0f14624a1d9c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $020f0f14624a1d9c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $020f0f14624a1d9c$var$$f() {
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf);
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$H);
}
function $020f0f14624a1d9c$var$ag(a, b, c) {
    if ($020f0f14624a1d9c$var$H.current !== $020f0f14624a1d9c$var$Vf) throw Error($020f0f14624a1d9c$var$p(168));
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$H, b);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Wf, c);
}
function $020f0f14624a1d9c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($020f0f14624a1d9c$var$p(108, $020f0f14624a1d9c$var$Ra(a) || "Unknown", e));
    return $020f0f14624a1d9c$var$A({}, c, d);
}
function $020f0f14624a1d9c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $020f0f14624a1d9c$var$Vf;
    $020f0f14624a1d9c$var$Xf = $020f0f14624a1d9c$var$H.current;
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$H, a);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Wf, $020f0f14624a1d9c$var$Wf.current);
    return !0;
}
function $020f0f14624a1d9c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($020f0f14624a1d9c$var$p(169));
    c ? (a = $020f0f14624a1d9c$var$bg(a, b, $020f0f14624a1d9c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf), $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$H), $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$H, a)) : $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Wf, c);
}
var $020f0f14624a1d9c$var$eg = null, $020f0f14624a1d9c$var$fg = !1, $020f0f14624a1d9c$var$gg = !1;
function $020f0f14624a1d9c$var$hg(a) {
    null === $020f0f14624a1d9c$var$eg ? $020f0f14624a1d9c$var$eg = [
        a
    ] : $020f0f14624a1d9c$var$eg.push(a);
}
function $020f0f14624a1d9c$var$ig(a) {
    $020f0f14624a1d9c$var$fg = !0;
    $020f0f14624a1d9c$var$hg(a);
}
function $020f0f14624a1d9c$var$jg() {
    if (!$020f0f14624a1d9c$var$gg && null !== $020f0f14624a1d9c$var$eg) {
        $020f0f14624a1d9c$var$gg = !0;
        var a = 0, b = $020f0f14624a1d9c$var$C;
        try {
            var c = $020f0f14624a1d9c$var$eg;
            for($020f0f14624a1d9c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $020f0f14624a1d9c$var$eg = null;
            $020f0f14624a1d9c$var$fg = !1;
        } catch (e) {
            throw null !== $020f0f14624a1d9c$var$eg && ($020f0f14624a1d9c$var$eg = $020f0f14624a1d9c$var$eg.slice(a + 1)), $020f0f14624a1d9c$var$ac($020f0f14624a1d9c$var$fc, $020f0f14624a1d9c$var$jg), e;
        } finally{
            $020f0f14624a1d9c$var$C = b, $020f0f14624a1d9c$var$gg = !1;
        }
    }
    return null;
}
var $020f0f14624a1d9c$var$kg = [], $020f0f14624a1d9c$var$lg = 0, $020f0f14624a1d9c$var$mg = null, $020f0f14624a1d9c$var$ng = 0, $020f0f14624a1d9c$var$og = [], $020f0f14624a1d9c$var$pg = 0, $020f0f14624a1d9c$var$qg = null, $020f0f14624a1d9c$var$rg = 1, $020f0f14624a1d9c$var$sg = "";
function $020f0f14624a1d9c$var$tg(a, b) {
    $020f0f14624a1d9c$var$kg[$020f0f14624a1d9c$var$lg++] = $020f0f14624a1d9c$var$ng;
    $020f0f14624a1d9c$var$kg[$020f0f14624a1d9c$var$lg++] = $020f0f14624a1d9c$var$mg;
    $020f0f14624a1d9c$var$mg = a;
    $020f0f14624a1d9c$var$ng = b;
}
function $020f0f14624a1d9c$var$ug(a, b, c) {
    $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$rg;
    $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$sg;
    $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$qg;
    $020f0f14624a1d9c$var$qg = a;
    var d = $020f0f14624a1d9c$var$rg;
    a = $020f0f14624a1d9c$var$sg;
    var e = 32 - $020f0f14624a1d9c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $020f0f14624a1d9c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $020f0f14624a1d9c$var$rg = 1 << 32 - $020f0f14624a1d9c$var$oc(b) + e | c << e | d;
        $020f0f14624a1d9c$var$sg = f + a;
    } else $020f0f14624a1d9c$var$rg = 1 << f | c << e | d, $020f0f14624a1d9c$var$sg = a;
}
function $020f0f14624a1d9c$var$vg(a) {
    null !== a.return && ($020f0f14624a1d9c$var$tg(a, 1), $020f0f14624a1d9c$var$ug(a, 1, 0));
}
function $020f0f14624a1d9c$var$wg(a) {
    for(; a === $020f0f14624a1d9c$var$mg;)$020f0f14624a1d9c$var$mg = $020f0f14624a1d9c$var$kg[--$020f0f14624a1d9c$var$lg], $020f0f14624a1d9c$var$kg[$020f0f14624a1d9c$var$lg] = null, $020f0f14624a1d9c$var$ng = $020f0f14624a1d9c$var$kg[--$020f0f14624a1d9c$var$lg], $020f0f14624a1d9c$var$kg[$020f0f14624a1d9c$var$lg] = null;
    for(; a === $020f0f14624a1d9c$var$qg;)$020f0f14624a1d9c$var$qg = $020f0f14624a1d9c$var$og[--$020f0f14624a1d9c$var$pg], $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg] = null, $020f0f14624a1d9c$var$sg = $020f0f14624a1d9c$var$og[--$020f0f14624a1d9c$var$pg], $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg] = null, $020f0f14624a1d9c$var$rg = $020f0f14624a1d9c$var$og[--$020f0f14624a1d9c$var$pg], $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg] = null;
}
var $020f0f14624a1d9c$var$xg = null, $020f0f14624a1d9c$var$yg = null, $020f0f14624a1d9c$var$I = !1, $020f0f14624a1d9c$var$zg = null;
function $020f0f14624a1d9c$var$Ag(a, b) {
    var c = $020f0f14624a1d9c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $020f0f14624a1d9c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $020f0f14624a1d9c$var$xg = a, $020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $020f0f14624a1d9c$var$xg = a, $020f0f14624a1d9c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $020f0f14624a1d9c$var$qg ? {
                id: $020f0f14624a1d9c$var$rg,
                overflow: $020f0f14624a1d9c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $020f0f14624a1d9c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $020f0f14624a1d9c$var$xg = a, $020f0f14624a1d9c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $020f0f14624a1d9c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $020f0f14624a1d9c$var$Eg(a) {
    if ($020f0f14624a1d9c$var$I) {
        var b = $020f0f14624a1d9c$var$yg;
        if (b) {
            var c = b;
            if (!$020f0f14624a1d9c$var$Cg(a, b)) {
                if ($020f0f14624a1d9c$var$Dg(a)) throw Error($020f0f14624a1d9c$var$p(418));
                b = $020f0f14624a1d9c$var$Lf(c.nextSibling);
                var d = $020f0f14624a1d9c$var$xg;
                b && $020f0f14624a1d9c$var$Cg(a, b) ? $020f0f14624a1d9c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $020f0f14624a1d9c$var$I = !1, $020f0f14624a1d9c$var$xg = a);
            }
        } else {
            if ($020f0f14624a1d9c$var$Dg(a)) throw Error($020f0f14624a1d9c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $020f0f14624a1d9c$var$I = !1;
            $020f0f14624a1d9c$var$xg = a;
        }
    }
}
function $020f0f14624a1d9c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $020f0f14624a1d9c$var$xg = a;
}
function $020f0f14624a1d9c$var$Gg(a) {
    if (a !== $020f0f14624a1d9c$var$xg) return !1;
    if (!$020f0f14624a1d9c$var$I) return $020f0f14624a1d9c$var$Fg(a), $020f0f14624a1d9c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$020f0f14624a1d9c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $020f0f14624a1d9c$var$yg)) {
        if ($020f0f14624a1d9c$var$Dg(a)) throw $020f0f14624a1d9c$var$Hg(), Error($020f0f14624a1d9c$var$p(418));
        for(; b;)$020f0f14624a1d9c$var$Ag(a, b), b = $020f0f14624a1d9c$var$Lf(b.nextSibling);
    }
    $020f0f14624a1d9c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($020f0f14624a1d9c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $020f0f14624a1d9c$var$yg = null;
        }
    } else $020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$xg ? $020f0f14624a1d9c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $020f0f14624a1d9c$var$Hg() {
    for(var a = $020f0f14624a1d9c$var$yg; a;)a = $020f0f14624a1d9c$var$Lf(a.nextSibling);
}
function $020f0f14624a1d9c$var$Ig() {
    $020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$xg = null;
    $020f0f14624a1d9c$var$I = !1;
}
function $020f0f14624a1d9c$var$Jg(a) {
    null === $020f0f14624a1d9c$var$zg ? $020f0f14624a1d9c$var$zg = [
        a
    ] : $020f0f14624a1d9c$var$zg.push(a);
}
var $020f0f14624a1d9c$var$Kg = $020f0f14624a1d9c$var$ua.ReactCurrentBatchConfig;
function $020f0f14624a1d9c$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $020f0f14624a1d9c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $020f0f14624a1d9c$var$Mg = $020f0f14624a1d9c$var$Uf(null), $020f0f14624a1d9c$var$Ng = null, $020f0f14624a1d9c$var$Og = null, $020f0f14624a1d9c$var$Pg = null;
function $020f0f14624a1d9c$var$Qg() {
    $020f0f14624a1d9c$var$Pg = $020f0f14624a1d9c$var$Og = $020f0f14624a1d9c$var$Ng = null;
}
function $020f0f14624a1d9c$var$Rg(a) {
    var b = $020f0f14624a1d9c$var$Mg.current;
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Mg);
    a._currentValue = b;
}
function $020f0f14624a1d9c$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $020f0f14624a1d9c$var$Tg(a, b) {
    $020f0f14624a1d9c$var$Ng = a;
    $020f0f14624a1d9c$var$Pg = $020f0f14624a1d9c$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($020f0f14624a1d9c$var$Ug = !0), a.firstContext = null);
}
function $020f0f14624a1d9c$var$Vg(a) {
    var b = a._currentValue;
    if ($020f0f14624a1d9c$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $020f0f14624a1d9c$var$Og) {
            if (null === $020f0f14624a1d9c$var$Ng) throw Error($020f0f14624a1d9c$var$p(308));
            $020f0f14624a1d9c$var$Og = a;
            $020f0f14624a1d9c$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $020f0f14624a1d9c$var$Og = $020f0f14624a1d9c$var$Og.next = a;
    }
    return b;
}
var $020f0f14624a1d9c$var$Wg = null;
function $020f0f14624a1d9c$var$Xg(a) {
    null === $020f0f14624a1d9c$var$Wg ? $020f0f14624a1d9c$var$Wg = [
        a
    ] : $020f0f14624a1d9c$var$Wg.push(a);
}
function $020f0f14624a1d9c$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $020f0f14624a1d9c$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $020f0f14624a1d9c$var$Zg(a, d);
}
function $020f0f14624a1d9c$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $020f0f14624a1d9c$var$$g = !1;
function $020f0f14624a1d9c$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $020f0f14624a1d9c$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $020f0f14624a1d9c$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $020f0f14624a1d9c$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($020f0f14624a1d9c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $020f0f14624a1d9c$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $020f0f14624a1d9c$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $020f0f14624a1d9c$var$Zg(a, c);
}
function $020f0f14624a1d9c$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $020f0f14624a1d9c$var$Cc(a, c);
    }
}
function $020f0f14624a1d9c$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $020f0f14624a1d9c$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $020f0f14624a1d9c$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $020f0f14624a1d9c$var$A({}, q, r);
                            break a;
                        case 2:
                            $020f0f14624a1d9c$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $020f0f14624a1d9c$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $020f0f14624a1d9c$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($020f0f14624a1d9c$var$p(191, e));
            e.call(d);
        }
    }
}
var $020f0f14624a1d9c$var$jh = (new $50vd1.Component).refs;
function $020f0f14624a1d9c$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $020f0f14624a1d9c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $020f0f14624a1d9c$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $020f0f14624a1d9c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $020f0f14624a1d9c$var$L(), e = $020f0f14624a1d9c$var$lh(a), f = $020f0f14624a1d9c$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $020f0f14624a1d9c$var$dh(a, f, e);
        null !== b && ($020f0f14624a1d9c$var$mh(b, a, e, d), $020f0f14624a1d9c$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $020f0f14624a1d9c$var$L(), e = $020f0f14624a1d9c$var$lh(a), f = $020f0f14624a1d9c$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $020f0f14624a1d9c$var$dh(a, f, e);
        null !== b && ($020f0f14624a1d9c$var$mh(b, a, e, d), $020f0f14624a1d9c$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $020f0f14624a1d9c$var$L(), d = $020f0f14624a1d9c$var$lh(a), e = $020f0f14624a1d9c$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $020f0f14624a1d9c$var$dh(a, e, d);
        null !== b && ($020f0f14624a1d9c$var$mh(b, a, d, c), $020f0f14624a1d9c$var$eh(b, a, d));
    }
};
function $020f0f14624a1d9c$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$020f0f14624a1d9c$var$Ie(c, d) || !$020f0f14624a1d9c$var$Ie(e, f) : !0;
}
function $020f0f14624a1d9c$var$ph(a, b, c) {
    var d = !1, e = $020f0f14624a1d9c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $020f0f14624a1d9c$var$Vg(f) : (e = $020f0f14624a1d9c$var$Zf(b) ? $020f0f14624a1d9c$var$Xf : $020f0f14624a1d9c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $020f0f14624a1d9c$var$Yf(a, e) : $020f0f14624a1d9c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $020f0f14624a1d9c$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $020f0f14624a1d9c$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $020f0f14624a1d9c$var$nh.enqueueReplaceState(b, b.state, null);
}
function $020f0f14624a1d9c$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $020f0f14624a1d9c$var$jh;
    $020f0f14624a1d9c$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $020f0f14624a1d9c$var$Vg(f) : (f = $020f0f14624a1d9c$var$Zf(b) ? $020f0f14624a1d9c$var$Xf : $020f0f14624a1d9c$var$H.current, e.context = $020f0f14624a1d9c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($020f0f14624a1d9c$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $020f0f14624a1d9c$var$nh.enqueueReplaceState(e, e.state, null), $020f0f14624a1d9c$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $020f0f14624a1d9c$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($020f0f14624a1d9c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($020f0f14624a1d9c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $020f0f14624a1d9c$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($020f0f14624a1d9c$var$p(284));
        if (!c._owner) throw Error($020f0f14624a1d9c$var$p(290, a));
    }
    return a;
}
function $020f0f14624a1d9c$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($020f0f14624a1d9c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $020f0f14624a1d9c$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $020f0f14624a1d9c$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $020f0f14624a1d9c$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $020f0f14624a1d9c$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $020f0f14624a1d9c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $020f0f14624a1d9c$var$Ha && $020f0f14624a1d9c$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $020f0f14624a1d9c$var$sh(a, b, c), d.return = a, d;
        d = $020f0f14624a1d9c$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $020f0f14624a1d9c$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $020f0f14624a1d9c$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $020f0f14624a1d9c$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $020f0f14624a1d9c$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $020f0f14624a1d9c$var$va:
                    return c = $020f0f14624a1d9c$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $020f0f14624a1d9c$var$sh(a, null, b), c.return = a, c;
                case $020f0f14624a1d9c$var$wa:
                    return b = $020f0f14624a1d9c$var$zh(b, a.mode, c), b.return = a, b;
                case $020f0f14624a1d9c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($020f0f14624a1d9c$var$eb(b) || $020f0f14624a1d9c$var$Ka(b)) return b = $020f0f14624a1d9c$var$Ah(b, a.mode, c, null), b.return = a, b;
            $020f0f14624a1d9c$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $020f0f14624a1d9c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $020f0f14624a1d9c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $020f0f14624a1d9c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($020f0f14624a1d9c$var$eb(c) || $020f0f14624a1d9c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $020f0f14624a1d9c$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $020f0f14624a1d9c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $020f0f14624a1d9c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $020f0f14624a1d9c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($020f0f14624a1d9c$var$eb(d) || $020f0f14624a1d9c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $020f0f14624a1d9c$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $020f0f14624a1d9c$var$Ka(h);
        if ("function" !== typeof l) throw Error($020f0f14624a1d9c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($020f0f14624a1d9c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $020f0f14624a1d9c$var$I && $020f0f14624a1d9c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $020f0f14624a1d9c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $020f0f14624a1d9c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $020f0f14624a1d9c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $020f0f14624a1d9c$var$Ha && $020f0f14624a1d9c$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $020f0f14624a1d9c$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $020f0f14624a1d9c$var$ya ? (d = $020f0f14624a1d9c$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $020f0f14624a1d9c$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $020f0f14624a1d9c$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $020f0f14624a1d9c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $020f0f14624a1d9c$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $020f0f14624a1d9c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($020f0f14624a1d9c$var$eb(f)) return n(a, d, f, h);
            if ($020f0f14624a1d9c$var$Ka(f)) return t(a, d, f, h);
            $020f0f14624a1d9c$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $020f0f14624a1d9c$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $020f0f14624a1d9c$var$Bh = $020f0f14624a1d9c$var$vh(!0), $020f0f14624a1d9c$var$Ch = $020f0f14624a1d9c$var$vh(!1), $020f0f14624a1d9c$var$Dh = {}, $020f0f14624a1d9c$var$Eh = $020f0f14624a1d9c$var$Uf($020f0f14624a1d9c$var$Dh), $020f0f14624a1d9c$var$Fh = $020f0f14624a1d9c$var$Uf($020f0f14624a1d9c$var$Dh), $020f0f14624a1d9c$var$Gh = $020f0f14624a1d9c$var$Uf($020f0f14624a1d9c$var$Dh);
function $020f0f14624a1d9c$var$Hh(a) {
    if (a === $020f0f14624a1d9c$var$Dh) throw Error($020f0f14624a1d9c$var$p(174));
    return a;
}
function $020f0f14624a1d9c$var$Ih(a, b) {
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Gh, b);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Fh, a);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Eh, $020f0f14624a1d9c$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $020f0f14624a1d9c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $020f0f14624a1d9c$var$lb(b, a);
    }
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Eh);
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Eh, b);
}
function $020f0f14624a1d9c$var$Jh() {
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Eh);
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Fh);
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Gh);
}
function $020f0f14624a1d9c$var$Kh(a) {
    $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Gh.current);
    var b = $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Eh.current);
    var c = $020f0f14624a1d9c$var$lb(b, a.type);
    b !== c && ($020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Fh, a), $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Eh, c));
}
function $020f0f14624a1d9c$var$Lh(a) {
    $020f0f14624a1d9c$var$Fh.current === a && ($020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Eh), $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Fh));
}
var $020f0f14624a1d9c$var$M = $020f0f14624a1d9c$var$Uf(0);
function $020f0f14624a1d9c$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $020f0f14624a1d9c$var$Nh = [];
function $020f0f14624a1d9c$var$Oh() {
    for(var a = 0; a < $020f0f14624a1d9c$var$Nh.length; a++)$020f0f14624a1d9c$var$Nh[a]._workInProgressVersionPrimary = null;
    $020f0f14624a1d9c$var$Nh.length = 0;
}
var $020f0f14624a1d9c$var$Ph = $020f0f14624a1d9c$var$ua.ReactCurrentDispatcher, $020f0f14624a1d9c$var$Qh = $020f0f14624a1d9c$var$ua.ReactCurrentBatchConfig, $020f0f14624a1d9c$var$Rh = 0, $020f0f14624a1d9c$var$N = null, $020f0f14624a1d9c$var$O = null, $020f0f14624a1d9c$var$P = null, $020f0f14624a1d9c$var$Sh = !1, $020f0f14624a1d9c$var$Th = !1, $020f0f14624a1d9c$var$Uh = 0, $020f0f14624a1d9c$var$Vh = 0;
function $020f0f14624a1d9c$var$Q() {
    throw Error($020f0f14624a1d9c$var$p(321));
}
function $020f0f14624a1d9c$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$020f0f14624a1d9c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $020f0f14624a1d9c$var$Xh(a, b, c, d, e, f) {
    $020f0f14624a1d9c$var$Rh = f;
    $020f0f14624a1d9c$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $020f0f14624a1d9c$var$Ph.current = null === a || null === a.memoizedState ? $020f0f14624a1d9c$var$Yh : $020f0f14624a1d9c$var$Zh;
    a = c(d, e);
    if ($020f0f14624a1d9c$var$Th) {
        f = 0;
        do {
            $020f0f14624a1d9c$var$Th = !1;
            $020f0f14624a1d9c$var$Uh = 0;
            if (25 <= f) throw Error($020f0f14624a1d9c$var$p(301));
            f += 1;
            $020f0f14624a1d9c$var$P = $020f0f14624a1d9c$var$O = null;
            b.updateQueue = null;
            $020f0f14624a1d9c$var$Ph.current = $020f0f14624a1d9c$var$$h;
            a = c(d, e);
        }while ($020f0f14624a1d9c$var$Th);
    }
    $020f0f14624a1d9c$var$Ph.current = $020f0f14624a1d9c$var$ai;
    b = null !== $020f0f14624a1d9c$var$O && null !== $020f0f14624a1d9c$var$O.next;
    $020f0f14624a1d9c$var$Rh = 0;
    $020f0f14624a1d9c$var$P = $020f0f14624a1d9c$var$O = $020f0f14624a1d9c$var$N = null;
    $020f0f14624a1d9c$var$Sh = !1;
    if (b) throw Error($020f0f14624a1d9c$var$p(300));
    return a;
}
function $020f0f14624a1d9c$var$bi() {
    var a = 0 !== $020f0f14624a1d9c$var$Uh;
    $020f0f14624a1d9c$var$Uh = 0;
    return a;
}
function $020f0f14624a1d9c$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $020f0f14624a1d9c$var$P ? $020f0f14624a1d9c$var$N.memoizedState = $020f0f14624a1d9c$var$P = a : $020f0f14624a1d9c$var$P = $020f0f14624a1d9c$var$P.next = a;
    return $020f0f14624a1d9c$var$P;
}
function $020f0f14624a1d9c$var$di() {
    if (null === $020f0f14624a1d9c$var$O) {
        var a = $020f0f14624a1d9c$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $020f0f14624a1d9c$var$O.next;
    var b = null === $020f0f14624a1d9c$var$P ? $020f0f14624a1d9c$var$N.memoizedState : $020f0f14624a1d9c$var$P.next;
    if (null !== b) $020f0f14624a1d9c$var$P = b, $020f0f14624a1d9c$var$O = a;
    else {
        if (null === a) throw Error($020f0f14624a1d9c$var$p(310));
        $020f0f14624a1d9c$var$O = a;
        a = {
            memoizedState: $020f0f14624a1d9c$var$O.memoizedState,
            baseState: $020f0f14624a1d9c$var$O.baseState,
            baseQueue: $020f0f14624a1d9c$var$O.baseQueue,
            queue: $020f0f14624a1d9c$var$O.queue,
            next: null
        };
        null === $020f0f14624a1d9c$var$P ? $020f0f14624a1d9c$var$N.memoizedState = $020f0f14624a1d9c$var$P = a : $020f0f14624a1d9c$var$P = $020f0f14624a1d9c$var$P.next = a;
    }
    return $020f0f14624a1d9c$var$P;
}
function $020f0f14624a1d9c$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $020f0f14624a1d9c$var$fi(a) {
    var b = $020f0f14624a1d9c$var$di(), c = b.queue;
    if (null === c) throw Error($020f0f14624a1d9c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $020f0f14624a1d9c$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($020f0f14624a1d9c$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $020f0f14624a1d9c$var$N.lanes |= m;
                $020f0f14624a1d9c$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $020f0f14624a1d9c$var$He(d, b.memoizedState) || ($020f0f14624a1d9c$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $020f0f14624a1d9c$var$N.lanes |= f, $020f0f14624a1d9c$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $020f0f14624a1d9c$var$gi(a) {
    var b = $020f0f14624a1d9c$var$di(), c = b.queue;
    if (null === c) throw Error($020f0f14624a1d9c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $020f0f14624a1d9c$var$He(f, b.memoizedState) || ($020f0f14624a1d9c$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $020f0f14624a1d9c$var$hi() {}
function $020f0f14624a1d9c$var$ii(a, b) {
    var c = $020f0f14624a1d9c$var$N, d = $020f0f14624a1d9c$var$di(), e = b(), f = !$020f0f14624a1d9c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $020f0f14624a1d9c$var$Ug = !0);
    d = d.queue;
    $020f0f14624a1d9c$var$ji($020f0f14624a1d9c$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $020f0f14624a1d9c$var$P && $020f0f14624a1d9c$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $020f0f14624a1d9c$var$li(9, $020f0f14624a1d9c$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $020f0f14624a1d9c$var$R) throw Error($020f0f14624a1d9c$var$p(349));
        0 !== ($020f0f14624a1d9c$var$Rh & 30) || $020f0f14624a1d9c$var$ni(c, b, e);
    }
    return e;
}
function $020f0f14624a1d9c$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $020f0f14624a1d9c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $020f0f14624a1d9c$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $020f0f14624a1d9c$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $020f0f14624a1d9c$var$oi(b) && $020f0f14624a1d9c$var$pi(a);
}
function $020f0f14624a1d9c$var$ki(a, b, c) {
    return c(function() {
        $020f0f14624a1d9c$var$oi(b) && $020f0f14624a1d9c$var$pi(a);
    });
}
function $020f0f14624a1d9c$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$020f0f14624a1d9c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $020f0f14624a1d9c$var$pi(a) {
    var b = $020f0f14624a1d9c$var$Zg(a, 1);
    null !== b && $020f0f14624a1d9c$var$mh(b, a, 1, -1);
}
function $020f0f14624a1d9c$var$qi(a) {
    var b = $020f0f14624a1d9c$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $020f0f14624a1d9c$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $020f0f14624a1d9c$var$ri.bind(null, $020f0f14624a1d9c$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $020f0f14624a1d9c$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $020f0f14624a1d9c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $020f0f14624a1d9c$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $020f0f14624a1d9c$var$si() {
    return $020f0f14624a1d9c$var$di().memoizedState;
}
function $020f0f14624a1d9c$var$ti(a, b, c, d) {
    var e = $020f0f14624a1d9c$var$ci();
    $020f0f14624a1d9c$var$N.flags |= a;
    e.memoizedState = $020f0f14624a1d9c$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $020f0f14624a1d9c$var$ui(a, b, c, d) {
    var e = $020f0f14624a1d9c$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $020f0f14624a1d9c$var$O) {
        var g = $020f0f14624a1d9c$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $020f0f14624a1d9c$var$Wh(d, g.deps)) {
            e.memoizedState = $020f0f14624a1d9c$var$li(b, c, f, d);
            return;
        }
    }
    $020f0f14624a1d9c$var$N.flags |= a;
    e.memoizedState = $020f0f14624a1d9c$var$li(1 | b, c, f, d);
}
function $020f0f14624a1d9c$var$vi(a, b) {
    return $020f0f14624a1d9c$var$ti(8390656, 8, a, b);
}
function $020f0f14624a1d9c$var$ji(a, b) {
    return $020f0f14624a1d9c$var$ui(2048, 8, a, b);
}
function $020f0f14624a1d9c$var$wi(a, b) {
    return $020f0f14624a1d9c$var$ui(4, 2, a, b);
}
function $020f0f14624a1d9c$var$xi(a, b) {
    return $020f0f14624a1d9c$var$ui(4, 4, a, b);
}
function $020f0f14624a1d9c$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $020f0f14624a1d9c$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $020f0f14624a1d9c$var$ui(4, 4, $020f0f14624a1d9c$var$yi.bind(null, b, a), c);
}
function $020f0f14624a1d9c$var$Ai() {}
function $020f0f14624a1d9c$var$Bi(a, b) {
    var c = $020f0f14624a1d9c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $020f0f14624a1d9c$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $020f0f14624a1d9c$var$Ci(a, b) {
    var c = $020f0f14624a1d9c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $020f0f14624a1d9c$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $020f0f14624a1d9c$var$Di(a, b, c) {
    if (0 === ($020f0f14624a1d9c$var$Rh & 21)) return a.baseState && (a.baseState = !1, $020f0f14624a1d9c$var$Ug = !0), a.memoizedState = c;
    $020f0f14624a1d9c$var$He(c, b) || (c = $020f0f14624a1d9c$var$yc(), $020f0f14624a1d9c$var$N.lanes |= c, $020f0f14624a1d9c$var$hh |= c, a.baseState = !0);
    return b;
}
function $020f0f14624a1d9c$var$Ei(a, b) {
    var c = $020f0f14624a1d9c$var$C;
    $020f0f14624a1d9c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $020f0f14624a1d9c$var$Qh.transition;
    $020f0f14624a1d9c$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $020f0f14624a1d9c$var$C = c, $020f0f14624a1d9c$var$Qh.transition = d;
    }
}
function $020f0f14624a1d9c$var$Fi() {
    return $020f0f14624a1d9c$var$di().memoizedState;
}
function $020f0f14624a1d9c$var$Gi(a, b, c) {
    var d = $020f0f14624a1d9c$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($020f0f14624a1d9c$var$Hi(a)) $020f0f14624a1d9c$var$Ii(b, c);
    else if (c = $020f0f14624a1d9c$var$Yg(a, b, c, d), null !== c) {
        var e = $020f0f14624a1d9c$var$L();
        $020f0f14624a1d9c$var$mh(c, a, d, e);
        $020f0f14624a1d9c$var$Ji(c, b, d);
    }
}
function $020f0f14624a1d9c$var$ri(a, b, c) {
    var d = $020f0f14624a1d9c$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($020f0f14624a1d9c$var$Hi(a)) $020f0f14624a1d9c$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($020f0f14624a1d9c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $020f0f14624a1d9c$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $020f0f14624a1d9c$var$Yg(a, b, e, d);
        null !== c && (e = $020f0f14624a1d9c$var$L(), $020f0f14624a1d9c$var$mh(c, a, d, e), $020f0f14624a1d9c$var$Ji(c, b, d));
    }
}
function $020f0f14624a1d9c$var$Hi(a) {
    var b = a.alternate;
    return a === $020f0f14624a1d9c$var$N || null !== b && b === $020f0f14624a1d9c$var$N;
}
function $020f0f14624a1d9c$var$Ii(a, b) {
    $020f0f14624a1d9c$var$Th = $020f0f14624a1d9c$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $020f0f14624a1d9c$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $020f0f14624a1d9c$var$Cc(a, c);
    }
}
var $020f0f14624a1d9c$var$ai = {
    readContext: $020f0f14624a1d9c$var$Vg,
    useCallback: $020f0f14624a1d9c$var$Q,
    useContext: $020f0f14624a1d9c$var$Q,
    useEffect: $020f0f14624a1d9c$var$Q,
    useImperativeHandle: $020f0f14624a1d9c$var$Q,
    useInsertionEffect: $020f0f14624a1d9c$var$Q,
    useLayoutEffect: $020f0f14624a1d9c$var$Q,
    useMemo: $020f0f14624a1d9c$var$Q,
    useReducer: $020f0f14624a1d9c$var$Q,
    useRef: $020f0f14624a1d9c$var$Q,
    useState: $020f0f14624a1d9c$var$Q,
    useDebugValue: $020f0f14624a1d9c$var$Q,
    useDeferredValue: $020f0f14624a1d9c$var$Q,
    useTransition: $020f0f14624a1d9c$var$Q,
    useMutableSource: $020f0f14624a1d9c$var$Q,
    useSyncExternalStore: $020f0f14624a1d9c$var$Q,
    useId: $020f0f14624a1d9c$var$Q,
    unstable_isNewReconciler: !1
}, $020f0f14624a1d9c$var$Yh = {
    readContext: $020f0f14624a1d9c$var$Vg,
    useCallback: function(a, b) {
        $020f0f14624a1d9c$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $020f0f14624a1d9c$var$Vg,
    useEffect: $020f0f14624a1d9c$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $020f0f14624a1d9c$var$ti(4194308, 4, $020f0f14624a1d9c$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $020f0f14624a1d9c$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $020f0f14624a1d9c$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $020f0f14624a1d9c$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $020f0f14624a1d9c$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $020f0f14624a1d9c$var$Gi.bind(null, $020f0f14624a1d9c$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $020f0f14624a1d9c$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $020f0f14624a1d9c$var$qi,
    useDebugValue: $020f0f14624a1d9c$var$Ai,
    useDeferredValue: function(a) {
        return $020f0f14624a1d9c$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $020f0f14624a1d9c$var$qi(!1), b = a[0];
        a = $020f0f14624a1d9c$var$Ei.bind(null, a[1]);
        $020f0f14624a1d9c$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $020f0f14624a1d9c$var$N, e = $020f0f14624a1d9c$var$ci();
        if ($020f0f14624a1d9c$var$I) {
            if (void 0 === c) throw Error($020f0f14624a1d9c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $020f0f14624a1d9c$var$R) throw Error($020f0f14624a1d9c$var$p(349));
            0 !== ($020f0f14624a1d9c$var$Rh & 30) || $020f0f14624a1d9c$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $020f0f14624a1d9c$var$vi($020f0f14624a1d9c$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $020f0f14624a1d9c$var$li(9, $020f0f14624a1d9c$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $020f0f14624a1d9c$var$ci(), b = $020f0f14624a1d9c$var$R.identifierPrefix;
        if ($020f0f14624a1d9c$var$I) {
            var c = $020f0f14624a1d9c$var$sg;
            var d = $020f0f14624a1d9c$var$rg;
            c = (d & ~(1 << 32 - $020f0f14624a1d9c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $020f0f14624a1d9c$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $020f0f14624a1d9c$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $020f0f14624a1d9c$var$Zh = {
    readContext: $020f0f14624a1d9c$var$Vg,
    useCallback: $020f0f14624a1d9c$var$Bi,
    useContext: $020f0f14624a1d9c$var$Vg,
    useEffect: $020f0f14624a1d9c$var$ji,
    useImperativeHandle: $020f0f14624a1d9c$var$zi,
    useInsertionEffect: $020f0f14624a1d9c$var$wi,
    useLayoutEffect: $020f0f14624a1d9c$var$xi,
    useMemo: $020f0f14624a1d9c$var$Ci,
    useReducer: $020f0f14624a1d9c$var$fi,
    useRef: $020f0f14624a1d9c$var$si,
    useState: function() {
        return $020f0f14624a1d9c$var$fi($020f0f14624a1d9c$var$ei);
    },
    useDebugValue: $020f0f14624a1d9c$var$Ai,
    useDeferredValue: function(a) {
        var b = $020f0f14624a1d9c$var$di();
        return $020f0f14624a1d9c$var$Di(b, $020f0f14624a1d9c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $020f0f14624a1d9c$var$fi($020f0f14624a1d9c$var$ei)[0], b = $020f0f14624a1d9c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $020f0f14624a1d9c$var$hi,
    useSyncExternalStore: $020f0f14624a1d9c$var$ii,
    useId: $020f0f14624a1d9c$var$Fi,
    unstable_isNewReconciler: !1
}, $020f0f14624a1d9c$var$$h = {
    readContext: $020f0f14624a1d9c$var$Vg,
    useCallback: $020f0f14624a1d9c$var$Bi,
    useContext: $020f0f14624a1d9c$var$Vg,
    useEffect: $020f0f14624a1d9c$var$ji,
    useImperativeHandle: $020f0f14624a1d9c$var$zi,
    useInsertionEffect: $020f0f14624a1d9c$var$wi,
    useLayoutEffect: $020f0f14624a1d9c$var$xi,
    useMemo: $020f0f14624a1d9c$var$Ci,
    useReducer: $020f0f14624a1d9c$var$gi,
    useRef: $020f0f14624a1d9c$var$si,
    useState: function() {
        return $020f0f14624a1d9c$var$gi($020f0f14624a1d9c$var$ei);
    },
    useDebugValue: $020f0f14624a1d9c$var$Ai,
    useDeferredValue: function(a) {
        var b = $020f0f14624a1d9c$var$di();
        return null === $020f0f14624a1d9c$var$O ? b.memoizedState = a : $020f0f14624a1d9c$var$Di(b, $020f0f14624a1d9c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $020f0f14624a1d9c$var$gi($020f0f14624a1d9c$var$ei)[0], b = $020f0f14624a1d9c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $020f0f14624a1d9c$var$hi,
    useSyncExternalStore: $020f0f14624a1d9c$var$ii,
    useId: $020f0f14624a1d9c$var$Fi,
    unstable_isNewReconciler: !1
};
function $020f0f14624a1d9c$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $020f0f14624a1d9c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $020f0f14624a1d9c$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $020f0f14624a1d9c$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $020f0f14624a1d9c$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $020f0f14624a1d9c$var$Oi(a, b, c) {
    c = $020f0f14624a1d9c$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $020f0f14624a1d9c$var$Pi || ($020f0f14624a1d9c$var$Pi = !0, $020f0f14624a1d9c$var$Qi = d);
        $020f0f14624a1d9c$var$Mi(a, b);
    };
    return c;
}
function $020f0f14624a1d9c$var$Ri(a, b, c) {
    c = $020f0f14624a1d9c$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $020f0f14624a1d9c$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $020f0f14624a1d9c$var$Mi(a, b);
        "function" !== typeof d && (null === $020f0f14624a1d9c$var$Si ? $020f0f14624a1d9c$var$Si = new Set([
            this
        ]) : $020f0f14624a1d9c$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $020f0f14624a1d9c$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $020f0f14624a1d9c$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $020f0f14624a1d9c$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $020f0f14624a1d9c$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $020f0f14624a1d9c$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $020f0f14624a1d9c$var$ch(-1, 1), b.tag = 2, $020f0f14624a1d9c$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $020f0f14624a1d9c$var$Xi = $020f0f14624a1d9c$var$ua.ReactCurrentOwner, $020f0f14624a1d9c$var$Ug = !1;
function $020f0f14624a1d9c$var$Yi(a, b, c, d) {
    b.child = null === a ? $020f0f14624a1d9c$var$Ch(b, null, c, d) : $020f0f14624a1d9c$var$Bh(b, a.child, c, d);
}
function $020f0f14624a1d9c$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $020f0f14624a1d9c$var$Tg(b, e);
    d = $020f0f14624a1d9c$var$Xh(a, b, c, d, f, e);
    c = $020f0f14624a1d9c$var$bi();
    if (null !== a && !$020f0f14624a1d9c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $020f0f14624a1d9c$var$$i(a, b, e);
    $020f0f14624a1d9c$var$I && c && $020f0f14624a1d9c$var$vg(b);
    b.flags |= 1;
    $020f0f14624a1d9c$var$Yi(a, b, d, e);
    return b.child;
}
function $020f0f14624a1d9c$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$020f0f14624a1d9c$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $020f0f14624a1d9c$var$cj(a, b, f, d, e);
        a = $020f0f14624a1d9c$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $020f0f14624a1d9c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $020f0f14624a1d9c$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $020f0f14624a1d9c$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $020f0f14624a1d9c$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($020f0f14624a1d9c$var$Ie(f, d) && a.ref === b.ref) {
            if ($020f0f14624a1d9c$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($020f0f14624a1d9c$var$Ug = !0);
            else return b.lanes = a.lanes, $020f0f14624a1d9c$var$$i(a, b, e);
        }
    }
    return $020f0f14624a1d9c$var$dj(a, b, c, d, e);
}
function $020f0f14624a1d9c$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$fj, $020f0f14624a1d9c$var$gj), $020f0f14624a1d9c$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$fj, $020f0f14624a1d9c$var$gj), $020f0f14624a1d9c$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$fj, $020f0f14624a1d9c$var$gj);
            $020f0f14624a1d9c$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$fj, $020f0f14624a1d9c$var$gj), $020f0f14624a1d9c$var$gj |= d;
    $020f0f14624a1d9c$var$Yi(a, b, e, c);
    return b.child;
}
function $020f0f14624a1d9c$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $020f0f14624a1d9c$var$dj(a, b, c, d, e) {
    var f = $020f0f14624a1d9c$var$Zf(c) ? $020f0f14624a1d9c$var$Xf : $020f0f14624a1d9c$var$H.current;
    f = $020f0f14624a1d9c$var$Yf(b, f);
    $020f0f14624a1d9c$var$Tg(b, e);
    c = $020f0f14624a1d9c$var$Xh(a, b, c, d, f, e);
    d = $020f0f14624a1d9c$var$bi();
    if (null !== a && !$020f0f14624a1d9c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $020f0f14624a1d9c$var$$i(a, b, e);
    $020f0f14624a1d9c$var$I && d && $020f0f14624a1d9c$var$vg(b);
    b.flags |= 1;
    $020f0f14624a1d9c$var$Yi(a, b, c, e);
    return b.child;
}
function $020f0f14624a1d9c$var$ij(a, b, c, d, e) {
    if ($020f0f14624a1d9c$var$Zf(c)) {
        var f = !0;
        $020f0f14624a1d9c$var$cg(b);
    } else f = !1;
    $020f0f14624a1d9c$var$Tg(b, e);
    if (null === b.stateNode) $020f0f14624a1d9c$var$jj(a, b), $020f0f14624a1d9c$var$ph(b, c, d), $020f0f14624a1d9c$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $020f0f14624a1d9c$var$Vg(l) : (l = $020f0f14624a1d9c$var$Zf(c) ? $020f0f14624a1d9c$var$Xf : $020f0f14624a1d9c$var$H.current, l = $020f0f14624a1d9c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $020f0f14624a1d9c$var$qh(b, g, d, l);
        $020f0f14624a1d9c$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $020f0f14624a1d9c$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $020f0f14624a1d9c$var$Wf.current || $020f0f14624a1d9c$var$$g ? ("function" === typeof m && ($020f0f14624a1d9c$var$kh(b, c, m, d), k = b.memoizedState), (h = $020f0f14624a1d9c$var$$g || $020f0f14624a1d9c$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $020f0f14624a1d9c$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $020f0f14624a1d9c$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $020f0f14624a1d9c$var$Vg(k) : (k = $020f0f14624a1d9c$var$Zf(c) ? $020f0f14624a1d9c$var$Xf : $020f0f14624a1d9c$var$H.current, k = $020f0f14624a1d9c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $020f0f14624a1d9c$var$qh(b, g, d, k);
        $020f0f14624a1d9c$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $020f0f14624a1d9c$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $020f0f14624a1d9c$var$Wf.current || $020f0f14624a1d9c$var$$g ? ("function" === typeof y && ($020f0f14624a1d9c$var$kh(b, c, y, d), n = b.memoizedState), (l = $020f0f14624a1d9c$var$$g || $020f0f14624a1d9c$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $020f0f14624a1d9c$var$kj(a, b, c, d, f, e);
}
function $020f0f14624a1d9c$var$kj(a, b, c, d, e, f) {
    $020f0f14624a1d9c$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $020f0f14624a1d9c$var$dg(b, c, !1), $020f0f14624a1d9c$var$$i(a, b, f);
    d = b.stateNode;
    $020f0f14624a1d9c$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $020f0f14624a1d9c$var$Bh(b, a.child, null, f), b.child = $020f0f14624a1d9c$var$Bh(b, null, h, f)) : $020f0f14624a1d9c$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $020f0f14624a1d9c$var$dg(b, c, !0);
    return b.child;
}
function $020f0f14624a1d9c$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $020f0f14624a1d9c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $020f0f14624a1d9c$var$ag(a, b.context, !1);
    $020f0f14624a1d9c$var$Ih(a, b.containerInfo);
}
function $020f0f14624a1d9c$var$mj(a, b, c, d, e) {
    $020f0f14624a1d9c$var$Ig();
    $020f0f14624a1d9c$var$Jg(e);
    b.flags |= 256;
    $020f0f14624a1d9c$var$Yi(a, b, c, d);
    return b.child;
}
var $020f0f14624a1d9c$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $020f0f14624a1d9c$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $020f0f14624a1d9c$var$pj(a, b, c) {
    var d = b.pendingProps, e = $020f0f14624a1d9c$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, e & 1);
    if (null === a) {
        $020f0f14624a1d9c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $020f0f14624a1d9c$var$qj(g, d, 0, null), a = $020f0f14624a1d9c$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $020f0f14624a1d9c$var$oj(c), b.memoizedState = $020f0f14624a1d9c$var$nj, a) : $020f0f14624a1d9c$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $020f0f14624a1d9c$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $020f0f14624a1d9c$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $020f0f14624a1d9c$var$wh(h, f) : (f = $020f0f14624a1d9c$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $020f0f14624a1d9c$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $020f0f14624a1d9c$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $020f0f14624a1d9c$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $020f0f14624a1d9c$var$rj(a, b) {
    b = $020f0f14624a1d9c$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $020f0f14624a1d9c$var$tj(a, b, c, d) {
    null !== d && $020f0f14624a1d9c$var$Jg(d);
    $020f0f14624a1d9c$var$Bh(b, a.child, null, c);
    a = $020f0f14624a1d9c$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $020f0f14624a1d9c$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $020f0f14624a1d9c$var$Li(Error($020f0f14624a1d9c$var$p(422))), $020f0f14624a1d9c$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $020f0f14624a1d9c$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $020f0f14624a1d9c$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $020f0f14624a1d9c$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $020f0f14624a1d9c$var$oj(g);
        b.memoizedState = $020f0f14624a1d9c$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $020f0f14624a1d9c$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($020f0f14624a1d9c$var$p(419));
        d = $020f0f14624a1d9c$var$Li(f, d, void 0);
        return $020f0f14624a1d9c$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($020f0f14624a1d9c$var$Ug || h) {
        d = $020f0f14624a1d9c$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $020f0f14624a1d9c$var$Zg(a, e), $020f0f14624a1d9c$var$mh(d, a, e, -1));
        }
        $020f0f14624a1d9c$var$uj();
        d = $020f0f14624a1d9c$var$Li(Error($020f0f14624a1d9c$var$p(421)));
        return $020f0f14624a1d9c$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $020f0f14624a1d9c$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$Lf(e.nextSibling);
    $020f0f14624a1d9c$var$xg = b;
    $020f0f14624a1d9c$var$I = !0;
    $020f0f14624a1d9c$var$zg = null;
    null !== a && ($020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$rg, $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$sg, $020f0f14624a1d9c$var$og[$020f0f14624a1d9c$var$pg++] = $020f0f14624a1d9c$var$qg, $020f0f14624a1d9c$var$rg = a.id, $020f0f14624a1d9c$var$sg = a.overflow, $020f0f14624a1d9c$var$qg = b);
    b = $020f0f14624a1d9c$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $020f0f14624a1d9c$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $020f0f14624a1d9c$var$Sg(a.return, b, c);
}
function $020f0f14624a1d9c$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $020f0f14624a1d9c$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $020f0f14624a1d9c$var$Yi(a, b, d.children, c);
    d = $020f0f14624a1d9c$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $020f0f14624a1d9c$var$wj(a, c, b);
            else if (19 === a.tag) $020f0f14624a1d9c$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $020f0f14624a1d9c$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $020f0f14624a1d9c$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $020f0f14624a1d9c$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $020f0f14624a1d9c$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $020f0f14624a1d9c$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $020f0f14624a1d9c$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $020f0f14624a1d9c$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $020f0f14624a1d9c$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($020f0f14624a1d9c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $020f0f14624a1d9c$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $020f0f14624a1d9c$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $020f0f14624a1d9c$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $020f0f14624a1d9c$var$lj(b);
            $020f0f14624a1d9c$var$Ig();
            break;
        case 5:
            $020f0f14624a1d9c$var$Kh(b);
            break;
        case 1:
            $020f0f14624a1d9c$var$Zf(b.type) && $020f0f14624a1d9c$var$cg(b);
            break;
        case 4:
            $020f0f14624a1d9c$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, $020f0f14624a1d9c$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $020f0f14624a1d9c$var$pj(a, b, c);
                $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, $020f0f14624a1d9c$var$M.current & 1);
                a = $020f0f14624a1d9c$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, $020f0f14624a1d9c$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $020f0f14624a1d9c$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, $020f0f14624a1d9c$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $020f0f14624a1d9c$var$ej(a, b, c);
    }
    return $020f0f14624a1d9c$var$$i(a, b, c);
}
var $020f0f14624a1d9c$var$Aj, $020f0f14624a1d9c$var$Bj, $020f0f14624a1d9c$var$Cj, $020f0f14624a1d9c$var$Dj;
$020f0f14624a1d9c$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$020f0f14624a1d9c$var$Bj = function() {};
$020f0f14624a1d9c$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $020f0f14624a1d9c$var$Ya(a, e);
                d = $020f0f14624a1d9c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $020f0f14624a1d9c$var$A({}, e, {
                    value: void 0
                });
                d = $020f0f14624a1d9c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $020f0f14624a1d9c$var$gb(a, e);
                d = $020f0f14624a1d9c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $020f0f14624a1d9c$var$Bf);
        }
        $020f0f14624a1d9c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($020f0f14624a1d9c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($020f0f14624a1d9c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $020f0f14624a1d9c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$020f0f14624a1d9c$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $020f0f14624a1d9c$var$Ej(a, b) {
    if (!$020f0f14624a1d9c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $020f0f14624a1d9c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $020f0f14624a1d9c$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $020f0f14624a1d9c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $020f0f14624a1d9c$var$S(b), null;
        case 1:
            return $020f0f14624a1d9c$var$Zf(b.type) && $020f0f14624a1d9c$var$$f(), $020f0f14624a1d9c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $020f0f14624a1d9c$var$Jh();
            $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf);
            $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$H);
            $020f0f14624a1d9c$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $020f0f14624a1d9c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $020f0f14624a1d9c$var$zg && ($020f0f14624a1d9c$var$Gj($020f0f14624a1d9c$var$zg), $020f0f14624a1d9c$var$zg = null));
            $020f0f14624a1d9c$var$Bj(a, b);
            $020f0f14624a1d9c$var$S(b);
            return null;
        case 5:
            $020f0f14624a1d9c$var$Lh(b);
            var e = $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $020f0f14624a1d9c$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($020f0f14624a1d9c$var$p(166));
                    $020f0f14624a1d9c$var$S(b);
                    return null;
                }
                a = $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Eh.current);
                if ($020f0f14624a1d9c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$020f0f14624a1d9c$var$Of] = b;
                    d[$020f0f14624a1d9c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $020f0f14624a1d9c$var$D("cancel", d);
                            $020f0f14624a1d9c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $020f0f14624a1d9c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $020f0f14624a1d9c$var$lf.length; e++)$020f0f14624a1d9c$var$D($020f0f14624a1d9c$var$lf[e], d);
                            break;
                        case "source":
                            $020f0f14624a1d9c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $020f0f14624a1d9c$var$D("error", d);
                            $020f0f14624a1d9c$var$D("load", d);
                            break;
                        case "details":
                            $020f0f14624a1d9c$var$D("toggle", d);
                            break;
                        case "input":
                            $020f0f14624a1d9c$var$Za(d, f);
                            $020f0f14624a1d9c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $020f0f14624a1d9c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $020f0f14624a1d9c$var$hb(d, f), $020f0f14624a1d9c$var$D("invalid", d);
                    }
                    $020f0f14624a1d9c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $020f0f14624a1d9c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $020f0f14624a1d9c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $020f0f14624a1d9c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $020f0f14624a1d9c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $020f0f14624a1d9c$var$Va(d);
                            $020f0f14624a1d9c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $020f0f14624a1d9c$var$Va(d);
                            $020f0f14624a1d9c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $020f0f14624a1d9c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $020f0f14624a1d9c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$020f0f14624a1d9c$var$Of] = b;
                    a[$020f0f14624a1d9c$var$Pf] = d;
                    $020f0f14624a1d9c$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $020f0f14624a1d9c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $020f0f14624a1d9c$var$D("cancel", a);
                                $020f0f14624a1d9c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $020f0f14624a1d9c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $020f0f14624a1d9c$var$lf.length; e++)$020f0f14624a1d9c$var$D($020f0f14624a1d9c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $020f0f14624a1d9c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $020f0f14624a1d9c$var$D("error", a);
                                $020f0f14624a1d9c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $020f0f14624a1d9c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $020f0f14624a1d9c$var$Za(a, d);
                                e = $020f0f14624a1d9c$var$Ya(a, d);
                                $020f0f14624a1d9c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $020f0f14624a1d9c$var$A({}, d, {
                                    value: void 0
                                });
                                $020f0f14624a1d9c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $020f0f14624a1d9c$var$hb(a, d);
                                e = $020f0f14624a1d9c$var$gb(a, d);
                                $020f0f14624a1d9c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $020f0f14624a1d9c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $020f0f14624a1d9c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $020f0f14624a1d9c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $020f0f14624a1d9c$var$ob(a, k) : "number" === typeof k && $020f0f14624a1d9c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($020f0f14624a1d9c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $020f0f14624a1d9c$var$D("scroll", a) : null != k && $020f0f14624a1d9c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $020f0f14624a1d9c$var$Va(a);
                                $020f0f14624a1d9c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $020f0f14624a1d9c$var$Va(a);
                                $020f0f14624a1d9c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $020f0f14624a1d9c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $020f0f14624a1d9c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $020f0f14624a1d9c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $020f0f14624a1d9c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $020f0f14624a1d9c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $020f0f14624a1d9c$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($020f0f14624a1d9c$var$p(166));
                c = $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Gh.current);
                $020f0f14624a1d9c$var$Hh($020f0f14624a1d9c$var$Eh.current);
                if ($020f0f14624a1d9c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$020f0f14624a1d9c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $020f0f14624a1d9c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $020f0f14624a1d9c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $020f0f14624a1d9c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$020f0f14624a1d9c$var$Of] = b, b.stateNode = d;
            }
            $020f0f14624a1d9c$var$S(b);
            return null;
        case 13:
            $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($020f0f14624a1d9c$var$I && null !== $020f0f14624a1d9c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $020f0f14624a1d9c$var$Hg(), $020f0f14624a1d9c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $020f0f14624a1d9c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($020f0f14624a1d9c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($020f0f14624a1d9c$var$p(317));
                        f[$020f0f14624a1d9c$var$Of] = b;
                    } else $020f0f14624a1d9c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $020f0f14624a1d9c$var$S(b);
                    f = !1;
                } else null !== $020f0f14624a1d9c$var$zg && ($020f0f14624a1d9c$var$Gj($020f0f14624a1d9c$var$zg), $020f0f14624a1d9c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($020f0f14624a1d9c$var$M.current & 1) ? 0 === $020f0f14624a1d9c$var$T && ($020f0f14624a1d9c$var$T = 3) : $020f0f14624a1d9c$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $020f0f14624a1d9c$var$S(b);
            return null;
        case 4:
            return $020f0f14624a1d9c$var$Jh(), $020f0f14624a1d9c$var$Bj(a, b), null === a && $020f0f14624a1d9c$var$sf(b.stateNode.containerInfo), $020f0f14624a1d9c$var$S(b), null;
        case 10:
            return $020f0f14624a1d9c$var$Rg(b.type._context), $020f0f14624a1d9c$var$S(b), null;
        case 17:
            return $020f0f14624a1d9c$var$Zf(b.type) && $020f0f14624a1d9c$var$$f(), $020f0f14624a1d9c$var$S(b), null;
        case 19:
            $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M);
            f = b.memoizedState;
            if (null === f) return $020f0f14624a1d9c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $020f0f14624a1d9c$var$Ej(f, !1);
                else {
                    if (0 !== $020f0f14624a1d9c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $020f0f14624a1d9c$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $020f0f14624a1d9c$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, $020f0f14624a1d9c$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $020f0f14624a1d9c$var$B() > $020f0f14624a1d9c$var$Hj && (b.flags |= 128, d = !0, $020f0f14624a1d9c$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $020f0f14624a1d9c$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $020f0f14624a1d9c$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$020f0f14624a1d9c$var$I) return $020f0f14624a1d9c$var$S(b), null;
                    } else 2 * $020f0f14624a1d9c$var$B() - f.renderingStartTime > $020f0f14624a1d9c$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $020f0f14624a1d9c$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $020f0f14624a1d9c$var$B(), b.sibling = null, c = $020f0f14624a1d9c$var$M.current, $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$M, d ? c & 1 | 2 : c & 1), b;
            $020f0f14624a1d9c$var$S(b);
            return null;
        case 22:
        case 23:
            return $020f0f14624a1d9c$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($020f0f14624a1d9c$var$gj & 1073741824) && ($020f0f14624a1d9c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $020f0f14624a1d9c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($020f0f14624a1d9c$var$p(156, b.tag));
}
function $020f0f14624a1d9c$var$Jj(a, b) {
    $020f0f14624a1d9c$var$wg(b);
    switch(b.tag){
        case 1:
            return $020f0f14624a1d9c$var$Zf(b.type) && $020f0f14624a1d9c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $020f0f14624a1d9c$var$Jh(), $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf), $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$H), $020f0f14624a1d9c$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $020f0f14624a1d9c$var$Lh(b), null;
        case 13:
            $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($020f0f14624a1d9c$var$p(340));
                $020f0f14624a1d9c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M), null;
        case 4:
            return $020f0f14624a1d9c$var$Jh(), null;
        case 10:
            return $020f0f14624a1d9c$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $020f0f14624a1d9c$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $020f0f14624a1d9c$var$Kj = !1, $020f0f14624a1d9c$var$U = !1, $020f0f14624a1d9c$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $020f0f14624a1d9c$var$V = null;
function $020f0f14624a1d9c$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $020f0f14624a1d9c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $020f0f14624a1d9c$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $020f0f14624a1d9c$var$W(a, b, d);
    }
}
var $020f0f14624a1d9c$var$Oj = !1;
function $020f0f14624a1d9c$var$Pj(a, b) {
    $020f0f14624a1d9c$var$Cf = $020f0f14624a1d9c$var$dd;
    a = $020f0f14624a1d9c$var$Me();
    if ($020f0f14624a1d9c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $020f0f14624a1d9c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $020f0f14624a1d9c$var$dd = !1;
    for($020f0f14624a1d9c$var$V = b; null !== $020f0f14624a1d9c$var$V;)if (b = $020f0f14624a1d9c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $020f0f14624a1d9c$var$V = a;
    else for(; null !== $020f0f14624a1d9c$var$V;){
        b = $020f0f14624a1d9c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $020f0f14624a1d9c$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($020f0f14624a1d9c$var$p(163));
            }
        } catch (F) {
            $020f0f14624a1d9c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $020f0f14624a1d9c$var$V = a;
            break;
        }
        $020f0f14624a1d9c$var$V = b.return;
    }
    n = $020f0f14624a1d9c$var$Oj;
    $020f0f14624a1d9c$var$Oj = !1;
    return n;
}
function $020f0f14624a1d9c$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $020f0f14624a1d9c$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $020f0f14624a1d9c$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $020f0f14624a1d9c$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $020f0f14624a1d9c$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $020f0f14624a1d9c$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$020f0f14624a1d9c$var$Of], delete b[$020f0f14624a1d9c$var$Pf], delete b[$020f0f14624a1d9c$var$of], delete b[$020f0f14624a1d9c$var$Qf], delete b[$020f0f14624a1d9c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $020f0f14624a1d9c$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $020f0f14624a1d9c$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $020f0f14624a1d9c$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $020f0f14624a1d9c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $020f0f14624a1d9c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($020f0f14624a1d9c$var$Wj(a, b, c), a = a.sibling; null !== a;)$020f0f14624a1d9c$var$Wj(a, b, c), a = a.sibling;
}
function $020f0f14624a1d9c$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($020f0f14624a1d9c$var$Xj(a, b, c), a = a.sibling; null !== a;)$020f0f14624a1d9c$var$Xj(a, b, c), a = a.sibling;
}
var $020f0f14624a1d9c$var$X = null, $020f0f14624a1d9c$var$Yj = !1;
function $020f0f14624a1d9c$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$020f0f14624a1d9c$var$ak(a, b, c), c = c.sibling;
}
function $020f0f14624a1d9c$var$ak(a, b, c) {
    if ($020f0f14624a1d9c$var$lc && "function" === typeof $020f0f14624a1d9c$var$lc.onCommitFiberUnmount) try {
        $020f0f14624a1d9c$var$lc.onCommitFiberUnmount($020f0f14624a1d9c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $020f0f14624a1d9c$var$U || $020f0f14624a1d9c$var$Mj(c, b);
        case 6:
            var d = $020f0f14624a1d9c$var$X, e = $020f0f14624a1d9c$var$Yj;
            $020f0f14624a1d9c$var$X = null;
            $020f0f14624a1d9c$var$Zj(a, b, c);
            $020f0f14624a1d9c$var$X = d;
            $020f0f14624a1d9c$var$Yj = e;
            null !== $020f0f14624a1d9c$var$X && ($020f0f14624a1d9c$var$Yj ? (a = $020f0f14624a1d9c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $020f0f14624a1d9c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $020f0f14624a1d9c$var$X && ($020f0f14624a1d9c$var$Yj ? (a = $020f0f14624a1d9c$var$X, c = c.stateNode, 8 === a.nodeType ? $020f0f14624a1d9c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $020f0f14624a1d9c$var$Kf(a, c), $020f0f14624a1d9c$var$bd(a)) : $020f0f14624a1d9c$var$Kf($020f0f14624a1d9c$var$X, c.stateNode));
            break;
        case 4:
            d = $020f0f14624a1d9c$var$X;
            e = $020f0f14624a1d9c$var$Yj;
            $020f0f14624a1d9c$var$X = c.stateNode.containerInfo;
            $020f0f14624a1d9c$var$Yj = !0;
            $020f0f14624a1d9c$var$Zj(a, b, c);
            $020f0f14624a1d9c$var$X = d;
            $020f0f14624a1d9c$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$020f0f14624a1d9c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $020f0f14624a1d9c$var$Nj(c, b, g) : 0 !== (f & 4) && $020f0f14624a1d9c$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $020f0f14624a1d9c$var$Zj(a, b, c);
            break;
        case 1:
            if (!$020f0f14624a1d9c$var$U && ($020f0f14624a1d9c$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $020f0f14624a1d9c$var$W(c, b, h);
            }
            $020f0f14624a1d9c$var$Zj(a, b, c);
            break;
        case 21:
            $020f0f14624a1d9c$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($020f0f14624a1d9c$var$U = (d = $020f0f14624a1d9c$var$U) || null !== c.memoizedState, $020f0f14624a1d9c$var$Zj(a, b, c), $020f0f14624a1d9c$var$U = d) : $020f0f14624a1d9c$var$Zj(a, b, c);
            break;
        default:
            $020f0f14624a1d9c$var$Zj(a, b, c);
    }
}
function $020f0f14624a1d9c$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $020f0f14624a1d9c$var$Lj);
        b.forEach(function(b) {
            var d = $020f0f14624a1d9c$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $020f0f14624a1d9c$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $020f0f14624a1d9c$var$X = h.stateNode;
                        $020f0f14624a1d9c$var$Yj = !1;
                        break a;
                    case 3:
                        $020f0f14624a1d9c$var$X = h.stateNode.containerInfo;
                        $020f0f14624a1d9c$var$Yj = !0;
                        break a;
                    case 4:
                        $020f0f14624a1d9c$var$X = h.stateNode.containerInfo;
                        $020f0f14624a1d9c$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $020f0f14624a1d9c$var$X) throw Error($020f0f14624a1d9c$var$p(160));
            $020f0f14624a1d9c$var$ak(f, g, e);
            $020f0f14624a1d9c$var$X = null;
            $020f0f14624a1d9c$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $020f0f14624a1d9c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$020f0f14624a1d9c$var$ek(b, a), b = b.sibling;
}
function $020f0f14624a1d9c$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            if (d & 4) {
                try {
                    $020f0f14624a1d9c$var$Qj(3, a, a.return), $020f0f14624a1d9c$var$Rj(3, a);
                } catch (t) {
                    $020f0f14624a1d9c$var$W(a, a.return, t);
                }
                try {
                    $020f0f14624a1d9c$var$Qj(5, a, a.return);
                } catch (t) {
                    $020f0f14624a1d9c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            d & 512 && null !== c && $020f0f14624a1d9c$var$Mj(c, c.return);
            break;
        case 5:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            d & 512 && null !== c && $020f0f14624a1d9c$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $020f0f14624a1d9c$var$ob(e, "");
                } catch (t) {
                    $020f0f14624a1d9c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $020f0f14624a1d9c$var$ab(e, f);
                    $020f0f14624a1d9c$var$vb(h, g);
                    var l = $020f0f14624a1d9c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $020f0f14624a1d9c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $020f0f14624a1d9c$var$nb(e, q) : "children" === m ? $020f0f14624a1d9c$var$ob(e, q) : $020f0f14624a1d9c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $020f0f14624a1d9c$var$bb(e, f);
                            break;
                        case "textarea":
                            $020f0f14624a1d9c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $020f0f14624a1d9c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $020f0f14624a1d9c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $020f0f14624a1d9c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$020f0f14624a1d9c$var$Pf] = f;
                } catch (t) {
                    $020f0f14624a1d9c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($020f0f14624a1d9c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $020f0f14624a1d9c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $020f0f14624a1d9c$var$bd(b.containerInfo);
            } catch (t) {
                $020f0f14624a1d9c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            break;
        case 13:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($020f0f14624a1d9c$var$gk = $020f0f14624a1d9c$var$B()));
            d & 4 && $020f0f14624a1d9c$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($020f0f14624a1d9c$var$U = (l = $020f0f14624a1d9c$var$U) || m, $020f0f14624a1d9c$var$dk(b, a), $020f0f14624a1d9c$var$U = l) : $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($020f0f14624a1d9c$var$V = a, m = a.child; null !== m;){
                    for(q = $020f0f14624a1d9c$var$V = m; null !== $020f0f14624a1d9c$var$V;){
                        r = $020f0f14624a1d9c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $020f0f14624a1d9c$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $020f0f14624a1d9c$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $020f0f14624a1d9c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $020f0f14624a1d9c$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $020f0f14624a1d9c$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $020f0f14624a1d9c$var$V = y) : $020f0f14624a1d9c$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $020f0f14624a1d9c$var$rb("display", g));
                            } catch (t) {
                                $020f0f14624a1d9c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $020f0f14624a1d9c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $020f0f14624a1d9c$var$dk(b, a);
            $020f0f14624a1d9c$var$fk(a);
            d & 4 && $020f0f14624a1d9c$var$bk(a);
            break;
        case 21:
            break;
        default:
            $020f0f14624a1d9c$var$dk(b, a), $020f0f14624a1d9c$var$fk(a);
    }
}
function $020f0f14624a1d9c$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($020f0f14624a1d9c$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($020f0f14624a1d9c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($020f0f14624a1d9c$var$ob(e, ""), d.flags &= -33);
                    var f = $020f0f14624a1d9c$var$Vj(a);
                    $020f0f14624a1d9c$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $020f0f14624a1d9c$var$Vj(a);
                    $020f0f14624a1d9c$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($020f0f14624a1d9c$var$p(161));
            }
        } catch (k) {
            $020f0f14624a1d9c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $020f0f14624a1d9c$var$ik(a, b, c) {
    $020f0f14624a1d9c$var$V = a;
    $020f0f14624a1d9c$var$jk(a, b, c);
}
function $020f0f14624a1d9c$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $020f0f14624a1d9c$var$V;){
        var e = $020f0f14624a1d9c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $020f0f14624a1d9c$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $020f0f14624a1d9c$var$U;
                h = $020f0f14624a1d9c$var$Kj;
                var l = $020f0f14624a1d9c$var$U;
                $020f0f14624a1d9c$var$Kj = g;
                if (($020f0f14624a1d9c$var$U = k) && !l) for($020f0f14624a1d9c$var$V = e; null !== $020f0f14624a1d9c$var$V;)g = $020f0f14624a1d9c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $020f0f14624a1d9c$var$kk(e) : null !== k ? (k.return = g, $020f0f14624a1d9c$var$V = k) : $020f0f14624a1d9c$var$kk(e);
                for(; null !== f;)$020f0f14624a1d9c$var$V = f, $020f0f14624a1d9c$var$jk(f, b, c), f = f.sibling;
                $020f0f14624a1d9c$var$V = e;
                $020f0f14624a1d9c$var$Kj = h;
                $020f0f14624a1d9c$var$U = l;
            }
            $020f0f14624a1d9c$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $020f0f14624a1d9c$var$V = f) : $020f0f14624a1d9c$var$lk(a, b, c);
    }
}
function $020f0f14624a1d9c$var$lk(a) {
    for(; null !== $020f0f14624a1d9c$var$V;){
        var b = $020f0f14624a1d9c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $020f0f14624a1d9c$var$U || $020f0f14624a1d9c$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$020f0f14624a1d9c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $020f0f14624a1d9c$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $020f0f14624a1d9c$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $020f0f14624a1d9c$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $020f0f14624a1d9c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($020f0f14624a1d9c$var$p(163));
                }
                $020f0f14624a1d9c$var$U || b.flags & 512 && $020f0f14624a1d9c$var$Sj(b);
            } catch (r) {
                $020f0f14624a1d9c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $020f0f14624a1d9c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $020f0f14624a1d9c$var$V = c;
            break;
        }
        $020f0f14624a1d9c$var$V = b.return;
    }
}
function $020f0f14624a1d9c$var$hk(a) {
    for(; null !== $020f0f14624a1d9c$var$V;){
        var b = $020f0f14624a1d9c$var$V;
        if (b === a) {
            $020f0f14624a1d9c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $020f0f14624a1d9c$var$V = c;
            break;
        }
        $020f0f14624a1d9c$var$V = b.return;
    }
}
function $020f0f14624a1d9c$var$kk(a) {
    for(; null !== $020f0f14624a1d9c$var$V;){
        var b = $020f0f14624a1d9c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $020f0f14624a1d9c$var$Rj(4, b);
                    } catch (k) {
                        $020f0f14624a1d9c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $020f0f14624a1d9c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $020f0f14624a1d9c$var$Sj(b);
                    } catch (k) {
                        $020f0f14624a1d9c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $020f0f14624a1d9c$var$Sj(b);
                    } catch (k) {
                        $020f0f14624a1d9c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $020f0f14624a1d9c$var$W(b, b.return, k);
        }
        if (b === a) {
            $020f0f14624a1d9c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $020f0f14624a1d9c$var$V = h;
            break;
        }
        $020f0f14624a1d9c$var$V = b.return;
    }
}
var $020f0f14624a1d9c$var$mk = Math.ceil, $020f0f14624a1d9c$var$nk = $020f0f14624a1d9c$var$ua.ReactCurrentDispatcher, $020f0f14624a1d9c$var$ok = $020f0f14624a1d9c$var$ua.ReactCurrentOwner, $020f0f14624a1d9c$var$pk = $020f0f14624a1d9c$var$ua.ReactCurrentBatchConfig, $020f0f14624a1d9c$var$K = 0, $020f0f14624a1d9c$var$R = null, $020f0f14624a1d9c$var$Y = null, $020f0f14624a1d9c$var$Z = 0, $020f0f14624a1d9c$var$gj = 0, $020f0f14624a1d9c$var$fj = $020f0f14624a1d9c$var$Uf(0), $020f0f14624a1d9c$var$T = 0, $020f0f14624a1d9c$var$qk = null, $020f0f14624a1d9c$var$hh = 0, $020f0f14624a1d9c$var$rk = 0, $020f0f14624a1d9c$var$sk = 0, $020f0f14624a1d9c$var$tk = null, $020f0f14624a1d9c$var$uk = null, $020f0f14624a1d9c$var$gk = 0, $020f0f14624a1d9c$var$Hj = Infinity, $020f0f14624a1d9c$var$vk = null, $020f0f14624a1d9c$var$Pi = !1, $020f0f14624a1d9c$var$Qi = null, $020f0f14624a1d9c$var$Si = null, $020f0f14624a1d9c$var$wk = !1, $020f0f14624a1d9c$var$xk = null, $020f0f14624a1d9c$var$yk = 0, $020f0f14624a1d9c$var$zk = 0, $020f0f14624a1d9c$var$Ak = null, $020f0f14624a1d9c$var$Bk = -1, $020f0f14624a1d9c$var$Ck = 0;
function $020f0f14624a1d9c$var$L() {
    return 0 !== ($020f0f14624a1d9c$var$K & 6) ? $020f0f14624a1d9c$var$B() : -1 !== $020f0f14624a1d9c$var$Bk ? $020f0f14624a1d9c$var$Bk : $020f0f14624a1d9c$var$Bk = $020f0f14624a1d9c$var$B();
}
function $020f0f14624a1d9c$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($020f0f14624a1d9c$var$K & 2) && 0 !== $020f0f14624a1d9c$var$Z) return $020f0f14624a1d9c$var$Z & -$020f0f14624a1d9c$var$Z;
    if (null !== $020f0f14624a1d9c$var$Kg.transition) return 0 === $020f0f14624a1d9c$var$Ck && ($020f0f14624a1d9c$var$Ck = $020f0f14624a1d9c$var$yc()), $020f0f14624a1d9c$var$Ck;
    a = $020f0f14624a1d9c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $020f0f14624a1d9c$var$jd(a.type);
    return a;
}
function $020f0f14624a1d9c$var$mh(a, b, c, d) {
    if (50 < $020f0f14624a1d9c$var$zk) throw $020f0f14624a1d9c$var$zk = 0, $020f0f14624a1d9c$var$Ak = null, Error($020f0f14624a1d9c$var$p(185));
    $020f0f14624a1d9c$var$Ac(a, c, d);
    if (0 === ($020f0f14624a1d9c$var$K & 2) || a !== $020f0f14624a1d9c$var$R) a === $020f0f14624a1d9c$var$R && (0 === ($020f0f14624a1d9c$var$K & 2) && ($020f0f14624a1d9c$var$rk |= c), 4 === $020f0f14624a1d9c$var$T && $020f0f14624a1d9c$var$Dk(a, $020f0f14624a1d9c$var$Z)), $020f0f14624a1d9c$var$Ek(a, d), 1 === c && 0 === $020f0f14624a1d9c$var$K && 0 === (b.mode & 1) && ($020f0f14624a1d9c$var$Hj = $020f0f14624a1d9c$var$B() + 500, $020f0f14624a1d9c$var$fg && $020f0f14624a1d9c$var$jg());
}
function $020f0f14624a1d9c$var$Ek(a, b) {
    var c = a.callbackNode;
    $020f0f14624a1d9c$var$wc(a, b);
    var d = $020f0f14624a1d9c$var$uc(a, a === $020f0f14624a1d9c$var$R ? $020f0f14624a1d9c$var$Z : 0);
    if (0 === d) null !== c && $020f0f14624a1d9c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $020f0f14624a1d9c$var$bc(c);
        if (1 === b) 0 === a.tag ? $020f0f14624a1d9c$var$ig($020f0f14624a1d9c$var$Fk.bind(null, a)) : $020f0f14624a1d9c$var$hg($020f0f14624a1d9c$var$Fk.bind(null, a)), $020f0f14624a1d9c$var$Jf(function() {
            0 === ($020f0f14624a1d9c$var$K & 6) && $020f0f14624a1d9c$var$jg();
        }), c = null;
        else {
            switch($020f0f14624a1d9c$var$Dc(d)){
                case 1:
                    c = $020f0f14624a1d9c$var$fc;
                    break;
                case 4:
                    c = $020f0f14624a1d9c$var$gc;
                    break;
                case 16:
                    c = $020f0f14624a1d9c$var$hc;
                    break;
                case 536870912:
                    c = $020f0f14624a1d9c$var$jc;
                    break;
                default:
                    c = $020f0f14624a1d9c$var$hc;
            }
            c = $020f0f14624a1d9c$var$Gk(c, $020f0f14624a1d9c$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $020f0f14624a1d9c$var$Hk(a, b) {
    $020f0f14624a1d9c$var$Bk = -1;
    $020f0f14624a1d9c$var$Ck = 0;
    if (0 !== ($020f0f14624a1d9c$var$K & 6)) throw Error($020f0f14624a1d9c$var$p(327));
    var c = a.callbackNode;
    if ($020f0f14624a1d9c$var$Ik() && a.callbackNode !== c) return null;
    var d = $020f0f14624a1d9c$var$uc(a, a === $020f0f14624a1d9c$var$R ? $020f0f14624a1d9c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $020f0f14624a1d9c$var$Jk(a, d);
    else {
        b = d;
        var e = $020f0f14624a1d9c$var$K;
        $020f0f14624a1d9c$var$K |= 2;
        var f = $020f0f14624a1d9c$var$Kk();
        if ($020f0f14624a1d9c$var$R !== a || $020f0f14624a1d9c$var$Z !== b) $020f0f14624a1d9c$var$vk = null, $020f0f14624a1d9c$var$Hj = $020f0f14624a1d9c$var$B() + 500, $020f0f14624a1d9c$var$Lk(a, b);
        for(;;)try {
            $020f0f14624a1d9c$var$Mk();
            break;
        } catch (h) {
            $020f0f14624a1d9c$var$Nk(a, h);
        }
        $020f0f14624a1d9c$var$Qg();
        $020f0f14624a1d9c$var$nk.current = f;
        $020f0f14624a1d9c$var$K = e;
        null !== $020f0f14624a1d9c$var$Y ? b = 0 : ($020f0f14624a1d9c$var$R = null, $020f0f14624a1d9c$var$Z = 0, b = $020f0f14624a1d9c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $020f0f14624a1d9c$var$xc(a), 0 !== e && (d = e, b = $020f0f14624a1d9c$var$Ok(a, e)));
        if (1 === b) throw c = $020f0f14624a1d9c$var$qk, $020f0f14624a1d9c$var$Lk(a, 0), $020f0f14624a1d9c$var$Dk(a, d), $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B()), c;
        if (6 === b) $020f0f14624a1d9c$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$020f0f14624a1d9c$var$Pk(e) && (b = $020f0f14624a1d9c$var$Jk(a, d), 2 === b && (f = $020f0f14624a1d9c$var$xc(a), 0 !== f && (d = f, b = $020f0f14624a1d9c$var$Ok(a, f))), 1 === b)) throw c = $020f0f14624a1d9c$var$qk, $020f0f14624a1d9c$var$Lk(a, 0), $020f0f14624a1d9c$var$Dk(a, d), $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($020f0f14624a1d9c$var$p(345));
                case 2:
                    $020f0f14624a1d9c$var$Qk(a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk);
                    break;
                case 3:
                    $020f0f14624a1d9c$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $020f0f14624a1d9c$var$gk + 500 - $020f0f14624a1d9c$var$B(), 10 < b)) {
                        if (0 !== $020f0f14624a1d9c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $020f0f14624a1d9c$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $020f0f14624a1d9c$var$Ff($020f0f14624a1d9c$var$Qk.bind(null, a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk), b);
                        break;
                    }
                    $020f0f14624a1d9c$var$Qk(a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk);
                    break;
                case 4:
                    $020f0f14624a1d9c$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $020f0f14624a1d9c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $020f0f14624a1d9c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $020f0f14624a1d9c$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $020f0f14624a1d9c$var$Ff($020f0f14624a1d9c$var$Qk.bind(null, a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk), d);
                        break;
                    }
                    $020f0f14624a1d9c$var$Qk(a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk);
                    break;
                case 5:
                    $020f0f14624a1d9c$var$Qk(a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk);
                    break;
                default:
                    throw Error($020f0f14624a1d9c$var$p(329));
            }
        }
    }
    $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B());
    return a.callbackNode === c ? $020f0f14624a1d9c$var$Hk.bind(null, a) : null;
}
function $020f0f14624a1d9c$var$Ok(a, b) {
    var c = $020f0f14624a1d9c$var$tk;
    a.current.memoizedState.isDehydrated && ($020f0f14624a1d9c$var$Lk(a, b).flags |= 256);
    a = $020f0f14624a1d9c$var$Jk(a, b);
    2 !== a && (b = $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$uk = c, null !== b && $020f0f14624a1d9c$var$Gj(b));
    return a;
}
function $020f0f14624a1d9c$var$Gj(a) {
    null === $020f0f14624a1d9c$var$uk ? $020f0f14624a1d9c$var$uk = a : $020f0f14624a1d9c$var$uk.push.apply($020f0f14624a1d9c$var$uk, a);
}
function $020f0f14624a1d9c$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$020f0f14624a1d9c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $020f0f14624a1d9c$var$Dk(a, b) {
    b &= ~$020f0f14624a1d9c$var$sk;
    b &= ~$020f0f14624a1d9c$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $020f0f14624a1d9c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $020f0f14624a1d9c$var$Fk(a) {
    if (0 !== ($020f0f14624a1d9c$var$K & 6)) throw Error($020f0f14624a1d9c$var$p(327));
    $020f0f14624a1d9c$var$Ik();
    var b = $020f0f14624a1d9c$var$uc(a, 0);
    if (0 === (b & 1)) return $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B()), null;
    var c = $020f0f14624a1d9c$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $020f0f14624a1d9c$var$xc(a);
        0 !== d && (b = d, c = $020f0f14624a1d9c$var$Ok(a, d));
    }
    if (1 === c) throw c = $020f0f14624a1d9c$var$qk, $020f0f14624a1d9c$var$Lk(a, 0), $020f0f14624a1d9c$var$Dk(a, b), $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B()), c;
    if (6 === c) throw Error($020f0f14624a1d9c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $020f0f14624a1d9c$var$Qk(a, $020f0f14624a1d9c$var$uk, $020f0f14624a1d9c$var$vk);
    $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B());
    return null;
}
function $020f0f14624a1d9c$var$Rk(a, b) {
    var c = $020f0f14624a1d9c$var$K;
    $020f0f14624a1d9c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $020f0f14624a1d9c$var$K = c, 0 === $020f0f14624a1d9c$var$K && ($020f0f14624a1d9c$var$Hj = $020f0f14624a1d9c$var$B() + 500, $020f0f14624a1d9c$var$fg && $020f0f14624a1d9c$var$jg());
    }
}
function $020f0f14624a1d9c$var$Sk(a) {
    null !== $020f0f14624a1d9c$var$xk && 0 === $020f0f14624a1d9c$var$xk.tag && 0 === ($020f0f14624a1d9c$var$K & 6) && $020f0f14624a1d9c$var$Ik();
    var b = $020f0f14624a1d9c$var$K;
    $020f0f14624a1d9c$var$K |= 1;
    var c = $020f0f14624a1d9c$var$pk.transition, d = $020f0f14624a1d9c$var$C;
    try {
        if ($020f0f14624a1d9c$var$pk.transition = null, $020f0f14624a1d9c$var$C = 1, a) return a();
    } finally{
        $020f0f14624a1d9c$var$C = d, $020f0f14624a1d9c$var$pk.transition = c, $020f0f14624a1d9c$var$K = b, 0 === ($020f0f14624a1d9c$var$K & 6) && $020f0f14624a1d9c$var$jg();
    }
}
function $020f0f14624a1d9c$var$Ij() {
    $020f0f14624a1d9c$var$gj = $020f0f14624a1d9c$var$fj.current;
    $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$fj);
}
function $020f0f14624a1d9c$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $020f0f14624a1d9c$var$Gf(c));
    if (null !== $020f0f14624a1d9c$var$Y) for(c = $020f0f14624a1d9c$var$Y.return; null !== c;){
        var d = c;
        $020f0f14624a1d9c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $020f0f14624a1d9c$var$$f();
                break;
            case 3:
                $020f0f14624a1d9c$var$Jh();
                $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$Wf);
                $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$H);
                $020f0f14624a1d9c$var$Oh();
                break;
            case 5:
                $020f0f14624a1d9c$var$Lh(d);
                break;
            case 4:
                $020f0f14624a1d9c$var$Jh();
                break;
            case 13:
                $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M);
                break;
            case 19:
                $020f0f14624a1d9c$var$E($020f0f14624a1d9c$var$M);
                break;
            case 10:
                $020f0f14624a1d9c$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $020f0f14624a1d9c$var$Ij();
        }
        c = c.return;
    }
    $020f0f14624a1d9c$var$R = a;
    $020f0f14624a1d9c$var$Y = a = $020f0f14624a1d9c$var$wh(a.current, null);
    $020f0f14624a1d9c$var$Z = $020f0f14624a1d9c$var$gj = b;
    $020f0f14624a1d9c$var$T = 0;
    $020f0f14624a1d9c$var$qk = null;
    $020f0f14624a1d9c$var$sk = $020f0f14624a1d9c$var$rk = $020f0f14624a1d9c$var$hh = 0;
    $020f0f14624a1d9c$var$uk = $020f0f14624a1d9c$var$tk = null;
    if (null !== $020f0f14624a1d9c$var$Wg) {
        for(b = 0; b < $020f0f14624a1d9c$var$Wg.length; b++)if (c = $020f0f14624a1d9c$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $020f0f14624a1d9c$var$Wg = null;
    }
    return a;
}
function $020f0f14624a1d9c$var$Nk(a, b) {
    do {
        var c = $020f0f14624a1d9c$var$Y;
        try {
            $020f0f14624a1d9c$var$Qg();
            $020f0f14624a1d9c$var$Ph.current = $020f0f14624a1d9c$var$ai;
            if ($020f0f14624a1d9c$var$Sh) {
                for(var d = $020f0f14624a1d9c$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $020f0f14624a1d9c$var$Sh = !1;
            }
            $020f0f14624a1d9c$var$Rh = 0;
            $020f0f14624a1d9c$var$P = $020f0f14624a1d9c$var$O = $020f0f14624a1d9c$var$N = null;
            $020f0f14624a1d9c$var$Th = !1;
            $020f0f14624a1d9c$var$Uh = 0;
            $020f0f14624a1d9c$var$ok.current = null;
            if (null === c || null === c.return) {
                $020f0f14624a1d9c$var$T = 1;
                $020f0f14624a1d9c$var$qk = b;
                $020f0f14624a1d9c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $020f0f14624a1d9c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $020f0f14624a1d9c$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $020f0f14624a1d9c$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $020f0f14624a1d9c$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $020f0f14624a1d9c$var$Ti(f, l, b);
                            $020f0f14624a1d9c$var$uj();
                            break a;
                        }
                        k = Error($020f0f14624a1d9c$var$p(426));
                    }
                } else if ($020f0f14624a1d9c$var$I && h.mode & 1) {
                    var J = $020f0f14624a1d9c$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $020f0f14624a1d9c$var$Wi(J, g, h, f, b);
                        $020f0f14624a1d9c$var$Jg($020f0f14624a1d9c$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $020f0f14624a1d9c$var$Ki(k, h);
                4 !== $020f0f14624a1d9c$var$T && ($020f0f14624a1d9c$var$T = 2);
                null === $020f0f14624a1d9c$var$tk ? $020f0f14624a1d9c$var$tk = [
                    f
                ] : $020f0f14624a1d9c$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $020f0f14624a1d9c$var$Oi(f, k, b);
                            $020f0f14624a1d9c$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $020f0f14624a1d9c$var$Si || !$020f0f14624a1d9c$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $020f0f14624a1d9c$var$Ri(f, h, b);
                                $020f0f14624a1d9c$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $020f0f14624a1d9c$var$Tk(c);
        } catch (na) {
            b = na;
            $020f0f14624a1d9c$var$Y === c && null !== c && ($020f0f14624a1d9c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $020f0f14624a1d9c$var$Kk() {
    var a = $020f0f14624a1d9c$var$nk.current;
    $020f0f14624a1d9c$var$nk.current = $020f0f14624a1d9c$var$ai;
    return null === a ? $020f0f14624a1d9c$var$ai : a;
}
function $020f0f14624a1d9c$var$uj() {
    if (0 === $020f0f14624a1d9c$var$T || 3 === $020f0f14624a1d9c$var$T || 2 === $020f0f14624a1d9c$var$T) $020f0f14624a1d9c$var$T = 4;
    null === $020f0f14624a1d9c$var$R || 0 === ($020f0f14624a1d9c$var$hh & 268435455) && 0 === ($020f0f14624a1d9c$var$rk & 268435455) || $020f0f14624a1d9c$var$Dk($020f0f14624a1d9c$var$R, $020f0f14624a1d9c$var$Z);
}
function $020f0f14624a1d9c$var$Jk(a, b) {
    var c = $020f0f14624a1d9c$var$K;
    $020f0f14624a1d9c$var$K |= 2;
    var d = $020f0f14624a1d9c$var$Kk();
    if ($020f0f14624a1d9c$var$R !== a || $020f0f14624a1d9c$var$Z !== b) $020f0f14624a1d9c$var$vk = null, $020f0f14624a1d9c$var$Lk(a, b);
    for(;;)try {
        $020f0f14624a1d9c$var$Uk();
        break;
    } catch (e) {
        $020f0f14624a1d9c$var$Nk(a, e);
    }
    $020f0f14624a1d9c$var$Qg();
    $020f0f14624a1d9c$var$K = c;
    $020f0f14624a1d9c$var$nk.current = d;
    if (null !== $020f0f14624a1d9c$var$Y) throw Error($020f0f14624a1d9c$var$p(261));
    $020f0f14624a1d9c$var$R = null;
    $020f0f14624a1d9c$var$Z = 0;
    return $020f0f14624a1d9c$var$T;
}
function $020f0f14624a1d9c$var$Uk() {
    for(; null !== $020f0f14624a1d9c$var$Y;)$020f0f14624a1d9c$var$Vk($020f0f14624a1d9c$var$Y);
}
function $020f0f14624a1d9c$var$Mk() {
    for(; null !== $020f0f14624a1d9c$var$Y && !$020f0f14624a1d9c$var$cc();)$020f0f14624a1d9c$var$Vk($020f0f14624a1d9c$var$Y);
}
function $020f0f14624a1d9c$var$Vk(a) {
    var b = $020f0f14624a1d9c$var$Wk(a.alternate, a, $020f0f14624a1d9c$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $020f0f14624a1d9c$var$Tk(a) : $020f0f14624a1d9c$var$Y = b;
    $020f0f14624a1d9c$var$ok.current = null;
}
function $020f0f14624a1d9c$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $020f0f14624a1d9c$var$Fj(c, b, $020f0f14624a1d9c$var$gj), null !== c) {
                $020f0f14624a1d9c$var$Y = c;
                return;
            }
        } else {
            c = $020f0f14624a1d9c$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $020f0f14624a1d9c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $020f0f14624a1d9c$var$T = 6;
                $020f0f14624a1d9c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $020f0f14624a1d9c$var$Y = b;
            return;
        }
        $020f0f14624a1d9c$var$Y = b = a;
    }while (null !== b);
    0 === $020f0f14624a1d9c$var$T && ($020f0f14624a1d9c$var$T = 5);
}
function $020f0f14624a1d9c$var$Qk(a, b, c) {
    var d = $020f0f14624a1d9c$var$C, e = $020f0f14624a1d9c$var$pk.transition;
    try {
        $020f0f14624a1d9c$var$pk.transition = null, $020f0f14624a1d9c$var$C = 1, $020f0f14624a1d9c$var$Xk(a, b, c, d);
    } finally{
        $020f0f14624a1d9c$var$pk.transition = e, $020f0f14624a1d9c$var$C = d;
    }
    return null;
}
function $020f0f14624a1d9c$var$Xk(a, b, c, d) {
    do $020f0f14624a1d9c$var$Ik();
    while (null !== $020f0f14624a1d9c$var$xk);
    if (0 !== ($020f0f14624a1d9c$var$K & 6)) throw Error($020f0f14624a1d9c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($020f0f14624a1d9c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $020f0f14624a1d9c$var$Bc(a, f);
    a === $020f0f14624a1d9c$var$R && ($020f0f14624a1d9c$var$Y = $020f0f14624a1d9c$var$R = null, $020f0f14624a1d9c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $020f0f14624a1d9c$var$wk || ($020f0f14624a1d9c$var$wk = !0, $020f0f14624a1d9c$var$Gk($020f0f14624a1d9c$var$hc, function() {
        $020f0f14624a1d9c$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $020f0f14624a1d9c$var$pk.transition;
        $020f0f14624a1d9c$var$pk.transition = null;
        var g = $020f0f14624a1d9c$var$C;
        $020f0f14624a1d9c$var$C = 1;
        var h = $020f0f14624a1d9c$var$K;
        $020f0f14624a1d9c$var$K |= 4;
        $020f0f14624a1d9c$var$ok.current = null;
        $020f0f14624a1d9c$var$Pj(a, c);
        $020f0f14624a1d9c$var$ek(c, a);
        $020f0f14624a1d9c$var$Oe($020f0f14624a1d9c$var$Df);
        $020f0f14624a1d9c$var$dd = !!$020f0f14624a1d9c$var$Cf;
        $020f0f14624a1d9c$var$Df = $020f0f14624a1d9c$var$Cf = null;
        a.current = c;
        $020f0f14624a1d9c$var$ik(c, a, e);
        $020f0f14624a1d9c$var$dc();
        $020f0f14624a1d9c$var$K = h;
        $020f0f14624a1d9c$var$C = g;
        $020f0f14624a1d9c$var$pk.transition = f;
    } else a.current = c;
    $020f0f14624a1d9c$var$wk && ($020f0f14624a1d9c$var$wk = !1, $020f0f14624a1d9c$var$xk = a, $020f0f14624a1d9c$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($020f0f14624a1d9c$var$Si = null);
    $020f0f14624a1d9c$var$mc(c.stateNode, d);
    $020f0f14624a1d9c$var$Ek(a, $020f0f14624a1d9c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($020f0f14624a1d9c$var$Pi) throw $020f0f14624a1d9c$var$Pi = !1, a = $020f0f14624a1d9c$var$Qi, $020f0f14624a1d9c$var$Qi = null, a;
    0 !== ($020f0f14624a1d9c$var$yk & 1) && 0 !== a.tag && $020f0f14624a1d9c$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $020f0f14624a1d9c$var$Ak ? $020f0f14624a1d9c$var$zk++ : ($020f0f14624a1d9c$var$zk = 0, $020f0f14624a1d9c$var$Ak = a) : $020f0f14624a1d9c$var$zk = 0;
    $020f0f14624a1d9c$var$jg();
    return null;
}
function $020f0f14624a1d9c$var$Ik() {
    if (null !== $020f0f14624a1d9c$var$xk) {
        var a = $020f0f14624a1d9c$var$Dc($020f0f14624a1d9c$var$yk), b = $020f0f14624a1d9c$var$pk.transition, c = $020f0f14624a1d9c$var$C;
        try {
            $020f0f14624a1d9c$var$pk.transition = null;
            $020f0f14624a1d9c$var$C = 16 > a ? 16 : a;
            if (null === $020f0f14624a1d9c$var$xk) var d = !1;
            else {
                a = $020f0f14624a1d9c$var$xk;
                $020f0f14624a1d9c$var$xk = null;
                $020f0f14624a1d9c$var$yk = 0;
                if (0 !== ($020f0f14624a1d9c$var$K & 6)) throw Error($020f0f14624a1d9c$var$p(331));
                var e = $020f0f14624a1d9c$var$K;
                $020f0f14624a1d9c$var$K |= 4;
                for($020f0f14624a1d9c$var$V = a.current; null !== $020f0f14624a1d9c$var$V;){
                    var f = $020f0f14624a1d9c$var$V, g = f.child;
                    if (0 !== ($020f0f14624a1d9c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($020f0f14624a1d9c$var$V = l; null !== $020f0f14624a1d9c$var$V;){
                                    var m = $020f0f14624a1d9c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $020f0f14624a1d9c$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $020f0f14624a1d9c$var$V = q;
                                    else for(; null !== $020f0f14624a1d9c$var$V;){
                                        m = $020f0f14624a1d9c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $020f0f14624a1d9c$var$Tj(m);
                                        if (m === l) {
                                            $020f0f14624a1d9c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $020f0f14624a1d9c$var$V = r;
                                            break;
                                        }
                                        $020f0f14624a1d9c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $020f0f14624a1d9c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $020f0f14624a1d9c$var$V = g;
                    else b: for(; null !== $020f0f14624a1d9c$var$V;){
                        f = $020f0f14624a1d9c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $020f0f14624a1d9c$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $020f0f14624a1d9c$var$V = x;
                            break b;
                        }
                        $020f0f14624a1d9c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($020f0f14624a1d9c$var$V = w; null !== $020f0f14624a1d9c$var$V;){
                    g = $020f0f14624a1d9c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $020f0f14624a1d9c$var$V = u;
                    else b: for(g = w; null !== $020f0f14624a1d9c$var$V;){
                        h = $020f0f14624a1d9c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $020f0f14624a1d9c$var$Rj(9, h);
                            }
                        } catch (na) {
                            $020f0f14624a1d9c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $020f0f14624a1d9c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $020f0f14624a1d9c$var$V = F;
                            break b;
                        }
                        $020f0f14624a1d9c$var$V = h.return;
                    }
                }
                $020f0f14624a1d9c$var$K = e;
                $020f0f14624a1d9c$var$jg();
                if ($020f0f14624a1d9c$var$lc && "function" === typeof $020f0f14624a1d9c$var$lc.onPostCommitFiberRoot) try {
                    $020f0f14624a1d9c$var$lc.onPostCommitFiberRoot($020f0f14624a1d9c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $020f0f14624a1d9c$var$C = c, $020f0f14624a1d9c$var$pk.transition = b;
        }
    }
    return !1;
}
function $020f0f14624a1d9c$var$Yk(a, b, c) {
    b = $020f0f14624a1d9c$var$Ki(c, b);
    b = $020f0f14624a1d9c$var$Oi(a, b, 1);
    a = $020f0f14624a1d9c$var$dh(a, b, 1);
    b = $020f0f14624a1d9c$var$L();
    null !== a && ($020f0f14624a1d9c$var$Ac(a, 1, b), $020f0f14624a1d9c$var$Ek(a, b));
}
function $020f0f14624a1d9c$var$W(a, b, c) {
    if (3 === a.tag) $020f0f14624a1d9c$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $020f0f14624a1d9c$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $020f0f14624a1d9c$var$Si || !$020f0f14624a1d9c$var$Si.has(d))) {
                a = $020f0f14624a1d9c$var$Ki(c, a);
                a = $020f0f14624a1d9c$var$Ri(b, a, 1);
                b = $020f0f14624a1d9c$var$dh(b, a, 1);
                a = $020f0f14624a1d9c$var$L();
                null !== b && ($020f0f14624a1d9c$var$Ac(b, 1, a), $020f0f14624a1d9c$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $020f0f14624a1d9c$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $020f0f14624a1d9c$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $020f0f14624a1d9c$var$R === a && ($020f0f14624a1d9c$var$Z & c) === c && (4 === $020f0f14624a1d9c$var$T || 3 === $020f0f14624a1d9c$var$T && ($020f0f14624a1d9c$var$Z & 130023424) === $020f0f14624a1d9c$var$Z && 500 > $020f0f14624a1d9c$var$B() - $020f0f14624a1d9c$var$gk ? $020f0f14624a1d9c$var$Lk(a, 0) : $020f0f14624a1d9c$var$sk |= c);
    $020f0f14624a1d9c$var$Ek(a, b);
}
function $020f0f14624a1d9c$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $020f0f14624a1d9c$var$sc, $020f0f14624a1d9c$var$sc <<= 1, 0 === ($020f0f14624a1d9c$var$sc & 130023424) && ($020f0f14624a1d9c$var$sc = 4194304)));
    var c = $020f0f14624a1d9c$var$L();
    a = $020f0f14624a1d9c$var$Zg(a, b);
    null !== a && ($020f0f14624a1d9c$var$Ac(a, b, c), $020f0f14624a1d9c$var$Ek(a, c));
}
function $020f0f14624a1d9c$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $020f0f14624a1d9c$var$Zk(a, c);
}
function $020f0f14624a1d9c$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($020f0f14624a1d9c$var$p(314));
    }
    null !== d && d.delete(b);
    $020f0f14624a1d9c$var$Zk(a, c);
}
var $020f0f14624a1d9c$var$Wk;
$020f0f14624a1d9c$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $020f0f14624a1d9c$var$Wf.current) $020f0f14624a1d9c$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $020f0f14624a1d9c$var$Ug = !1, $020f0f14624a1d9c$var$zj(a, b, c);
            $020f0f14624a1d9c$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $020f0f14624a1d9c$var$Ug = !1, $020f0f14624a1d9c$var$I && 0 !== (b.flags & 1048576) && $020f0f14624a1d9c$var$ug(b, $020f0f14624a1d9c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $020f0f14624a1d9c$var$jj(a, b);
            a = b.pendingProps;
            var e = $020f0f14624a1d9c$var$Yf(b, $020f0f14624a1d9c$var$H.current);
            $020f0f14624a1d9c$var$Tg(b, c);
            e = $020f0f14624a1d9c$var$Xh(null, b, d, a, e, c);
            var f = $020f0f14624a1d9c$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $020f0f14624a1d9c$var$Zf(d) ? (f = !0, $020f0f14624a1d9c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $020f0f14624a1d9c$var$ah(b), e.updater = $020f0f14624a1d9c$var$nh, b.stateNode = e, e._reactInternals = b, $020f0f14624a1d9c$var$rh(b, d, a, c), b = $020f0f14624a1d9c$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $020f0f14624a1d9c$var$I && f && $020f0f14624a1d9c$var$vg(b), $020f0f14624a1d9c$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $020f0f14624a1d9c$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $020f0f14624a1d9c$var$$k(d);
                a = $020f0f14624a1d9c$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $020f0f14624a1d9c$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $020f0f14624a1d9c$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $020f0f14624a1d9c$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $020f0f14624a1d9c$var$aj(null, b, d, $020f0f14624a1d9c$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($020f0f14624a1d9c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $020f0f14624a1d9c$var$Lg(d, e), $020f0f14624a1d9c$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $020f0f14624a1d9c$var$Lg(d, e), $020f0f14624a1d9c$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $020f0f14624a1d9c$var$lj(b);
                if (null === a) throw Error($020f0f14624a1d9c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $020f0f14624a1d9c$var$bh(a, b);
                $020f0f14624a1d9c$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $020f0f14624a1d9c$var$Ki(Error($020f0f14624a1d9c$var$p(423)), b);
                        b = $020f0f14624a1d9c$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $020f0f14624a1d9c$var$Ki(Error($020f0f14624a1d9c$var$p(424)), b);
                        b = $020f0f14624a1d9c$var$mj(a, b, d, c, e);
                        break a;
                    } else for($020f0f14624a1d9c$var$yg = $020f0f14624a1d9c$var$Lf(b.stateNode.containerInfo.firstChild), $020f0f14624a1d9c$var$xg = b, $020f0f14624a1d9c$var$I = !0, $020f0f14624a1d9c$var$zg = null, c = $020f0f14624a1d9c$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $020f0f14624a1d9c$var$Ig();
                    if (d === e) {
                        b = $020f0f14624a1d9c$var$$i(a, b, c);
                        break a;
                    }
                    $020f0f14624a1d9c$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $020f0f14624a1d9c$var$Kh(b), null === a && $020f0f14624a1d9c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $020f0f14624a1d9c$var$Ef(d, e) ? g = null : null !== f && $020f0f14624a1d9c$var$Ef(d, f) && (b.flags |= 32), $020f0f14624a1d9c$var$hj(a, b), $020f0f14624a1d9c$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $020f0f14624a1d9c$var$Eg(b), null;
        case 13:
            return $020f0f14624a1d9c$var$pj(a, b, c);
        case 4:
            return $020f0f14624a1d9c$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $020f0f14624a1d9c$var$Bh(b, null, d, c) : $020f0f14624a1d9c$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $020f0f14624a1d9c$var$Lg(d, e), $020f0f14624a1d9c$var$Zi(a, b, d, e, c);
        case 7:
            return $020f0f14624a1d9c$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $020f0f14624a1d9c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $020f0f14624a1d9c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $020f0f14624a1d9c$var$G($020f0f14624a1d9c$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($020f0f14624a1d9c$var$He(f.value, g)) {
                        if (f.children === e.children && !$020f0f14624a1d9c$var$Wf.current) {
                            b = $020f0f14624a1d9c$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $020f0f14624a1d9c$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $020f0f14624a1d9c$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($020f0f14624a1d9c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $020f0f14624a1d9c$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $020f0f14624a1d9c$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $020f0f14624a1d9c$var$Tg(b, c), e = $020f0f14624a1d9c$var$Vg(e), d = d(e), b.flags |= 1, $020f0f14624a1d9c$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $020f0f14624a1d9c$var$Lg(d, b.pendingProps), e = $020f0f14624a1d9c$var$Lg(d.type, e), $020f0f14624a1d9c$var$aj(a, b, d, e, c);
        case 15:
            return $020f0f14624a1d9c$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $020f0f14624a1d9c$var$Lg(d, e), $020f0f14624a1d9c$var$jj(a, b), b.tag = 1, $020f0f14624a1d9c$var$Zf(d) ? (a = !0, $020f0f14624a1d9c$var$cg(b)) : a = !1, $020f0f14624a1d9c$var$Tg(b, c), $020f0f14624a1d9c$var$ph(b, d, e), $020f0f14624a1d9c$var$rh(b, d, e, c), $020f0f14624a1d9c$var$kj(null, b, d, !0, a, c);
        case 19:
            return $020f0f14624a1d9c$var$yj(a, b, c);
        case 22:
            return $020f0f14624a1d9c$var$ej(a, b, c);
    }
    throw Error($020f0f14624a1d9c$var$p(156, b.tag));
};
function $020f0f14624a1d9c$var$Gk(a, b) {
    return $020f0f14624a1d9c$var$ac(a, b);
}
function $020f0f14624a1d9c$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $020f0f14624a1d9c$var$Bg(a, b, c, d) {
    return new $020f0f14624a1d9c$var$al(a, b, c, d);
}
function $020f0f14624a1d9c$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $020f0f14624a1d9c$var$$k(a) {
    if ("function" === typeof a) return $020f0f14624a1d9c$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $020f0f14624a1d9c$var$Da) return 11;
        if (a === $020f0f14624a1d9c$var$Ga) return 14;
    }
    return 2;
}
function $020f0f14624a1d9c$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $020f0f14624a1d9c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $020f0f14624a1d9c$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $020f0f14624a1d9c$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $020f0f14624a1d9c$var$ya:
            return $020f0f14624a1d9c$var$Ah(c.children, e, f, b);
        case $020f0f14624a1d9c$var$za:
            g = 8;
            e |= 8;
            break;
        case $020f0f14624a1d9c$var$Aa:
            return a = $020f0f14624a1d9c$var$Bg(12, c, b, e | 2), a.elementType = $020f0f14624a1d9c$var$Aa, a.lanes = f, a;
        case $020f0f14624a1d9c$var$Ea:
            return a = $020f0f14624a1d9c$var$Bg(13, c, b, e), a.elementType = $020f0f14624a1d9c$var$Ea, a.lanes = f, a;
        case $020f0f14624a1d9c$var$Fa:
            return a = $020f0f14624a1d9c$var$Bg(19, c, b, e), a.elementType = $020f0f14624a1d9c$var$Fa, a.lanes = f, a;
        case $020f0f14624a1d9c$var$Ia:
            return $020f0f14624a1d9c$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $020f0f14624a1d9c$var$Ba:
                    g = 10;
                    break a;
                case $020f0f14624a1d9c$var$Ca:
                    g = 9;
                    break a;
                case $020f0f14624a1d9c$var$Da:
                    g = 11;
                    break a;
                case $020f0f14624a1d9c$var$Ga:
                    g = 14;
                    break a;
                case $020f0f14624a1d9c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($020f0f14624a1d9c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $020f0f14624a1d9c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $020f0f14624a1d9c$var$Ah(a, b, c, d) {
    a = $020f0f14624a1d9c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $020f0f14624a1d9c$var$qj(a, b, c, d) {
    a = $020f0f14624a1d9c$var$Bg(22, a, d, b);
    a.elementType = $020f0f14624a1d9c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $020f0f14624a1d9c$var$xh(a, b, c) {
    a = $020f0f14624a1d9c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $020f0f14624a1d9c$var$zh(a, b, c) {
    b = $020f0f14624a1d9c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $020f0f14624a1d9c$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $020f0f14624a1d9c$var$zc(0);
    this.expirationTimes = $020f0f14624a1d9c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $020f0f14624a1d9c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $020f0f14624a1d9c$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $020f0f14624a1d9c$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $020f0f14624a1d9c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $020f0f14624a1d9c$var$ah(f);
    return a;
}
function $020f0f14624a1d9c$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $020f0f14624a1d9c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $020f0f14624a1d9c$var$el(a) {
    if (!a) return $020f0f14624a1d9c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($020f0f14624a1d9c$var$Vb(a) !== a || 1 !== a.tag) throw Error($020f0f14624a1d9c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($020f0f14624a1d9c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($020f0f14624a1d9c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($020f0f14624a1d9c$var$Zf(c)) return $020f0f14624a1d9c$var$bg(a, c, b);
    }
    return b;
}
function $020f0f14624a1d9c$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $020f0f14624a1d9c$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $020f0f14624a1d9c$var$el(null);
    c = a.current;
    d = $020f0f14624a1d9c$var$L();
    e = $020f0f14624a1d9c$var$lh(c);
    f = $020f0f14624a1d9c$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $020f0f14624a1d9c$var$dh(c, f, e);
    a.current.lanes = e;
    $020f0f14624a1d9c$var$Ac(a, e, d);
    $020f0f14624a1d9c$var$Ek(a, d);
    return a;
}
function $020f0f14624a1d9c$var$gl(a, b, c, d) {
    var e = b.current, f = $020f0f14624a1d9c$var$L(), g = $020f0f14624a1d9c$var$lh(e);
    c = $020f0f14624a1d9c$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $020f0f14624a1d9c$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $020f0f14624a1d9c$var$dh(e, b, g);
    null !== a && ($020f0f14624a1d9c$var$mh(a, e, g, f), $020f0f14624a1d9c$var$eh(a, e, g));
    return g;
}
function $020f0f14624a1d9c$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $020f0f14624a1d9c$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $020f0f14624a1d9c$var$jl(a, b) {
    $020f0f14624a1d9c$var$il(a, b);
    (a = a.alternate) && $020f0f14624a1d9c$var$il(a, b);
}
function $020f0f14624a1d9c$var$kl() {
    return null;
}
var $020f0f14624a1d9c$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $020f0f14624a1d9c$var$ml(a) {
    this._internalRoot = a;
}
$020f0f14624a1d9c$var$nl.prototype.render = $020f0f14624a1d9c$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($020f0f14624a1d9c$var$p(409));
    $020f0f14624a1d9c$var$gl(a, b, null, null);
};
$020f0f14624a1d9c$var$nl.prototype.unmount = $020f0f14624a1d9c$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $020f0f14624a1d9c$var$Sk(function() {
            $020f0f14624a1d9c$var$gl(null, a, null, null);
        });
        b[$020f0f14624a1d9c$var$uf] = null;
    }
};
function $020f0f14624a1d9c$var$nl(a) {
    this._internalRoot = a;
}
$020f0f14624a1d9c$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $020f0f14624a1d9c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $020f0f14624a1d9c$var$Qc.length && 0 !== b && b < $020f0f14624a1d9c$var$Qc[c].priority; c++);
        $020f0f14624a1d9c$var$Qc.splice(c, 0, a);
        0 === c && $020f0f14624a1d9c$var$Vc(a);
    }
};
function $020f0f14624a1d9c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $020f0f14624a1d9c$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $020f0f14624a1d9c$var$ql() {}
function $020f0f14624a1d9c$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $020f0f14624a1d9c$var$hl(g);
                f.call(a);
            };
        }
        var g = $020f0f14624a1d9c$var$fl(b, d, a, 0, null, !1, !1, "", $020f0f14624a1d9c$var$ql);
        a._reactRootContainer = g;
        a[$020f0f14624a1d9c$var$uf] = g.current;
        $020f0f14624a1d9c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $020f0f14624a1d9c$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $020f0f14624a1d9c$var$hl(k);
            h.call(a);
        };
    }
    var k = $020f0f14624a1d9c$var$cl(a, 0, !1, null, null, !1, !1, "", $020f0f14624a1d9c$var$ql);
    a._reactRootContainer = k;
    a[$020f0f14624a1d9c$var$uf] = k.current;
    $020f0f14624a1d9c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $020f0f14624a1d9c$var$Sk(function() {
        $020f0f14624a1d9c$var$gl(b, k, c, d);
    });
    return k;
}
function $020f0f14624a1d9c$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $020f0f14624a1d9c$var$hl(g);
                h.call(a);
            };
        }
        $020f0f14624a1d9c$var$gl(b, g, a, e);
    } else g = $020f0f14624a1d9c$var$rl(c, b, a, e, d);
    return $020f0f14624a1d9c$var$hl(g);
}
$020f0f14624a1d9c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $020f0f14624a1d9c$var$tc(b.pendingLanes);
                0 !== c && ($020f0f14624a1d9c$var$Cc(b, c | 1), $020f0f14624a1d9c$var$Ek(b, $020f0f14624a1d9c$var$B()), 0 === ($020f0f14624a1d9c$var$K & 6) && ($020f0f14624a1d9c$var$Hj = $020f0f14624a1d9c$var$B() + 500, $020f0f14624a1d9c$var$jg()));
            }
            break;
        case 13:
            $020f0f14624a1d9c$var$Sk(function() {
                var b = $020f0f14624a1d9c$var$Zg(a, 1);
                if (null !== b) {
                    var c = $020f0f14624a1d9c$var$L();
                    $020f0f14624a1d9c$var$mh(b, a, 1, c);
                }
            }), $020f0f14624a1d9c$var$jl(a, 1);
    }
};
$020f0f14624a1d9c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $020f0f14624a1d9c$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $020f0f14624a1d9c$var$L();
            $020f0f14624a1d9c$var$mh(b, a, 134217728, c);
        }
        $020f0f14624a1d9c$var$jl(a, 134217728);
    }
};
$020f0f14624a1d9c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $020f0f14624a1d9c$var$lh(a), c = $020f0f14624a1d9c$var$Zg(a, b);
        if (null !== c) {
            var d = $020f0f14624a1d9c$var$L();
            $020f0f14624a1d9c$var$mh(c, a, b, d);
        }
        $020f0f14624a1d9c$var$jl(a, b);
    }
};
$020f0f14624a1d9c$var$Hc = function() {
    return $020f0f14624a1d9c$var$C;
};
$020f0f14624a1d9c$var$Ic = function(a, b) {
    var c = $020f0f14624a1d9c$var$C;
    try {
        return $020f0f14624a1d9c$var$C = a, b();
    } finally{
        $020f0f14624a1d9c$var$C = c;
    }
};
$020f0f14624a1d9c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $020f0f14624a1d9c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $020f0f14624a1d9c$var$Db(d);
                        if (!e) throw Error($020f0f14624a1d9c$var$p(90));
                        $020f0f14624a1d9c$var$Wa(d);
                        $020f0f14624a1d9c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $020f0f14624a1d9c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $020f0f14624a1d9c$var$fb(a, !!c.multiple, b, !1);
    }
};
$020f0f14624a1d9c$var$Gb = $020f0f14624a1d9c$var$Rk;
$020f0f14624a1d9c$var$Hb = $020f0f14624a1d9c$var$Sk;
var $020f0f14624a1d9c$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $020f0f14624a1d9c$var$Cb,
        $020f0f14624a1d9c$var$ue,
        $020f0f14624a1d9c$var$Db,
        $020f0f14624a1d9c$var$Eb,
        $020f0f14624a1d9c$var$Fb,
        $020f0f14624a1d9c$var$Rk
    ]
}, $020f0f14624a1d9c$var$ul = {
    findFiberByHostInstance: $020f0f14624a1d9c$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $020f0f14624a1d9c$var$vl = {
    bundleType: $020f0f14624a1d9c$var$ul.bundleType,
    version: $020f0f14624a1d9c$var$ul.version,
    rendererPackageName: $020f0f14624a1d9c$var$ul.rendererPackageName,
    rendererConfig: $020f0f14624a1d9c$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $020f0f14624a1d9c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $020f0f14624a1d9c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $020f0f14624a1d9c$var$ul.findFiberByHostInstance || $020f0f14624a1d9c$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $020f0f14624a1d9c$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$020f0f14624a1d9c$var$wl.isDisabled && $020f0f14624a1d9c$var$wl.supportsFiber) try {
        $020f0f14624a1d9c$var$kc = $020f0f14624a1d9c$var$wl.inject($020f0f14624a1d9c$var$vl), $020f0f14624a1d9c$var$lc = $020f0f14624a1d9c$var$wl;
    } catch (a) {}
}
$020f0f14624a1d9c$export$ae55be85d98224ed = $020f0f14624a1d9c$var$tl;
$020f0f14624a1d9c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$020f0f14624a1d9c$var$ol(b)) throw Error($020f0f14624a1d9c$var$p(200));
    return $020f0f14624a1d9c$var$dl(a, b, null, c);
};
$020f0f14624a1d9c$export$882461b6382ed46c = function(a, b) {
    if (!$020f0f14624a1d9c$var$ol(a)) throw Error($020f0f14624a1d9c$var$p(299));
    var c = !1, d = "", e = $020f0f14624a1d9c$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $020f0f14624a1d9c$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$020f0f14624a1d9c$var$uf] = b.current;
    $020f0f14624a1d9c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $020f0f14624a1d9c$var$ml(b);
};
$020f0f14624a1d9c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($020f0f14624a1d9c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($020f0f14624a1d9c$var$p(268, a));
    }
    a = $020f0f14624a1d9c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$020f0f14624a1d9c$export$cd75ccfd720a3cd4 = function(a) {
    return $020f0f14624a1d9c$var$Sk(a);
};
$020f0f14624a1d9c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$020f0f14624a1d9c$var$pl(b)) throw Error($020f0f14624a1d9c$var$p(200));
    return $020f0f14624a1d9c$var$sl(null, a, b, !0, c);
};
$020f0f14624a1d9c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$020f0f14624a1d9c$var$ol(a)) throw Error($020f0f14624a1d9c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $020f0f14624a1d9c$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $020f0f14624a1d9c$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$020f0f14624a1d9c$var$uf] = b.current;
    $020f0f14624a1d9c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $020f0f14624a1d9c$var$nl(b);
};
$020f0f14624a1d9c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$020f0f14624a1d9c$var$pl(b)) throw Error($020f0f14624a1d9c$var$p(200));
    return $020f0f14624a1d9c$var$sl(null, a, b, !1, c);
};
$020f0f14624a1d9c$export$502457920280e6be = function(a) {
    if (!$020f0f14624a1d9c$var$pl(a)) throw Error($020f0f14624a1d9c$var$p(40));
    return a._reactRootContainer ? ($020f0f14624a1d9c$var$Sk(function() {
        $020f0f14624a1d9c$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$020f0f14624a1d9c$var$uf] = null;
        });
    }), !0) : !1;
};
$020f0f14624a1d9c$export$c78a37762a8d58e1 = $020f0f14624a1d9c$var$Rk;
$020f0f14624a1d9c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$020f0f14624a1d9c$var$pl(c)) throw Error($020f0f14624a1d9c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($020f0f14624a1d9c$var$p(38));
    return $020f0f14624a1d9c$var$sl(a, b, c, !1, d);
};
$020f0f14624a1d9c$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("SIuCF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kL14H"));

});
parcelRegister("kL14H", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $f1c907df267950dc$export$c4744153514ff05d, (v) => $f1c907df267950dc$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $f1c907df267950dc$export$3e506c1ccc9cc1a7, (v) => $f1c907df267950dc$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $f1c907df267950dc$export$e26fe2ed2fa76875, (v) => $f1c907df267950dc$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $f1c907df267950dc$export$502329bbf4b505b1, (v) => $f1c907df267950dc$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $f1c907df267950dc$export$6e3807111c4874c4, (v) => $f1c907df267950dc$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $f1c907df267950dc$export$c27134553091fb3a, (v) => $f1c907df267950dc$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $f1c907df267950dc$export$33ee1acdc04fd2a2, (v) => $f1c907df267950dc$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $f1c907df267950dc$export$b00a404bbd5edef2, (v) => $f1c907df267950dc$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $f1c907df267950dc$export$8352ce38b91d0c62, (v) => $f1c907df267950dc$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $f1c907df267950dc$export$d66a1c1c77bd778b, (v) => $f1c907df267950dc$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $f1c907df267950dc$export$d3dfb8e4810cb555, (v) => $f1c907df267950dc$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $f1c907df267950dc$export$839f9183b0465a69, (v) => $f1c907df267950dc$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $f1c907df267950dc$export$72fdf0e06517287b, (v) => $f1c907df267950dc$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $f1c907df267950dc$export$4b844e58a3e414b4, (v) => $f1c907df267950dc$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $f1c907df267950dc$export$816d2913ae6b83b1, (v) => $f1c907df267950dc$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $f1c907df267950dc$export$61bcfe829111a1d0, (v) => $f1c907df267950dc$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $f1c907df267950dc$export$7ee8c9beb337bc3f, (v) => $f1c907df267950dc$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $f1c907df267950dc$export$b5836b71941fa3ed, (v) => $f1c907df267950dc$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $f1c907df267950dc$export$cf845f2c119da08a, (v) => $f1c907df267950dc$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f1c907df267950dc$export$c4744153514ff05d;
var $f1c907df267950dc$export$3e506c1ccc9cc1a7;
var $f1c907df267950dc$export$e26fe2ed2fa76875;
var $f1c907df267950dc$export$502329bbf4b505b1;
var $f1c907df267950dc$export$6e3807111c4874c4;
var $f1c907df267950dc$export$c27134553091fb3a;
var $f1c907df267950dc$export$33ee1acdc04fd2a2;
var $f1c907df267950dc$export$b00a404bbd5edef2;
var $f1c907df267950dc$export$8352ce38b91d0c62;
var $f1c907df267950dc$export$d66a1c1c77bd778b;
var $f1c907df267950dc$export$d3dfb8e4810cb555;
var $f1c907df267950dc$export$839f9183b0465a69;
var $f1c907df267950dc$export$72fdf0e06517287b;
var $f1c907df267950dc$export$4b844e58a3e414b4;
var $f1c907df267950dc$export$816d2913ae6b83b1;
var $f1c907df267950dc$export$61bcfe829111a1d0;
var $f1c907df267950dc$export$7ee8c9beb337bc3f;
var $f1c907df267950dc$export$b5836b71941fa3ed;
var $f1c907df267950dc$export$cf845f2c119da08a;
"use strict";
function $f1c907df267950dc$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f1c907df267950dc$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f1c907df267950dc$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f1c907df267950dc$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f1c907df267950dc$var$g(C, c)) n < e && 0 > $f1c907df267950dc$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f1c907df267950dc$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f1c907df267950dc$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f1c907df267950dc$var$l = performance;
    $f1c907df267950dc$export$c4744153514ff05d = function() {
        return $f1c907df267950dc$var$l.now();
    };
} else {
    var $f1c907df267950dc$var$p = Date, $f1c907df267950dc$var$q = $f1c907df267950dc$var$p.now();
    $f1c907df267950dc$export$c4744153514ff05d = function() {
        return $f1c907df267950dc$var$p.now() - $f1c907df267950dc$var$q;
    };
}
var $f1c907df267950dc$var$r = [], $f1c907df267950dc$var$t = [], $f1c907df267950dc$var$u = 1, $f1c907df267950dc$var$v = null, $f1c907df267950dc$var$y = 3, $f1c907df267950dc$var$z = !1, $f1c907df267950dc$var$A = !1, $f1c907df267950dc$var$B = !1, $f1c907df267950dc$var$D = "function" === typeof setTimeout ? setTimeout : null, $f1c907df267950dc$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f1c907df267950dc$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f1c907df267950dc$var$G(a) {
    for(var b = $f1c907df267950dc$var$h($f1c907df267950dc$var$t); null !== b;){
        if (null === b.callback) $f1c907df267950dc$var$k($f1c907df267950dc$var$t);
        else if (b.startTime <= a) $f1c907df267950dc$var$k($f1c907df267950dc$var$t), b.sortIndex = b.expirationTime, $f1c907df267950dc$var$f($f1c907df267950dc$var$r, b);
        else break;
        b = $f1c907df267950dc$var$h($f1c907df267950dc$var$t);
    }
}
function $f1c907df267950dc$var$H(a) {
    $f1c907df267950dc$var$B = !1;
    $f1c907df267950dc$var$G(a);
    if (!$f1c907df267950dc$var$A) {
        if (null !== $f1c907df267950dc$var$h($f1c907df267950dc$var$r)) $f1c907df267950dc$var$A = !0, $f1c907df267950dc$var$I($f1c907df267950dc$var$J);
        else {
            var b = $f1c907df267950dc$var$h($f1c907df267950dc$var$t);
            null !== b && $f1c907df267950dc$var$K($f1c907df267950dc$var$H, b.startTime - a);
        }
    }
}
function $f1c907df267950dc$var$J(a, b) {
    $f1c907df267950dc$var$A = !1;
    $f1c907df267950dc$var$B && ($f1c907df267950dc$var$B = !1, $f1c907df267950dc$var$E($f1c907df267950dc$var$L), $f1c907df267950dc$var$L = -1);
    $f1c907df267950dc$var$z = !0;
    var c = $f1c907df267950dc$var$y;
    try {
        $f1c907df267950dc$var$G(b);
        for($f1c907df267950dc$var$v = $f1c907df267950dc$var$h($f1c907df267950dc$var$r); null !== $f1c907df267950dc$var$v && (!($f1c907df267950dc$var$v.expirationTime > b) || a && !$f1c907df267950dc$var$M());){
            var d = $f1c907df267950dc$var$v.callback;
            if ("function" === typeof d) {
                $f1c907df267950dc$var$v.callback = null;
                $f1c907df267950dc$var$y = $f1c907df267950dc$var$v.priorityLevel;
                var e = d($f1c907df267950dc$var$v.expirationTime <= b);
                b = $f1c907df267950dc$export$c4744153514ff05d();
                "function" === typeof e ? $f1c907df267950dc$var$v.callback = e : $f1c907df267950dc$var$v === $f1c907df267950dc$var$h($f1c907df267950dc$var$r) && $f1c907df267950dc$var$k($f1c907df267950dc$var$r);
                $f1c907df267950dc$var$G(b);
            } else $f1c907df267950dc$var$k($f1c907df267950dc$var$r);
            $f1c907df267950dc$var$v = $f1c907df267950dc$var$h($f1c907df267950dc$var$r);
        }
        if (null !== $f1c907df267950dc$var$v) var w = !0;
        else {
            var m = $f1c907df267950dc$var$h($f1c907df267950dc$var$t);
            null !== m && $f1c907df267950dc$var$K($f1c907df267950dc$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f1c907df267950dc$var$v = null, $f1c907df267950dc$var$y = c, $f1c907df267950dc$var$z = !1;
    }
}
var $f1c907df267950dc$var$N = !1, $f1c907df267950dc$var$O = null, $f1c907df267950dc$var$L = -1, $f1c907df267950dc$var$P = 5, $f1c907df267950dc$var$Q = -1;
function $f1c907df267950dc$var$M() {
    return $f1c907df267950dc$export$c4744153514ff05d() - $f1c907df267950dc$var$Q < $f1c907df267950dc$var$P ? !1 : !0;
}
function $f1c907df267950dc$var$R() {
    if (null !== $f1c907df267950dc$var$O) {
        var a = $f1c907df267950dc$export$c4744153514ff05d();
        $f1c907df267950dc$var$Q = a;
        var b = !0;
        try {
            b = $f1c907df267950dc$var$O(!0, a);
        } finally{
            b ? $f1c907df267950dc$var$S() : ($f1c907df267950dc$var$N = !1, $f1c907df267950dc$var$O = null);
        }
    } else $f1c907df267950dc$var$N = !1;
}
var $f1c907df267950dc$var$S;
if ("function" === typeof $f1c907df267950dc$var$F) $f1c907df267950dc$var$S = function() {
    $f1c907df267950dc$var$F($f1c907df267950dc$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f1c907df267950dc$var$T = new MessageChannel, $f1c907df267950dc$var$U = $f1c907df267950dc$var$T.port2;
    $f1c907df267950dc$var$T.port1.onmessage = $f1c907df267950dc$var$R;
    $f1c907df267950dc$var$S = function() {
        $f1c907df267950dc$var$U.postMessage(null);
    };
} else $f1c907df267950dc$var$S = function() {
    $f1c907df267950dc$var$D($f1c907df267950dc$var$R, 0);
};
function $f1c907df267950dc$var$I(a) {
    $f1c907df267950dc$var$O = a;
    $f1c907df267950dc$var$N || ($f1c907df267950dc$var$N = !0, $f1c907df267950dc$var$S());
}
function $f1c907df267950dc$var$K(a, b) {
    $f1c907df267950dc$var$L = $f1c907df267950dc$var$D(function() {
        a($f1c907df267950dc$export$c4744153514ff05d());
    }, b);
}
$f1c907df267950dc$export$3e506c1ccc9cc1a7 = 5;
$f1c907df267950dc$export$e26fe2ed2fa76875 = 1;
$f1c907df267950dc$export$502329bbf4b505b1 = 4;
$f1c907df267950dc$export$6e3807111c4874c4 = 3;
$f1c907df267950dc$export$c27134553091fb3a = null;
$f1c907df267950dc$export$33ee1acdc04fd2a2 = 2;
$f1c907df267950dc$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f1c907df267950dc$export$8352ce38b91d0c62 = function() {
    $f1c907df267950dc$var$A || $f1c907df267950dc$var$z || ($f1c907df267950dc$var$A = !0, $f1c907df267950dc$var$I($f1c907df267950dc$var$J));
};
$f1c907df267950dc$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f1c907df267950dc$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f1c907df267950dc$export$d3dfb8e4810cb555 = function() {
    return $f1c907df267950dc$var$y;
};
$f1c907df267950dc$export$839f9183b0465a69 = function() {
    return $f1c907df267950dc$var$h($f1c907df267950dc$var$r);
};
$f1c907df267950dc$export$72fdf0e06517287b = function(a) {
    switch($f1c907df267950dc$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f1c907df267950dc$var$y;
    }
    var c = $f1c907df267950dc$var$y;
    $f1c907df267950dc$var$y = b;
    try {
        return a();
    } finally{
        $f1c907df267950dc$var$y = c;
    }
};
$f1c907df267950dc$export$4b844e58a3e414b4 = function() {};
$f1c907df267950dc$export$816d2913ae6b83b1 = function() {};
$f1c907df267950dc$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f1c907df267950dc$var$y;
    $f1c907df267950dc$var$y = a;
    try {
        return b();
    } finally{
        $f1c907df267950dc$var$y = c;
    }
};
$f1c907df267950dc$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f1c907df267950dc$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f1c907df267950dc$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f1c907df267950dc$var$f($f1c907df267950dc$var$t, a), null === $f1c907df267950dc$var$h($f1c907df267950dc$var$r) && a === $f1c907df267950dc$var$h($f1c907df267950dc$var$t) && ($f1c907df267950dc$var$B ? ($f1c907df267950dc$var$E($f1c907df267950dc$var$L), $f1c907df267950dc$var$L = -1) : $f1c907df267950dc$var$B = !0, $f1c907df267950dc$var$K($f1c907df267950dc$var$H, c - d))) : (a.sortIndex = e, $f1c907df267950dc$var$f($f1c907df267950dc$var$r, a), $f1c907df267950dc$var$A || $f1c907df267950dc$var$z || ($f1c907df267950dc$var$A = !0, $f1c907df267950dc$var$I($f1c907df267950dc$var$J)));
    return a;
};
$f1c907df267950dc$export$b5836b71941fa3ed = $f1c907df267950dc$var$M;
$f1c907df267950dc$export$cf845f2c119da08a = function(a) {
    var b = $f1c907df267950dc$var$y;
    return function() {
        var c = $f1c907df267950dc$var$y;
        $f1c907df267950dc$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f1c907df267950dc$var$y = c;
        }
    };
};

});



parcelRegister("iGccQ", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $d9959e24dc215742$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $d9959e24dc215742$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "Link", () => $d9959e24dc215742$export$a6c7ac8248d6e38a);
/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $50vd1 = parcelRequire("50vd1");

var $idNu3 = parcelRequire("idNu3");

var $fspFK = parcelRequire("fspFK");
var $4CHxl = parcelRequire("4CHxl");

var $fspFK = parcelRequire("fspFK");
function $d9959e24dc215742$var$_extends() {
    $d9959e24dc215742$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9959e24dc215742$var$_extends.apply(this, arguments);
}
function $d9959e24dc215742$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d9959e24dc215742$var$defaultMethod = "get";
const $d9959e24dc215742$var$defaultEncType = "application/x-www-form-urlencoded";
function $d9959e24dc215742$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d9959e24dc215742$var$isButtonElement(object) {
    return $d9959e24dc215742$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d9959e24dc215742$var$isFormElement(object) {
    return $d9959e24dc215742$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d9959e24dc215742$var$isInputElement(object) {
    return $d9959e24dc215742$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d9959e24dc215742$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d9959e24dc215742$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d9959e24dc215742$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d9959e24dc215742$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d9959e24dc215742$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d9959e24dc215742$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d9959e24dc215742$var$_formDataSupportsSubmitter = null;
function $d9959e24dc215742$var$isFormDataSubmitterSupported() {
    if ($d9959e24dc215742$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d9959e24dc215742$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d9959e24dc215742$var$_formDataSupportsSubmitter = true;
    }
    return $d9959e24dc215742$var$_formDataSupportsSubmitter;
}
const $d9959e24dc215742$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d9959e24dc215742$var$getFormEncType(encType) {
    if (encType != null && !$d9959e24dc215742$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d9959e24dc215742$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d9959e24dc215742$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fspFK.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $d9959e24dc215742$var$defaultMethod;
        encType = $d9959e24dc215742$var$getFormEncType(target.getAttribute("enctype")) || $d9959e24dc215742$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d9959e24dc215742$var$isButtonElement(target) || $d9959e24dc215742$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fspFK.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d9959e24dc215742$var$defaultMethod;
        encType = $d9959e24dc215742$var$getFormEncType(target.getAttribute("formenctype")) || $d9959e24dc215742$var$getFormEncType(form.getAttribute("enctype")) || $d9959e24dc215742$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d9959e24dc215742$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d9959e24dc215742$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d9959e24dc215742$var$defaultMethod;
        action = null;
        encType = $d9959e24dc215742$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d9959e24dc215742$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $d9959e24dc215742$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $d9959e24dc215742$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $d9959e24dc215742$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fspFK.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9959e24dc215742$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fspFK.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9959e24dc215742$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4CHxl.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9959e24dc215742$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fspFK.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9959e24dc215742$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fspFK.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9959e24dc215742$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4CHxl.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9959e24dc215742$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d9959e24dc215742$var$_extends({}, state, {
        errors: $d9959e24dc215742$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d9959e24dc215742$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fspFK.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d9959e24dc215742$export$7ad602f0e94e62d1 = /*#__PURE__*/ $50vd1.createContext({
    isTransitioning: false
});
const $d9959e24dc215742$export$148fd98d095596d4 = /*#__PURE__*/ $50vd1.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9959e24dc215742$var$START_TRANSITION = "startTransition";
const $d9959e24dc215742$var$startTransitionImpl = $50vd1[$d9959e24dc215742$var$START_TRANSITION];
const $d9959e24dc215742$var$FLUSH_SYNC = "flushSync";
const $d9959e24dc215742$var$flushSyncImpl = $idNu3[$d9959e24dc215742$var$FLUSH_SYNC];
const $d9959e24dc215742$var$USE_ID = "useId";
const $d9959e24dc215742$var$useIdImpl = $50vd1[$d9959e24dc215742$var$USE_ID];
function $d9959e24dc215742$var$startTransitionSafe(cb) {
    if ($d9959e24dc215742$var$startTransitionImpl) $d9959e24dc215742$var$startTransitionImpl(cb);
    else cb();
}
function $d9959e24dc215742$var$flushSyncSafe(cb) {
    if ($d9959e24dc215742$var$flushSyncImpl) $d9959e24dc215742$var$flushSyncImpl(cb);
    else cb();
}
class $d9959e24dc215742$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9959e24dc215742$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $50vd1.useState(router.state);
    let [pendingState, setPendingState] = $50vd1.useState();
    let [vtContext, setVtContext] = $50vd1.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $50vd1.useState();
    let [transition, setTransition] = $50vd1.useState();
    let [interruption, setInterruption] = $50vd1.useState();
    let fetcherData = $50vd1.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $50vd1.useCallback((cb)=>{
        if (v7_startTransition) $d9959e24dc215742$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $50vd1.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d9959e24dc215742$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d9959e24dc215742$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d9959e24dc215742$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d9959e24dc215742$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d9959e24dc215742$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $50vd1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $50vd1.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d9959e24dc215742$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $50vd1.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $50vd1.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $50vd1.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $50vd1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $50vd1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $50vd1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $50vd1.createElement($50vd1.Fragment, null, /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $50vd1.createElement($d9959e24dc215742$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $50vd1.createElement($d9959e24dc215742$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $50vd1.createElement($d9959e24dc215742$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $d9959e24dc215742$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4CHxl.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d9959e24dc215742$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $50vd1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fspFK.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $50vd1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $50vd1.useCallback((newState)=>{
        v7_startTransition && $d9959e24dc215742$var$startTransitionImpl ? $d9959e24dc215742$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $50vd1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d9959e24dc215742$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $50vd1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fspFK.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $50vd1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $50vd1.useCallback((newState)=>{
        v7_startTransition && $d9959e24dc215742$var$startTransitionImpl ? $d9959e24dc215742$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $50vd1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d9959e24dc215742$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $50vd1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $50vd1.useCallback((newState)=>{
        v7_startTransition && $d9959e24dc215742$var$startTransitionImpl ? $d9959e24dc215742$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $50vd1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $50vd1.createElement((0, $4CHxl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d9959e24dc215742$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d9959e24dc215742$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d9959e24dc215742$export$a6c7ac8248d6e38a = /*#__PURE__*/ $50vd1.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $d9959e24dc215742$var$_objectWithoutPropertiesLoose(_ref7, $d9959e24dc215742$var$_excluded);
    let { basename: basename } = $50vd1.useContext((0, $4CHxl.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d9959e24dc215742$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d9959e24dc215742$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fspFK.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4CHxl.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $d9959e24dc215742$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $50vd1.createElement("a", $d9959e24dc215742$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d9959e24dc215742$export$b0d92dbee9b5b60d = /*#__PURE__*/ $50vd1.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $d9959e24dc215742$var$_objectWithoutPropertiesLoose(_ref8, $d9959e24dc215742$var$_excluded2);
    let path = (0, $4CHxl.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $4CHxl.useLocation)();
    let routerState = $50vd1.useContext((0, $4CHxl.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $50vd1.useContext((0, $4CHxl.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d9959e24dc215742$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fspFK.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $50vd1.createElement($d9959e24dc215742$export$a6c7ac8248d6e38a, $d9959e24dc215742$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d9959e24dc215742$export$a7fed597f4b8afd8 = /*#__PURE__*/ $50vd1.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d9959e24dc215742$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $d9959e24dc215742$var$_objectWithoutPropertiesLoose(_ref9, $d9959e24dc215742$var$_excluded3);
    let submit = $d9959e24dc215742$export$47c85c6e3a081d3();
    let formAction = $d9959e24dc215742$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $50vd1.createElement("form", $d9959e24dc215742$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d9959e24dc215742$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $d9959e24dc215742$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d9959e24dc215742$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d9959e24dc215742$var$DataRouterHook || ($d9959e24dc215742$var$DataRouterHook = {}));
var $d9959e24dc215742$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d9959e24dc215742$var$DataRouterStateHook || ($d9959e24dc215742$var$DataRouterStateHook = {}));
// Internal hooks
function $d9959e24dc215742$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9959e24dc215742$var$useDataRouterContext(hookName) {
    let ctx = $50vd1.useContext((0, $4CHxl.UNSAFE_DataRouterContext));
    !ctx && (0, $fspFK.UNSAFE_invariant)(false);
    return ctx;
}
function $d9959e24dc215742$var$useDataRouterState(hookName) {
    let state = $50vd1.useContext((0, $4CHxl.UNSAFE_DataRouterStateContext));
    !state && (0, $fspFK.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d9959e24dc215742$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4CHxl.useNavigate)();
    let location = (0, $4CHxl.useLocation)();
    let path = (0, $4CHxl.useResolvedPath)(to, {
        relative: relative
    });
    return $50vd1.useCallback((event)=>{
        if ($d9959e24dc215742$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fspFK.createPath)(location) === (0, $fspFK.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d9959e24dc215742$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $50vd1.useRef($d9959e24dc215742$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $50vd1.useRef(false);
    let location = (0, $4CHxl.useLocation)();
    let searchParams = $50vd1.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d9959e24dc215742$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4CHxl.useNavigate)();
    let setSearchParams = $50vd1.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d9959e24dc215742$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d9959e24dc215742$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d9959e24dc215742$var$fetcherId = 0;
let $d9959e24dc215742$var$getUniqueFetcherId = ()=>"__" + String(++$d9959e24dc215742$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d9959e24dc215742$export$47c85c6e3a081d3() {
    let { router: router } = $d9959e24dc215742$var$useDataRouterContext($d9959e24dc215742$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $50vd1.useContext((0, $4CHxl.UNSAFE_NavigationContext));
    let currentRouteId = (0, $4CHxl.UNSAFE_useRouteId)();
    return $50vd1.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d9959e24dc215742$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d9959e24dc215742$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d9959e24dc215742$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d9959e24dc215742$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $50vd1.useContext((0, $4CHxl.UNSAFE_NavigationContext));
    let routeContext = $50vd1.useContext((0, $4CHxl.UNSAFE_RouteContext));
    !routeContext && (0, $fspFK.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d9959e24dc215742$var$_extends({}, (0, $4CHxl.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4CHxl.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fspFK.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $fspFK.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d9959e24dc215742$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d9959e24dc215742$var$useDataRouterContext($d9959e24dc215742$var$DataRouterHook.UseFetcher);
    let state = $d9959e24dc215742$var$useDataRouterState($d9959e24dc215742$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $50vd1.useContext($d9959e24dc215742$export$148fd98d095596d4);
    let route = $50vd1.useContext((0, $4CHxl.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fspFK.UNSAFE_invariant)(false);
    !route && (0, $fspFK.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $fspFK.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d9959e24dc215742$var$useIdImpl ? $d9959e24dc215742$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $50vd1.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d9959e24dc215742$var$getUniqueFetcherId());
    // Registration/cleanup
    $50vd1.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $50vd1.useCallback((href, opts)=>{
        !routeId && (0, $fspFK.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d9959e24dc215742$export$47c85c6e3a081d3();
    let submit = $50vd1.useCallback((target, opts)=>{
        submitImpl(target, $d9959e24dc215742$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $50vd1.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $50vd1.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $50vd1.createElement($d9959e24dc215742$export$a7fed597f4b8afd8, $d9959e24dc215742$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fspFK.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $50vd1.useMemo(()=>$d9959e24dc215742$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d9959e24dc215742$export$fa996778a3a31087() {
    let state = $d9959e24dc215742$var$useDataRouterState($d9959e24dc215742$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $d9959e24dc215742$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d9959e24dc215742$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d9959e24dc215742$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d9959e24dc215742$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d9959e24dc215742$var$useDataRouterContext($d9959e24dc215742$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d9959e24dc215742$var$useDataRouterState($d9959e24dc215742$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $50vd1.useContext((0, $4CHxl.UNSAFE_NavigationContext));
    let location = (0, $4CHxl.useLocation)();
    let matches = (0, $4CHxl.useMatches)();
    let navigation = (0, $4CHxl.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $50vd1.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d9959e24dc215742$var$usePageHide($50vd1.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d9959e24dc215742$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d9959e24dc215742$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d9959e24dc215742$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $50vd1.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d9959e24dc215742$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d9959e24dc215742$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $50vd1.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d9959e24dc215742$var$_extends({}, location, {
                    pathname: (0, $fspFK.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d9959e24dc215742$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $50vd1.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9959e24dc215742$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $50vd1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9959e24dc215742$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $50vd1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d9959e24dc215742$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4CHxl.useBlocker)(when);
    $50vd1.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $50vd1.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d9959e24dc215742$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $50vd1.useContext($d9959e24dc215742$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fspFK.UNSAFE_invariant)(false);
    let { basename: basename } = $d9959e24dc215742$var$useDataRouterContext($d9959e24dc215742$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4CHxl.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fspFK.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fspFK.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fspFK.matchPath)(path.pathname, nextPath) != null || (0, $fspFK.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("idNu3", function(module, exports) {
"use strict";
function $d43fd356e0f5d69c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d43fd356e0f5d69c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d43fd356e0f5d69c$var$checkDCE();

module.exports = (parcelRequire("aXsFt"));

});

parcelRegister("fspFK", function(module, exports) {

$parcel$export(module.exports, "Action", () => $b40d62889eaa1981$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $b40d62889eaa1981$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $b40d62889eaa1981$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $b40d62889eaa1981$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $b40d62889eaa1981$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $b40d62889eaa1981$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $b40d62889eaa1981$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $b40d62889eaa1981$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $b40d62889eaa1981$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $b40d62889eaa1981$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $b40d62889eaa1981$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $b40d62889eaa1981$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $b40d62889eaa1981$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $b40d62889eaa1981$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $b40d62889eaa1981$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $b40d62889eaa1981$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $b40d62889eaa1981$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $b40d62889eaa1981$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $b40d62889eaa1981$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $b40d62889eaa1981$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b40d62889eaa1981$var$_extends() {
    $b40d62889eaa1981$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b40d62889eaa1981$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b40d62889eaa1981$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b40d62889eaa1981$export$e19cd5f9376f8cee || ($b40d62889eaa1981$export$e19cd5f9376f8cee = {}));
const $b40d62889eaa1981$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b40d62889eaa1981$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b40d62889eaa1981$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b40d62889eaa1981$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b40d62889eaa1981$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b40d62889eaa1981$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b40d62889eaa1981$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b40d62889eaa1981$export$fe53371bee54353d(to);
    }
    return $b40d62889eaa1981$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b40d62889eaa1981$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b40d62889eaa1981$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b40d62889eaa1981$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b40d62889eaa1981$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b40d62889eaa1981$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b40d62889eaa1981$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b40d62889eaa1981$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b40d62889eaa1981$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b40d62889eaa1981$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b40d62889eaa1981$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b40d62889eaa1981$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b40d62889eaa1981$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b40d62889eaa1981$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b40d62889eaa1981$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b40d62889eaa1981$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b40d62889eaa1981$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b40d62889eaa1981$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Push;
        let location = $b40d62889eaa1981$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b40d62889eaa1981$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace;
        let location = $b40d62889eaa1981$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b40d62889eaa1981$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b40d62889eaa1981$export$fe53371bee54353d(to);
        $b40d62889eaa1981$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b40d62889eaa1981$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b40d62889eaa1981$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b40d62889eaa1981$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b40d62889eaa1981$var$ResultType || ($b40d62889eaa1981$var$ResultType = {}));
const $b40d62889eaa1981$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b40d62889eaa1981$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b40d62889eaa1981$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b40d62889eaa1981$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b40d62889eaa1981$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b40d62889eaa1981$var$isIndexRoute(route)) {
            let indexRoute = $b40d62889eaa1981$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b40d62889eaa1981$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b40d62889eaa1981$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b40d62889eaa1981$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b40d62889eaa1981$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b40d62889eaa1981$var$flattenRoutes(routes);
    $b40d62889eaa1981$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $b40d62889eaa1981$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $b40d62889eaa1981$var$safelyDecodeURI(pathname));
    return matches;
}
function $b40d62889eaa1981$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b40d62889eaa1981$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b40d62889eaa1981$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b40d62889eaa1981$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b40d62889eaa1981$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b40d62889eaa1981$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b40d62889eaa1981$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b40d62889eaa1981$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b40d62889eaa1981$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b40d62889eaa1981$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b40d62889eaa1981$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b40d62889eaa1981$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b40d62889eaa1981$var$paramRe = /^:[\w-]+$/;
const $b40d62889eaa1981$var$dynamicSegmentValue = 3;
const $b40d62889eaa1981$var$indexRouteValue = 2;
const $b40d62889eaa1981$var$emptySegmentValue = 1;
const $b40d62889eaa1981$var$staticSegmentValue = 10;
const $b40d62889eaa1981$var$splatPenalty = -2;
const $b40d62889eaa1981$var$isSplat = (s)=>s === "*";
function $b40d62889eaa1981$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b40d62889eaa1981$var$isSplat)) initialScore += $b40d62889eaa1981$var$splatPenalty;
    if (index) initialScore += $b40d62889eaa1981$var$indexRouteValue;
    return segments.filter((s)=>!$b40d62889eaa1981$var$isSplat(s)).reduce((score, segment)=>score + ($b40d62889eaa1981$var$paramRe.test(segment) ? $b40d62889eaa1981$var$dynamicSegmentValue : segment === "" ? $b40d62889eaa1981$var$emptySegmentValue : $b40d62889eaa1981$var$staticSegmentValue), initialScore);
}
function $b40d62889eaa1981$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b40d62889eaa1981$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b40d62889eaa1981$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b40d62889eaa1981$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b40d62889eaa1981$export$a5c6d149b50c1d86($b40d62889eaa1981$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b40d62889eaa1981$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b40d62889eaa1981$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b40d62889eaa1981$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b40d62889eaa1981$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b40d62889eaa1981$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b40d62889eaa1981$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $b40d62889eaa1981$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b40d62889eaa1981$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b40d62889eaa1981$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b40d62889eaa1981$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $b40d62889eaa1981$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $b40d62889eaa1981$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $b40d62889eaa1981$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b40d62889eaa1981$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b40d62889eaa1981$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b40d62889eaa1981$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b40d62889eaa1981$var$normalizeSearch(search),
        hash: $b40d62889eaa1981$var$normalizeHash(hash)
    };
}
function $b40d62889eaa1981$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b40d62889eaa1981$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b40d62889eaa1981$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b40d62889eaa1981$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b40d62889eaa1981$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b40d62889eaa1981$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b40d62889eaa1981$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b40d62889eaa1981$var$_extends({}, toArg);
        $b40d62889eaa1981$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b40d62889eaa1981$var$getInvalidPathError("?", "pathname", "search", to));
        $b40d62889eaa1981$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b40d62889eaa1981$var$getInvalidPathError("#", "pathname", "hash", to));
        $b40d62889eaa1981$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b40d62889eaa1981$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b40d62889eaa1981$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b40d62889eaa1981$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b40d62889eaa1981$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b40d62889eaa1981$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b40d62889eaa1981$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b40d62889eaa1981$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b40d62889eaa1981$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b40d62889eaa1981$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b40d62889eaa1981$export$42a99a7a4bc0e76a extends Error {
}
class $b40d62889eaa1981$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b40d62889eaa1981$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b40d62889eaa1981$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b40d62889eaa1981$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b40d62889eaa1981$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b40d62889eaa1981$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b40d62889eaa1981$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b40d62889eaa1981$var$unwrapTrackedPromise(value) {
    if (!$b40d62889eaa1981$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b40d62889eaa1981$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b40d62889eaa1981$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b40d62889eaa1981$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b40d62889eaa1981$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b40d62889eaa1981$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b40d62889eaa1981$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b40d62889eaa1981$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b40d62889eaa1981$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b40d62889eaa1981$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b40d62889eaa1981$var$validMutationMethods = new Set($b40d62889eaa1981$var$validMutationMethodsArr);
const $b40d62889eaa1981$var$validRequestMethodsArr = [
    "get",
    ...$b40d62889eaa1981$var$validMutationMethodsArr
];
const $b40d62889eaa1981$var$validRequestMethods = new Set($b40d62889eaa1981$var$validRequestMethodsArr);
const $b40d62889eaa1981$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b40d62889eaa1981$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b40d62889eaa1981$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b40d62889eaa1981$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b40d62889eaa1981$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b40d62889eaa1981$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b40d62889eaa1981$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b40d62889eaa1981$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b40d62889eaa1981$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b40d62889eaa1981$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b40d62889eaa1981$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b40d62889eaa1981$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $b40d62889eaa1981$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b40d62889eaa1981$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b40d62889eaa1981$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b40d62889eaa1981$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b40d62889eaa1981$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b40d62889eaa1981$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b40d62889eaa1981$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b40d62889eaa1981$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b40d62889eaa1981$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b40d62889eaa1981$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b40d62889eaa1981$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b40d62889eaa1981$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b40d62889eaa1981$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b40d62889eaa1981$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b40d62889eaa1981$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b40d62889eaa1981$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b40d62889eaa1981$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b40d62889eaa1981$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b40d62889eaa1981$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b40d62889eaa1981$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b40d62889eaa1981$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b40d62889eaa1981$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b40d62889eaa1981$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b40d62889eaa1981$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b40d62889eaa1981$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $b40d62889eaa1981$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b40d62889eaa1981$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b40d62889eaa1981$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b40d62889eaa1981$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b40d62889eaa1981$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$b40d62889eaa1981$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $b40d62889eaa1981$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $b40d62889eaa1981$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b40d62889eaa1981$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b40d62889eaa1981$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $b40d62889eaa1981$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b40d62889eaa1981$var$ResultType.error,
            error: $b40d62889eaa1981$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $b40d62889eaa1981$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b40d62889eaa1981$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b40d62889eaa1981$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b40d62889eaa1981$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $b40d62889eaa1981$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($b40d62889eaa1981$var$isDeferredResult(result)) throw $b40d62889eaa1981$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b40d62889eaa1981$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b40d62889eaa1981$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b40d62889eaa1981$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b40d62889eaa1981$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $b40d62889eaa1981$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($b40d62889eaa1981$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b40d62889eaa1981$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b40d62889eaa1981$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b40d62889eaa1981$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b40d62889eaa1981$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b40d62889eaa1981$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $b40d62889eaa1981$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b40d62889eaa1981$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b40d62889eaa1981$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b40d62889eaa1981$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $b40d62889eaa1981$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b40d62889eaa1981$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $b40d62889eaa1981$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $b40d62889eaa1981$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b40d62889eaa1981$var$isRedirectResult(actionResult) || $b40d62889eaa1981$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b40d62889eaa1981$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b40d62889eaa1981$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b40d62889eaa1981$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b40d62889eaa1981$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b40d62889eaa1981$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b40d62889eaa1981$var$isDeferredResult(actionResult)) throw $b40d62889eaa1981$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b40d62889eaa1981$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b40d62889eaa1981$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b40d62889eaa1981$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b40d62889eaa1981$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b40d62889eaa1981$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b40d62889eaa1981$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b40d62889eaa1981$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b40d62889eaa1981$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b40d62889eaa1981$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b40d62889eaa1981$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b40d62889eaa1981$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b40d62889eaa1981$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $b40d62889eaa1981$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $b40d62889eaa1981$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b40d62889eaa1981$var$isDeferredResult(result)) result = await $b40d62889eaa1981$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b40d62889eaa1981$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b40d62889eaa1981$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b40d62889eaa1981$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b40d62889eaa1981$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b40d62889eaa1981$export$3e9cee6b33872309(!$b40d62889eaa1981$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b40d62889eaa1981$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $b40d62889eaa1981$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $b40d62889eaa1981$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b40d62889eaa1981$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b40d62889eaa1981$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $b40d62889eaa1981$export$e19cd5f9376f8cee.Replace : $b40d62889eaa1981$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b40d62889eaa1981$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b40d62889eaa1981$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $b40d62889eaa1981$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b40d62889eaa1981$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b40d62889eaa1981$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b40d62889eaa1981$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $b40d62889eaa1981$var$callLoaderOrAction("loader", $b40d62889eaa1981$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $b40d62889eaa1981$var$ResultType.error,
                        error: $b40d62889eaa1981$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $b40d62889eaa1981$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b40d62889eaa1981$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b40d62889eaa1981$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b40d62889eaa1981$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b40d62889eaa1981$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b40d62889eaa1981$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b40d62889eaa1981$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b40d62889eaa1981$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b40d62889eaa1981$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b40d62889eaa1981$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b40d62889eaa1981$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b40d62889eaa1981$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b40d62889eaa1981$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b40d62889eaa1981$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b40d62889eaa1981$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b40d62889eaa1981$export$4d0306f8f6a4585b = Symbol("deferred");
function $b40d62889eaa1981$export$3336b097a6fbc59a(routes, opts) {
    $b40d62889eaa1981$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b40d62889eaa1981$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b40d62889eaa1981$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    let dataRoutes = $b40d62889eaa1981$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b40d62889eaa1981$var$createLocation("", $b40d62889eaa1981$export$fe53371bee54353d(url), null, "default");
        let matches = $b40d62889eaa1981$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b40d62889eaa1981$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b40d62889eaa1981$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b40d62889eaa1981$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b40d62889eaa1981$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b40d62889eaa1981$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($b40d62889eaa1981$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b40d62889eaa1981$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b40d62889eaa1981$var$createLocation("", $b40d62889eaa1981$export$fe53371bee54353d(url), null, "default");
        let matches = $b40d62889eaa1981$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b40d62889eaa1981$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b40d62889eaa1981$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b40d62889eaa1981$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b40d62889eaa1981$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b40d62889eaa1981$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b40d62889eaa1981$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($b40d62889eaa1981$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b40d62889eaa1981$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $b40d62889eaa1981$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b40d62889eaa1981$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b40d62889eaa1981$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $b40d62889eaa1981$var$isResponse(result) ? result : $b40d62889eaa1981$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($b40d62889eaa1981$var$isQueryRouteResponse(e)) {
                if (e.type === $b40d62889eaa1981$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b40d62889eaa1981$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b40d62889eaa1981$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b40d62889eaa1981$var$ResultType.error,
                error: error
            };
        } else {
            result = await $b40d62889eaa1981$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($b40d62889eaa1981$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($b40d62889eaa1981$var$isDeferredResult(result)) {
            let error = $b40d62889eaa1981$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b40d62889eaa1981$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b40d62889eaa1981$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($b40d62889eaa1981$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b40d62889eaa1981$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $b40d62889eaa1981$var$_extends({}, context, {
                statusCode: $b40d62889eaa1981$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $b40d62889eaa1981$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $b40d62889eaa1981$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $b40d62889eaa1981$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b40d62889eaa1981$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $b40d62889eaa1981$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b40d62889eaa1981$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b40d62889eaa1981$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b40d62889eaa1981$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b40d62889eaa1981$export$fec11da027c70692(routes, context, error) {
    let newContext = $b40d62889eaa1981$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b40d62889eaa1981$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b40d62889eaa1981$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b40d62889eaa1981$export$cae722b0cc860f13(to ? to : ".", $b40d62889eaa1981$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b40d62889eaa1981$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b40d62889eaa1981$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b40d62889eaa1981$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b40d62889eaa1981$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b40d62889eaa1981$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b40d62889eaa1981$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b40d62889eaa1981$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b40d62889eaa1981$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b40d62889eaa1981$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b40d62889eaa1981$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b40d62889eaa1981$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b40d62889eaa1981$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b40d62889eaa1981$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b40d62889eaa1981$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b40d62889eaa1981$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b40d62889eaa1981$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b40d62889eaa1981$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b40d62889eaa1981$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b40d62889eaa1981$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b40d62889eaa1981$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b40d62889eaa1981$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b40d62889eaa1981$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b40d62889eaa1981$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $b40d62889eaa1981$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($b40d62889eaa1981$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b40d62889eaa1981$var$shouldRevalidateLoader(match, $b40d62889eaa1981$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b40d62889eaa1981$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b40d62889eaa1981$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b40d62889eaa1981$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b40d62889eaa1981$var$shouldRevalidateLoader(fetcherMatch, $b40d62889eaa1981$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b40d62889eaa1981$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b40d62889eaa1981$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b40d62889eaa1981$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b40d62889eaa1981$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b40d62889eaa1981$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b40d62889eaa1981$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b40d62889eaa1981$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b40d62889eaa1981$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $b40d62889eaa1981$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $b40d62889eaa1981$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $b40d62889eaa1981$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b40d62889eaa1981$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b40d62889eaa1981$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b40d62889eaa1981$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b40d62889eaa1981$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $b40d62889eaa1981$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($b40d62889eaa1981$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($b40d62889eaa1981$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $b40d62889eaa1981$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$b40d62889eaa1981$var$ABSOLUTE_URL_REGEX.test(location)) location = $b40d62889eaa1981$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $b40d62889eaa1981$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $b40d62889eaa1981$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $b40d62889eaa1981$var$ResultType.error ? $b40d62889eaa1981$var$ResultType.error : $b40d62889eaa1981$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b40d62889eaa1981$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $b40d62889eaa1981$var$ResultType.error) return {
            type: resultType,
            error: new $b40d62889eaa1981$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $b40d62889eaa1981$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $b40d62889eaa1981$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($b40d62889eaa1981$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $b40d62889eaa1981$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $b40d62889eaa1981$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b40d62889eaa1981$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b40d62889eaa1981$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b40d62889eaa1981$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b40d62889eaa1981$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b40d62889eaa1981$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b40d62889eaa1981$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b40d62889eaa1981$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b40d62889eaa1981$export$3e9cee6b33872309(!$b40d62889eaa1981$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b40d62889eaa1981$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $b40d62889eaa1981$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b40d62889eaa1981$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($b40d62889eaa1981$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b40d62889eaa1981$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b40d62889eaa1981$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b40d62889eaa1981$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b40d62889eaa1981$var$isErrorResult(result)) {
            let boundaryMatch = $b40d62889eaa1981$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b40d62889eaa1981$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b40d62889eaa1981$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b40d62889eaa1981$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b40d62889eaa1981$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b40d62889eaa1981$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b40d62889eaa1981$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b40d62889eaa1981$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b40d62889eaa1981$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b40d62889eaa1981$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b40d62889eaa1981$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b40d62889eaa1981$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b40d62889eaa1981$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b40d62889eaa1981$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b40d62889eaa1981$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $b40d62889eaa1981$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(path) : path;
    return $b40d62889eaa1981$export$fe53371bee54353d($b40d62889eaa1981$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b40d62889eaa1981$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b40d62889eaa1981$var$isDeferredResult(result) {
    return result.type === $b40d62889eaa1981$var$ResultType.deferred;
}
function $b40d62889eaa1981$var$isErrorResult(result) {
    return result.type === $b40d62889eaa1981$var$ResultType.error;
}
function $b40d62889eaa1981$var$isRedirectResult(result) {
    return (result && result.type) === $b40d62889eaa1981$var$ResultType.redirect;
}
function $b40d62889eaa1981$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b40d62889eaa1981$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b40d62889eaa1981$var$isRedirectResponse(result) {
    if (!$b40d62889eaa1981$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b40d62889eaa1981$var$isQueryRouteResponse(obj) {
    return obj && $b40d62889eaa1981$var$isResponse(obj.response) && (obj.type === $b40d62889eaa1981$var$ResultType.data || obj.type === $b40d62889eaa1981$var$ResultType.error);
}
function $b40d62889eaa1981$var$isValidMethod(method) {
    return $b40d62889eaa1981$var$validRequestMethods.has(method.toLowerCase());
}
function $b40d62889eaa1981$var$isMutationMethod(method) {
    return $b40d62889eaa1981$var$validMutationMethods.has(method.toLowerCase());
}
async function $b40d62889eaa1981$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b40d62889eaa1981$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b40d62889eaa1981$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b40d62889eaa1981$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b40d62889eaa1981$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b40d62889eaa1981$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b40d62889eaa1981$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b40d62889eaa1981$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b40d62889eaa1981$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b40d62889eaa1981$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b40d62889eaa1981$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b40d62889eaa1981$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b40d62889eaa1981$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b40d62889eaa1981$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b40d62889eaa1981$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b40d62889eaa1981$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b40d62889eaa1981$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b40d62889eaa1981$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b40d62889eaa1981$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b40d62889eaa1981$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b40d62889eaa1981$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b40d62889eaa1981$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b40d62889eaa1981$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b40d62889eaa1981$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b40d62889eaa1981$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("4CHxl", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $35dc7b88e3959715$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $35dc7b88e3959715$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $35dc7b88e3959715$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $35dc7b88e3959715$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $35dc7b88e3959715$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $35dc7b88e3959715$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $35dc7b88e3959715$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $35dc7b88e3959715$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $35dc7b88e3959715$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $35dc7b88e3959715$export$5fcee62552a12fbf);
$parcel$export(module.exports, "useRouteError", () => $35dc7b88e3959715$export$ed527bf60f6e05f2);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $35dc7b88e3959715$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $35dc7b88e3959715$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $35dc7b88e3959715$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $35dc7b88e3959715$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $35dc7b88e3959715$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $35dc7b88e3959715$export$910ae8079b2c2852);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $35dc7b88e3959715$export$52b333d321859367);
/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $50vd1 = parcelRequire("50vd1");

var $fspFK = parcelRequire("fspFK");
function $35dc7b88e3959715$var$_extends() {
    $35dc7b88e3959715$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $35dc7b88e3959715$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $35dc7b88e3959715$export$3add0d5dce533e2e = /*#__PURE__*/ $50vd1.createContext(null);
const $35dc7b88e3959715$export$145dfa71566a64dc = /*#__PURE__*/ $50vd1.createContext(null);
const $35dc7b88e3959715$var$AwaitContext = /*#__PURE__*/ $50vd1.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $35dc7b88e3959715$export$26749e8557646306 = /*#__PURE__*/ $50vd1.createContext(null);
const $35dc7b88e3959715$export$c7914228fb69b0f5 = /*#__PURE__*/ $50vd1.createContext(null);
const $35dc7b88e3959715$export$9072aa6dd1f93057 = /*#__PURE__*/ $50vd1.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $35dc7b88e3959715$var$RouteErrorContext = /*#__PURE__*/ $50vd1.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $35dc7b88e3959715$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $35dc7b88e3959715$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fspFK.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $35dc7b88e3959715$export$9c954a9d03d32f4a() {
    return $50vd1.useContext($35dc7b88e3959715$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $35dc7b88e3959715$export$45d76561a5302f2b() {
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    return $50vd1.useContext($35dc7b88e3959715$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $35dc7b88e3959715$export$1b3f31771c5d07c() {
    return $50vd1.useContext($35dc7b88e3959715$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $35dc7b88e3959715$export$6c330e8992e8a295(pattern) {
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    let { pathname: pathname } = $35dc7b88e3959715$export$45d76561a5302f2b();
    return $50vd1.useMemo(()=>(0, $fspFK.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $35dc7b88e3959715$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $35dc7b88e3959715$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $50vd1.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $35dc7b88e3959715$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $35dc7b88e3959715$var$useNavigateStable() : $35dc7b88e3959715$var$useNavigateUnstable();
}
function $35dc7b88e3959715$var$useNavigateUnstable() {
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    let dataRouterContext = $50vd1.useContext($35dc7b88e3959715$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306);
    let { matches: matches } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $35dc7b88e3959715$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fspFK.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $50vd1.useRef(false);
    $35dc7b88e3959715$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $50vd1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fspFK.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fspFK.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $35dc7b88e3959715$var$OutletContext = /*#__PURE__*/ $50vd1.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $35dc7b88e3959715$export$4138103a3ae699cc() {
    return $50vd1.useContext($35dc7b88e3959715$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $35dc7b88e3959715$export$a3be3530d8e40d0b(context) {
    let outlet = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $35dc7b88e3959715$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $35dc7b88e3959715$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306);
    let { matches: matches } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $35dc7b88e3959715$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fspFK.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $50vd1.useMemo(()=>(0, $fspFK.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $35dc7b88e3959715$export$5d3fca4a98652595(routes, locationArg) {
    return $35dc7b88e3959715$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $35dc7b88e3959715$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    let { navigator: navigator } = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306);
    let { matches: parentMatches } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $35dc7b88e3959715$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fspFK.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fspFK.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $fspFK.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $35dc7b88e3959715$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fspFK.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fspFK.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $35dc7b88e3959715$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fspFK.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $35dc7b88e3959715$var$DefaultErrorComponent() {
    let error = $35dc7b88e3959715$export$ed527bf60f6e05f2();
    let message = (0, $fspFK.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $50vd1.createElement($50vd1.Fragment, null, /*#__PURE__*/ $50vd1.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $50vd1.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $50vd1.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $35dc7b88e3959715$var$defaultErrorElement = /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$DefaultErrorComponent, null);
class $35dc7b88e3959715$var$RenderErrorBoundary extends $50vd1.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $35dc7b88e3959715$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $50vd1.useContext($35dc7b88e3959715$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $35dc7b88e3959715$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $fspFK.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $35dc7b88e3959715$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $35dc7b88e3959715$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $50vd1.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $35dc7b88e3959715$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($35dc7b88e3959715$var$DataRouterHook || {});
var $35dc7b88e3959715$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($35dc7b88e3959715$var$DataRouterStateHook || {});
function $35dc7b88e3959715$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $35dc7b88e3959715$var$useDataRouterContext(hookName) {
    let ctx = $50vd1.useContext($35dc7b88e3959715$export$3add0d5dce533e2e);
    !ctx && (0, $fspFK.UNSAFE_invariant)(false);
    return ctx;
}
function $35dc7b88e3959715$var$useDataRouterState(hookName) {
    let state = $50vd1.useContext($35dc7b88e3959715$export$145dfa71566a64dc);
    !state && (0, $fspFK.UNSAFE_invariant)(false);
    return state;
}
function $35dc7b88e3959715$var$useRouteContext(hookName) {
    let route = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    !route && (0, $fspFK.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $35dc7b88e3959715$var$useCurrentRouteId(hookName) {
    let route = $35dc7b88e3959715$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fspFK.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $35dc7b88e3959715$export$5fc8298006ad9e58() {
    return $35dc7b88e3959715$var$useCurrentRouteId($35dc7b88e3959715$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $35dc7b88e3959715$export$d0fd4b7106de2769() {
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $35dc7b88e3959715$export$600dc272ed516c15() {
    let dataRouterContext = $35dc7b88e3959715$var$useDataRouterContext($35dc7b88e3959715$var$DataRouterHook.UseRevalidator);
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseRevalidator);
    return $50vd1.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $35dc7b88e3959715$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseMatches);
    return $50vd1.useMemo(()=>matches.map((m)=>(0, $fspFK.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $35dc7b88e3959715$export$1448a5050d252c4d() {
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseLoaderData);
    let routeId = $35dc7b88e3959715$var$useCurrentRouteId($35dc7b88e3959715$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $35dc7b88e3959715$export$fd5d37484eab868d(routeId) {
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $35dc7b88e3959715$export$fdc00f3f26066d5e() {
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseActionData);
    let routeId = $35dc7b88e3959715$var$useCurrentRouteId($35dc7b88e3959715$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $35dc7b88e3959715$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $50vd1.useContext($35dc7b88e3959715$var$RouteErrorContext);
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseRouteError);
    let routeId = $35dc7b88e3959715$var$useCurrentRouteId($35dc7b88e3959715$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $35dc7b88e3959715$export$78a72ddb39bdd145() {
    let value = $50vd1.useContext($35dc7b88e3959715$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $35dc7b88e3959715$export$17f53340677d5831() {
    let value = $50vd1.useContext($35dc7b88e3959715$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $35dc7b88e3959715$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $35dc7b88e3959715$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $35dc7b88e3959715$var$useDataRouterContext($35dc7b88e3959715$var$DataRouterHook.UseBlocker);
    let state = $35dc7b88e3959715$var$useDataRouterState($35dc7b88e3959715$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $50vd1.useState("");
    let blockerFunction = $50vd1.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $35dc7b88e3959715$var$_extends({}, currentLocation, {
                pathname: (0, $fspFK.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $35dc7b88e3959715$var$_extends({}, nextLocation, {
                pathname: (0, $fspFK.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $50vd1.useEffect(()=>{
        let key = String(++$35dc7b88e3959715$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $50vd1.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fspFK.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $35dc7b88e3959715$var$useNavigateStable() {
    let { router: router } = $35dc7b88e3959715$var$useDataRouterContext($35dc7b88e3959715$var$DataRouterHook.UseNavigateStable);
    let id = $35dc7b88e3959715$var$useCurrentRouteId($35dc7b88e3959715$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $50vd1.useRef(false);
    $35dc7b88e3959715$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $50vd1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $35dc7b88e3959715$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $35dc7b88e3959715$var$alreadyWarned = {};
function $35dc7b88e3959715$var$warningOnce(key, cond, message) {
    if (!cond && !$35dc7b88e3959715$var$alreadyWarned[key]) $35dc7b88e3959715$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $35dc7b88e3959715$var$START_TRANSITION = "startTransition";
const $35dc7b88e3959715$var$startTransitionImpl = $50vd1[$35dc7b88e3959715$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $35dc7b88e3959715$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $50vd1.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $50vd1.useCallback((newState)=>{
        if (v7_startTransition && $35dc7b88e3959715$var$startTransitionImpl) $35dc7b88e3959715$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $50vd1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $50vd1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $50vd1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $50vd1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $50vd1.createElement($50vd1.Fragment, null, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $35dc7b88e3959715$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $35dc7b88e3959715$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $35dc7b88e3959715$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $50vd1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fspFK.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $50vd1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $50vd1.useCallback((newState)=>{
        v7_startTransition && $35dc7b88e3959715$var$startTransitionImpl ? $35dc7b88e3959715$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $50vd1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $35dc7b88e3959715$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $50vd1.useContext($35dc7b88e3959715$export$26749e8557646306);
    let { matches: matches } = $50vd1.useContext($35dc7b88e3959715$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $35dc7b88e3959715$export$45d76561a5302f2b();
    let navigate = $35dc7b88e3959715$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fspFK.resolveTo)(to, (0, $fspFK.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $50vd1.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $35dc7b88e3959715$export$910ae8079b2c2852(props) {
    return $35dc7b88e3959715$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $35dc7b88e3959715$export$e7b0ac011bb776c6(_props) {
    (0, $fspFK.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $35dc7b88e3959715$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fspFK.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$35dc7b88e3959715$export$9c954a9d03d32f4a() && (0, $fspFK.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $50vd1.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $35dc7b88e3959715$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fspFK.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $50vd1.useMemo(()=>{
        let trailingPathname = (0, $fspFK.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $35dc7b88e3959715$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $35dc7b88e3959715$export$5d3fca4a98652595($35dc7b88e3959715$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $35dc7b88e3959715$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$ResolveAwait, null, children));
}
var $35dc7b88e3959715$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($35dc7b88e3959715$var$AwaitRenderStatus || {});
const $35dc7b88e3959715$var$neverSettledPromise = new Promise(()=>{});
class $35dc7b88e3959715$var$AwaitErrorBoundary extends $50vd1.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $35dc7b88e3959715$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $35dc7b88e3959715$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $35dc7b88e3959715$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $35dc7b88e3959715$var$AwaitRenderStatus.error : promise._data !== undefined ? $35dc7b88e3959715$var$AwaitRenderStatus.success : $35dc7b88e3959715$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $35dc7b88e3959715$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $35dc7b88e3959715$var$AwaitRenderStatus.error && promise._error instanceof (0, $fspFK.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $35dc7b88e3959715$var$neverSettledPromise;
        if (status === $35dc7b88e3959715$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $35dc7b88e3959715$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $35dc7b88e3959715$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $50vd1.createElement($35dc7b88e3959715$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $35dc7b88e3959715$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $35dc7b88e3959715$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $50vd1.createElement($50vd1.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $35dc7b88e3959715$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $50vd1.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $50vd1.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $50vd1.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $35dc7b88e3959715$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $35dc7b88e3959715$export$e7b0ac011bb776c6) && (0, $fspFK.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $fspFK.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $35dc7b88e3959715$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $35dc7b88e3959715$export$daf73786167a7f72(matches) {
    return $35dc7b88e3959715$var$_renderMatches(matches);
}
function $35dc7b88e3959715$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $50vd1.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $50vd1.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $50vd1.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $35dc7b88e3959715$export$f30f7e456d254e83(routes, opts) {
    return (0, $fspFK.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $35dc7b88e3959715$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fspFK.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $35dc7b88e3959715$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("kBOxH", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $f00e7805689abd5b$export$2105062e25df4afe);
$parcel$export(module.exports, "Provider", () => $f00e7805689abd5b$export$2881499e37b75b9a);
$parcel$export(module.exports, "useDispatch", () => $f00e7805689abd5b$export$8ad76b76a4c905f8);

var $50vd1 = parcelRequire("50vd1");

var $dJGZ6 = parcelRequire("dJGZ6");
var $f00e7805689abd5b$var$__defProp = Object.defineProperty;
var $f00e7805689abd5b$var$__defProps = Object.defineProperties;
var $f00e7805689abd5b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f00e7805689abd5b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f00e7805689abd5b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f00e7805689abd5b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f00e7805689abd5b$var$__defNormalProp = (obj, key, value)=>key in obj ? $f00e7805689abd5b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f00e7805689abd5b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f00e7805689abd5b$var$__hasOwnProp.call(b, prop)) $f00e7805689abd5b$var$__defNormalProp(a, prop, b[prop]);
    if ($f00e7805689abd5b$var$__getOwnPropSymbols) {
        for (var prop of $f00e7805689abd5b$var$__getOwnPropSymbols(b))if ($f00e7805689abd5b$var$__propIsEnum.call(b, prop)) $f00e7805689abd5b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f00e7805689abd5b$var$__spreadProps = (a, b)=>$f00e7805689abd5b$var$__defProps(a, $f00e7805689abd5b$var$__getOwnPropDescs(b));
var $f00e7805689abd5b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f00e7805689abd5b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f00e7805689abd5b$var$__getOwnPropSymbols) {
        for (var prop of $f00e7805689abd5b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f00e7805689abd5b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $f00e7805689abd5b$var$React = // prettier-ignore
// @ts-ignore
"default" in $50vd1 ? $50vd1["default"] : $50vd1;
// src/components/Context.ts
var $f00e7805689abd5b$var$ContextKey = Symbol.for(`react-redux-context`);
var $f00e7805689abd5b$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f00e7805689abd5b$var$getContext() {
    var _a;
    if (!$f00e7805689abd5b$var$React.createContext) return {};
    const contextMap = (_a = $f00e7805689abd5b$var$gT[$f00e7805689abd5b$var$ContextKey]) != null ? _a : $f00e7805689abd5b$var$gT[$f00e7805689abd5b$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($f00e7805689abd5b$var$React.createContext);
    if (!realContext) {
        realContext = $f00e7805689abd5b$var$React.createContext(null);
        contextMap.set($f00e7805689abd5b$var$React.createContext, realContext);
    }
    return realContext;
}
var $f00e7805689abd5b$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f00e7805689abd5b$var$getContext();
// src/utils/useSyncExternalStore.ts
var $f00e7805689abd5b$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $f00e7805689abd5b$var$createReduxContextHook(context = $f00e7805689abd5b$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $f00e7805689abd5b$var$React.useContext(context);
        return contextValue;
    };
}
var $f00e7805689abd5b$var$useReduxContext = /* @__PURE__ */ $f00e7805689abd5b$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $f00e7805689abd5b$var$useSyncExternalStoreWithSelector = $f00e7805689abd5b$var$notInitialized;
var $f00e7805689abd5b$var$initializeUseSelector = (fn)=>{
    $f00e7805689abd5b$var$useSyncExternalStoreWithSelector = fn;
};
var $f00e7805689abd5b$var$refEquality = (a, b)=>a === b;
function $f00e7805689abd5b$export$2b53f90d2bd1cbfb(context = $f00e7805689abd5b$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f00e7805689abd5b$export$cc80c08dc91f1c00 ? $f00e7805689abd5b$var$useReduxContext : $f00e7805689abd5b$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f00e7805689abd5b$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $f00e7805689abd5b$var$React.useRef(true);
        const wrappedSelector = $f00e7805689abd5b$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $f00e7805689abd5b$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $f00e7805689abd5b$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f00e7805689abd5b$export$2105062e25df4afe = /* @__PURE__ */ $f00e7805689abd5b$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $f00e7805689abd5b$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $f00e7805689abd5b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $f00e7805689abd5b$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $f00e7805689abd5b$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $f00e7805689abd5b$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $f00e7805689abd5b$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $f00e7805689abd5b$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $f00e7805689abd5b$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $f00e7805689abd5b$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $f00e7805689abd5b$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $f00e7805689abd5b$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $f00e7805689abd5b$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $f00e7805689abd5b$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $f00e7805689abd5b$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $f00e7805689abd5b$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $f00e7805689abd5b$var$ForwardRef = $f00e7805689abd5b$var$REACT_FORWARD_REF_TYPE;
var $f00e7805689abd5b$var$Memo = $f00e7805689abd5b$var$REACT_MEMO_TYPE;
function $f00e7805689abd5b$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $f00e7805689abd5b$var$REACT_FRAGMENT_TYPE || type === $f00e7805689abd5b$var$REACT_PROFILER_TYPE || type === $f00e7805689abd5b$var$REACT_STRICT_MODE_TYPE || type === $f00e7805689abd5b$var$REACT_SUSPENSE_TYPE || type === $f00e7805689abd5b$var$REACT_SUSPENSE_LIST_TYPE || type === $f00e7805689abd5b$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $f00e7805689abd5b$var$REACT_LAZY_TYPE || type.$$typeof === $f00e7805689abd5b$var$REACT_MEMO_TYPE || type.$$typeof === $f00e7805689abd5b$var$REACT_PROVIDER_TYPE || type.$$typeof === $f00e7805689abd5b$var$REACT_CONTEXT_TYPE || type.$$typeof === $f00e7805689abd5b$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $f00e7805689abd5b$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $f00e7805689abd5b$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $f00e7805689abd5b$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $f00e7805689abd5b$var$REACT_FRAGMENT_TYPE:
                        case $f00e7805689abd5b$var$REACT_PROFILER_TYPE:
                        case $f00e7805689abd5b$var$REACT_STRICT_MODE_TYPE:
                        case $f00e7805689abd5b$var$REACT_SUSPENSE_TYPE:
                        case $f00e7805689abd5b$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $f00e7805689abd5b$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $f00e7805689abd5b$var$REACT_CONTEXT_TYPE:
                                    case $f00e7805689abd5b$var$REACT_FORWARD_REF_TYPE:
                                    case $f00e7805689abd5b$var$REACT_LAZY_TYPE:
                                    case $f00e7805689abd5b$var$REACT_MEMO_TYPE:
                                    case $f00e7805689abd5b$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $f00e7805689abd5b$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $f00e7805689abd5b$var$isContextConsumer(object) {
    return $f00e7805689abd5b$var$typeOf(object) === $f00e7805689abd5b$var$REACT_CONTEXT_TYPE;
}
function $f00e7805689abd5b$var$isMemo(object) {
    return $f00e7805689abd5b$var$typeOf(object) === $f00e7805689abd5b$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f00e7805689abd5b$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f00e7805689abd5b$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f00e7805689abd5b$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f00e7805689abd5b$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f00e7805689abd5b$var$verify(mapStateToProps, "mapStateToProps");
    $f00e7805689abd5b$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f00e7805689abd5b$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f00e7805689abd5b$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f00e7805689abd5b$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f00e7805689abd5b$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f00e7805689abd5b$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f00e7805689abd5b$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f00e7805689abd5b$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f00e7805689abd5b$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f00e7805689abd5b$var$isPlainObject(value)) $f00e7805689abd5b$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f00e7805689abd5b$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f00e7805689abd5b$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f00e7805689abd5b$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f00e7805689abd5b$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f00e7805689abd5b$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f00e7805689abd5b$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f00e7805689abd5b$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f00e7805689abd5b$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f00e7805689abd5b$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f00e7805689abd5b$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f00e7805689abd5b$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f00e7805689abd5b$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f00e7805689abd5b$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f00e7805689abd5b$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f00e7805689abd5b$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f00e7805689abd5b$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f00e7805689abd5b$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f00e7805689abd5b$var$__spreadValues($f00e7805689abd5b$var$__spreadValues($f00e7805689abd5b$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f00e7805689abd5b$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f00e7805689abd5b$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f00e7805689abd5b$var$defaultMergeProps : typeof mergeProps === "function" ? $f00e7805689abd5b$var$wrapMergePropsFunc(mergeProps) : $f00e7805689abd5b$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f00e7805689abd5b$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f00e7805689abd5b$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f00e7805689abd5b$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f00e7805689abd5b$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f00e7805689abd5b$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f00e7805689abd5b$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f00e7805689abd5b$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f00e7805689abd5b$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f00e7805689abd5b$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f00e7805689abd5b$var$useIsomorphicLayoutEffect = $f00e7805689abd5b$var$canUseDOM ? $f00e7805689abd5b$var$React.useLayoutEffect : $f00e7805689abd5b$var$React.useEffect;
// src/utils/shallowEqual.ts
function $f00e7805689abd5b$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f00e7805689abd5b$export$d36bdfa510afb180(objA, objB) {
    if ($f00e7805689abd5b$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f00e7805689abd5b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f00e7805689abd5b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f00e7805689abd5b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f00e7805689abd5b$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f00e7805689abd5b$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f00e7805689abd5b$var$TYPE_STATICS = {
    [$f00e7805689abd5b$var$ForwardRef]: $f00e7805689abd5b$var$FORWARD_REF_STATICS,
    [$f00e7805689abd5b$var$Memo]: $f00e7805689abd5b$var$MEMO_STATICS
};
function $f00e7805689abd5b$var$getStatics(component) {
    if ($f00e7805689abd5b$var$isMemo(component)) return $f00e7805689abd5b$var$MEMO_STATICS;
    return $f00e7805689abd5b$var$TYPE_STATICS[component["$$typeof"]] || $f00e7805689abd5b$var$REACT_STATICS;
}
var $f00e7805689abd5b$var$defineProperty = Object.defineProperty;
var $f00e7805689abd5b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f00e7805689abd5b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f00e7805689abd5b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f00e7805689abd5b$var$getPrototypeOf = Object.getPrototypeOf;
var $f00e7805689abd5b$var$objectPrototype = Object.prototype;
function $f00e7805689abd5b$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f00e7805689abd5b$var$objectPrototype) {
            const inheritedComponent = $f00e7805689abd5b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f00e7805689abd5b$var$objectPrototype) $f00e7805689abd5b$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f00e7805689abd5b$var$getOwnPropertyNames(sourceComponent);
        if ($f00e7805689abd5b$var$getOwnPropertySymbols) keys = keys.concat($f00e7805689abd5b$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f00e7805689abd5b$var$getStatics(targetComponent);
        const sourceStatics = $f00e7805689abd5b$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f00e7805689abd5b$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f00e7805689abd5b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f00e7805689abd5b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $f00e7805689abd5b$var$useSyncExternalStore = $f00e7805689abd5b$var$notInitialized;
var $f00e7805689abd5b$var$initializeConnect = (fn)=>{
    $f00e7805689abd5b$var$useSyncExternalStore = fn;
};
var $f00e7805689abd5b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f00e7805689abd5b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f00e7805689abd5b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f00e7805689abd5b$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f00e7805689abd5b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f00e7805689abd5b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f00e7805689abd5b$var$strictEqual(a, b) {
    return a === b;
}
var $f00e7805689abd5b$var$hasWarnedAboutDeprecatedPureOption = false;
function $f00e7805689abd5b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f00e7805689abd5b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f00e7805689abd5b$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f00e7805689abd5b$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f00e7805689abd5b$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f00e7805689abd5b$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f00e7805689abd5b$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f00e7805689abd5b$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f00e7805689abd5b$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $f00e7805689abd5b$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f00e7805689abd5b$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $f00e7805689abd5b$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $f00e7805689abd5b$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $f00e7805689abd5b$var$React.useMemo(()=>{
                return $f00e7805689abd5b$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $f00e7805689abd5b$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f00e7805689abd5b$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f00e7805689abd5b$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $f00e7805689abd5b$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f00e7805689abd5b$var$__spreadProps($f00e7805689abd5b$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $f00e7805689abd5b$var$React.useRef();
            const lastWrapperProps = $f00e7805689abd5b$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $f00e7805689abd5b$var$React.useRef();
            const renderIsScheduled = $f00e7805689abd5b$var$React.useRef(false);
            const isProcessingDispatch = $f00e7805689abd5b$var$React.useRef(false);
            const isMounted = $f00e7805689abd5b$var$React.useRef(false);
            const latestSubscriptionCallbackError = $f00e7805689abd5b$var$React.useRef();
            $f00e7805689abd5b$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $f00e7805689abd5b$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $f00e7805689abd5b$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f00e7805689abd5b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f00e7805689abd5b$var$useIsomorphicLayoutEffectWithArgs($f00e7805689abd5b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $f00e7805689abd5b$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f00e7805689abd5b$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $f00e7805689abd5b$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $f00e7805689abd5b$var$React.createElement(WrappedComponent, $f00e7805689abd5b$var$__spreadProps($f00e7805689abd5b$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $f00e7805689abd5b$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $f00e7805689abd5b$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $f00e7805689abd5b$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $f00e7805689abd5b$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $f00e7805689abd5b$var$React.createElement(Connect, $f00e7805689abd5b$var$__spreadProps($f00e7805689abd5b$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f00e7805689abd5b$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f00e7805689abd5b$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f00e7805689abd5b$export$64605811ab45167f = $f00e7805689abd5b$var$connect;
// src/components/Provider.tsx
function $f00e7805689abd5b$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $f00e7805689abd5b$var$React.useMemo(()=>{
        const subscription = $f00e7805689abd5b$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $f00e7805689abd5b$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $f00e7805689abd5b$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f00e7805689abd5b$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $f00e7805689abd5b$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f00e7805689abd5b$export$2881499e37b75b9a = $f00e7805689abd5b$var$Provider;
// src/hooks/useStore.ts
function $f00e7805689abd5b$export$671dba69185d0304(context = $f00e7805689abd5b$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f00e7805689abd5b$export$cc80c08dc91f1c00 ? $f00e7805689abd5b$var$useReduxContext : // @ts-ignore
    $f00e7805689abd5b$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f00e7805689abd5b$export$6ccbb43953eebf8 = /* @__PURE__ */ $f00e7805689abd5b$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f00e7805689abd5b$export$bc9b55530897c558(context = $f00e7805689abd5b$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f00e7805689abd5b$export$cc80c08dc91f1c00 ? $f00e7805689abd5b$export$6ccbb43953eebf8 : $f00e7805689abd5b$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f00e7805689abd5b$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f00e7805689abd5b$export$bc9b55530897c558();
// src/exports.ts
var $f00e7805689abd5b$export$712ea50be43a7858 = $f00e7805689abd5b$var$defaultNoopBatch;
// src/index.ts
$f00e7805689abd5b$var$initializeUseSelector((0, $dJGZ6.useSyncExternalStoreWithSelector));
$f00e7805689abd5b$var$initializeConnect($50vd1.useSyncExternalStore);

});
parcelRegister("dJGZ6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5Bb7S"));

});
parcelRegister("5Bb7S", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $413909d42cbfcfff$export$bf730a2d8bf68b42, (v) => $413909d42cbfcfff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $413909d42cbfcfff$export$bf730a2d8bf68b42;
"use strict";

var $50vd1 = parcelRequire("50vd1");
function $413909d42cbfcfff$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $413909d42cbfcfff$var$p = "function" === typeof Object.is ? Object.is : $413909d42cbfcfff$var$n, $413909d42cbfcfff$var$q = $50vd1.useSyncExternalStore, $413909d42cbfcfff$var$r = $50vd1.useRef, $413909d42cbfcfff$var$t = $50vd1.useEffect, $413909d42cbfcfff$var$u = $50vd1.useMemo, $413909d42cbfcfff$var$v = $50vd1.useDebugValue;
$413909d42cbfcfff$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $413909d42cbfcfff$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $413909d42cbfcfff$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($413909d42cbfcfff$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $413909d42cbfcfff$var$q(a, c[0], c[1]);
    $413909d42cbfcfff$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $413909d42cbfcfff$var$v(d);
    return d;
};

});



parcelRegister("gNObz", function(module, exports) {
"use client";
"use strict";
var $c3b826c1279466de$var$Y = Object.create;
var $c3b826c1279466de$var$E = Object.defineProperty;
var $c3b826c1279466de$var$q = Object.getOwnPropertyDescriptor;
var $c3b826c1279466de$var$G = Object.getOwnPropertyNames;
var $c3b826c1279466de$var$K = Object.getPrototypeOf, $c3b826c1279466de$var$Z = Object.prototype.hasOwnProperty;
var $c3b826c1279466de$var$ee = (e, t)=>{
    for(var o in t)$c3b826c1279466de$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $c3b826c1279466de$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $c3b826c1279466de$var$G(t))!$c3b826c1279466de$var$Z.call(e, r) && r !== o && $c3b826c1279466de$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $c3b826c1279466de$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $c3b826c1279466de$var$W = (e, t, o)=>(o = e != null ? $c3b826c1279466de$var$Y($c3b826c1279466de$var$K(e)) : {}, $c3b826c1279466de$var$j(t || !e || !e.__esModule ? $c3b826c1279466de$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $c3b826c1279466de$var$te = (e)=>$c3b826c1279466de$var$j($c3b826c1279466de$var$E({}, "__esModule", {
        value: !0
    }), e);
var $c3b826c1279466de$var$Ve = {};
$c3b826c1279466de$var$ee($c3b826c1279466de$var$Ve, {
    CheckmarkIcon: ()=>$c3b826c1279466de$var$F,
    ErrorIcon: ()=>$c3b826c1279466de$var$w,
    LoaderIcon: ()=>$c3b826c1279466de$var$M,
    ToastBar: ()=>$c3b826c1279466de$var$$,
    ToastIcon: ()=>$c3b826c1279466de$var$U,
    Toaster: ()=>$c3b826c1279466de$var$J,
    default: ()=>$c3b826c1279466de$var$_e,
    resolveValue: ()=>$c3b826c1279466de$var$u,
    toast: ()=>$c3b826c1279466de$var$n,
    useToaster: ()=>$c3b826c1279466de$var$V,
    useToasterStore: ()=>$c3b826c1279466de$var$_
});
module.exports = $c3b826c1279466de$var$te($c3b826c1279466de$var$Ve);
var $c3b826c1279466de$var$oe = (e)=>typeof e == "function", $c3b826c1279466de$var$u = (e, t)=>$c3b826c1279466de$var$oe(e) ? e(t) : e;
var $c3b826c1279466de$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $c3b826c1279466de$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $c3b826c1279466de$var$re = 20;
var $c3b826c1279466de$var$v = new Map, $c3b826c1279466de$var$se = 1e3, $c3b826c1279466de$var$X = (e)=>{
    if ($c3b826c1279466de$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $c3b826c1279466de$var$v.delete(e), $c3b826c1279466de$var$l({
            type: 4,
            toastId: e
        });
    }, $c3b826c1279466de$var$se);
    $c3b826c1279466de$var$v.set(e, t);
}, $c3b826c1279466de$var$ae = (e)=>{
    let t = $c3b826c1279466de$var$v.get(e);
    t && clearTimeout(t);
}, $c3b826c1279466de$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $c3b826c1279466de$var$re)
            };
        case 1:
            return t.toast.id && $c3b826c1279466de$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $c3b826c1279466de$var$H(e, {
                type: 1,
                toast: o
            }) : $c3b826c1279466de$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $c3b826c1279466de$var$X(s) : e.toasts.forEach((a)=>{
                $c3b826c1279466de$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $c3b826c1279466de$var$I = [], $c3b826c1279466de$var$D = {
    toasts: [],
    pausedAt: void 0
}, $c3b826c1279466de$var$l = (e)=>{
    $c3b826c1279466de$var$D = $c3b826c1279466de$var$H($c3b826c1279466de$var$D, e), $c3b826c1279466de$var$I.forEach((t)=>{
        t($c3b826c1279466de$var$D);
    });
}, $c3b826c1279466de$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $c3b826c1279466de$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("50vd1")).useState)($c3b826c1279466de$var$D);
    (0, (parcelRequire("50vd1")).useEffect)(()=>($c3b826c1279466de$var$I.push(o), ()=>{
            let r = $c3b826c1279466de$var$I.indexOf(o);
            r > -1 && $c3b826c1279466de$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $c3b826c1279466de$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $c3b826c1279466de$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $c3b826c1279466de$var$Q()
    }), $c3b826c1279466de$var$S = (e)=>(t, o)=>{
        let s = $c3b826c1279466de$var$ce(t, e, o);
        return $c3b826c1279466de$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $c3b826c1279466de$var$n = (e, t)=>$c3b826c1279466de$var$S("blank")(e, t);
$c3b826c1279466de$var$n.error = $c3b826c1279466de$var$S("error");
$c3b826c1279466de$var$n.success = $c3b826c1279466de$var$S("success");
$c3b826c1279466de$var$n.loading = $c3b826c1279466de$var$S("loading");
$c3b826c1279466de$var$n.custom = $c3b826c1279466de$var$S("custom");
$c3b826c1279466de$var$n.dismiss = (e)=>{
    $c3b826c1279466de$var$l({
        type: 3,
        toastId: e
    });
};
$c3b826c1279466de$var$n.remove = (e)=>$c3b826c1279466de$var$l({
        type: 4,
        toastId: e
    });
$c3b826c1279466de$var$n.promise = (e, t, o)=>{
    let s = $c3b826c1279466de$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($c3b826c1279466de$var$n.success($c3b826c1279466de$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $c3b826c1279466de$var$n.error($c3b826c1279466de$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $c3b826c1279466de$var$pe = (e, t)=>{
    $c3b826c1279466de$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $c3b826c1279466de$var$de = ()=>{
    $c3b826c1279466de$var$l({
        type: 5,
        time: Date.now()
    });
}, $c3b826c1279466de$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $c3b826c1279466de$var$_(e);
    (0, (parcelRequire("50vd1")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $c3b826c1279466de$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$c3b826c1279466de$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("50vd1")).useCallback)(()=>{
        o && $c3b826c1279466de$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("50vd1")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $c3b826c1279466de$var$pe,
            startPause: $c3b826c1279466de$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $c3b826c1279466de$var$T = $c3b826c1279466de$var$W((parcelRequire("50vd1")));

var $cyP6J = parcelRequire("cyP6J");

var $c3b826c1279466de$var$y = $c3b826c1279466de$var$W((parcelRequire("50vd1")));

var $cyP6J = parcelRequire("cyP6J");

var $cyP6J = parcelRequire("cyP6J");
var $c3b826c1279466de$var$me = $cyP6J.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $c3b826c1279466de$var$ue = $cyP6J.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $c3b826c1279466de$var$le = $cyP6J.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $c3b826c1279466de$var$w = (0, $cyP6J.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$c3b826c1279466de$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$c3b826c1279466de$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$c3b826c1279466de$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $cyP6J = parcelRequire("cyP6J");
var $c3b826c1279466de$var$Te = $cyP6J.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $c3b826c1279466de$var$M = (0, $cyP6J.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$c3b826c1279466de$var$Te} 1s linear infinite;
`;

var $cyP6J = parcelRequire("cyP6J");
var $c3b826c1279466de$var$fe = $cyP6J.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $c3b826c1279466de$var$ye = $cyP6J.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $c3b826c1279466de$var$F = (0, $cyP6J.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$c3b826c1279466de$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$c3b826c1279466de$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $c3b826c1279466de$var$ge = (0, $cyP6J.styled)("div")`
  position: absolute;
`, $c3b826c1279466de$var$he = (0, $cyP6J.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $c3b826c1279466de$var$xe = $cyP6J.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $c3b826c1279466de$var$be = (0, $cyP6J.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$c3b826c1279466de$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $c3b826c1279466de$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$be, null, t) : t : o === "blank" ? null : $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$he, null, $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$M, {
        ...s
    }), o !== "loading" && $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$ge, null, o === "error" ? $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$w, {
        ...s
    }) : $c3b826c1279466de$var$y.createElement($c3b826c1279466de$var$F, {
        ...s
    })));
};
var $c3b826c1279466de$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $c3b826c1279466de$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $c3b826c1279466de$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $c3b826c1279466de$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $c3b826c1279466de$var$Ee = (0, $cyP6J.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $c3b826c1279466de$var$Re = (0, $cyP6J.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $c3b826c1279466de$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $c3b826c1279466de$var$R() ? [
        $c3b826c1279466de$var$Pe,
        $c3b826c1279466de$var$Oe
    ] : [
        $c3b826c1279466de$var$Se(s),
        $c3b826c1279466de$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $cyP6J.keyframes)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $cyP6J.keyframes)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $c3b826c1279466de$var$$ = $c3b826c1279466de$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $c3b826c1279466de$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $c3b826c1279466de$var$T.createElement($c3b826c1279466de$var$U, {
        toast: e
    }), c = $c3b826c1279466de$var$T.createElement($c3b826c1279466de$var$Re, {
        ...e.ariaProps
    }, $c3b826c1279466de$var$u(e.message, e));
    return $c3b826c1279466de$var$T.createElement($c3b826c1279466de$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $c3b826c1279466de$var$T.createElement($c3b826c1279466de$var$T.Fragment, null, a, c));
});

var $cyP6J = parcelRequire("cyP6J");

var $c3b826c1279466de$var$f = $c3b826c1279466de$var$W((parcelRequire("50vd1")));
(0, $cyP6J.setup)($c3b826c1279466de$var$f.createElement);
var $c3b826c1279466de$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $c3b826c1279466de$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $c3b826c1279466de$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $c3b826c1279466de$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $c3b826c1279466de$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $c3b826c1279466de$var$ke = $cyP6J.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $c3b826c1279466de$var$L = 16, $c3b826c1279466de$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $c3b826c1279466de$var$V(o);
    return $c3b826c1279466de$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $c3b826c1279466de$var$L,
            left: $c3b826c1279466de$var$L,
            right: $c3b826c1279466de$var$L,
            bottom: $c3b826c1279466de$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $c3b826c1279466de$var$De(g, z);
        return $c3b826c1279466de$var$f.createElement($c3b826c1279466de$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $c3b826c1279466de$var$ke : "",
            style: O
        }, p.type === "custom" ? $c3b826c1279466de$var$u(p.message, p) : r ? r(p) : $c3b826c1279466de$var$f.createElement($c3b826c1279466de$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $c3b826c1279466de$var$_e = $c3b826c1279466de$var$n;

});
parcelRegister("cyP6J", function(module, exports) {

$parcel$export(module.exports, "css", () => $92504de43b1423a2$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $92504de43b1423a2$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "setup", () => $92504de43b1423a2$export$de27182ff8187d6c);
$parcel$export(module.exports, "styled", () => $92504de43b1423a2$export$3817b7a54a07cec7);
let $92504de43b1423a2$var$e = {
    data: ""
}, $92504de43b1423a2$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $92504de43b1423a2$var$e, $92504de43b1423a2$export$54aba348a7896325 = (e)=>{
    let r = $92504de43b1423a2$var$t(e), l = r.data;
    return r.data = "", l;
}, $92504de43b1423a2$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $92504de43b1423a2$var$a = /\/\*[^]*?\*\/|  +/g, $92504de43b1423a2$var$n = /\n+/g, $92504de43b1423a2$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $92504de43b1423a2$var$o(c, n) : n + "{" + $92504de43b1423a2$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $92504de43b1423a2$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $92504de43b1423a2$var$o.p ? $92504de43b1423a2$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $92504de43b1423a2$var$c = {}, $92504de43b1423a2$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $92504de43b1423a2$var$s(e[r]);
        return t;
    }
    return e;
}, $92504de43b1423a2$var$i = (e, t, r, i, p)=>{
    let u = $92504de43b1423a2$var$s(e), d = $92504de43b1423a2$var$c[u] || ($92504de43b1423a2$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$92504de43b1423a2$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $92504de43b1423a2$var$l.exec(e.replace($92504de43b1423a2$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($92504de43b1423a2$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($92504de43b1423a2$var$n, " ").trim();
            return o[0];
        })(e);
        $92504de43b1423a2$var$c[d] = $92504de43b1423a2$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $92504de43b1423a2$var$c.g ? $92504de43b1423a2$var$c.g : null;
    return r && ($92504de43b1423a2$var$c.g = $92504de43b1423a2$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($92504de43b1423a2$var$c[d], t, i, f), d;
}, $92504de43b1423a2$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $92504de43b1423a2$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $92504de43b1423a2$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $92504de43b1423a2$var$i(l.unshift ? l.raw ? $92504de43b1423a2$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $92504de43b1423a2$var$t(r.target), r.g, r.o, r.k);
}
let $92504de43b1423a2$var$d, $92504de43b1423a2$var$f, $92504de43b1423a2$var$g, $92504de43b1423a2$export$442f1a04865e4790 = $92504de43b1423a2$export$dbf350e5966cf602.bind({
    g: 1
}), $92504de43b1423a2$export$d25ddfdf17c3ad3e = $92504de43b1423a2$export$dbf350e5966cf602.bind({
    k: 1
});
function $92504de43b1423a2$export$de27182ff8187d6c(e, t, r, l) {
    $92504de43b1423a2$var$o.p = t, $92504de43b1423a2$var$d = e, $92504de43b1423a2$var$f = r, $92504de43b1423a2$var$g = l;
}
function $92504de43b1423a2$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $92504de43b1423a2$var$f && $92504de43b1423a2$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $92504de43b1423a2$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $92504de43b1423a2$var$g && i[0] && $92504de43b1423a2$var$g(c), $92504de43b1423a2$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});


parcelRegister("8H118", function(module, exports) {

$parcel$export(module.exports, "default", () => $654320e5f09a3bd6$export$2e2bcd8739ae039);

var $50vd1 = parcelRequire("50vd1");
const $654320e5f09a3bd6$var$LocationContext = /*#__PURE__*/ (0, $50vd1.createContext)({
    location: {}
});
var $654320e5f09a3bd6$export$2e2bcd8739ae039 = $654320e5f09a3bd6$var$LocationContext;

});

parcelRegister("6eUyJ", function(module, exports) {

$parcel$export(module.exports, "findRestaurants", () => $48afec612e847489$export$152d367f0dd65b76);
$parcel$export(module.exports, "findRestaurantsFast", () => $48afec612e847489$export$8cdb2e9b0525cbc5);
$parcel$export(module.exports, "findRestaurantsRating", () => $48afec612e847489$export$62eca81fc918673a);
$parcel$export(module.exports, "findRestaurantsOffer", () => $48afec612e847489$export$d0fe29f753b05c4e);
$parcel$export(module.exports, "findRestaurantsVeg", () => $48afec612e847489$export$f204bf3cd5daab57);
$parcel$export(module.exports, "findRestaurantsLess300", () => $48afec612e847489$export$2a37664c214576e1);
$parcel$export(module.exports, "findRestaurants300to600", () => $48afec612e847489$export$bd167bda81bd06e0);
$parcel$export(module.exports, "handleScrollTop", () => $48afec612e847489$export$5fc0eda079579766);

var $gNObz = parcelRequire("gNObz");
const $48afec612e847489$export$152d367f0dd65b76 = (search, restaurants)=>{
    const data = restaurants.filter((restaurant)=>{
        return restaurant.info.name.toLowerCase().includes(search.toLowerCase());
    });
    return data;
};
const $48afec612e847489$export$8cdb2e9b0525cbc5 = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.sla?.deliveryTime <= 25);
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Fast Delivery Restaurants");
    }
};
const $48afec612e847489$export$62eca81fc918673a = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.avgRating >= 4);
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Top Ratings Restaurants");
    }
};
const $48afec612e847489$export$d0fe29f753b05c4e = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.aggregatedDiscountInfoV3?.header?.includes("OFF"));
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Showing Offers Restaurants");
    }
};
const $48afec612e847489$export$f204bf3cd5daab57 = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.veg == true);
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Showing Pure Veg Restaurants");
    }
};
const $48afec612e847489$export$2a37664c214576e1 = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.costForTwo?.includes("200") || restItem?.info?.costForTwo?.includes("250"));
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Budget-Friendly Restaurants");
    }
};
const $48afec612e847489$export$bd167bda81bd06e0 = (res, setRes, fil, filter, setFilter)=>{
    if (fil == filter) {
        setRes(res);
        setFilter("jack");
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("All Restaurants Display");
    } else {
        setFilter(fil);
        const data = res?.filter((restItem)=>restItem?.info?.costForTwo?.includes("300") || restItem?.info?.costForTwo?.includes("350") || restItem?.info?.costForTwo?.includes("400") || restItem?.info?.costForTwo?.includes("450") || restItem?.info?.costForTwo?.includes("500") || restItem?.info?.costForTwo?.includes("550") || restItem?.info?.costForTwo?.includes("600"));
        setRes(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Discover Dining Deals: \u20B9300 - \u20B9600");
    }
};
const $48afec612e847489$export$5fc0eda079579766 = ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};

});

parcelRegister("iBNpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c2024356f0543b$export$2e2bcd8739ae039);

var $iq6Qi = parcelRequire("iq6Qi");

var $c4Bdm = parcelRequire("c4Bdm");
const $d8c2024356f0543b$var$RestaurantCard = (restaurantList)=>{
    const { name: name, cuisines: cuisines, cloudinaryImageId: cloudinaryImageId, avgRating: avgRating, sla: sla, areaName: areaName, aggregatedDiscountInfoV3: aggregatedDiscountInfoV3 } = restaurantList;
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "img-box",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                        className: "img",
                        src: (0, $c4Bdm.IMG_URL) + cloudinaryImageId
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "card-offer",
                        children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("h3", {
                            className: "card-head",
                            children: [
                                aggregatedDiscountInfoV3?.header,
                                " ",
                                aggregatedDiscountInfoV3?.subHeader
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                className: "card-head",
                children: name
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                children: [
                    avgRating ? /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iq6Qi.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                    className: "fa-solid fa-star"
                                })
                            }),
                            avgRating,
                            " \u2022"
                        ]
                    }) : null,
                    " ",
                    sla?.slaString
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                className: "card-head",
                children: cuisines?.join(", ")
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: areaName
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {}),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {})
        ]
    });
};
var $d8c2024356f0543b$export$2e2bcd8739ae039 = $d8c2024356f0543b$var$RestaurantCard;

});
parcelRegister("c4Bdm", function(module, exports) {

$parcel$export(module.exports, "IMG_URL", () => $8ca2b9ce3fea3fcc$export$1d6744690e556718);
$parcel$export(module.exports, "IMG_SMALL_URL", () => $8ca2b9ce3fea3fcc$export$949b149e559d6566);
$parcel$export(module.exports, "FETCH_REST_URL", () => $8ca2b9ce3fea3fcc$export$793ca50ad1bdb3d3);
$parcel$export(module.exports, "FETCH_MENU_URL", () => $8ca2b9ce3fea3fcc$export$dd647375149eac);
$parcel$export(module.exports, "FETCH_INFO_URL", () => $8ca2b9ce3fea3fcc$export$a7808d88e9c2a027);
$parcel$export(module.exports, "FETCH_SEARCH_URL", () => $8ca2b9ce3fea3fcc$export$fc88e524e80c39d9);
$parcel$export(module.exports, "FETCH_PRE_SEARCH_URL", () => $8ca2b9ce3fea3fcc$export$6ba3bdeb15d80a44);
$parcel$export(module.exports, "OFFER_LOGO_URL", () => $8ca2b9ce3fea3fcc$export$67aeadb27a6dbdbb);
$parcel$export(module.exports, "IMG_INFO_URL", () => $8ca2b9ce3fea3fcc$export$5a21c55f68b41b26);
$parcel$export(module.exports, "IMG_SEARCH_URL", () => $8ca2b9ce3fea3fcc$export$750879dafd64c08b);
$parcel$export(module.exports, "IMG_PRE_SEARCH_URL", () => $8ca2b9ce3fea3fcc$export$12c26f0d2e428f5e);
$parcel$export(module.exports, "IMG_NOT_FOUND_URL", () => $8ca2b9ce3fea3fcc$export$d3c857ad27b253b9);
$parcel$export(module.exports, "IMG_ERROR_URL", () => $8ca2b9ce3fea3fcc$export$959a0705e4adf6ae);
$parcel$export(module.exports, "IMG_NOT_FOUND_SEARCH_URL", () => $8ca2b9ce3fea3fcc$export$b16f27eb2f54d5c);
$parcel$export(module.exports, "IMG_OFFLINE_URL", () => $8ca2b9ce3fea3fcc$export$328596cba4d7626f);
$parcel$export(module.exports, "IMG_RESTAURANT_NOT_URL", () => $8ca2b9ce3fea3fcc$export$81927e922885cde8);
$parcel$export(module.exports, "CONTACT_MSG", () => $8ca2b9ce3fea3fcc$export$1229d677daa89e3a);
const $8ca2b9ce3fea3fcc$export$1d6744690e556718 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $8ca2b9ce3fea3fcc$export$949b149e559d6566 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,e_color,c_fill/";
const $8ca2b9ce3fea3fcc$var$CORS_URL = "https://cors-handlers.vercel.app/";
const $8ca2b9ce3fea3fcc$export$793ca50ad1bdb3d3 = `${$8ca2b9ce3fea3fcc$var$CORS_URL}api/?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Flist%2Fv5%3Fis-seo-homepage-enabled%3Dtrue%26page_type%3DDESKTOP_WEB_LISTING%26`;
const $8ca2b9ce3fea3fcc$export$dd647375149eac = `${$8ca2b9ce3fea3fcc$var$CORS_URL}api/?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Fmenu%2Fpl%3Fpage-type%3DREGULAR_MENU%26complete-menu%3Dtrue%26catalog_qa%3Dundefined%26submitAction%3DENTER%26restaurantId%3D`;
const $8ca2b9ce3fea3fcc$export$a7808d88e9c2a027 = `${$8ca2b9ce3fea3fcc$var$CORS_URL}api/?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Flist%2Fv5%3FsortBy%3D%26filters%3D%26type%3Drcv2%26offset%3D0%26page_type%3Dnull%26collection%3D`;
const $8ca2b9ce3fea3fcc$export$fc88e524e80c39d9 = `${$8ca2b9ce3fea3fcc$var$CORS_URL}api/?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Fsearch%2Fsuggest%3FtrackingId%3Dnull`;
const $8ca2b9ce3fea3fcc$export$6ba3bdeb15d80a44 = `${$8ca2b9ce3fea3fcc$var$CORS_URL}api/?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Flanding%2FPRE_SEARCH%3F%26`;
const $8ca2b9ce3fea3fcc$export$67aeadb27a6dbdbb = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_20,h_20/";
const $8ca2b9ce3fea3fcc$export$5a21c55f68b41b26 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";
const $8ca2b9ce3fea3fcc$export$750879dafd64c08b = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_112,h_112,c_fill/";
const $8ca2b9ce3fea3fcc$export$12c26f0d2e428f5e = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/";
const $8ca2b9ce3fea3fcc$export$d3c857ad27b253b9 = "https://img.freepik.com/free-vector/choose-concept-illustration_114360-5566.jpg?w=740&t=st=1707694077~exp=1707694677~hmac=ab7ce4acf3858d5cf92e4b66a8c76536ab12b88adb63348db868564e5e48773d";
const $8ca2b9ce3fea3fcc$export$959a0705e4adf6ae = "https://img.freepik.com/free-vector/monster-404-error-concept-illustration_114360-1879.jpg?w=740&t=st=1707696379~exp=1707696979~hmac=73ecf431946a3e0143bae8b9710484cb87d7dcea47a51dce9bd3d87eadeb2a6c";
const $8ca2b9ce3fea3fcc$export$b16f27eb2f54d5c = "https://img.freepik.com/free-vector/hand-drawn-no-data-illustration_23-2150696458.jpg?w=740&t=st=1707770818~exp=1707771418~hmac=2f659884f97f78536f73ce53b1bebb2ccf9483660854e7faaff54325df335e0b";
const $8ca2b9ce3fea3fcc$export$328596cba4d7626f = "https://img.freepik.com/free-vector/tiny-people-examining-operating-system-error-warning-web-page-isolated-flat-illustration_74855-11104.jpg?w=996&t=st=1708003009~exp=1708003609~hmac=8b4e90b44aefae9daad9978641551edb0d718cd9c5fc67de77f6874a37907a80";
const $8ca2b9ce3fea3fcc$export$81927e922885cde8 = "https://img.freepik.com/free-vector/yes-no-concept-illustration_114360-7714.jpg?w=740&t=st=1707999100~exp=1707999700~hmac=4b3929e1b820dd1850b67521bfc4b4816ca39823bf64e02e042a68d665b12749";
const $8ca2b9ce3fea3fcc$export$1229d677daa89e3a = {
    linkedIn: {
        name: "there!",
        description: "I'm thrilled to connect with you! If you're interested in staying updated on my projects, insights, and professional journey, feel free to visit my LinkedIn profile. Don't forget to hit that 'Follow' button to stay in the loop!",
        subDescription: "Looking forward to connecting with you on LinkedIn!",
        social: "Explore My LinkedIn Profile",
        link: "https://www.linkedin.com/in/vickyraj15/",
        msg: "Best regards,",
        icon: "\uD83C\uDF10"
    },
    facebook: {
        name: "There!",
        description: "For more updates, interesting shares, and a glimpse into my life, consider connecting with me on Facebook! Follow or send a friend request to stay in touch.",
        subDescription: "Looking forward to connecting with you on Facebook! Feel free to drop a message or engage with the content.",
        social: "Explore My Facebook Profile",
        link: "https://www.facebook.com/xtylist.vicky.badashah/",
        msg: "Best regards,",
        icon: "\uD83C\uDF10"
    },
    instagram: {
        name: "Friends!",
        description: "If you enjoy visual content, behind-the-scenes looks, and updates on my projects and experiences, I invite you to check out my Instagram profile! Follow along for a vibrant feed of moments and stories.",
        subDescription: "Feel free to drop a comment or DM-I love connecting with like-minded individuals!",
        social: "Explore My Instagram Profile",
        link: "https://www.instagram.com/vickyraj9700/?hl=en",
        msg: "See you on Instagram,",
        icon: "\uD83C\uDF10"
    },
    github: {
        name: "Fellow Developers!",
        description: "If you're interested in my coding projects, contributions, and open-source work, feel free to explore my GitHub profile. Give it a star if you find something interesting, and let's connect in the coding world!",
        subDescription: "Looking forward to collaborating with you on GitHub!",
        social: "Explore My GitHub Profile",
        link: "https://github.com/vickyraj15",
        msg: "Happy coding,",
        icon: "\uD83C\uDF10"
    },
    email: {
        name: "There!",
        description: "If you have any questions, inquiries, or just want to say hello, I'm just an email away! Feel free to reach out, and I'll get back to you as soon as possible.",
        subDescription: "Looking forward to hearing from you!",
        social: "Email Now!",
        link: "mailto: vickyraj15@gmail.com",
        msg: "Best regards,",
        icon: "\uD83D\uDCE7"
    }
};
// RestaurantList is JSON Data for displaying cards
const $8ca2b9ce3fea3fcc$var$RestaurantList = [
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "74453",
            name: "Domino's Pizza",
            uuid: "87727dbd-7f2b-4857-9763-359624165845",
            city: "21",
            area: "Athwa",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "bz9zkh2aqywjhpankb07",
            cuisines: [
                "Pizzas"
            ],
            tags: [],
            costForTwo: 40000,
            costForTwoString: "\u20B9400 FOR TWO",
            deliveryTime: 45,
            minDeliveryTime: 45,
            maxDeliveryTime: 45,
            slaString: "45 MINS",
            lastMileTravel: 0,
            slugs: {
                restaurant: "dominos-pizza-majura-nondh-test_surat",
                city: "surat"
            },
            cityState: "21",
            address: "Shop 32 To 35, Sheetal Shopping Square,Near Lb Turning Point, Bhatar Road,MAJURA NONDH, Surat,GUJARAT-395001",
            locality: "Bhatar Road",
            parentId: 2456,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "2.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "74453",
                deliveryTime: 45,
                minDeliveryTime: 45,
                maxDeliveryTime: 45,
                lastMileTravel: 0,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.0",
            totalRatings: 1000,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "410476",
            name: "The Brooklyn Creamery - Healthy Ice Cream",
            uuid: "82e23b48-b6bd-4ee0-9746-06737ec062b0",
            city: "21",
            area: "althan bhatar",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "ldtibwymvzehvmdwl8la",
            cuisines: [
                "Desserts",
                "Ice Cream",
                "Healthy Food"
            ],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "\u20B9200 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 6.300000190734863,
            slugs: {
                restaurant: "the-brooklyn-creamery-low-cal-ice-cream-adajan-fc-adajan",
                city: "surat"
            },
            cityState: "21",
            address: "C paiki, Chalta no. 23, Guru Ashish Building, Ground Floor, Opp Kotyark Nagar, Rander Road, Surat 395005",
            locality: "Adajan FC",
            parentId: 236673,
            unserviceable: true,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "6.3 kms",
            hasSurge: false,
            sla: {
                restaurantId: "410476",
                deliveryTime: 31,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 6.300000190734863,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.4",
            totalRatings: 100,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "81094",
            name: "Richie Rich Juices & Shakes",
            uuid: "40b0b55b-e9af-43e7-aeae-be1b012d0b1d",
            city: "21",
            area: "Athwa",
            totalRatingsString: "500+ ratings",
            cloudinaryImageId: "nyp7yrzwc1dc2xqfkydk",
            cuisines: [
                "Ice Cream"
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "\u20B9250 FOR TWO",
            deliveryTime: 30,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 5.599999904632568,
            slugs: {
                restaurant: "juices-shakes-by-richie-rich-athwa-athwa",
                city: "surat"
            },
            cityState: "21",
            address: "Richie Rich Building , Opposite Golden Square Complex, Parle Point, Athwa, Surat",
            locality: "Parle Point",
            parentId: 771,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "5.5 kms",
            hasSurge: false,
            sla: {
                restaurantId: "81094",
                deliveryTime: 30,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 5.599999904632568,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "3.9",
            totalRatings: 500,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "311443",
            name: "Siddhi Icecream & Thick Shake",
            uuid: "1ca3e8c2-e5da-4b59-8f7e-868991cb40b7",
            city: "21",
            area: "Nanpura",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "spd3y5gok3vvwqulgmda",
            cuisines: [
                "Ice Cream",
                "Juices",
                "Desserts",
                "Beverages"
            ],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "\u20B9200 FOR TWO",
            deliveryTime: 30,
            minDeliveryTime: 25,
            maxDeliveryTime: 35,
            slaString: "25-35 MINS",
            lastMileTravel: 3,
            slugs: {
                restaurant: "siddhi-icecream-athwa-athwa",
                city: "surat"
            },
            cityState: "21",
            address: "siddhi icecream, Kadampally Society, Timaliawad, Nanpura, Surat, Gujarat, India",
            locality: "Athwa",
            parentId: 387846,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "3 kms",
            hasSurge: false,
            sla: {
                restaurantId: "311443",
                deliveryTime: 30,
                minDeliveryTime: 25,
                maxDeliveryTime: 35,
                lastMileTravel: 3,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.5",
            totalRatings: 100,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "307070",
            name: "Pizza Pie",
            uuid: "68598bcb-7460-4466-a8b2-113158c6cf8c",
            city: "21",
            area: "Nanpura",
            totalRatingsString: "50+ ratings",
            cloudinaryImageId: "bvr70adr30ejyr5ua79k",
            cuisines: [
                "Pizzas"
            ],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "\u20B9300 FOR TWO",
            deliveryTime: 37,
            minDeliveryTime: 35,
            maxDeliveryTime: 45,
            slaString: "35-45 MINS",
            lastMileTravel: 4,
            slugs: {
                restaurant: "pizza-pie-athwa-athwa",
                city: "surat"
            },
            cityState: "21",
            address: "1/704 Sarang building, Nanpura New Rd, opposite river palace, near Ramji Mandir, Nanpura, Surat, Gujarat",
            locality: "Nanpura",
            parentId: 158854,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "4 kms",
            hasSurge: false,
            sla: {
                restaurantId: "307070",
                deliveryTime: 37,
                minDeliveryTime: 35,
                maxDeliveryTime: 45,
                lastMileTravel: 4,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.2",
            totalRatings: 50,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "76858",
            name: "Feeling Hungry",
            uuid: "45f9ea54-f3cf-4f6b-8d85-e3468657fe51",
            city: "21",
            area: "Athwa",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "oxsb5mr1xsmhnxhunjsc",
            cuisines: [
                "Chinese",
                "North Indian",
                "Biryani"
            ],
            tags: [],
            costForTwo: 2000,
            costForTwoString: "\u20B920 FOR TWO",
            deliveryTime: 35,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 3.700000047683716,
            slugs: {
                restaurant: "feeling-hungry-adajan-gam-adajan",
                city: "surat"
            },
            cityState: "21",
            address: "GF shop no 1, Babubhai Chambers, Beside Sardar Bridge , Athwagate, surat",
            locality: "Royal Residency, Adajan Gam",
            parentId: 79237,
            unserviceable: true,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "3.7 kms",
            hasSurge: false,
            sla: {
                restaurantId: "76858",
                deliveryTime: 35,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 3.700000047683716,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "3.2",
            totalRatings: 1000,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "617279",
            name: "Malaxmi Fast Food",
            uuid: "4848cb1b-b1c4-4a6e-9a6d-f96b781357db",
            city: "21",
            area: "Adajan",
            totalRatingsString: "20+ ratings",
            cloudinaryImageId: "agkm7cflq72tkualhstb",
            cuisines: [
                "Fast Food",
                "Pizzas",
                "Snacks",
                "Beverages"
            ],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "\u20B9200 FOR TWO",
            deliveryTime: 44,
            minDeliveryTime: 40,
            maxDeliveryTime: 50,
            slaString: "40-50 MINS",
            lastMileTravel: 9.100000381469727,
            slugs: {
                restaurant: "mahalaxmi-fast-food-adajan-adajan-2",
                city: "surat"
            },
            cityState: "21",
            address: "shop no 15,palanpur food zone,opp.sai trith,pal gam suart",
            locality: "Palanpur Food Zone",
            parentId: 373635,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "9.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "617279",
                deliveryTime: 44,
                minDeliveryTime: 40,
                maxDeliveryTime: 50,
                lastMileTravel: 9.100000381469727,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.0",
            totalRatings: 20,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "469264",
            name: "Dessert House",
            uuid: "7a320917-c577-49cb-875a-1e585a3adbc1",
            city: "21",
            area: "Piplod",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "jegpumsjcmomksbr2sxr",
            cuisines: [
                "Desserts",
                "Ice Cream"
            ],
            tags: [],
            costForTwo: 15000,
            costForTwoString: "\u20B9150 FOR TWO",
            deliveryTime: 27,
            minDeliveryTime: 25,
            maxDeliveryTime: 35,
            slaString: "25-35 MINS",
            lastMileTravel: 6.199999809265137,
            slugs: {
                restaurant: "dessert-house-piplod-piplod",
                city: "surat"
            },
            cityState: "21",
            address: "SHOP NO 2, MARVELLA CORRIDOR OPP. C B PATEL HEALTH CLUB V.I.P ROAD, VESU",
            locality: "Piplod",
            parentId: 71430,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "6.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "469264",
                deliveryTime: 27,
                minDeliveryTime: 25,
                maxDeliveryTime: 35,
                lastMileTravel: 6.199999809265137,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.5",
            totalRatings: 0,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "395204",
            name: "McDonald's Gourmet Burger Collection",
            uuid: "55c33a9b-bb51-4b9d-8c94-708d48b08ebd",
            city: "21",
            area: "Piplod",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "wzbo5xivr8hstl0vxzcm",
            cuisines: [
                "Burgers",
                "Beverages",
                "Cafe",
                "Desserts"
            ],
            tags: [],
            costForTwo: 50000,
            costForTwoString: "\u20B9500 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 8.199999809265137,
            slugs: {
                restaurant: "mcdonalds-gourmet-burger-collection-valentine-cinema-piplod",
                city: "surat"
            },
            cityState: "21",
            address: "MC Donalds Family Restaurant Valentine Mall Valentine Cine Vision Surat , Dhumas Road, Nr Govardhan Haveli, Surat 395007",
            locality: "Valentine Cinema",
            parentId: 10761,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "8.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "395204",
                deliveryTime: 31,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 8.199999809265137,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.2",
            totalRatings: 100,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "193541",
            name: "Behrouz Biryani",
            uuid: "abc2e9d1-df00-4449-bde3-4c35982d0ef3",
            city: "21",
            area: "Adajan Patiya",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "craozjakzx7sll2uracb",
            cuisines: [
                "Biryani",
                "Mughlai",
                "Lucknowi",
                "Hyderabadi",
                "Kebabs",
                "North Indian",
                "Persian",
                "Desserts"
            ],
            tags: [],
            costForTwo: 50000,
            costForTwoString: "\u20B9500 FOR TWO",
            deliveryTime: 49,
            minDeliveryTime: 45,
            maxDeliveryTime: 55,
            slaString: "45-55 MINS",
            lastMileTravel: 6.400000095367432,
            slugs: {
                restaurant: "behrouz-biryani-adajan-adajan",
                city: "surat"
            },
            cityState: "21",
            address: "Chalta no 23, Ground Floor, Guru Ashish Building, Below Stallon Gym, Opp Kotyark Nagar, Near Navyug College, Adajan, Surat 395005",
            locality: "Nr Navyug College, Rander Road",
            parentId: 1803,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "6.4 kms",
            hasSurge: false,
            sla: {
                restaurantId: "193541",
                deliveryTime: 49,
                minDeliveryTime: 45,
                maxDeliveryTime: 55,
                lastMileTravel: 6.400000095367432,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.3",
            totalRatings: 1000,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "475510",
            name: "Momos House",
            uuid: "34320d9a-ffa7-450c-ad61-d50485306626",
            city: "21",
            area: "Piplod",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "vmold2zualdrrypxcvue",
            cuisines: [
                "Fast Food"
            ],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "\u20B9200 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 6.199999809265137,
            slugs: {
                restaurant: "momo\u2019s-house-piplod-piplod",
                city: "surat"
            },
            cityState: "21",
            address: "SHOP NO - 2, MARVELLA CORRIDOR, OPP. C B PATEL HEALTH CLUB, V.I.P. ROAD, Surat,, Vesu , Surat Municipal Corporation, Surat Municipal Corporation, Gujarat - 395007",
            locality: "Vesu",
            parentId: 15884,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "6.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "475510",
                deliveryTime: 31,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 6.199999809265137,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.1",
            totalRatings: 0,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "127596",
            name: "Sabir Chicken",
            uuid: "f0f49821-52ed-4435-9014-c845e964a3d8",
            city: "21",
            area: "Chowk Bazar",
            totalRatingsString: "5000+ ratings",
            cloudinaryImageId: "kilrdjqt8chduasii5ni",
            cuisines: [
                "North Indian",
                "Biryani"
            ],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "\u20B9300 FOR TWO",
            deliveryTime: 30,
            minDeliveryTime: 25,
            maxDeliveryTime: 35,
            slaString: "25-35 MINS",
            lastMileTravel: 4.300000190734863,
            slugs: {
                restaurant: "sabir-chicken-athwa-athwa",
                city: "surat"
            },
            cityState: "21",
            address: "Nehru Bridge, Behind Nagin Chand Hall, Chowk Bazar, Surat, Gujarat 395003",
            locality: "Chowk Bazar",
            parentId: 173978,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "4.3 kms",
            hasSurge: false,
            sla: {
                restaurantId: "127596",
                deliveryTime: 30,
                minDeliveryTime: 25,
                maxDeliveryTime: 35,
                lastMileTravel: 4.300000190734863,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.1",
            totalRatings: 5000,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "64656",
            name: "Mahesh Pav Bhaji",
            uuid: "ccfda4b9-82b1-4f22-9567-eb98c448b267",
            city: "21",
            area: "Adajan",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "84d3bea985f13bd980dc39c9c73bc87f",
            cuisines: [
                "Desserts",
                "Chinese",
                "South Indian",
                "Ice Cream",
                "Pizzas"
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "\u20B9250 FOR TWO",
            deliveryTime: 36,
            minDeliveryTime: 35,
            maxDeliveryTime: 45,
            slaString: "35-45 MINS",
            lastMileTravel: 6.900000095367432,
            slugs: {
                restaurant: "mahesh-pav-bhaji-adajan-gam-adajan",
                city: "surat"
            },
            cityState: "21",
            address: "Shop 12, Garden View Apartment, Honey Park Road, Adajan Gam, Surat",
            locality: "Adajan Gam",
            parentId: 6553,
            unserviceable: true,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "30% off",
                shortDescriptionList: [
                    {
                        meta: "30% off | Use JUMBO",
                        discountType: "Percentage",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "30% off up to \u20B9150 on orders above \u20B9400 | Use code JUMBO",
                        discountType: "Percentage",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "30% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use JUMBO",
                        discountType: "Percentage",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "30% off up to \u20B9150 on orders above \u20B9400 | Use code JUMBO",
                        discountType: "Percentage",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "6.9 kms",
            hasSurge: false,
            sla: {
                restaurantId: "64656",
                deliveryTime: 36,
                minDeliveryTime: 35,
                maxDeliveryTime: 45,
                lastMileTravel: 6.900000095367432,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.1",
            totalRatings: 10000,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "255204",
            name: "The Dango Cake Shop",
            uuid: "dbfd3f3c-77a6-4979-96c4-ce9863e54cdc",
            city: "21",
            area: "Galaxy Circle",
            totalRatingsString: "50+ ratings",
            cloudinaryImageId: "mnvfpsoealkflze4e5qi",
            cuisines: [
                "Bakery"
            ],
            tags: [],
            costForTwo: 27000,
            costForTwoString: "\u20B9270 FOR TWO",
            deliveryTime: 34,
            minDeliveryTime: 30,
            maxDeliveryTime: 40,
            slaString: "30-40 MINS",
            lastMileTravel: 7.699999809265137,
            slugs: {
                restaurant: "twisted-cake-live-cake-adajan-adajan",
                city: "surat"
            },
            cityState: "21",
            address: "44 La Victoria, galaxy circle pal Surat",
            locality: "Galaxy Circle",
            parentId: 207513,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "7.6 kms",
            hasSurge: false,
            sla: {
                restaurantId: "255204",
                deliveryTime: 34,
                minDeliveryTime: 30,
                maxDeliveryTime: 40,
                lastMileTravel: 7.699999809265137,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "4.2",
            totalRatings: 50,
            new: false
        },
        subtype: "basic"
    },
    {
        type: "restaurant",
        info: {
            type: "F",
            id: "664656",
            name: "Cheezylicious Cafe",
            uuid: "5880e561-10ed-4f96-990b-2251e2f09c82",
            city: "21",
            area: "Piplod",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "fda9ad56b9d62070fec105cd93693129",
            cuisines: [
                "Cafe",
                "Fast Food",
                "Chinese",
                "Snacks",
                "Italian",
                "Mexican"
            ],
            tags: [],
            costForTwo: 15000,
            costForTwoString: "\u20B9150 FOR TWO",
            deliveryTime: 38,
            minDeliveryTime: 35,
            maxDeliveryTime: 45,
            slaString: "35-45 MINS",
            lastMileTravel: 7.599999904632568,
            slugs: {
                restaurant: "cheezylicious-cafe-piplod-piplod-2",
                city: "surat"
            },
            cityState: "21",
            address: "Shop no G10 ground floor, aagam square B/S Dream heritage, Canal road, Vesu",
            locality: "Dream heritage",
            parentId: 59292,
            unserviceable: true,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "FREE DELIVERY",
                shortDescriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            aggregatedDiscountInfoV2: {
                header: "",
                shortDescriptionList: [
                    {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                descriptionList: [
                    {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT"
                    }
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: ""
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: ""
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: ""
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: []
            },
            lastMileTravelString: "7.5 kms",
            hasSurge: false,
            sla: {
                restaurantId: "664656",
                deliveryTime: 38,
                minDeliveryTime: 35,
                maxDeliveryTime: 45,
                lastMileTravel: 7.599999904632568,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE_WITH_BANNER",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY"
            },
            promoted: false,
            avgRating: "3.9",
            totalRatings: 0,
            new: true
        },
        subtype: "basic"
    }
];
var $8ca2b9ce3fea3fcc$export$2e2bcd8739ae039 = $8ca2b9ce3fea3fcc$var$RestaurantList;

});


parcelRegister("h7f4L", function(module, exports) {

$parcel$export(module.exports, "ShimmerCol", () => $c75ec8df196fa82a$export$10adafe47b4bf014);
$parcel$export(module.exports, "ShimmerMenu", () => $c75ec8df196fa82a$export$b975019d6e095a38);
$parcel$export(module.exports, "default", () => $c75ec8df196fa82a$export$2e2bcd8739ae039);

var $iq6Qi = parcelRequire("iq6Qi");
const $c75ec8df196fa82a$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "main-home-shimmer",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "outer_circle",
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "inner_circle",
                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                className: "fa-solid fa-pizza-slice fa-fade"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h2", {
                        children: "Looking for great food near you ..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                className: "body-box-res body-box",
                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    className: "main-header-box",
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "box-shimmer big-header-home"
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "main-header-filter",
                            children: Array(5).fill("").map((elem, idx)=>{
                                return /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                                    className: "shimmer-fbtn"
                                }, "shim-fil" + idx);
                            })
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "main-card",
                            children: Array(8).fill("").map((elem, idx)=>{
                                return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                    className: "shimmer card",
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                            className: "img-box img-shimmer"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                            className: "box-shimmer big-shimmer"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                            className: "box-shimmer"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                            className: "box-shimmer"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                            className: "box-shimmer"
                                        })
                                    ]
                                }, "shimmer-menu" + idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $c75ec8df196fa82a$export$10adafe47b4bf014 = ()=>{
    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iq6Qi.Fragment), {
        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
            className: "body-box-res body-box",
            children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "main-header-box",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "box-shimmer big-header"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "box-shimmer big-header-half"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "main-card",
                        children: Array(8).fill("").map((elem, idx)=>{
                            return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                className: "shimmer card",
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "img-box img-shimmer"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "box-shimmer big-shimmer"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "box-shimmer"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "box-shimmer"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "box-shimmer"
                                    })
                                ]
                            }, "shimmer-menu" + idx);
                        })
                    })
                ]
            })
        })
    });
};
const $c75ec8df196fa82a$export$b975019d6e095a38 = ()=>{
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        id: "res-menu",
        className: "body-box",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                id: "res-menu-box",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        id: "res-menu-name",
                        className: "shimmer-menu",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                className: "shimmer-box-menu"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        id: "res-menu-price",
                        className: "shimmer-box-menu",
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {
                            children: "\xa0"
                        })
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        id: "res-menu-img",
                        className: "shimmer-box-menu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "res-menu-off",
                children: Array(4).fill("").map((item, idx)=>{
                    return /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        id: "res-menu-offbox",
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "shimmer-box-menu",
                            children: "\xa0"
                        })
                    }, "res-off" + idx);
                })
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "res-menu-cardbox",
                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    id: "res-menu-cardb",
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "shimmer-box-menu",
                            children: "\xa0"
                        }),
                        Array(5).fill("").map((item, i)=>{
                            return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                id: "res-menu-cardele",
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "shimmer-box-menu",
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "shimmer-box-menu",
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "shimmer-box-menu",
                                                children: "\xa0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "menu-img shimmer-box-menu"
                                    })
                                ]
                            }, "res-menu-card" + i);
                        })
                    ]
                })
            })
        ]
    });
};
var $c75ec8df196fa82a$export$2e2bcd8739ae039 = $c75ec8df196fa82a$var$Shimmer;

});

parcelRegister("iKDOx", function(module, exports) {

$parcel$export(module.exports, "addToCart", () => $da6b681bdf2d48a5$export$576b6dd9d68b37bc);
$parcel$export(module.exports, "increaseCount", () => $da6b681bdf2d48a5$export$3dc6f63915334094);
$parcel$export(module.exports, "decreaseCount", () => $da6b681bdf2d48a5$export$3c407a1ad05274f0);
$parcel$export(module.exports, "clearCart", () => $da6b681bdf2d48a5$export$810121176e3e3671);
$parcel$export(module.exports, "default", () => $da6b681bdf2d48a5$export$2e2bcd8739ae039);

var $5Xyjr = parcelRequire("5Xyjr");
const $da6b681bdf2d48a5$var$cartSlice = (0, $5Xyjr.createSlice)({
    name: "cart",
    initialState: {
        items: [],
        restaurant: null
    },
    reducers: {
        addToCart: (state, action)=>{
            if (state.restaurant === null) {
                state.restaurant = action.payload.resCart;
                state.items.push(action.payload.item);
            } else if (state.restaurant.id != action.payload.resCart.id) {
                state.restaurant = action.payload.resCart;
                state.items = [
                    action.payload.item
                ];
            } else state.items.push(action.payload.item);
        },
        // removeFromCart: (state, action) => {
        // 	state.items = state.items.filter(
        // 		(item) => item[0].id !== action.payload.id
        // 	);
        // 	if (state.items.length == 0) {
        // 		state.restaurant = null;
        // 	}
        // },
        increaseCount: (state, action)=>{
            state.items.map((item)=>{
                if (item[0].id == action.payload) item[1]++;
            });
        },
        decreaseCount: (state, action)=>{
            state.items.map((item, idx)=>{
                if (item[0].id == action.payload) {
                    item[1]--;
                    if (item[1] == 0) state.items.splice(idx, 1);
                }
                if (state.items.length == 0) state.restaurant = null;
            });
        },
        clearCart: (state)=>{
            state.items = [];
            state.restaurant = null;
        }
    }
});
const { addToCart: $da6b681bdf2d48a5$export$576b6dd9d68b37bc, increaseCount: $da6b681bdf2d48a5$export$3dc6f63915334094, decreaseCount: $da6b681bdf2d48a5$export$3c407a1ad05274f0, clearCart: $da6b681bdf2d48a5$export$810121176e3e3671 } = $da6b681bdf2d48a5$var$cartSlice.actions;
var $da6b681bdf2d48a5$export$2e2bcd8739ae039 = $da6b681bdf2d48a5$var$cartSlice.reducer;

});
parcelRegister("5Xyjr", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $456d1435f01151b3$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $456d1435f01151b3$export$4d8d9bd83c24ae8b);
// src/index.ts

var $lYby2 = parcelRequire("lYby2");

var $5JVef = parcelRequire("5JVef");

var $jDz3G = parcelRequire("jDz3G");

var $i7tcV = parcelRequire("i7tcV");

var $juhyG = parcelRequire("juhyG");
var $456d1435f01151b3$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $jDz3G.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5JVef.isDraft)(value) ? (0, $5JVef.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $456d1435f01151b3$export$a5d3c27355e35910 = $456d1435f01151b3$export$aab6de9e3dbb1473((0, $jDz3G.weakMapMemoize));
var $456d1435f01151b3$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $lYby2.compose;
    return (0, $lYby2.compose).apply(null, arguments);
};
var $456d1435f01151b3$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $456d1435f01151b3$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $456d1435f01151b3$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($456d1435f01151b3$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $lYby2.isAction)(action) && action.type === type;
    return actionCreator;
}
function $456d1435f01151b3$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $456d1435f01151b3$var$hasMatchFunction(action);
}
function $456d1435f01151b3$export$ebd532f9034651f3(action) {
    return (0, $lYby2.isAction)(action) && Object.keys(action).every($456d1435f01151b3$var$isValidKey);
}
function $456d1435f01151b3$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $456d1435f01151b3$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $456d1435f01151b3$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $456d1435f01151b3$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $456d1435f01151b3$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $456d1435f01151b3$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $456d1435f01151b3$var$freezeDraftable(val) {
    return (0, $5JVef.isDraftable)(val) ? (0, $5JVef.produce)(val, ()=>{}) : val;
}
function $456d1435f01151b3$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($456d1435f01151b3$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $456d1435f01151b3$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $456d1435f01151b3$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $456d1435f01151b3$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $456d1435f01151b3$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $456d1435f01151b3$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $456d1435f01151b3$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $456d1435f01151b3$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $456d1435f01151b3$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $456d1435f01151b3$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $456d1435f01151b3$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $lYby2.isPlainObject)(val);
}
function $456d1435f01151b3$export$ada5dca0b571bc7(value, path = "", isSerializable = $456d1435f01151b3$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $456d1435f01151b3$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $456d1435f01151b3$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $456d1435f01151b3$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$456d1435f01151b3$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $456d1435f01151b3$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $456d1435f01151b3$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $456d1435f01151b3$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $456d1435f01151b3$export$1908877435b1d5e9();
        if (thunk) {
            if ($456d1435f01151b3$var$isBoolean(thunk)) middlewareArray.push((0, $i7tcV.thunk));
            else middlewareArray.push((0, $i7tcV.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $456d1435f01151b3$export$8fb31c0f05df007b = "RTK_autoBatch";
var $456d1435f01151b3$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$456d1435f01151b3$export$8fb31c0f05df007b]: true
            }
        });
var $456d1435f01151b3$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $456d1435f01151b3$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $456d1435f01151b3$var$createQueueWithTimer(10);
var $456d1435f01151b3$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $456d1435f01151b3$var$rAF : options.type === "callback" ? options.queueNotification : $456d1435f01151b3$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$456d1435f01151b3$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $456d1435f01151b3$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $456d1435f01151b3$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($456d1435f01151b3$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $456d1435f01151b3$var$IS_PRODUCTION = true;
function $456d1435f01151b3$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $456d1435f01151b3$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $lYby2.isPlainObject)(reducer)) rootReducer = (0, $lYby2.combineReducers)(reducer);
    else throw new Error($456d1435f01151b3$export$378fa86b259c0280(1));
    if (!$456d1435f01151b3$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($456d1435f01151b3$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$456d1435f01151b3$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($456d1435f01151b3$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$456d1435f01151b3$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($456d1435f01151b3$export$378fa86b259c0280(4));
    let finalCompose = (0, $lYby2.compose);
    if (devTools) finalCompose = $456d1435f01151b3$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$456d1435f01151b3$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $lYby2.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $456d1435f01151b3$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$456d1435f01151b3$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($456d1435f01151b3$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$456d1435f01151b3$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($456d1435f01151b3$export$378fa86b259c0280(6));
    if (!$456d1435f01151b3$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($456d1435f01151b3$export$378fa86b259c0280(7));
    if (!$456d1435f01151b3$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $lYby2.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $456d1435f01151b3$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($456d1435f01151b3$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($456d1435f01151b3$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $456d1435f01151b3$var$isStateFunction(x) {
    return typeof x === "function";
}
function $456d1435f01151b3$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $456d1435f01151b3$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($456d1435f01151b3$var$isStateFunction(initialState)) getInitialState = ()=>$456d1435f01151b3$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $456d1435f01151b3$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5JVef.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5JVef.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($456d1435f01151b3$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $5JVef.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $456d1435f01151b3$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $456d1435f01151b3$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $456d1435f01151b3$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $456d1435f01151b3$var$matches = (matcher, action)=>{
    if ($456d1435f01151b3$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $456d1435f01151b3$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$456d1435f01151b3$var$matches(matcher, action));
    };
}
function $456d1435f01151b3$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$456d1435f01151b3$var$matches(matcher, action));
    };
}
function $456d1435f01151b3$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $456d1435f01151b3$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $456d1435f01151b3$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$456d1435f01151b3$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$456d1435f01151b3$var$isAsyncThunkArray(asyncThunks)) return $456d1435f01151b3$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $456d1435f01151b3$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $456d1435f01151b3$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$456d1435f01151b3$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$456d1435f01151b3$var$isAsyncThunkArray(asyncThunks)) return $456d1435f01151b3$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $456d1435f01151b3$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $456d1435f01151b3$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $456d1435f01151b3$export$9dd1fb32974da385($456d1435f01151b3$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$456d1435f01151b3$var$isAsyncThunkArray(asyncThunks)) return $456d1435f01151b3$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $456d1435f01151b3$export$9dd1fb32974da385($456d1435f01151b3$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $456d1435f01151b3$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$456d1435f01151b3$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$456d1435f01151b3$var$isAsyncThunkArray(asyncThunks)) return $456d1435f01151b3$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $456d1435f01151b3$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $456d1435f01151b3$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$456d1435f01151b3$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$456d1435f01151b3$var$isAsyncThunkArray(asyncThunks)) return $456d1435f01151b3$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $456d1435f01151b3$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $456d1435f01151b3$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $456d1435f01151b3$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $456d1435f01151b3$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $456d1435f01151b3$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $456d1435f01151b3$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $456d1435f01151b3$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $456d1435f01151b3$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $456d1435f01151b3$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $456d1435f01151b3$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $456d1435f01151b3$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $456d1435f01151b3$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($456d1435f01151b3$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $456d1435f01151b3$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $456d1435f01151b3$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $456d1435f01151b3$var$RejectWithValue) throw result;
                                if (result instanceof $456d1435f01151b3$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $456d1435f01151b3$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($456d1435f01151b3$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $456d1435f01151b3$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $456d1435f01151b3$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $456d1435f01151b3$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $456d1435f01151b3$var$asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
var $456d1435f01151b3$export$343355ed40c51c46 = {
    [$456d1435f01151b3$var$asyncThunkSymbol]: $456d1435f01151b3$export$6abd22dc03e5063f
};
var $456d1435f01151b3$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($456d1435f01151b3$export$23a094319a4b586 || {});
function $456d1435f01151b3$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $456d1435f01151b3$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$456d1435f01151b3$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($456d1435f01151b3$export$378fa86b259c0280(11));
        typeof $juhyG;
        const reducers = (typeof options.reducers === "function" ? options.reducers($456d1435f01151b3$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($456d1435f01151b3$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($456d1435f01151b3$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $456d1435f01151b3$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($456d1435f01151b3$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $456d1435f01151b3$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $456d1435f01151b3$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $456d1435f01151b3$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $456d1435f01151b3$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $456d1435f01151b3$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $456d1435f01151b3$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $456d1435f01151b3$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $456d1435f01151b3$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $456d1435f01151b3$export$4d8d9bd83c24ae8b = $456d1435f01151b3$export$affdea4146de9cf5();
function $456d1435f01151b3$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $456d1435f01151b3$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$456d1435f01151b3$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($456d1435f01151b3$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $456d1435f01151b3$export$309c7a02b0b0bc62(type, prepareCallback) : $456d1435f01151b3$export$309c7a02b0b0bc62(type));
}
function $456d1435f01151b3$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $456d1435f01151b3$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $456d1435f01151b3$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($456d1435f01151b3$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $456d1435f01151b3$var$noop,
        pending: pending || $456d1435f01151b3$var$noop,
        rejected: rejected || $456d1435f01151b3$var$noop,
        settled: settled || $456d1435f01151b3$var$noop
    });
}
function $456d1435f01151b3$var$noop() {}
// src/entities/entity_state.ts
function $456d1435f01151b3$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $456d1435f01151b3$var$createInitialStateFactory() {
    function getInitialState(additionalState = {}) {
        return Object.assign($456d1435f01151b3$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $456d1435f01151b3$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $456d1435f01151b3$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $456d1435f01151b3$var$isDraftTyped = (0, $5JVef.isDraft);
function $456d1435f01151b3$var$createSingleArgumentStateOperator(mutator) {
    const operator = $456d1435f01151b3$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $456d1435f01151b3$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $456d1435f01151b3$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($456d1435f01151b3$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5JVef.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $456d1435f01151b3$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $456d1435f01151b3$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $456d1435f01151b3$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $456d1435f01151b3$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $456d1435f01151b3$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $456d1435f01151b3$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $456d1435f01151b3$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $456d1435f01151b3$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$456d1435f01151b3$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $456d1435f01151b3$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $456d1435f01151b3$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $456d1435f01151b3$var$createStateOperator(addOneMutably),
        addMany: $456d1435f01151b3$var$createStateOperator(addManyMutably),
        setOne: $456d1435f01151b3$var$createStateOperator(setOneMutably),
        setMany: $456d1435f01151b3$var$createStateOperator(setManyMutably),
        setAll: $456d1435f01151b3$var$createStateOperator(setAllMutably),
        updateOne: $456d1435f01151b3$var$createStateOperator(updateOneMutably),
        updateMany: $456d1435f01151b3$var$createStateOperator(updateManyMutably),
        upsertOne: $456d1435f01151b3$var$createStateOperator(upsertOneMutably),
        upsertMany: $456d1435f01151b3$var$createStateOperator(upsertManyMutably),
        removeOne: $456d1435f01151b3$var$createStateOperator(removeOneMutably),
        removeMany: $456d1435f01151b3$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $456d1435f01151b3$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $456d1435f01151b3$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($456d1435f01151b3$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $456d1435f01151b3$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $456d1435f01151b3$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $456d1435f01151b3$var$createStateOperator(addOneMutably),
        updateOne: $456d1435f01151b3$var$createStateOperator(updateOneMutably),
        upsertOne: $456d1435f01151b3$var$createStateOperator(upsertOneMutably),
        setOne: $456d1435f01151b3$var$createStateOperator(setOneMutably),
        setMany: $456d1435f01151b3$var$createStateOperator(setManyMutably),
        setAll: $456d1435f01151b3$var$createStateOperator(setAllMutably),
        addMany: $456d1435f01151b3$var$createStateOperator(addManyMutably),
        updateMany: $456d1435f01151b3$var$createStateOperator(updateManyMutably),
        upsertMany: $456d1435f01151b3$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $456d1435f01151b3$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateFactory = $456d1435f01151b3$var$createInitialStateFactory();
    const selectorsFactory = $456d1435f01151b3$var$createSelectorsFactory();
    const stateAdapter = sortComparer ? $456d1435f01151b3$var$createSortedStateAdapter(selectId, sortComparer) : $456d1435f01151b3$var$createUnsortedStateAdapter(selectId);
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $456d1435f01151b3$var$task = "task";
var $456d1435f01151b3$var$listener = "listener";
var $456d1435f01151b3$var$completed = "completed";
var $456d1435f01151b3$var$cancelled = "cancelled";
var $456d1435f01151b3$var$taskCancelled = `task-${$456d1435f01151b3$var$cancelled}`;
var $456d1435f01151b3$var$taskCompleted = `task-${$456d1435f01151b3$var$completed}`;
var $456d1435f01151b3$var$listenerCancelled = `${$456d1435f01151b3$var$listener}-${$456d1435f01151b3$var$cancelled}`;
var $456d1435f01151b3$var$listenerCompleted = `${$456d1435f01151b3$var$listener}-${$456d1435f01151b3$var$completed}`;
var $456d1435f01151b3$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$456d1435f01151b3$var$task} ${$456d1435f01151b3$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $456d1435f01151b3$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($456d1435f01151b3$export$378fa86b259c0280(32));
};
var $456d1435f01151b3$var$noop2 = ()=>{};
var $456d1435f01151b3$var$catchRejection = (promise, onError = $456d1435f01151b3$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $456d1435f01151b3$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $456d1435f01151b3$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $456d1435f01151b3$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $456d1435f01151b3$export$cb1bdac908fed7f(reason);
    }
};
function $456d1435f01151b3$var$raceWithSignal(signal, promise) {
    let cleanup = $456d1435f01151b3$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $456d1435f01151b3$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $456d1435f01151b3$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $456d1435f01151b3$var$noop2;
    });
}
var $456d1435f01151b3$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $456d1435f01151b3$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $456d1435f01151b3$var$createPause = (signal)=>{
    return (promise)=>{
        return $456d1435f01151b3$var$catchRejection($456d1435f01151b3$var$raceWithSignal(signal, promise).then((output)=>{
            $456d1435f01151b3$var$validateActive(signal);
            return output;
        }));
    };
};
var $456d1435f01151b3$var$createDelay = (signal)=>{
    const pause = $456d1435f01151b3$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $456d1435f01151b3$var$assign } = Object;
var $456d1435f01151b3$var$INTERNAL_NIL_TOKEN = {};
var $456d1435f01151b3$var$alm = "listenerMiddleware";
var $456d1435f01151b3$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$456d1435f01151b3$var$addAbortSignalListener(parentAbortSignal, ()=>$456d1435f01151b3$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $456d1435f01151b3$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $456d1435f01151b3$var$runTask(async ()=>{
            $456d1435f01151b3$var$validateActive(parentAbortSignal);
            $456d1435f01151b3$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $456d1435f01151b3$var$createPause(childAbortController.signal),
                delay: $456d1435f01151b3$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $456d1435f01151b3$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$456d1435f01151b3$var$abortControllerWithReason(childAbortController, $456d1435f01151b3$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($456d1435f01151b3$var$noop2));
        return {
            result: $456d1435f01151b3$var$createPause(parentAbortSignal)(result),
            cancel () {
                $456d1435f01151b3$var$abortControllerWithReason(childAbortController, $456d1435f01151b3$var$taskCancelled);
            }
        };
    };
};
var $456d1435f01151b3$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $456d1435f01151b3$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $456d1435f01151b3$var$raceWithSignal(signal, Promise.race(promises));
            $456d1435f01151b3$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$456d1435f01151b3$var$catchRejection(take(predicate, timeout));
};
var $456d1435f01151b3$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $456d1435f01151b3$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($456d1435f01151b3$export$378fa86b259c0280(21));
    $456d1435f01151b3$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $456d1435f01151b3$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $456d1435f01151b3$var$getListenerEntryPropsFrom(options);
    const id = $456d1435f01151b3$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($456d1435f01151b3$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$456d1435f01151b3$var$createListenerEntry
});
var $456d1435f01151b3$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $456d1435f01151b3$var$abortControllerWithReason(controller, $456d1435f01151b3$var$listenerCancelled);
    });
};
var $456d1435f01151b3$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($456d1435f01151b3$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $456d1435f01151b3$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $456d1435f01151b3$export$f03a6b845d3fb58b = Object.assign($456d1435f01151b3$export$309c7a02b0b0bc62(`${$456d1435f01151b3$var$alm}/add`), {
    withTypes: ()=>$456d1435f01151b3$export$f03a6b845d3fb58b
});
var $456d1435f01151b3$export$b1b8022855fb2b71 = $456d1435f01151b3$export$309c7a02b0b0bc62(`${$456d1435f01151b3$var$alm}/removeAll`);
var $456d1435f01151b3$export$b03e9483f936dccb = Object.assign($456d1435f01151b3$export$309c7a02b0b0bc62(`${$456d1435f01151b3$var$alm}/remove`), {
    withTypes: ()=>$456d1435f01151b3$export$b03e9483f936dccb
});
var $456d1435f01151b3$var$defaultErrorHandler = (...args)=>{
    console.error(`${$456d1435f01151b3$var$alm}/error`, ...args);
};
var $456d1435f01151b3$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $456d1435f01151b3$var$defaultErrorHandler } = middlewareOptions;
    $456d1435f01151b3$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $456d1435f01151b3$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $456d1435f01151b3$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $456d1435f01151b3$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $456d1435f01151b3$var$getListenerEntryPropsFrom(options);
        const entry = $456d1435f01151b3$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $456d1435f01151b3$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $456d1435f01151b3$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $456d1435f01151b3$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $456d1435f01151b3$var$createDelay(internalTaskController.signal),
                pause: $456d1435f01151b3$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $456d1435f01151b3$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $456d1435f01151b3$var$abortControllerWithReason(controller, $456d1435f01151b3$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $456d1435f01151b3$var$abortControllerWithReason(internalTaskController, $456d1435f01151b3$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $456d1435f01151b3$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $456d1435f01151b3$export$cb1bdac908fed7f)) $456d1435f01151b3$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $456d1435f01151b3$var$abortControllerWithReason(internalTaskController, $456d1435f01151b3$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $456d1435f01151b3$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $lYby2.isAction)(action)) return next(action);
                if ($456d1435f01151b3$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($456d1435f01151b3$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($456d1435f01151b3$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $456d1435f01151b3$var$INTERNAL_NIL_TOKEN) throw new Error($456d1435f01151b3$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $456d1435f01151b3$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $456d1435f01151b3$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $456d1435f01151b3$var$createMiddlewareEntry = (middleware)=>({
        id: $456d1435f01151b3$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $456d1435f01151b3$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $456d1435f01151b3$export$4bb1606a79445586 = ()=>{
    const instanceId = $456d1435f01151b3$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($456d1435f01151b3$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $456d1435f01151b3$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $456d1435f01151b3$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$456d1435f01151b3$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $lYby2.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $456d1435f01151b3$export$9dd1fb32974da385(withMiddleware, $456d1435f01151b3$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $456d1435f01151b3$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $456d1435f01151b3$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$456d1435f01151b3$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $456d1435f01151b3$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $456d1435f01151b3$var$isStateProxy = (value)=>!!value && !!value[$456d1435f01151b3$var$ORIGINAL_STATE];
var $456d1435f01151b3$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $456d1435f01151b3$var$createStateProxy = (state, reducerMap)=>$456d1435f01151b3$var$emplace($456d1435f01151b3$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $456d1435f01151b3$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $456d1435f01151b3$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($456d1435f01151b3$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $456d1435f01151b3$var$original = (state)=>{
    if (!$456d1435f01151b3$var$isStateProxy(state)) throw new Error($456d1435f01151b3$export$378fa86b259c0280(25));
    return state[$456d1435f01151b3$var$ORIGINAL_STATE];
};
function $456d1435f01151b3$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($456d1435f01151b3$var$getReducers(slices));
    const getReducer = ()=>(0, $lYby2.combineReducers)(reducerMap);
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $juhyG;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($456d1435f01151b3$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $456d1435f01151b3$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $456d1435f01151b3$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("lYby2", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $ffe828bd26922865$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $ffe828bd26922865$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ffe828bd26922865$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ffe828bd26922865$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ffe828bd26922865$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $ffe828bd26922865$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $ffe828bd26922865$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $ffe828bd26922865$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $ffe828bd26922865$var$symbol_observable_default = $ffe828bd26922865$var$$$observable;
// src/utils/actionTypes.ts
var $ffe828bd26922865$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $ffe828bd26922865$var$ActionTypes = {
    INIT: `@@redux/INIT${$ffe828bd26922865$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$ffe828bd26922865$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$ffe828bd26922865$var$randomString()}`
};
var $ffe828bd26922865$export$4219e499db7ca678 = $ffe828bd26922865$var$ActionTypes;
// src/utils/isPlainObject.ts
function $ffe828bd26922865$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $ffe828bd26922865$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ffe828bd26922865$var$isDate(val)) return "date";
    if ($ffe828bd26922865$var$isError(val)) return "error";
    const constructorName = $ffe828bd26922865$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ffe828bd26922865$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ffe828bd26922865$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ffe828bd26922865$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ffe828bd26922865$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $ffe828bd26922865$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(1));
        return enhancer($ffe828bd26922865$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$ffe828bd26922865$export$53b83ca8eaab0383(action)) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $ffe828bd26922865$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$ffe828bd26922865$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $ffe828bd26922865$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$ffe828bd26922865$var$symbol_observable_default]: observable
    };
    return store;
}
function $ffe828bd26922865$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $ffe828bd26922865$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $ffe828bd26922865$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $ffe828bd26922865$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $ffe828bd26922865$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ffe828bd26922865$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$ffe828bd26922865$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ffe828bd26922865$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $ffe828bd26922865$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $ffe828bd26922865$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $ffe828bd26922865$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ffe828bd26922865$var$formatProdErrorMessage(13));
    });
}
function $ffe828bd26922865$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $ffe828bd26922865$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($ffe828bd26922865$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $ffe828bd26922865$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $ffe828bd26922865$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ffe828bd26922865$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ffe828bd26922865$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ffe828bd26922865$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $ffe828bd26922865$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $ffe828bd26922865$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($ffe828bd26922865$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $ffe828bd26922865$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $ffe828bd26922865$export$b956e38827fca970(action) {
    return $ffe828bd26922865$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("5JVef", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $42dd8c27be524056$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $42dd8c27be524056$export$16e3aed3edb85946);
$parcel$export(module.exports, "current", () => $42dd8c27be524056$export$97aac956da55dae9);
$parcel$export(module.exports, "produce", () => $42dd8c27be524056$export$b46cabe22e78bc00);
var $42dd8c27be524056$var$__defProp = Object.defineProperty;
var $42dd8c27be524056$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $42dd8c27be524056$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $42dd8c27be524056$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $42dd8c27be524056$var$__defNormalProp = (obj, key, value)=>key in obj ? $42dd8c27be524056$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $42dd8c27be524056$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($42dd8c27be524056$var$__hasOwnProp.call(b, prop)) $42dd8c27be524056$var$__defNormalProp(a, prop, b[prop]);
    if ($42dd8c27be524056$var$__getOwnPropSymbols) {
        for (var prop of $42dd8c27be524056$var$__getOwnPropSymbols(b))if ($42dd8c27be524056$var$__propIsEnum.call(b, prop)) $42dd8c27be524056$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $42dd8c27be524056$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $42dd8c27be524056$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $42dd8c27be524056$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $42dd8c27be524056$var$errors = [];
function $42dd8c27be524056$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $42dd8c27be524056$var$getPrototypeOf = Object.getPrototypeOf;
function $42dd8c27be524056$export$541ac630993a4c84(value) {
    return !!value && !!value[$42dd8c27be524056$var$DRAFT_STATE];
}
function $42dd8c27be524056$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $42dd8c27be524056$var$isPlainObject(value) || Array.isArray(value) || !!value[$42dd8c27be524056$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$42dd8c27be524056$export$6ee2082928bcb0ee]) || $42dd8c27be524056$var$isMap(value) || $42dd8c27be524056$var$isSet(value);
}
var $42dd8c27be524056$var$objectCtorString = Object.prototype.constructor.toString();
function $42dd8c27be524056$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $42dd8c27be524056$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $42dd8c27be524056$var$objectCtorString;
}
function $42dd8c27be524056$export$22e8af3f75a010e3(value) {
    if (!$42dd8c27be524056$export$541ac630993a4c84(value)) $42dd8c27be524056$var$die(15, value);
    return value[$42dd8c27be524056$var$DRAFT_STATE].base_;
}
function $42dd8c27be524056$var$each(obj, iter) {
    if ($42dd8c27be524056$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $42dd8c27be524056$var$getArchtype(thing) {
    const state = thing[$42dd8c27be524056$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $42dd8c27be524056$var$isMap(thing) ? 2 /* Map */  : $42dd8c27be524056$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $42dd8c27be524056$var$has(thing, prop) {
    return $42dd8c27be524056$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $42dd8c27be524056$var$get(thing, prop) {
    return $42dd8c27be524056$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $42dd8c27be524056$var$set(thing, propOrOldValue, value) {
    const t = $42dd8c27be524056$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $42dd8c27be524056$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $42dd8c27be524056$var$isMap(target) {
    return target instanceof Map;
}
function $42dd8c27be524056$var$isSet(target) {
    return target instanceof Set;
}
function $42dd8c27be524056$var$latest(state) {
    return state.copy_ || state.base_;
}
function $42dd8c27be524056$var$shallowCopy(base, strict) {
    if ($42dd8c27be524056$var$isMap(base)) return new Map(base);
    if ($42dd8c27be524056$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $42dd8c27be524056$var$isPlainObject(base)) {
        if (!$42dd8c27be524056$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $42dd8c27be524056$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$42dd8c27be524056$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($42dd8c27be524056$var$getPrototypeOf(base), descriptors);
}
function $42dd8c27be524056$export$792f3d81ea979f55(obj, deep = false) {
    if ($42dd8c27be524056$var$isFrozen(obj) || $42dd8c27be524056$export$541ac630993a4c84(obj) || !$42dd8c27be524056$export$16e3aed3edb85946(obj)) return obj;
    if ($42dd8c27be524056$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $42dd8c27be524056$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $42dd8c27be524056$var$each(obj, (_key, value)=>$42dd8c27be524056$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $42dd8c27be524056$var$dontMutateFrozenCollections() {
    $42dd8c27be524056$var$die(2);
}
function $42dd8c27be524056$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $42dd8c27be524056$var$plugins = {};
function $42dd8c27be524056$var$getPlugin(pluginKey) {
    const plugin = $42dd8c27be524056$var$plugins[pluginKey];
    if (!plugin) $42dd8c27be524056$var$die(0, pluginKey);
    return plugin;
}
function $42dd8c27be524056$var$loadPlugin(pluginKey, implementation) {
    if (!$42dd8c27be524056$var$plugins[pluginKey]) $42dd8c27be524056$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $42dd8c27be524056$var$currentScope;
function $42dd8c27be524056$var$getCurrentScope() {
    return $42dd8c27be524056$var$currentScope;
}
function $42dd8c27be524056$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $42dd8c27be524056$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $42dd8c27be524056$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $42dd8c27be524056$var$revokeScope(scope) {
    $42dd8c27be524056$var$leaveScope(scope);
    scope.drafts_.forEach($42dd8c27be524056$var$revokeDraft);
    scope.drafts_ = null;
}
function $42dd8c27be524056$var$leaveScope(scope) {
    if (scope === $42dd8c27be524056$var$currentScope) $42dd8c27be524056$var$currentScope = scope.parent_;
}
function $42dd8c27be524056$var$enterScope(immer2) {
    return $42dd8c27be524056$var$currentScope = $42dd8c27be524056$var$createScope($42dd8c27be524056$var$currentScope, immer2);
}
function $42dd8c27be524056$var$revokeDraft(draft) {
    const state = draft[$42dd8c27be524056$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $42dd8c27be524056$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$42dd8c27be524056$var$DRAFT_STATE].modified_) {
            $42dd8c27be524056$var$revokeScope(scope);
            $42dd8c27be524056$var$die(4);
        }
        if ($42dd8c27be524056$export$16e3aed3edb85946(result)) {
            result = $42dd8c27be524056$var$finalize(scope, result);
            if (!scope.parent_) $42dd8c27be524056$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $42dd8c27be524056$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$42dd8c27be524056$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $42dd8c27be524056$var$finalize(scope, baseDraft, []);
    $42dd8c27be524056$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $42dd8c27be524056$export$45b790e32b2810ee ? result : void 0;
}
function $42dd8c27be524056$var$finalize(rootScope, value, path) {
    if ($42dd8c27be524056$var$isFrozen(value)) return value;
    const state = value[$42dd8c27be524056$var$DRAFT_STATE];
    if (!state) {
        $42dd8c27be524056$var$each(value, (key, childValue)=>$42dd8c27be524056$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $42dd8c27be524056$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $42dd8c27be524056$var$each(resultEach, (key, childValue)=>$42dd8c27be524056$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $42dd8c27be524056$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $42dd8c27be524056$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $42dd8c27be524056$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($42dd8c27be524056$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$42dd8c27be524056$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $42dd8c27be524056$var$finalize(rootScope, childValue, path);
        $42dd8c27be524056$var$set(targetObject, prop, res);
        if ($42dd8c27be524056$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($42dd8c27be524056$export$16e3aed3edb85946(childValue) && !$42dd8c27be524056$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $42dd8c27be524056$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $42dd8c27be524056$var$maybeFreeze(rootScope, childValue);
    }
}
function $42dd8c27be524056$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $42dd8c27be524056$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $42dd8c27be524056$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $42dd8c27be524056$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $42dd8c27be524056$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $42dd8c27be524056$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $42dd8c27be524056$var$objectTraps = {
    get (state, prop) {
        if (prop === $42dd8c27be524056$var$DRAFT_STATE) return state;
        const source = $42dd8c27be524056$var$latest(state);
        if (!$42dd8c27be524056$var$has(source, prop)) return $42dd8c27be524056$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$42dd8c27be524056$export$16e3aed3edb85946(value)) return value;
        if (value === $42dd8c27be524056$var$peek(state.base_, prop)) {
            $42dd8c27be524056$var$prepareCopy(state);
            return state.copy_[prop] = $42dd8c27be524056$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $42dd8c27be524056$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($42dd8c27be524056$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $42dd8c27be524056$var$getDescriptorFromProto($42dd8c27be524056$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $42dd8c27be524056$var$peek($42dd8c27be524056$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$42dd8c27be524056$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($42dd8c27be524056$var$is(value, current2) && (value !== void 0 || $42dd8c27be524056$var$has(state.base_, prop))) return true;
            $42dd8c27be524056$var$prepareCopy(state);
            $42dd8c27be524056$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($42dd8c27be524056$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $42dd8c27be524056$var$prepareCopy(state);
            $42dd8c27be524056$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $42dd8c27be524056$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $42dd8c27be524056$var$die(11);
    },
    getPrototypeOf (state) {
        return $42dd8c27be524056$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $42dd8c27be524056$var$die(12);
    }
};
var $42dd8c27be524056$var$arrayTraps = {};
$42dd8c27be524056$var$each($42dd8c27be524056$var$objectTraps, (key, fn)=>{
    $42dd8c27be524056$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$42dd8c27be524056$var$arrayTraps.deleteProperty = function(state, prop) {
    return $42dd8c27be524056$var$arrayTraps.set.call(this, state, prop, void 0);
};
$42dd8c27be524056$var$arrayTraps.set = function(state, prop, value) {
    return $42dd8c27be524056$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $42dd8c27be524056$var$peek(draft, prop) {
    const state = draft[$42dd8c27be524056$var$DRAFT_STATE];
    const source = state ? $42dd8c27be524056$var$latest(state) : draft;
    return source[prop];
}
function $42dd8c27be524056$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $42dd8c27be524056$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $42dd8c27be524056$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $42dd8c27be524056$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $42dd8c27be524056$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $42dd8c27be524056$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $42dd8c27be524056$var$markChanged(state.parent_);
    }
}
function $42dd8c27be524056$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $42dd8c27be524056$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $42dd8c27be524056$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $42dd8c27be524056$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $42dd8c27be524056$var$die(7);
            let result;
            if ($42dd8c27be524056$export$16e3aed3edb85946(base)) {
                const scope = $42dd8c27be524056$var$enterScope(this);
                const proxy = $42dd8c27be524056$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $42dd8c27be524056$var$revokeScope(scope);
                    else $42dd8c27be524056$var$leaveScope(scope);
                }
                $42dd8c27be524056$var$usePatchesInScope(scope, patchListener);
                return $42dd8c27be524056$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $42dd8c27be524056$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $42dd8c27be524056$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $42dd8c27be524056$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $42dd8c27be524056$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$42dd8c27be524056$export$16e3aed3edb85946(base)) $42dd8c27be524056$var$die(8);
        if ($42dd8c27be524056$export$541ac630993a4c84(base)) base = $42dd8c27be524056$export$97aac956da55dae9(base);
        const scope = $42dd8c27be524056$var$enterScope(this);
        const proxy = $42dd8c27be524056$var$createProxy(base, void 0);
        proxy[$42dd8c27be524056$var$DRAFT_STATE].isManual_ = true;
        $42dd8c27be524056$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$42dd8c27be524056$var$DRAFT_STATE];
        if (!state || !state.isManual_) $42dd8c27be524056$var$die(9);
        const { scope_: scope } = state;
        $42dd8c27be524056$var$usePatchesInScope(scope, patchListener);
        return $42dd8c27be524056$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $42dd8c27be524056$var$getPlugin("Patches").applyPatches_;
        if ($42dd8c27be524056$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $42dd8c27be524056$var$createProxy(value, parent) {
    const draft = $42dd8c27be524056$var$isMap(value) ? $42dd8c27be524056$var$getPlugin("MapSet").proxyMap_(value, parent) : $42dd8c27be524056$var$isSet(value) ? $42dd8c27be524056$var$getPlugin("MapSet").proxySet_(value, parent) : $42dd8c27be524056$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $42dd8c27be524056$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $42dd8c27be524056$export$97aac956da55dae9(value) {
    if (!$42dd8c27be524056$export$541ac630993a4c84(value)) $42dd8c27be524056$var$die(10, value);
    return $42dd8c27be524056$var$currentImpl(value);
}
function $42dd8c27be524056$var$currentImpl(value) {
    if (!$42dd8c27be524056$export$16e3aed3edb85946(value) || $42dd8c27be524056$var$isFrozen(value)) return value;
    const state = value[$42dd8c27be524056$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $42dd8c27be524056$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $42dd8c27be524056$var$shallowCopy(value, true);
    $42dd8c27be524056$var$each(copy, (key, childValue)=>{
        $42dd8c27be524056$var$set(copy, key, $42dd8c27be524056$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $42dd8c27be524056$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $42dd8c27be524056$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $42dd8c27be524056$var$get(base_, key);
            const value = $42dd8c27be524056$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $42dd8c27be524056$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $42dd8c27be524056$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $42dd8c27be524056$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $42dd8c27be524056$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $42dd8c27be524056$var$die(errorOffset + 3);
                base = $42dd8c27be524056$var$get(base, p);
                if (typeof base !== "object") $42dd8c27be524056$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $42dd8c27be524056$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $42dd8c27be524056$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $42dd8c27be524056$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$42dd8c27be524056$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($42dd8c27be524056$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($42dd8c27be524056$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($42dd8c27be524056$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($42dd8c27be524056$var$has(obj, $42dd8c27be524056$export$6ee2082928bcb0ee)) cloned[$42dd8c27be524056$export$6ee2082928bcb0ee] = obj[$42dd8c27be524056$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($42dd8c27be524056$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $42dd8c27be524056$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $42dd8c27be524056$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$42dd8c27be524056$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $42dd8c27be524056$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $42dd8c27be524056$var$latest(this[$42dd8c27be524056$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $42dd8c27be524056$var$latest(this[$42dd8c27be524056$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$42dd8c27be524056$var$latest(state).has(key) || $42dd8c27be524056$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $42dd8c27be524056$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $42dd8c27be524056$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($42dd8c27be524056$var$latest(state).size) {
                prepareMapCopy(state);
                $42dd8c27be524056$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $42dd8c27be524056$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            $42dd8c27be524056$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $42dd8c27be524056$var$latest(state).get(key);
            if (state.finalized_ || !$42dd8c27be524056$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $42dd8c27be524056$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $42dd8c27be524056$var$latest(this[$42dd8c27be524056$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($42dd8c27be524056$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$42dd8c27be524056$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $42dd8c27be524056$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $42dd8c27be524056$var$latest(this[$42dd8c27be524056$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $42dd8c27be524056$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $42dd8c27be524056$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($42dd8c27be524056$var$latest(state).size) {
                prepareSetCopy(state);
                $42dd8c27be524056$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$42dd8c27be524056$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($42dd8c27be524056$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($42dd8c27be524056$export$16e3aed3edb85946(value)) {
                    const draft = $42dd8c27be524056$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $42dd8c27be524056$var$die(3, JSON.stringify($42dd8c27be524056$var$latest(state)));
    }
    $42dd8c27be524056$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $42dd8c27be524056$var$immer = new $42dd8c27be524056$export$aaadc6ff0f822719();
var $42dd8c27be524056$export$b46cabe22e78bc00 = $42dd8c27be524056$var$immer.produce;
var $42dd8c27be524056$export$4da66d41c9492c78 = $42dd8c27be524056$var$immer.produceWithPatches.bind($42dd8c27be524056$var$immer);
var $42dd8c27be524056$export$573f26f60825c493 = $42dd8c27be524056$var$immer.setAutoFreeze.bind($42dd8c27be524056$var$immer);
var $42dd8c27be524056$export$333ce65961cbe047 = $42dd8c27be524056$var$immer.setUseStrictShallowCopy.bind($42dd8c27be524056$var$immer);
var $42dd8c27be524056$export$a8b8e03e6bbe5473 = $42dd8c27be524056$var$immer.applyPatches.bind($42dd8c27be524056$var$immer);
var $42dd8c27be524056$export$3c3214997190395f = $42dd8c27be524056$var$immer.createDraft.bind($42dd8c27be524056$var$immer);
var $42dd8c27be524056$export$c60f5e69c521b528 = $42dd8c27be524056$var$immer.finishDraft.bind($42dd8c27be524056$var$immer);
function $42dd8c27be524056$export$c05b21e3257751e5(value) {
    return value;
}
function $42dd8c27be524056$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("jDz3G", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $e4bcdab7cf800024$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $e4bcdab7cf800024$export$5943f4447f6ef248);
var $e4bcdab7cf800024$var$__defProp = Object.defineProperty;
var $e4bcdab7cf800024$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e4bcdab7cf800024$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e4bcdab7cf800024$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e4bcdab7cf800024$var$__defNormalProp = (obj, key, value)=>key in obj ? $e4bcdab7cf800024$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e4bcdab7cf800024$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e4bcdab7cf800024$var$__hasOwnProp.call(b, prop)) $e4bcdab7cf800024$var$__defNormalProp(a, prop, b[prop]);
    if ($e4bcdab7cf800024$var$__getOwnPropSymbols) {
        for (var prop of $e4bcdab7cf800024$var$__getOwnPropSymbols(b))if ($e4bcdab7cf800024$var$__propIsEnum.call(b, prop)) $e4bcdab7cf800024$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e4bcdab7cf800024$var$__publicField = (obj, key, value)=>{
    $e4bcdab7cf800024$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $e4bcdab7cf800024$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $e4bcdab7cf800024$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $e4bcdab7cf800024$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $e4bcdab7cf800024$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($e4bcdab7cf800024$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $e4bcdab7cf800024$var$NOT_FOUND = "NOT_FOUND";
function $e4bcdab7cf800024$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $e4bcdab7cf800024$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $e4bcdab7cf800024$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $e4bcdab7cf800024$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $e4bcdab7cf800024$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $e4bcdab7cf800024$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $e4bcdab7cf800024$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $e4bcdab7cf800024$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $e4bcdab7cf800024$var$__spreadValues($e4bcdab7cf800024$var$__spreadValues({}, $e4bcdab7cf800024$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $e4bcdab7cf800024$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $e4bcdab7cf800024$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $e4bcdab7cf800024$var$$REVISION = 0;
var $e4bcdab7cf800024$var$CURRENT_TRACKER = null;
var $e4bcdab7cf800024$var$Cell = class {
    constructor(initialValue, isEqual = $e4bcdab7cf800024$var$tripleEq){
        $e4bcdab7cf800024$var$__publicField(this, "revision", $e4bcdab7cf800024$var$$REVISION);
        $e4bcdab7cf800024$var$__publicField(this, "_value");
        $e4bcdab7cf800024$var$__publicField(this, "_lastValue");
        $e4bcdab7cf800024$var$__publicField(this, "_isEqual", $e4bcdab7cf800024$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $e4bcdab7cf800024$var$CURRENT_TRACKER == null || $e4bcdab7cf800024$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$e4bcdab7cf800024$var$$REVISION;
    }
};
function $e4bcdab7cf800024$var$tripleEq(a, b) {
    return a === b;
}
var $e4bcdab7cf800024$var$TrackingCache = class {
    constructor(fn){
        $e4bcdab7cf800024$var$__publicField(this, "_cachedValue");
        $e4bcdab7cf800024$var$__publicField(this, "_cachedRevision", -1);
        $e4bcdab7cf800024$var$__publicField(this, "_deps", []);
        $e4bcdab7cf800024$var$__publicField(this, "hits", 0);
        $e4bcdab7cf800024$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $e4bcdab7cf800024$var$CURRENT_TRACKER;
            $e4bcdab7cf800024$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $e4bcdab7cf800024$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $e4bcdab7cf800024$var$CURRENT_TRACKER == null || $e4bcdab7cf800024$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $e4bcdab7cf800024$var$getValue(cell) {
    if (!(cell instanceof $e4bcdab7cf800024$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $e4bcdab7cf800024$var$setValue(storage, value) {
    if (!(storage instanceof $e4bcdab7cf800024$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $e4bcdab7cf800024$var$createCell(initialValue, isEqual = $e4bcdab7cf800024$var$tripleEq) {
    return new $e4bcdab7cf800024$var$Cell(initialValue, isEqual);
}
function $e4bcdab7cf800024$var$createCache(fn) {
    $e4bcdab7cf800024$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $e4bcdab7cf800024$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $e4bcdab7cf800024$var$neverEq = (a, b)=>false;
function $e4bcdab7cf800024$var$createTag() {
    return $e4bcdab7cf800024$var$createCell(null, $e4bcdab7cf800024$var$neverEq);
}
function $e4bcdab7cf800024$var$dirtyTag(tag, value) {
    $e4bcdab7cf800024$var$setValue(tag, value);
}
var $e4bcdab7cf800024$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $e4bcdab7cf800024$var$createTag();
    $e4bcdab7cf800024$var$getValue(tag);
};
var $e4bcdab7cf800024$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $e4bcdab7cf800024$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $e4bcdab7cf800024$var$REDUX_PROXY_LABEL = Symbol();
var $e4bcdab7cf800024$var$nextId = 0;
var $e4bcdab7cf800024$var$proto = Object.getPrototypeOf({});
var $e4bcdab7cf800024$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $e4bcdab7cf800024$var$__publicField(this, "proxy", new Proxy(this, $e4bcdab7cf800024$var$objectProxyHandler));
        $e4bcdab7cf800024$var$__publicField(this, "tag", $e4bcdab7cf800024$var$createTag());
        $e4bcdab7cf800024$var$__publicField(this, "tags", {});
        $e4bcdab7cf800024$var$__publicField(this, "children", {});
        $e4bcdab7cf800024$var$__publicField(this, "collectionTag", null);
        $e4bcdab7cf800024$var$__publicField(this, "id", $e4bcdab7cf800024$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $e4bcdab7cf800024$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $e4bcdab7cf800024$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $e4bcdab7cf800024$var$createNode(childValue);
                if (childNode.tag) $e4bcdab7cf800024$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $e4bcdab7cf800024$var$createTag();
                    tag.value = childValue;
                }
                $e4bcdab7cf800024$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $e4bcdab7cf800024$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $e4bcdab7cf800024$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $e4bcdab7cf800024$var$__publicField(this, "proxy", new Proxy([
            this
        ], $e4bcdab7cf800024$var$arrayProxyHandler));
        $e4bcdab7cf800024$var$__publicField(this, "tag", $e4bcdab7cf800024$var$createTag());
        $e4bcdab7cf800024$var$__publicField(this, "tags", {});
        $e4bcdab7cf800024$var$__publicField(this, "children", {});
        $e4bcdab7cf800024$var$__publicField(this, "collectionTag", null);
        $e4bcdab7cf800024$var$__publicField(this, "id", $e4bcdab7cf800024$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $e4bcdab7cf800024$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $e4bcdab7cf800024$var$consumeCollection(node);
        return $e4bcdab7cf800024$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $e4bcdab7cf800024$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $e4bcdab7cf800024$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $e4bcdab7cf800024$var$objectProxyHandler.has(node, prop);
    }
};
function $e4bcdab7cf800024$var$createNode(value) {
    if (Array.isArray(value)) return new $e4bcdab7cf800024$var$ArrayTreeNode(value);
    return new $e4bcdab7cf800024$var$ObjectTreeNode(value);
}
function $e4bcdab7cf800024$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $e4bcdab7cf800024$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $e4bcdab7cf800024$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $e4bcdab7cf800024$var$dirtyCollection(node);
            $e4bcdab7cf800024$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $e4bcdab7cf800024$var$updateNode(childNode, newChildValue);
        else {
            $e4bcdab7cf800024$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $e4bcdab7cf800024$var$deleteNode(node) {
    if (node.tag) $e4bcdab7cf800024$var$dirtyTag(node.tag, null);
    $e4bcdab7cf800024$var$dirtyCollection(node);
    for(const key in node.tags)$e4bcdab7cf800024$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$e4bcdab7cf800024$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $e4bcdab7cf800024$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $e4bcdab7cf800024$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $e4bcdab7cf800024$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $e4bcdab7cf800024$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $e4bcdab7cf800024$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $e4bcdab7cf800024$export$3f025202a230c6dd = (a, b)=>a === b;
function $e4bcdab7cf800024$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $e4bcdab7cf800024$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $e4bcdab7cf800024$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $e4bcdab7cf800024$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $e4bcdab7cf800024$var$createSingletonCache(comparator) : $e4bcdab7cf800024$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $e4bcdab7cf800024$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $e4bcdab7cf800024$export$c8f9cf88d9fdee55(func) {
    const node = $e4bcdab7cf800024$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $e4bcdab7cf800024$var$createCacheKeyComparator($e4bcdab7cf800024$export$3f025202a230c6dd);
    const cache = $e4bcdab7cf800024$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $e4bcdab7cf800024$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $e4bcdab7cf800024$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $e4bcdab7cf800024$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $e4bcdab7cf800024$var$StrongRef;
var $e4bcdab7cf800024$var$UNTERMINATED = 0;
var $e4bcdab7cf800024$var$TERMINATED = 1;
function $e4bcdab7cf800024$var$createCacheNode() {
    return {
        s: $e4bcdab7cf800024$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $e4bcdab7cf800024$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $e4bcdab7cf800024$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $e4bcdab7cf800024$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $e4bcdab7cf800024$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $e4bcdab7cf800024$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $e4bcdab7cf800024$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $e4bcdab7cf800024$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $e4bcdab7cf800024$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $e4bcdab7cf800024$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $e4bcdab7cf800024$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $e4bcdab7cf800024$var$__spreadValues($e4bcdab7cf800024$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $e4bcdab7cf800024$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $e4bcdab7cf800024$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $e4bcdab7cf800024$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $e4bcdab7cf800024$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $e4bcdab7cf800024$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $e4bcdab7cf800024$export$595d22ed68ca2841 = /* @__PURE__ */ $e4bcdab7cf800024$export$5943f4447f6ef248($e4bcdab7cf800024$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $e4bcdab7cf800024$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $e4bcdab7cf800024$export$595d22ed68ca2841)=>{
    $e4bcdab7cf800024$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$e4bcdab7cf800024$export$75979cfcd91bf38f
});

});

parcelRegister("i7tcV", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $d30f8974660914c7$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $d30f8974660914c7$export$16d06542a1949d9e);
// src/index.ts
function $d30f8974660914c7$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $d30f8974660914c7$export$dd164f5517779f15 = $d30f8974660914c7$var$createThunkMiddleware();
var $d30f8974660914c7$export$16d06542a1949d9e = $d30f8974660914c7$var$createThunkMiddleware;

});

parcelRegister("juhyG", function(module, exports) {
// shim for using process in browser
var $e2fe7063766c8b3b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e2fe7063766c8b3b$var$cachedSetTimeout;
var $e2fe7063766c8b3b$var$cachedClearTimeout;
function $e2fe7063766c8b3b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e2fe7063766c8b3b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e2fe7063766c8b3b$var$cachedSetTimeout = setTimeout;
        else $e2fe7063766c8b3b$var$cachedSetTimeout = $e2fe7063766c8b3b$var$defaultSetTimout;
    } catch (e) {
        $e2fe7063766c8b3b$var$cachedSetTimeout = $e2fe7063766c8b3b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e2fe7063766c8b3b$var$cachedClearTimeout = clearTimeout;
        else $e2fe7063766c8b3b$var$cachedClearTimeout = $e2fe7063766c8b3b$var$defaultClearTimeout;
    } catch (e) {
        $e2fe7063766c8b3b$var$cachedClearTimeout = $e2fe7063766c8b3b$var$defaultClearTimeout;
    }
})();
function $e2fe7063766c8b3b$var$runTimeout(fun) {
    if ($e2fe7063766c8b3b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e2fe7063766c8b3b$var$cachedSetTimeout === $e2fe7063766c8b3b$var$defaultSetTimout || !$e2fe7063766c8b3b$var$cachedSetTimeout) && setTimeout) {
        $e2fe7063766c8b3b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e2fe7063766c8b3b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e2fe7063766c8b3b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e2fe7063766c8b3b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e2fe7063766c8b3b$var$runClearTimeout(marker) {
    if ($e2fe7063766c8b3b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e2fe7063766c8b3b$var$cachedClearTimeout === $e2fe7063766c8b3b$var$defaultClearTimeout || !$e2fe7063766c8b3b$var$cachedClearTimeout) && clearTimeout) {
        $e2fe7063766c8b3b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e2fe7063766c8b3b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e2fe7063766c8b3b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e2fe7063766c8b3b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e2fe7063766c8b3b$var$queue = [];
var $e2fe7063766c8b3b$var$draining = false;
var $e2fe7063766c8b3b$var$currentQueue;
var $e2fe7063766c8b3b$var$queueIndex = -1;
function $e2fe7063766c8b3b$var$cleanUpNextTick() {
    if (!$e2fe7063766c8b3b$var$draining || !$e2fe7063766c8b3b$var$currentQueue) return;
    $e2fe7063766c8b3b$var$draining = false;
    if ($e2fe7063766c8b3b$var$currentQueue.length) $e2fe7063766c8b3b$var$queue = $e2fe7063766c8b3b$var$currentQueue.concat($e2fe7063766c8b3b$var$queue);
    else $e2fe7063766c8b3b$var$queueIndex = -1;
    if ($e2fe7063766c8b3b$var$queue.length) $e2fe7063766c8b3b$var$drainQueue();
}
function $e2fe7063766c8b3b$var$drainQueue() {
    if ($e2fe7063766c8b3b$var$draining) return;
    var timeout = $e2fe7063766c8b3b$var$runTimeout($e2fe7063766c8b3b$var$cleanUpNextTick);
    $e2fe7063766c8b3b$var$draining = true;
    var len = $e2fe7063766c8b3b$var$queue.length;
    while(len){
        $e2fe7063766c8b3b$var$currentQueue = $e2fe7063766c8b3b$var$queue;
        $e2fe7063766c8b3b$var$queue = [];
        while(++$e2fe7063766c8b3b$var$queueIndex < len)if ($e2fe7063766c8b3b$var$currentQueue) $e2fe7063766c8b3b$var$currentQueue[$e2fe7063766c8b3b$var$queueIndex].run();
        $e2fe7063766c8b3b$var$queueIndex = -1;
        len = $e2fe7063766c8b3b$var$queue.length;
    }
    $e2fe7063766c8b3b$var$currentQueue = null;
    $e2fe7063766c8b3b$var$draining = false;
    $e2fe7063766c8b3b$var$runClearTimeout(timeout);
}
$e2fe7063766c8b3b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e2fe7063766c8b3b$var$queue.push(new $e2fe7063766c8b3b$var$Item(fun, args));
    if ($e2fe7063766c8b3b$var$queue.length === 1 && !$e2fe7063766c8b3b$var$draining) $e2fe7063766c8b3b$var$runTimeout($e2fe7063766c8b3b$var$drainQueue);
};
// v8 likes predictible objects
function $e2fe7063766c8b3b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e2fe7063766c8b3b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e2fe7063766c8b3b$var$process.title = "browser";
$e2fe7063766c8b3b$var$process.browser = true;
$e2fe7063766c8b3b$var$process.env = {};
$e2fe7063766c8b3b$var$process.argv = [];
$e2fe7063766c8b3b$var$process.version = ""; // empty string to avoid regexp issues
$e2fe7063766c8b3b$var$process.versions = {};
function $e2fe7063766c8b3b$var$noop() {}
$e2fe7063766c8b3b$var$process.on = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.addListener = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.once = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.off = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.removeListener = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.removeAllListeners = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.emit = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.prependListener = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.prependOnceListener = $e2fe7063766c8b3b$var$noop;
$e2fe7063766c8b3b$var$process.listeners = function(name) {
    return [];
};
$e2fe7063766c8b3b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e2fe7063766c8b3b$var$process.cwd = function() {
    return "/";
};
$e2fe7063766c8b3b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e2fe7063766c8b3b$var$process.umask = function() {
    return 0;
};

});



parcelRegister("jimHT", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "ErrorMessage", () => ErrorMessage);

var $lSCDD = parcelRequire("lSCDD");

var $iC7rx = parcelRequire("iC7rx");

var $50vd1 = parcelRequire("50vd1");

var $c4Bi3 = parcelRequire("c4Bi3");

var $7cal1 = parcelRequire("7cal1");

var $jxVy9 = parcelRequire("jxVy9");

var $70duG = parcelRequire("70duG");

var $2c4D7 = parcelRequire("2c4D7");

var $cyKKf = parcelRequire("cyKKf");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $50vd1.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $50vd1.useContext)(FormikContext);
    !!!formik && (0, $7cal1.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $50vd1.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $70duG.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $jxVy9.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $70duG.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $jxVy9.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $50vd1.useRef)(props.initialValues);
    var initialErrors = (0, $50vd1.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $50vd1.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $50vd1.useRef)(props.initialStatus);
    var isMounted = (0, $50vd1.useRef)(false);
    var fieldRegistry = (0, $50vd1.useRef)({});
    (0, $50vd1.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $50vd1.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $50vd1.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $50vd1.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $50vd1.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $50vd1.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $50vd1.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $50vd1.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $50vd1.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $lSCDD.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $50vd1.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $50vd1.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $50vd1.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $50vd1.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $50vd1.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $50vd1.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $50vd1.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $50vd1.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $50vd1.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $50vd1.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $50vd1.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $50vd1.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $50vd1.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $50vd1.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $50vd1.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $50vd1.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $50vd1.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $50vd1.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $50vd1.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $50vd1.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $50vd1.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $50vd1.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $50vd1.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $50vd1.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $iC7rx.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $iC7rx.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $lSCDD.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $lSCDD.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $50vd1.useLayoutEffect) : (0, $50vd1.useEffect);
function useEventCallback(fn) {
    var ref = (0, $50vd1.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $50vd1.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $50vd1.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $7cal1.default)(false);
    var fieldHelpers = (0, $50vd1.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $50vd1.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $50vd1.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $50vd1.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $50vd1.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $50vd1.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $50vd1.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $50vd1.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $50vd1.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $50vd1.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $50vd1.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($2c4D7)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $50vd1.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $7cal1.default)(false);
            return (0, $50vd1.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c4D7)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $cyKKf.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($c4Bi3)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $50vd1.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $50vd1.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $50vd1.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $50vd1.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $50vd1.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $7cal1.default)(false);
        !!(component && render) && (0, $7cal1.default)(false);
        !!(is && children && isFunction(children)) && (0, $7cal1.default)(false);
        !!(component && children && isFunction(children)) && (0, $7cal1.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $7cal1.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $50vd1.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $50vd1.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $50vd1.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $50vd1.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $50vd1.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("lSCDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fedc9ce181de7865$export$2e2bcd8739ae039);
var $fedc9ce181de7865$var$isMergeableObject = function isMergeableObject(value) {
    return $fedc9ce181de7865$var$isNonNullObject(value) && !$fedc9ce181de7865$var$isSpecial(value);
};
function $fedc9ce181de7865$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $fedc9ce181de7865$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $fedc9ce181de7865$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $fedc9ce181de7865$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $fedc9ce181de7865$var$REACT_ELEMENT_TYPE = $fedc9ce181de7865$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $fedc9ce181de7865$var$isReactElement(value) {
    return value.$$typeof === $fedc9ce181de7865$var$REACT_ELEMENT_TYPE;
}
function $fedc9ce181de7865$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $fedc9ce181de7865$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $fedc9ce181de7865$var$deepmerge($fedc9ce181de7865$var$emptyTarget(value), value, options) : value;
}
function $fedc9ce181de7865$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $fedc9ce181de7865$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $fedc9ce181de7865$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $fedc9ce181de7865$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $fedc9ce181de7865$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $fedc9ce181de7865$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $fedc9ce181de7865$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $fedc9ce181de7865$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $fedc9ce181de7865$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $fedc9ce181de7865$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $fedc9ce181de7865$var$mergeObject(target, source, options);
}
$fedc9ce181de7865$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $fedc9ce181de7865$var$deepmerge(prev, next, options);
    }, {});
};
var $fedc9ce181de7865$var$deepmerge_1 = $fedc9ce181de7865$var$deepmerge;
var $fedc9ce181de7865$export$2e2bcd8739ae039 = $fedc9ce181de7865$var$deepmerge_1;

});

parcelRegister("iC7rx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d18cadac205b5a$export$2e2bcd8739ae039);

var $4Vy8R = parcelRequire("4Vy8R");

var $jSGRV = parcelRequire("jSGRV");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $d8d18cadac205b5a$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $d8d18cadac205b5a$var$funcProto = Function.prototype, $d8d18cadac205b5a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d8d18cadac205b5a$var$funcToString = $d8d18cadac205b5a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d8d18cadac205b5a$var$hasOwnProperty = $d8d18cadac205b5a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d8d18cadac205b5a$var$objectCtorString = $d8d18cadac205b5a$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d8d18cadac205b5a$var$isPlainObject(value) {
    if (!(0, $3iyEO.default)(value) || (0, $4Vy8R.default)(value) != $d8d18cadac205b5a$var$objectTag) return false;
    var proto = (0, $jSGRV.default)(value);
    if (proto === null) return true;
    var Ctor = $d8d18cadac205b5a$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $d8d18cadac205b5a$var$funcToString.call(Ctor) == $d8d18cadac205b5a$var$objectCtorString;
}
var $d8d18cadac205b5a$export$2e2bcd8739ae039 = $d8d18cadac205b5a$var$isPlainObject;

});
parcelRegister("4Vy8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $3966f8295ff43cdc$export$2e2bcd8739ae039);

var $7BbnC = parcelRequire("7BbnC");

var $g5iua = parcelRequire("g5iua");

var $c5JJW = parcelRequire("c5JJW");
/** `Object#toString` result references. */ var $3966f8295ff43cdc$var$nullTag = "[object Null]", $3966f8295ff43cdc$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3966f8295ff43cdc$var$symToStringTag = (0, $7BbnC.default) ? (0, $7BbnC.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3966f8295ff43cdc$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3966f8295ff43cdc$var$undefinedTag : $3966f8295ff43cdc$var$nullTag;
    return $3966f8295ff43cdc$var$symToStringTag && $3966f8295ff43cdc$var$symToStringTag in Object(value) ? (0, $g5iua.default)(value) : (0, $c5JJW.default)(value);
}
var $3966f8295ff43cdc$export$2e2bcd8739ae039 = $3966f8295ff43cdc$var$baseGetTag;

});
parcelRegister("7BbnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5884d0f2e27e86d4$export$2e2bcd8739ae039);

var $cdLtB = parcelRequire("cdLtB");
/** Built-in value references. */ var $5884d0f2e27e86d4$var$Symbol = (0, $cdLtB.default).Symbol;
var $5884d0f2e27e86d4$export$2e2bcd8739ae039 = $5884d0f2e27e86d4$var$Symbol;

});
parcelRegister("cdLtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5b86c136da98eb$export$2e2bcd8739ae039);

var $gflQN = parcelRequire("gflQN");
/** Detect free variable `self`. */ var $8e5b86c136da98eb$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8e5b86c136da98eb$var$root = (0, $gflQN.default) || $8e5b86c136da98eb$var$freeSelf || Function("return this")();
var $8e5b86c136da98eb$export$2e2bcd8739ae039 = $8e5b86c136da98eb$var$root;

});
parcelRegister("gflQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3eff1b3f4ce5fd$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $bd3eff1b3f4ce5fd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bd3eff1b3f4ce5fd$export$2e2bcd8739ae039 = $bd3eff1b3f4ce5fd$var$freeGlobal;

});



parcelRegister("g5iua", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5b73cf115cca21$export$2e2bcd8739ae039);

var $7BbnC = parcelRequire("7BbnC");
/** Used for built-in method references. */ var $bb5b73cf115cca21$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb5b73cf115cca21$var$hasOwnProperty = $bb5b73cf115cca21$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bb5b73cf115cca21$var$nativeObjectToString = $bb5b73cf115cca21$var$objectProto.toString;
/** Built-in value references. */ var $bb5b73cf115cca21$var$symToStringTag = (0, $7BbnC.default) ? (0, $7BbnC.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $bb5b73cf115cca21$var$getRawTag(value) {
    var isOwn = $bb5b73cf115cca21$var$hasOwnProperty.call(value, $bb5b73cf115cca21$var$symToStringTag), tag = value[$bb5b73cf115cca21$var$symToStringTag];
    try {
        value[$bb5b73cf115cca21$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $bb5b73cf115cca21$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$bb5b73cf115cca21$var$symToStringTag] = tag;
        else delete value[$bb5b73cf115cca21$var$symToStringTag];
    }
    return result;
}
var $bb5b73cf115cca21$export$2e2bcd8739ae039 = $bb5b73cf115cca21$var$getRawTag;

});

parcelRegister("c5JJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cd96eb29fcdeaef$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $8cd96eb29fcdeaef$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8cd96eb29fcdeaef$var$nativeObjectToString = $8cd96eb29fcdeaef$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8cd96eb29fcdeaef$var$objectToString(value) {
    return $8cd96eb29fcdeaef$var$nativeObjectToString.call(value);
}
var $8cd96eb29fcdeaef$export$2e2bcd8739ae039 = $8cd96eb29fcdeaef$var$objectToString;

});


parcelRegister("jSGRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e794505349c892f4$export$2e2bcd8739ae039);

var $9VSEB = parcelRequire("9VSEB");
/** Built-in value references. */ var $e794505349c892f4$var$getPrototype = (0, $9VSEB.default)(Object.getPrototypeOf, Object);
var $e794505349c892f4$export$2e2bcd8739ae039 = $e794505349c892f4$var$getPrototype;

});
parcelRegister("9VSEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $73b3d50bccf94be3$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $73b3d50bccf94be3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $73b3d50bccf94be3$export$2e2bcd8739ae039 = $73b3d50bccf94be3$var$overArg;

});


parcelRegister("3iyEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $266defb90f7f05e4$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $266defb90f7f05e4$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $266defb90f7f05e4$export$2e2bcd8739ae039 = $266defb90f7f05e4$var$isObjectLike;

});


parcelRegister("c4Bi3", function(module, exports) {
"use strict";
var $8ca2c8d244dab56b$var$isArray = Array.isArray;
var $8ca2c8d244dab56b$var$keyList = Object.keys;
var $8ca2c8d244dab56b$var$hasProp = Object.prototype.hasOwnProperty;
var $8ca2c8d244dab56b$var$hasElementType = typeof Element !== "undefined";
function $8ca2c8d244dab56b$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $8ca2c8d244dab56b$var$isArray(a), arrB = $8ca2c8d244dab56b$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$8ca2c8d244dab56b$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $8ca2c8d244dab56b$var$keyList(a);
        length = keys.length;
        if (length !== $8ca2c8d244dab56b$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$8ca2c8d244dab56b$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($8ca2c8d244dab56b$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$8ca2c8d244dab56b$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $8ca2c8d244dab56b$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7cal1", function(module, exports) {

$parcel$export(module.exports, "default", () => $53d1ac541258fa23$export$2e2bcd8739ae039);
var $53d1ac541258fa23$var$isProduction = true;
function $53d1ac541258fa23$var$warning(condition, message) {
    if (!$53d1ac541258fa23$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $53d1ac541258fa23$export$2e2bcd8739ae039 = $53d1ac541258fa23$var$warning;

});

parcelRegister("jxVy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3adbd9381dd9f7e$export$2e2bcd8739ae039);

var $5EA90 = parcelRequire("5EA90");
/** Used to compose bitmasks for cloning. */ var $e3adbd9381dd9f7e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $e3adbd9381dd9f7e$var$clone(value) {
    return (0, $5EA90.default)(value, $e3adbd9381dd9f7e$var$CLONE_SYMBOLS_FLAG);
}
var $e3adbd9381dd9f7e$export$2e2bcd8739ae039 = $e3adbd9381dd9f7e$var$clone;

});
parcelRegister("5EA90", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dcb9acf65d8168$export$2e2bcd8739ae039);

var $5SFKX = parcelRequire("5SFKX");

var $dkPRS = parcelRequire("dkPRS");

var $10ADx = parcelRequire("10ADx");

var $3dF2c = parcelRequire("3dF2c");

var $j5nkt = parcelRequire("j5nkt");

var $bEaiQ = parcelRequire("bEaiQ");

var $4m08N = parcelRequire("4m08N");

var $1I88C = parcelRequire("1I88C");

var $1aega = parcelRequire("1aega");

var $fgvBa = parcelRequire("fgvBa");

var $ljVnC = parcelRequire("ljVnC");

var $1Njgi = parcelRequire("1Njgi");

var $a3weY = parcelRequire("a3weY");

var $44Ua8 = parcelRequire("44Ua8");

var $80kg7 = parcelRequire("80kg7");

var $ipNyZ = parcelRequire("ipNyZ");

var $4374k = parcelRequire("4374k");

var $dzKFi = parcelRequire("dzKFi");

var $aEm6h = parcelRequire("aEm6h");

var $3gkQ4 = parcelRequire("3gkQ4");

var $kOOZf = parcelRequire("kOOZf");

var $iJbss = parcelRequire("iJbss");
/** Used to compose bitmasks for cloning. */ var $41dcb9acf65d8168$var$CLONE_DEEP_FLAG = 1, $41dcb9acf65d8168$var$CLONE_FLAT_FLAG = 2, $41dcb9acf65d8168$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $41dcb9acf65d8168$var$argsTag = "[object Arguments]", $41dcb9acf65d8168$var$arrayTag = "[object Array]", $41dcb9acf65d8168$var$boolTag = "[object Boolean]", $41dcb9acf65d8168$var$dateTag = "[object Date]", $41dcb9acf65d8168$var$errorTag = "[object Error]", $41dcb9acf65d8168$var$funcTag = "[object Function]", $41dcb9acf65d8168$var$genTag = "[object GeneratorFunction]", $41dcb9acf65d8168$var$mapTag = "[object Map]", $41dcb9acf65d8168$var$numberTag = "[object Number]", $41dcb9acf65d8168$var$objectTag = "[object Object]", $41dcb9acf65d8168$var$regexpTag = "[object RegExp]", $41dcb9acf65d8168$var$setTag = "[object Set]", $41dcb9acf65d8168$var$stringTag = "[object String]", $41dcb9acf65d8168$var$symbolTag = "[object Symbol]", $41dcb9acf65d8168$var$weakMapTag = "[object WeakMap]";
var $41dcb9acf65d8168$var$arrayBufferTag = "[object ArrayBuffer]", $41dcb9acf65d8168$var$dataViewTag = "[object DataView]", $41dcb9acf65d8168$var$float32Tag = "[object Float32Array]", $41dcb9acf65d8168$var$float64Tag = "[object Float64Array]", $41dcb9acf65d8168$var$int8Tag = "[object Int8Array]", $41dcb9acf65d8168$var$int16Tag = "[object Int16Array]", $41dcb9acf65d8168$var$int32Tag = "[object Int32Array]", $41dcb9acf65d8168$var$uint8Tag = "[object Uint8Array]", $41dcb9acf65d8168$var$uint8ClampedTag = "[object Uint8ClampedArray]", $41dcb9acf65d8168$var$uint16Tag = "[object Uint16Array]", $41dcb9acf65d8168$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $41dcb9acf65d8168$var$cloneableTags = {};
$41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$argsTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$arrayTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$arrayBufferTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$dataViewTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$boolTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$dateTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$float32Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$float64Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$int8Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$int16Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$int32Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$mapTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$numberTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$objectTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$regexpTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$setTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$stringTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$symbolTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$uint8Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$uint8ClampedTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$uint16Tag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$uint32Tag] = true;
$41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$errorTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$funcTag] = $41dcb9acf65d8168$var$cloneableTags[$41dcb9acf65d8168$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $41dcb9acf65d8168$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $41dcb9acf65d8168$var$CLONE_DEEP_FLAG, isFlat = bitmask & $41dcb9acf65d8168$var$CLONE_FLAT_FLAG, isFull = bitmask & $41dcb9acf65d8168$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $aEm6h.default)(value)) return value;
    var isArr = (0, $ipNyZ.default)(value);
    if (isArr) {
        result = (0, $a3weY.default)(value);
        if (!isDeep) return (0, $4m08N.default)(value, result);
    } else {
        var tag = (0, $1Njgi.default)(value), isFunc = tag == $41dcb9acf65d8168$var$funcTag || tag == $41dcb9acf65d8168$var$genTag;
        if ((0, $4374k.default)(value)) return (0, $bEaiQ.default)(value, isDeep);
        if (tag == $41dcb9acf65d8168$var$objectTag || tag == $41dcb9acf65d8168$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $80kg7.default)(value);
            if (!isDeep) return isFlat ? (0, $1aega.default)(value, (0, $j5nkt.default)(result, value)) : (0, $1I88C.default)(value, (0, $3dF2c.default)(result, value));
        } else {
            if (!$41dcb9acf65d8168$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $44Ua8.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $5SFKX.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $3gkQ4.default)(value)) value.forEach(function(subValue) {
        result.add($41dcb9acf65d8168$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $dzKFi.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $41dcb9acf65d8168$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $ljVnC.default) : (0, $fgvBa.default) : isFlat ? (0, $iJbss.default) : (0, $kOOZf.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $dkPRS.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $10ADx.default)(result, key, $41dcb9acf65d8168$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $41dcb9acf65d8168$export$2e2bcd8739ae039 = $41dcb9acf65d8168$var$baseClone;

});
parcelRegister("5SFKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $448262d6bfd89507$export$2e2bcd8739ae039);

var $imu6S = parcelRequire("imu6S");

var $kSnTS = parcelRequire("kSnTS");

var $gIQ5S = parcelRequire("gIQ5S");

var $e80Lf = parcelRequire("e80Lf");

var $aYHag = parcelRequire("aYHag");

var $ddYmV = parcelRequire("ddYmV");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $448262d6bfd89507$var$Stack(entries) {
    var data = this.__data__ = new (0, $imu6S.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$448262d6bfd89507$var$Stack.prototype.clear = (0, $kSnTS.default);
$448262d6bfd89507$var$Stack.prototype["delete"] = (0, $gIQ5S.default);
$448262d6bfd89507$var$Stack.prototype.get = (0, $e80Lf.default);
$448262d6bfd89507$var$Stack.prototype.has = (0, $aYHag.default);
$448262d6bfd89507$var$Stack.prototype.set = (0, $ddYmV.default);
var $448262d6bfd89507$export$2e2bcd8739ae039 = $448262d6bfd89507$var$Stack;

});
parcelRegister("imu6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e1a340e721b21a$export$2e2bcd8739ae039);

var $bjx3K = parcelRequire("bjx3K");

var $1bkNJ = parcelRequire("1bkNJ");

var $jjc0s = parcelRequire("jjc0s");

var $hpB9R = parcelRequire("hpB9R");

var $42t91 = parcelRequire("42t91");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d5e1a340e721b21a$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d5e1a340e721b21a$var$ListCache.prototype.clear = (0, $bjx3K.default);
$d5e1a340e721b21a$var$ListCache.prototype["delete"] = (0, $1bkNJ.default);
$d5e1a340e721b21a$var$ListCache.prototype.get = (0, $jjc0s.default);
$d5e1a340e721b21a$var$ListCache.prototype.has = (0, $hpB9R.default);
$d5e1a340e721b21a$var$ListCache.prototype.set = (0, $42t91.default);
var $d5e1a340e721b21a$export$2e2bcd8739ae039 = $d5e1a340e721b21a$var$ListCache;

});
parcelRegister("bjx3K", function(module, exports) {

$parcel$export(module.exports, "default", () => $83cb1cfe0402f109$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83cb1cfe0402f109$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $83cb1cfe0402f109$export$2e2bcd8739ae039 = $83cb1cfe0402f109$var$listCacheClear;

});

parcelRegister("1bkNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc6f4381ea0271c$export$2e2bcd8739ae039);

var $cs7X2 = parcelRequire("cs7X2");
/** Used for built-in method references. */ var $0dc6f4381ea0271c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0dc6f4381ea0271c$var$splice = $0dc6f4381ea0271c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0dc6f4381ea0271c$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $cs7X2.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0dc6f4381ea0271c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $0dc6f4381ea0271c$export$2e2bcd8739ae039 = $0dc6f4381ea0271c$var$listCacheDelete;

});
parcelRegister("cs7X2", function(module, exports) {

$parcel$export(module.exports, "default", () => $910e44841ab1be26$export$2e2bcd8739ae039);

var $gkhdf = parcelRequire("gkhdf");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $910e44841ab1be26$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $gkhdf.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $910e44841ab1be26$export$2e2bcd8739ae039 = $910e44841ab1be26$var$assocIndexOf;

});
parcelRegister("gkhdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2bddb05626c7db$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $be2bddb05626c7db$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $be2bddb05626c7db$export$2e2bcd8739ae039 = $be2bddb05626c7db$var$eq;

});



parcelRegister("jjc0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e91ae3f382e2bf$export$2e2bcd8739ae039);

var $cs7X2 = parcelRequire("cs7X2");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e0e91ae3f382e2bf$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $cs7X2.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $e0e91ae3f382e2bf$export$2e2bcd8739ae039 = $e0e91ae3f382e2bf$var$listCacheGet;

});

parcelRegister("hpB9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad1984181f56f4a$export$2e2bcd8739ae039);

var $cs7X2 = parcelRequire("cs7X2");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cad1984181f56f4a$var$listCacheHas(key) {
    return (0, $cs7X2.default)(this.__data__, key) > -1;
}
var $cad1984181f56f4a$export$2e2bcd8739ae039 = $cad1984181f56f4a$var$listCacheHas;

});

parcelRegister("42t91", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0df4d856e9250a$export$2e2bcd8739ae039);

var $cs7X2 = parcelRequire("cs7X2");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $2f0df4d856e9250a$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $cs7X2.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $2f0df4d856e9250a$export$2e2bcd8739ae039 = $2f0df4d856e9250a$var$listCacheSet;

});


parcelRegister("kSnTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32b63df67fbe21a$export$2e2bcd8739ae039);

var $imu6S = parcelRequire("imu6S");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f32b63df67fbe21a$var$stackClear() {
    this.__data__ = new (0, $imu6S.default);
    this.size = 0;
}
var $f32b63df67fbe21a$export$2e2bcd8739ae039 = $f32b63df67fbe21a$var$stackClear;

});

parcelRegister("gIQ5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c92a2843d7dabd$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c2c92a2843d7dabd$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $c2c92a2843d7dabd$export$2e2bcd8739ae039 = $c2c92a2843d7dabd$var$stackDelete;

});

parcelRegister("e80Lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a492672e7d7e1d38$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a492672e7d7e1d38$var$stackGet(key) {
    return this.__data__.get(key);
}
var $a492672e7d7e1d38$export$2e2bcd8739ae039 = $a492672e7d7e1d38$var$stackGet;

});

parcelRegister("aYHag", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe0fd8fd4835be2$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7fe0fd8fd4835be2$var$stackHas(key) {
    return this.__data__.has(key);
}
var $7fe0fd8fd4835be2$export$2e2bcd8739ae039 = $7fe0fd8fd4835be2$var$stackHas;

});

parcelRegister("ddYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0b513c586b5df7$export$2e2bcd8739ae039);

var $imu6S = parcelRequire("imu6S");

var $36cjO = parcelRequire("36cjO");

var $a2sft = parcelRequire("a2sft");
/** Used as the size to enable large array optimizations. */ var $9a0b513c586b5df7$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9a0b513c586b5df7$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $imu6S.default)) {
        var pairs = data.__data__;
        if (!(0, $36cjO.default) || pairs.length < $9a0b513c586b5df7$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $a2sft.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $9a0b513c586b5df7$export$2e2bcd8739ae039 = $9a0b513c586b5df7$var$stackSet;

});
parcelRegister("36cjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $241b7cd27d8efba2$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");

var $cdLtB = parcelRequire("cdLtB");
/* Built-in method references that are verified to be native. */ var $241b7cd27d8efba2$var$Map = (0, $kTAGe.default)((0, $cdLtB.default), "Map");
var $241b7cd27d8efba2$export$2e2bcd8739ae039 = $241b7cd27d8efba2$var$Map;

});
parcelRegister("kTAGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f365659c834c9b32$export$2e2bcd8739ae039);

var $4AcVP = parcelRequire("4AcVP");

var $aP1cN = parcelRequire("aP1cN");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f365659c834c9b32$var$getNative(object, key) {
    var value = (0, $aP1cN.default)(object, key);
    return (0, $4AcVP.default)(value) ? value : undefined;
}
var $f365659c834c9b32$export$2e2bcd8739ae039 = $f365659c834c9b32$var$getNative;

});
parcelRegister("4AcVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $35648e320b96fc39$export$2e2bcd8739ae039);

var $ihXrZ = parcelRequire("ihXrZ");

var $fS5mT = parcelRequire("fS5mT");

var $aEm6h = parcelRequire("aEm6h");

var $1kW6w = parcelRequire("1kW6w");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $35648e320b96fc39$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $35648e320b96fc39$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $35648e320b96fc39$var$funcProto = Function.prototype, $35648e320b96fc39$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $35648e320b96fc39$var$funcToString = $35648e320b96fc39$var$funcProto.toString;
/** Used to check objects for own properties. */ var $35648e320b96fc39$var$hasOwnProperty = $35648e320b96fc39$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $35648e320b96fc39$var$reIsNative = RegExp("^" + $35648e320b96fc39$var$funcToString.call($35648e320b96fc39$var$hasOwnProperty).replace($35648e320b96fc39$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $35648e320b96fc39$var$baseIsNative(value) {
    if (!(0, $aEm6h.default)(value) || (0, $fS5mT.default)(value)) return false;
    var pattern = (0, $ihXrZ.default)(value) ? $35648e320b96fc39$var$reIsNative : $35648e320b96fc39$var$reIsHostCtor;
    return pattern.test((0, $1kW6w.default)(value));
}
var $35648e320b96fc39$export$2e2bcd8739ae039 = $35648e320b96fc39$var$baseIsNative;

});
parcelRegister("ihXrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d507ee2bdd0e5da2$export$2e2bcd8739ae039);

var $4Vy8R = parcelRequire("4Vy8R");

var $aEm6h = parcelRequire("aEm6h");
/** `Object#toString` result references. */ var $d507ee2bdd0e5da2$var$asyncTag = "[object AsyncFunction]", $d507ee2bdd0e5da2$var$funcTag = "[object Function]", $d507ee2bdd0e5da2$var$genTag = "[object GeneratorFunction]", $d507ee2bdd0e5da2$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d507ee2bdd0e5da2$var$isFunction(value) {
    if (!(0, $aEm6h.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $4Vy8R.default)(value);
    return tag == $d507ee2bdd0e5da2$var$funcTag || tag == $d507ee2bdd0e5da2$var$genTag || tag == $d507ee2bdd0e5da2$var$asyncTag || tag == $d507ee2bdd0e5da2$var$proxyTag;
}
var $d507ee2bdd0e5da2$export$2e2bcd8739ae039 = $d507ee2bdd0e5da2$var$isFunction;

});
parcelRegister("aEm6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c0ec875bd1c8bf3$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7c0ec875bd1c8bf3$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $7c0ec875bd1c8bf3$export$2e2bcd8739ae039 = $7c0ec875bd1c8bf3$var$isObject;

});


parcelRegister("fS5mT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8e0102f97bd20b6$export$2e2bcd8739ae039);

var $ejXFK = parcelRequire("ejXFK");
/** Used to detect methods masquerading as native. */ var $b8e0102f97bd20b6$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $ejXFK.default) && (0, $ejXFK.default).keys && (0, $ejXFK.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b8e0102f97bd20b6$var$isMasked(func) {
    return !!$b8e0102f97bd20b6$var$maskSrcKey && $b8e0102f97bd20b6$var$maskSrcKey in func;
}
var $b8e0102f97bd20b6$export$2e2bcd8739ae039 = $b8e0102f97bd20b6$var$isMasked;

});
parcelRegister("ejXFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d120b6fed9965e$export$2e2bcd8739ae039);

var $cdLtB = parcelRequire("cdLtB");
/** Used to detect overreaching core-js shims. */ var $a6d120b6fed9965e$var$coreJsData = (0, $cdLtB.default)["__core-js_shared__"];
var $a6d120b6fed9965e$export$2e2bcd8739ae039 = $a6d120b6fed9965e$var$coreJsData;

});


parcelRegister("1kW6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f94baf6823014c1$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $0f94baf6823014c1$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0f94baf6823014c1$var$funcToString = $0f94baf6823014c1$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0f94baf6823014c1$var$toSource(func) {
    if (func != null) {
        try {
            return $0f94baf6823014c1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $0f94baf6823014c1$export$2e2bcd8739ae039 = $0f94baf6823014c1$var$toSource;

});


parcelRegister("aP1cN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e0f9a275f182459$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7e0f9a275f182459$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $7e0f9a275f182459$export$2e2bcd8739ae039 = $7e0f9a275f182459$var$getValue;

});



parcelRegister("a2sft", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f000e18dbcf8c5$export$2e2bcd8739ae039);

var $1yq94 = parcelRequire("1yq94");

var $5ub1u = parcelRequire("5ub1u");

var $8IVOT = parcelRequire("8IVOT");

var $hel33 = parcelRequire("hel33");

var $9ombq = parcelRequire("9ombq");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $74f000e18dbcf8c5$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$74f000e18dbcf8c5$var$MapCache.prototype.clear = (0, $1yq94.default);
$74f000e18dbcf8c5$var$MapCache.prototype["delete"] = (0, $5ub1u.default);
$74f000e18dbcf8c5$var$MapCache.prototype.get = (0, $8IVOT.default);
$74f000e18dbcf8c5$var$MapCache.prototype.has = (0, $hel33.default);
$74f000e18dbcf8c5$var$MapCache.prototype.set = (0, $9ombq.default);
var $74f000e18dbcf8c5$export$2e2bcd8739ae039 = $74f000e18dbcf8c5$var$MapCache;

});
parcelRegister("1yq94", function(module, exports) {

$parcel$export(module.exports, "default", () => $121d3f5491dce20a$export$2e2bcd8739ae039);

var $dtVUR = parcelRequire("dtVUR");

var $imu6S = parcelRequire("imu6S");

var $36cjO = parcelRequire("36cjO");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $121d3f5491dce20a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $dtVUR.default),
        "map": new ((0, $36cjO.default) || (0, $imu6S.default)),
        "string": new (0, $dtVUR.default)
    };
}
var $121d3f5491dce20a$export$2e2bcd8739ae039 = $121d3f5491dce20a$var$mapCacheClear;

});
parcelRegister("dtVUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0ae8b6dd7a1755$export$2e2bcd8739ae039);

var $1mnmh = parcelRequire("1mnmh");

var $fcDpp = parcelRequire("fcDpp");

var $iEiW5 = parcelRequire("iEiW5");

var $glPyd = parcelRequire("glPyd");

var $2Iw8E = parcelRequire("2Iw8E");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9d0ae8b6dd7a1755$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9d0ae8b6dd7a1755$var$Hash.prototype.clear = (0, $1mnmh.default);
$9d0ae8b6dd7a1755$var$Hash.prototype["delete"] = (0, $fcDpp.default);
$9d0ae8b6dd7a1755$var$Hash.prototype.get = (0, $iEiW5.default);
$9d0ae8b6dd7a1755$var$Hash.prototype.has = (0, $glPyd.default);
$9d0ae8b6dd7a1755$var$Hash.prototype.set = (0, $2Iw8E.default);
var $9d0ae8b6dd7a1755$export$2e2bcd8739ae039 = $9d0ae8b6dd7a1755$var$Hash;

});
parcelRegister("1mnmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fd9f701ffbd876e$export$2e2bcd8739ae039);

var $az9nQ = parcelRequire("az9nQ");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $0fd9f701ffbd876e$var$hashClear() {
    this.__data__ = (0, $az9nQ.default) ? (0, $az9nQ.default)(null) : {};
    this.size = 0;
}
var $0fd9f701ffbd876e$export$2e2bcd8739ae039 = $0fd9f701ffbd876e$var$hashClear;

});
parcelRegister("az9nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b1473a72bb473b7$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");
/* Built-in method references that are verified to be native. */ var $7b1473a72bb473b7$var$nativeCreate = (0, $kTAGe.default)(Object, "create");
var $7b1473a72bb473b7$export$2e2bcd8739ae039 = $7b1473a72bb473b7$var$nativeCreate;

});


parcelRegister("fcDpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1168bc452dfb057$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b1168bc452dfb057$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $b1168bc452dfb057$export$2e2bcd8739ae039 = $b1168bc452dfb057$var$hashDelete;

});

parcelRegister("iEiW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93aa6b618bdec86$export$2e2bcd8739ae039);

var $az9nQ = parcelRequire("az9nQ");
/** Used to stand-in for `undefined` hash values. */ var $d93aa6b618bdec86$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $d93aa6b618bdec86$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d93aa6b618bdec86$var$hasOwnProperty = $d93aa6b618bdec86$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d93aa6b618bdec86$var$hashGet(key) {
    var data = this.__data__;
    if (0, $az9nQ.default) {
        var result = data[key];
        return result === $d93aa6b618bdec86$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d93aa6b618bdec86$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d93aa6b618bdec86$export$2e2bcd8739ae039 = $d93aa6b618bdec86$var$hashGet;

});

parcelRegister("glPyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be76986f1ebeaac6$export$2e2bcd8739ae039);

var $az9nQ = parcelRequire("az9nQ");
/** Used for built-in method references. */ var $be76986f1ebeaac6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $be76986f1ebeaac6$var$hasOwnProperty = $be76986f1ebeaac6$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $be76986f1ebeaac6$var$hashHas(key) {
    var data = this.__data__;
    return (0, $az9nQ.default) ? data[key] !== undefined : $be76986f1ebeaac6$var$hasOwnProperty.call(data, key);
}
var $be76986f1ebeaac6$export$2e2bcd8739ae039 = $be76986f1ebeaac6$var$hashHas;

});

parcelRegister("2Iw8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fa89ede4819883c$export$2e2bcd8739ae039);

var $az9nQ = parcelRequire("az9nQ");
/** Used to stand-in for `undefined` hash values. */ var $1fa89ede4819883c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $1fa89ede4819883c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $az9nQ.default) && value === undefined ? $1fa89ede4819883c$var$HASH_UNDEFINED : value;
    return this;
}
var $1fa89ede4819883c$export$2e2bcd8739ae039 = $1fa89ede4819883c$var$hashSet;

});



parcelRegister("5ub1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe84e0e15da8d5d$export$2e2bcd8739ae039);

var $6p74U = parcelRequire("6p74U");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3fe84e0e15da8d5d$var$mapCacheDelete(key) {
    var result = (0, $6p74U.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3fe84e0e15da8d5d$export$2e2bcd8739ae039 = $3fe84e0e15da8d5d$var$mapCacheDelete;

});
parcelRegister("6p74U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9a917a44340f01$export$2e2bcd8739ae039);

var $dWEI3 = parcelRequire("dWEI3");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4a9a917a44340f01$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $dWEI3.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $4a9a917a44340f01$export$2e2bcd8739ae039 = $4a9a917a44340f01$var$getMapData;

});
parcelRegister("dWEI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27045317a0805cb$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $a27045317a0805cb$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $a27045317a0805cb$export$2e2bcd8739ae039 = $a27045317a0805cb$var$isKeyable;

});



parcelRegister("8IVOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $659f489eee3dedf1$export$2e2bcd8739ae039);

var $6p74U = parcelRequire("6p74U");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $659f489eee3dedf1$var$mapCacheGet(key) {
    return (0, $6p74U.default)(this, key).get(key);
}
var $659f489eee3dedf1$export$2e2bcd8739ae039 = $659f489eee3dedf1$var$mapCacheGet;

});

parcelRegister("hel33", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b4123acd23f636$export$2e2bcd8739ae039);

var $6p74U = parcelRequire("6p74U");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c8b4123acd23f636$var$mapCacheHas(key) {
    return (0, $6p74U.default)(this, key).has(key);
}
var $c8b4123acd23f636$export$2e2bcd8739ae039 = $c8b4123acd23f636$var$mapCacheHas;

});

parcelRegister("9ombq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6790183d732598$export$2e2bcd8739ae039);

var $6p74U = parcelRequire("6p74U");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $6d6790183d732598$var$mapCacheSet(key, value) {
    var data = (0, $6p74U.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $6d6790183d732598$export$2e2bcd8739ae039 = $6d6790183d732598$var$mapCacheSet;

});




parcelRegister("dkPRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b556084c610fad0$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $9b556084c610fad0$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $9b556084c610fad0$export$2e2bcd8739ae039 = $9b556084c610fad0$var$arrayEach;

});

parcelRegister("10ADx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc235d6f34b52d3$export$2e2bcd8739ae039);

var $65Qwo = parcelRequire("65Qwo");

var $gkhdf = parcelRequire("gkhdf");
/** Used for built-in method references. */ var $0bc235d6f34b52d3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0bc235d6f34b52d3$var$hasOwnProperty = $0bc235d6f34b52d3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0bc235d6f34b52d3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($0bc235d6f34b52d3$var$hasOwnProperty.call(object, key) && (0, $gkhdf.default)(objValue, value)) || value === undefined && !(key in object)) (0, $65Qwo.default)(object, key, value);
}
var $0bc235d6f34b52d3$export$2e2bcd8739ae039 = $0bc235d6f34b52d3$var$assignValue;

});
parcelRegister("65Qwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $46fbf364d7648b86$export$2e2bcd8739ae039);

var $i8SCE = parcelRequire("i8SCE");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $46fbf364d7648b86$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $i8SCE.default)) (0, $i8SCE.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $46fbf364d7648b86$export$2e2bcd8739ae039 = $46fbf364d7648b86$var$baseAssignValue;

});
parcelRegister("i8SCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d353583df3fb91d6$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");
var $d353583df3fb91d6$var$defineProperty = function() {
    try {
        var func = (0, $kTAGe.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $d353583df3fb91d6$export$2e2bcd8739ae039 = $d353583df3fb91d6$var$defineProperty;

});



parcelRegister("3dF2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $25826a98c024ddd3$export$2e2bcd8739ae039);

var $iJ86t = parcelRequire("iJ86t");

var $kOOZf = parcelRequire("kOOZf");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25826a98c024ddd3$var$baseAssign(object, source) {
    return object && (0, $iJ86t.default)(source, (0, $kOOZf.default)(source), object);
}
var $25826a98c024ddd3$export$2e2bcd8739ae039 = $25826a98c024ddd3$var$baseAssign;

});
parcelRegister("iJ86t", function(module, exports) {

$parcel$export(module.exports, "default", () => $da22b727ef29a4d6$export$2e2bcd8739ae039);

var $10ADx = parcelRequire("10ADx");

var $65Qwo = parcelRequire("65Qwo");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $da22b727ef29a4d6$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $65Qwo.default)(object, key, newValue);
        else (0, $10ADx.default)(object, key, newValue);
    }
    return object;
}
var $da22b727ef29a4d6$export$2e2bcd8739ae039 = $da22b727ef29a4d6$var$copyObject;

});

parcelRegister("kOOZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2800718bf8acdd0$export$2e2bcd8739ae039);

var $l2Zfk = parcelRequire("l2Zfk");

var $i2qa4 = parcelRequire("i2qa4");

var $70f1W = parcelRequire("70f1W");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $f2800718bf8acdd0$var$keys(object) {
    return (0, $70f1W.default)(object) ? (0, $l2Zfk.default)(object) : (0, $i2qa4.default)(object);
}
var $f2800718bf8acdd0$export$2e2bcd8739ae039 = $f2800718bf8acdd0$var$keys;

});
parcelRegister("l2Zfk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5294b1ce0bee18c$export$2e2bcd8739ae039);

var $iAybg = parcelRequire("iAybg");

var $6u3Ao = parcelRequire("6u3Ao");

var $ipNyZ = parcelRequire("ipNyZ");

var $4374k = parcelRequire("4374k");

var $bmtfv = parcelRequire("bmtfv");

var $iz7iW = parcelRequire("iz7iW");
/** Used for built-in method references. */ var $f5294b1ce0bee18c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f5294b1ce0bee18c$var$hasOwnProperty = $f5294b1ce0bee18c$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $f5294b1ce0bee18c$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $ipNyZ.default)(value), isArg = !isArr && (0, $6u3Ao.default)(value), isBuff = !isArr && !isArg && (0, $4374k.default)(value), isType = !isArr && !isArg && !isBuff && (0, $iz7iW.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $iAybg.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $f5294b1ce0bee18c$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $bmtfv.default)(key, length)))) result.push(key);
    return result;
}
var $f5294b1ce0bee18c$export$2e2bcd8739ae039 = $f5294b1ce0bee18c$var$arrayLikeKeys;

});
parcelRegister("iAybg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8861a586ac828e1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d8861a586ac828e1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $d8861a586ac828e1$export$2e2bcd8739ae039 = $d8861a586ac828e1$var$baseTimes;

});

parcelRegister("6u3Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8853866055f158$export$2e2bcd8739ae039);

var $jN0N1 = parcelRequire("jN0N1");

var $3iyEO = parcelRequire("3iyEO");
/** Used for built-in method references. */ var $4b8853866055f158$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4b8853866055f158$var$hasOwnProperty = $4b8853866055f158$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4b8853866055f158$var$propertyIsEnumerable = $4b8853866055f158$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4b8853866055f158$var$isArguments = (0, $jN0N1.default)(function() {
    return arguments;
}()) ? (0, $jN0N1.default) : function(value) {
    return (0, $3iyEO.default)(value) && $4b8853866055f158$var$hasOwnProperty.call(value, "callee") && !$4b8853866055f158$var$propertyIsEnumerable.call(value, "callee");
};
var $4b8853866055f158$export$2e2bcd8739ae039 = $4b8853866055f158$var$isArguments;

});
parcelRegister("jN0N1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68334c20cb1ea08$export$2e2bcd8739ae039);

var $4Vy8R = parcelRequire("4Vy8R");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $e68334c20cb1ea08$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e68334c20cb1ea08$var$baseIsArguments(value) {
    return (0, $3iyEO.default)(value) && (0, $4Vy8R.default)(value) == $e68334c20cb1ea08$var$argsTag;
}
var $e68334c20cb1ea08$export$2e2bcd8739ae039 = $e68334c20cb1ea08$var$baseIsArguments;

});


parcelRegister("ipNyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d681020e40800f22$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d681020e40800f22$var$isArray = Array.isArray;
var $d681020e40800f22$export$2e2bcd8739ae039 = $d681020e40800f22$var$isArray;

});

parcelRegister("4374k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f2cecfab45b04e3$export$2e2bcd8739ae039);

var $cdLtB = parcelRequire("cdLtB");

var $1Tp1B = parcelRequire("1Tp1B");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cdLtB.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $1Tp1B.default);
var $2f2cecfab45b04e3$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("1Tp1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $160e56e54f12f9e2$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $160e56e54f12f9e2$var$stubFalse() {
    return false;
}
var $160e56e54f12f9e2$export$2e2bcd8739ae039 = $160e56e54f12f9e2$var$stubFalse;

});


parcelRegister("bmtfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8458700d5b7d3399$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $8458700d5b7d3399$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $8458700d5b7d3399$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8458700d5b7d3399$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $8458700d5b7d3399$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $8458700d5b7d3399$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $8458700d5b7d3399$export$2e2bcd8739ae039 = $8458700d5b7d3399$var$isIndex;

});

parcelRegister("iz7iW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d841296b7fd1f374$export$2e2bcd8739ae039);

var $dDMmJ = parcelRequire("dDMmJ");

var $3eP2X = parcelRequire("3eP2X");

var $aXD9Z = parcelRequire("aXD9Z");
/* Node.js helper references. */ var $d841296b7fd1f374$var$nodeIsTypedArray = (0, $aXD9Z.default) && (0, $aXD9Z.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $d841296b7fd1f374$var$isTypedArray = $d841296b7fd1f374$var$nodeIsTypedArray ? (0, $3eP2X.default)($d841296b7fd1f374$var$nodeIsTypedArray) : (0, $dDMmJ.default);
var $d841296b7fd1f374$export$2e2bcd8739ae039 = $d841296b7fd1f374$var$isTypedArray;

});
parcelRegister("dDMmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ee46f43a33cdbd1$export$2e2bcd8739ae039);

var $4Vy8R = parcelRequire("4Vy8R");

var $SlQAp = parcelRequire("SlQAp");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $9ee46f43a33cdbd1$var$argsTag = "[object Arguments]", $9ee46f43a33cdbd1$var$arrayTag = "[object Array]", $9ee46f43a33cdbd1$var$boolTag = "[object Boolean]", $9ee46f43a33cdbd1$var$dateTag = "[object Date]", $9ee46f43a33cdbd1$var$errorTag = "[object Error]", $9ee46f43a33cdbd1$var$funcTag = "[object Function]", $9ee46f43a33cdbd1$var$mapTag = "[object Map]", $9ee46f43a33cdbd1$var$numberTag = "[object Number]", $9ee46f43a33cdbd1$var$objectTag = "[object Object]", $9ee46f43a33cdbd1$var$regexpTag = "[object RegExp]", $9ee46f43a33cdbd1$var$setTag = "[object Set]", $9ee46f43a33cdbd1$var$stringTag = "[object String]", $9ee46f43a33cdbd1$var$weakMapTag = "[object WeakMap]";
var $9ee46f43a33cdbd1$var$arrayBufferTag = "[object ArrayBuffer]", $9ee46f43a33cdbd1$var$dataViewTag = "[object DataView]", $9ee46f43a33cdbd1$var$float32Tag = "[object Float32Array]", $9ee46f43a33cdbd1$var$float64Tag = "[object Float64Array]", $9ee46f43a33cdbd1$var$int8Tag = "[object Int8Array]", $9ee46f43a33cdbd1$var$int16Tag = "[object Int16Array]", $9ee46f43a33cdbd1$var$int32Tag = "[object Int32Array]", $9ee46f43a33cdbd1$var$uint8Tag = "[object Uint8Array]", $9ee46f43a33cdbd1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9ee46f43a33cdbd1$var$uint16Tag = "[object Uint16Array]", $9ee46f43a33cdbd1$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9ee46f43a33cdbd1$var$typedArrayTags = {};
$9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$float32Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$float64Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$int8Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$int16Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$int32Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$uint8Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$uint8ClampedTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$uint16Tag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$uint32Tag] = true;
$9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$argsTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$arrayTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$arrayBufferTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$boolTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$dataViewTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$dateTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$errorTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$funcTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$mapTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$numberTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$objectTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$regexpTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$setTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$stringTag] = $9ee46f43a33cdbd1$var$typedArrayTags[$9ee46f43a33cdbd1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9ee46f43a33cdbd1$var$baseIsTypedArray(value) {
    return (0, $3iyEO.default)(value) && (0, $SlQAp.default)(value.length) && !!$9ee46f43a33cdbd1$var$typedArrayTags[(0, $4Vy8R.default)(value)];
}
var $9ee46f43a33cdbd1$export$2e2bcd8739ae039 = $9ee46f43a33cdbd1$var$baseIsTypedArray;

});
parcelRegister("SlQAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a35fda714977799$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $0a35fda714977799$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0a35fda714977799$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $0a35fda714977799$var$MAX_SAFE_INTEGER;
}
var $0a35fda714977799$export$2e2bcd8739ae039 = $0a35fda714977799$var$isLength;

});


parcelRegister("3eP2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $25ba46b584c996ff$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $25ba46b584c996ff$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $25ba46b584c996ff$export$2e2bcd8739ae039 = $25ba46b584c996ff$var$baseUnary;

});

parcelRegister("aXD9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fadca71ad32360e$export$2e2bcd8739ae039);

var $gflQN = parcelRequire("gflQN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $gflQN.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $7fadca71ad32360e$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("i2qa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21cb504632ca2ca$export$2e2bcd8739ae039);

var $40fJb = parcelRequire("40fJb");

var $9Tfm9 = parcelRequire("9Tfm9");
/** Used for built-in method references. */ var $d21cb504632ca2ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d21cb504632ca2ca$var$hasOwnProperty = $d21cb504632ca2ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d21cb504632ca2ca$var$baseKeys(object) {
    if (!(0, $40fJb.default)(object)) return (0, $9Tfm9.default)(object);
    var result = [];
    for(var key in Object(object))if ($d21cb504632ca2ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $d21cb504632ca2ca$export$2e2bcd8739ae039 = $d21cb504632ca2ca$var$baseKeys;

});
parcelRegister("40fJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea35cb6cb134355$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $2ea35cb6cb134355$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $2ea35cb6cb134355$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $2ea35cb6cb134355$var$objectProto;
    return value === proto;
}
var $2ea35cb6cb134355$export$2e2bcd8739ae039 = $2ea35cb6cb134355$var$isPrototype;

});

parcelRegister("9Tfm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $73352988b7dfdc62$export$2e2bcd8739ae039);

var $9VSEB = parcelRequire("9VSEB");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $73352988b7dfdc62$var$nativeKeys = (0, $9VSEB.default)(Object.keys, Object);
var $73352988b7dfdc62$export$2e2bcd8739ae039 = $73352988b7dfdc62$var$nativeKeys;

});


parcelRegister("70f1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $5194313244e14686$export$2e2bcd8739ae039);

var $ihXrZ = parcelRequire("ihXrZ");

var $SlQAp = parcelRequire("SlQAp");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5194313244e14686$var$isArrayLike(value) {
    return value != null && (0, $SlQAp.default)(value.length) && !(0, $ihXrZ.default)(value);
}
var $5194313244e14686$export$2e2bcd8739ae039 = $5194313244e14686$var$isArrayLike;

});



parcelRegister("j5nkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5094a746ede600$export$2e2bcd8739ae039);

var $iJ86t = parcelRequire("iJ86t");

var $iJbss = parcelRequire("iJbss");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $de5094a746ede600$var$baseAssignIn(object, source) {
    return object && (0, $iJ86t.default)(source, (0, $iJbss.default)(source), object);
}
var $de5094a746ede600$export$2e2bcd8739ae039 = $de5094a746ede600$var$baseAssignIn;

});
parcelRegister("iJbss", function(module, exports) {

$parcel$export(module.exports, "default", () => $da25514a6c009692$export$2e2bcd8739ae039);

var $l2Zfk = parcelRequire("l2Zfk");

var $kqQFb = parcelRequire("kqQFb");

var $70f1W = parcelRequire("70f1W");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $da25514a6c009692$var$keysIn(object) {
    return (0, $70f1W.default)(object) ? (0, $l2Zfk.default)(object, true) : (0, $kqQFb.default)(object);
}
var $da25514a6c009692$export$2e2bcd8739ae039 = $da25514a6c009692$var$keysIn;

});
parcelRegister("kqQFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $edff1630f0d7067a$export$2e2bcd8739ae039);

var $aEm6h = parcelRequire("aEm6h");

var $40fJb = parcelRequire("40fJb");

var $iLTDZ = parcelRequire("iLTDZ");
/** Used for built-in method references. */ var $edff1630f0d7067a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $edff1630f0d7067a$var$hasOwnProperty = $edff1630f0d7067a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $edff1630f0d7067a$var$baseKeysIn(object) {
    if (!(0, $aEm6h.default)(object)) return (0, $iLTDZ.default)(object);
    var isProto = (0, $40fJb.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$edff1630f0d7067a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $edff1630f0d7067a$export$2e2bcd8739ae039 = $edff1630f0d7067a$var$baseKeysIn;

});
parcelRegister("iLTDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $daa7c78070b0e2ff$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $daa7c78070b0e2ff$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $daa7c78070b0e2ff$export$2e2bcd8739ae039 = $daa7c78070b0e2ff$var$nativeKeysIn;

});




parcelRegister("bEaiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ab6c1193d6144c$export$2e2bcd8739ae039);

var $cdLtB = parcelRequire("cdLtB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cdLtB.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $87ab6c1193d6144c$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("4m08N", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b9537de3c464b2$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $32b9537de3c464b2$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $32b9537de3c464b2$export$2e2bcd8739ae039 = $32b9537de3c464b2$var$copyArray;

});

parcelRegister("1I88C", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f0368adc3b133e$export$2e2bcd8739ae039);

var $iJ86t = parcelRequire("iJ86t");

var $9iQfz = parcelRequire("9iQfz");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $13f0368adc3b133e$var$copySymbols(source, object) {
    return (0, $iJ86t.default)(source, (0, $9iQfz.default)(source), object);
}
var $13f0368adc3b133e$export$2e2bcd8739ae039 = $13f0368adc3b133e$var$copySymbols;

});
parcelRegister("9iQfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c5e534ba21ed102$export$2e2bcd8739ae039);

var $3LZMo = parcelRequire("3LZMo");

var $aVlR4 = parcelRequire("aVlR4");
/** Used for built-in method references. */ var $6c5e534ba21ed102$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6c5e534ba21ed102$var$propertyIsEnumerable = $6c5e534ba21ed102$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6c5e534ba21ed102$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6c5e534ba21ed102$var$getSymbols = !$6c5e534ba21ed102$var$nativeGetSymbols ? (0, $aVlR4.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $3LZMo.default)($6c5e534ba21ed102$var$nativeGetSymbols(object), function(symbol) {
        return $6c5e534ba21ed102$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $6c5e534ba21ed102$export$2e2bcd8739ae039 = $6c5e534ba21ed102$var$getSymbols;

});
parcelRegister("3LZMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf5af032e7db189$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2bf5af032e7db189$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $2bf5af032e7db189$export$2e2bcd8739ae039 = $2bf5af032e7db189$var$arrayFilter;

});

parcelRegister("aVlR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f402e2d8f92db38$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $7f402e2d8f92db38$var$stubArray() {
    return [];
}
var $7f402e2d8f92db38$export$2e2bcd8739ae039 = $7f402e2d8f92db38$var$stubArray;

});



parcelRegister("1aega", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d91c94ee00e2137$export$2e2bcd8739ae039);

var $iJ86t = parcelRequire("iJ86t");

var $aEXAP = parcelRequire("aEXAP");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0d91c94ee00e2137$var$copySymbolsIn(source, object) {
    return (0, $iJ86t.default)(source, (0, $aEXAP.default)(source), object);
}
var $0d91c94ee00e2137$export$2e2bcd8739ae039 = $0d91c94ee00e2137$var$copySymbolsIn;

});
parcelRegister("aEXAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2bddbf9d4c221f$export$2e2bcd8739ae039);

var $lSEcM = parcelRequire("lSEcM");

var $jSGRV = parcelRequire("jSGRV");

var $9iQfz = parcelRequire("9iQfz");

var $aVlR4 = parcelRequire("aVlR4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7c2bddbf9d4c221f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7c2bddbf9d4c221f$var$getSymbolsIn = !$7c2bddbf9d4c221f$var$nativeGetSymbols ? (0, $aVlR4.default) : function(object) {
    var result = [];
    while(object){
        (0, $lSEcM.default)(result, (0, $9iQfz.default)(object));
        object = (0, $jSGRV.default)(object);
    }
    return result;
};
var $7c2bddbf9d4c221f$export$2e2bcd8739ae039 = $7c2bddbf9d4c221f$var$getSymbolsIn;

});
parcelRegister("lSEcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $feddd40695d3b381$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $feddd40695d3b381$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $feddd40695d3b381$export$2e2bcd8739ae039 = $feddd40695d3b381$var$arrayPush;

});



parcelRegister("fgvBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d0dc715e09e294$export$2e2bcd8739ae039);

var $dhfpg = parcelRequire("dhfpg");

var $9iQfz = parcelRequire("9iQfz");

var $kOOZf = parcelRequire("kOOZf");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b1d0dc715e09e294$var$getAllKeys(object) {
    return (0, $dhfpg.default)(object, (0, $kOOZf.default), (0, $9iQfz.default));
}
var $b1d0dc715e09e294$export$2e2bcd8739ae039 = $b1d0dc715e09e294$var$getAllKeys;

});
parcelRegister("dhfpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa8d04b23aba544$export$2e2bcd8739ae039);

var $lSEcM = parcelRequire("lSEcM");

var $ipNyZ = parcelRequire("ipNyZ");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9aa8d04b23aba544$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $ipNyZ.default)(object) ? result : (0, $lSEcM.default)(result, symbolsFunc(object));
}
var $9aa8d04b23aba544$export$2e2bcd8739ae039 = $9aa8d04b23aba544$var$baseGetAllKeys;

});


parcelRegister("ljVnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f857e1ca80f1f1eb$export$2e2bcd8739ae039);

var $dhfpg = parcelRequire("dhfpg");

var $aEXAP = parcelRequire("aEXAP");

var $iJbss = parcelRequire("iJbss");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f857e1ca80f1f1eb$var$getAllKeysIn(object) {
    return (0, $dhfpg.default)(object, (0, $iJbss.default), (0, $aEXAP.default));
}
var $f857e1ca80f1f1eb$export$2e2bcd8739ae039 = $f857e1ca80f1f1eb$var$getAllKeysIn;

});

parcelRegister("1Njgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e94f08f34be6a5$export$2e2bcd8739ae039);

var $hT5Jd = parcelRequire("hT5Jd");

var $36cjO = parcelRequire("36cjO");

var $bVQfJ = parcelRequire("bVQfJ");

var $cdYOe = parcelRequire("cdYOe");

var $5lckP = parcelRequire("5lckP");

var $4Vy8R = parcelRequire("4Vy8R");

var $1kW6w = parcelRequire("1kW6w");
/** `Object#toString` result references. */ var $14e94f08f34be6a5$var$mapTag = "[object Map]", $14e94f08f34be6a5$var$objectTag = "[object Object]", $14e94f08f34be6a5$var$promiseTag = "[object Promise]", $14e94f08f34be6a5$var$setTag = "[object Set]", $14e94f08f34be6a5$var$weakMapTag = "[object WeakMap]";
var $14e94f08f34be6a5$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $14e94f08f34be6a5$var$dataViewCtorString = (0, $1kW6w.default)((0, $hT5Jd.default)), $14e94f08f34be6a5$var$mapCtorString = (0, $1kW6w.default)((0, $36cjO.default)), $14e94f08f34be6a5$var$promiseCtorString = (0, $1kW6w.default)((0, $bVQfJ.default)), $14e94f08f34be6a5$var$setCtorString = (0, $1kW6w.default)((0, $cdYOe.default)), $14e94f08f34be6a5$var$weakMapCtorString = (0, $1kW6w.default)((0, $5lckP.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $14e94f08f34be6a5$var$getTag = (0, $4Vy8R.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $hT5Jd.default) && $14e94f08f34be6a5$var$getTag(new (0, $hT5Jd.default)(new ArrayBuffer(1))) != $14e94f08f34be6a5$var$dataViewTag || (0, $36cjO.default) && $14e94f08f34be6a5$var$getTag(new (0, $36cjO.default)) != $14e94f08f34be6a5$var$mapTag || (0, $bVQfJ.default) && $14e94f08f34be6a5$var$getTag((0, $bVQfJ.default).resolve()) != $14e94f08f34be6a5$var$promiseTag || (0, $cdYOe.default) && $14e94f08f34be6a5$var$getTag(new (0, $cdYOe.default)) != $14e94f08f34be6a5$var$setTag || (0, $5lckP.default) && $14e94f08f34be6a5$var$getTag(new (0, $5lckP.default)) != $14e94f08f34be6a5$var$weakMapTag) $14e94f08f34be6a5$var$getTag = function(value) {
    var result = (0, $4Vy8R.default)(value), Ctor = result == $14e94f08f34be6a5$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $1kW6w.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $14e94f08f34be6a5$var$dataViewCtorString:
            return $14e94f08f34be6a5$var$dataViewTag;
        case $14e94f08f34be6a5$var$mapCtorString:
            return $14e94f08f34be6a5$var$mapTag;
        case $14e94f08f34be6a5$var$promiseCtorString:
            return $14e94f08f34be6a5$var$promiseTag;
        case $14e94f08f34be6a5$var$setCtorString:
            return $14e94f08f34be6a5$var$setTag;
        case $14e94f08f34be6a5$var$weakMapCtorString:
            return $14e94f08f34be6a5$var$weakMapTag;
    }
    return result;
};
var $14e94f08f34be6a5$export$2e2bcd8739ae039 = $14e94f08f34be6a5$var$getTag;

});
parcelRegister("hT5Jd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05c043ea2faf909$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");

var $cdLtB = parcelRequire("cdLtB");
/* Built-in method references that are verified to be native. */ var $d05c043ea2faf909$var$DataView = (0, $kTAGe.default)((0, $cdLtB.default), "DataView");
var $d05c043ea2faf909$export$2e2bcd8739ae039 = $d05c043ea2faf909$var$DataView;

});

parcelRegister("bVQfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8afd8cdd1997184a$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");

var $cdLtB = parcelRequire("cdLtB");
/* Built-in method references that are verified to be native. */ var $8afd8cdd1997184a$var$Promise = (0, $kTAGe.default)((0, $cdLtB.default), "Promise");
var $8afd8cdd1997184a$export$2e2bcd8739ae039 = $8afd8cdd1997184a$var$Promise;

});

parcelRegister("cdYOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e65de644b5c3d4c$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");

var $cdLtB = parcelRequire("cdLtB");
/* Built-in method references that are verified to be native. */ var $8e65de644b5c3d4c$var$Set = (0, $kTAGe.default)((0, $cdLtB.default), "Set");
var $8e65de644b5c3d4c$export$2e2bcd8739ae039 = $8e65de644b5c3d4c$var$Set;

});

parcelRegister("5lckP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e387b5e8999f760$export$2e2bcd8739ae039);

var $kTAGe = parcelRequire("kTAGe");

var $cdLtB = parcelRequire("cdLtB");
/* Built-in method references that are verified to be native. */ var $3e387b5e8999f760$var$WeakMap = (0, $kTAGe.default)((0, $cdLtB.default), "WeakMap");
var $3e387b5e8999f760$export$2e2bcd8739ae039 = $3e387b5e8999f760$var$WeakMap;

});


parcelRegister("a3weY", function(module, exports) {

$parcel$export(module.exports, "default", () => $752331814c9080ad$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $752331814c9080ad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $752331814c9080ad$var$hasOwnProperty = $752331814c9080ad$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $752331814c9080ad$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $752331814c9080ad$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $752331814c9080ad$export$2e2bcd8739ae039 = $752331814c9080ad$var$initCloneArray;

});

parcelRegister("44Ua8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8319ddd43456ba$export$2e2bcd8739ae039);

var $7BVEX = parcelRequire("7BVEX");

var $8PM82 = parcelRequire("8PM82");

var $iSatk = parcelRequire("iSatk");

var $cyx6L = parcelRequire("cyx6L");

var $gyWfN = parcelRequire("gyWfN");
/** `Object#toString` result references. */ var $2f8319ddd43456ba$var$boolTag = "[object Boolean]", $2f8319ddd43456ba$var$dateTag = "[object Date]", $2f8319ddd43456ba$var$mapTag = "[object Map]", $2f8319ddd43456ba$var$numberTag = "[object Number]", $2f8319ddd43456ba$var$regexpTag = "[object RegExp]", $2f8319ddd43456ba$var$setTag = "[object Set]", $2f8319ddd43456ba$var$stringTag = "[object String]", $2f8319ddd43456ba$var$symbolTag = "[object Symbol]";
var $2f8319ddd43456ba$var$arrayBufferTag = "[object ArrayBuffer]", $2f8319ddd43456ba$var$dataViewTag = "[object DataView]", $2f8319ddd43456ba$var$float32Tag = "[object Float32Array]", $2f8319ddd43456ba$var$float64Tag = "[object Float64Array]", $2f8319ddd43456ba$var$int8Tag = "[object Int8Array]", $2f8319ddd43456ba$var$int16Tag = "[object Int16Array]", $2f8319ddd43456ba$var$int32Tag = "[object Int32Array]", $2f8319ddd43456ba$var$uint8Tag = "[object Uint8Array]", $2f8319ddd43456ba$var$uint8ClampedTag = "[object Uint8ClampedArray]", $2f8319ddd43456ba$var$uint16Tag = "[object Uint16Array]", $2f8319ddd43456ba$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $2f8319ddd43456ba$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $2f8319ddd43456ba$var$arrayBufferTag:
            return (0, $7BVEX.default)(object);
        case $2f8319ddd43456ba$var$boolTag:
        case $2f8319ddd43456ba$var$dateTag:
            return new Ctor(+object);
        case $2f8319ddd43456ba$var$dataViewTag:
            return (0, $8PM82.default)(object, isDeep);
        case $2f8319ddd43456ba$var$float32Tag:
        case $2f8319ddd43456ba$var$float64Tag:
        case $2f8319ddd43456ba$var$int8Tag:
        case $2f8319ddd43456ba$var$int16Tag:
        case $2f8319ddd43456ba$var$int32Tag:
        case $2f8319ddd43456ba$var$uint8Tag:
        case $2f8319ddd43456ba$var$uint8ClampedTag:
        case $2f8319ddd43456ba$var$uint16Tag:
        case $2f8319ddd43456ba$var$uint32Tag:
            return (0, $gyWfN.default)(object, isDeep);
        case $2f8319ddd43456ba$var$mapTag:
            return new Ctor;
        case $2f8319ddd43456ba$var$numberTag:
        case $2f8319ddd43456ba$var$stringTag:
            return new Ctor(object);
        case $2f8319ddd43456ba$var$regexpTag:
            return (0, $iSatk.default)(object);
        case $2f8319ddd43456ba$var$setTag:
            return new Ctor;
        case $2f8319ddd43456ba$var$symbolTag:
            return (0, $cyx6L.default)(object);
    }
}
var $2f8319ddd43456ba$export$2e2bcd8739ae039 = $2f8319ddd43456ba$var$initCloneByTag;

});
parcelRegister("7BVEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a8b71da4387e91$export$2e2bcd8739ae039);

var $87D7U = parcelRequire("87D7U");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $58a8b71da4387e91$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $87D7U.default)(result).set(new (0, $87D7U.default)(arrayBuffer));
    return result;
}
var $58a8b71da4387e91$export$2e2bcd8739ae039 = $58a8b71da4387e91$var$cloneArrayBuffer;

});
parcelRegister("87D7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e9d53e86a052a08$export$2e2bcd8739ae039);

var $cdLtB = parcelRequire("cdLtB");
/** Built-in value references. */ var $5e9d53e86a052a08$var$Uint8Array = (0, $cdLtB.default).Uint8Array;
var $5e9d53e86a052a08$export$2e2bcd8739ae039 = $5e9d53e86a052a08$var$Uint8Array;

});


parcelRegister("8PM82", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e86b7fb43012db$export$2e2bcd8739ae039);

var $7BVEX = parcelRequire("7BVEX");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $66e86b7fb43012db$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $7BVEX.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $66e86b7fb43012db$export$2e2bcd8739ae039 = $66e86b7fb43012db$var$cloneDataView;

});

parcelRegister("iSatk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd564aed5bec7cf$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $dbd564aed5bec7cf$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $dbd564aed5bec7cf$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $dbd564aed5bec7cf$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $dbd564aed5bec7cf$export$2e2bcd8739ae039 = $dbd564aed5bec7cf$var$cloneRegExp;

});

parcelRegister("cyx6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9242579b8765432a$export$2e2bcd8739ae039);

var $7BbnC = parcelRequire("7BbnC");
/** Used to convert symbols to primitives and strings. */ var $9242579b8765432a$var$symbolProto = (0, $7BbnC.default) ? (0, $7BbnC.default).prototype : undefined, $9242579b8765432a$var$symbolValueOf = $9242579b8765432a$var$symbolProto ? $9242579b8765432a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9242579b8765432a$var$cloneSymbol(symbol) {
    return $9242579b8765432a$var$symbolValueOf ? Object($9242579b8765432a$var$symbolValueOf.call(symbol)) : {};
}
var $9242579b8765432a$export$2e2bcd8739ae039 = $9242579b8765432a$var$cloneSymbol;

});

parcelRegister("gyWfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ed0252ff886577$export$2e2bcd8739ae039);

var $7BVEX = parcelRequire("7BVEX");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c0ed0252ff886577$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $7BVEX.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $c0ed0252ff886577$export$2e2bcd8739ae039 = $c0ed0252ff886577$var$cloneTypedArray;

});


parcelRegister("80kg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d3e09ce400bc48e$export$2e2bcd8739ae039);

var $gC9qu = parcelRequire("gC9qu");

var $jSGRV = parcelRequire("jSGRV");

var $40fJb = parcelRequire("40fJb");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $5d3e09ce400bc48e$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $40fJb.default)(object) ? (0, $gC9qu.default)((0, $jSGRV.default)(object)) : {};
}
var $5d3e09ce400bc48e$export$2e2bcd8739ae039 = $5d3e09ce400bc48e$var$initCloneObject;

});
parcelRegister("gC9qu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c18781cd3fdf15d6$export$2e2bcd8739ae039);

var $aEm6h = parcelRequire("aEm6h");
/** Built-in value references. */ var $c18781cd3fdf15d6$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c18781cd3fdf15d6$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $aEm6h.default)(proto)) return {};
        if ($c18781cd3fdf15d6$var$objectCreate) return $c18781cd3fdf15d6$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $c18781cd3fdf15d6$export$2e2bcd8739ae039 = $c18781cd3fdf15d6$var$baseCreate;

});


parcelRegister("dzKFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e22bdfb46b96ebb$export$2e2bcd8739ae039);

var $gbyGB = parcelRequire("gbyGB");

var $3eP2X = parcelRequire("3eP2X");

var $aXD9Z = parcelRequire("aXD9Z");
/* Node.js helper references. */ var $9e22bdfb46b96ebb$var$nodeIsMap = (0, $aXD9Z.default) && (0, $aXD9Z.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $9e22bdfb46b96ebb$var$isMap = $9e22bdfb46b96ebb$var$nodeIsMap ? (0, $3eP2X.default)($9e22bdfb46b96ebb$var$nodeIsMap) : (0, $gbyGB.default);
var $9e22bdfb46b96ebb$export$2e2bcd8739ae039 = $9e22bdfb46b96ebb$var$isMap;

});
parcelRegister("gbyGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc889463933a6a08$export$2e2bcd8739ae039);

var $1Njgi = parcelRequire("1Njgi");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $bc889463933a6a08$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $bc889463933a6a08$var$baseIsMap(value) {
    return (0, $3iyEO.default)(value) && (0, $1Njgi.default)(value) == $bc889463933a6a08$var$mapTag;
}
var $bc889463933a6a08$export$2e2bcd8739ae039 = $bc889463933a6a08$var$baseIsMap;

});


parcelRegister("3gkQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $260307e07534a4bd$export$2e2bcd8739ae039);

var $5VsOv = parcelRequire("5VsOv");

var $3eP2X = parcelRequire("3eP2X");

var $aXD9Z = parcelRequire("aXD9Z");
/* Node.js helper references. */ var $260307e07534a4bd$var$nodeIsSet = (0, $aXD9Z.default) && (0, $aXD9Z.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $260307e07534a4bd$var$isSet = $260307e07534a4bd$var$nodeIsSet ? (0, $3eP2X.default)($260307e07534a4bd$var$nodeIsSet) : (0, $5VsOv.default);
var $260307e07534a4bd$export$2e2bcd8739ae039 = $260307e07534a4bd$var$isSet;

});
parcelRegister("5VsOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4508a06b420210da$export$2e2bcd8739ae039);

var $1Njgi = parcelRequire("1Njgi");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $4508a06b420210da$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $4508a06b420210da$var$baseIsSet(value) {
    return (0, $3iyEO.default)(value) && (0, $1Njgi.default)(value) == $4508a06b420210da$var$setTag;
}
var $4508a06b420210da$export$2e2bcd8739ae039 = $4508a06b420210da$var$baseIsSet;

});




parcelRegister("70duG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5193001d4b118f94$export$2e2bcd8739ae039);

var $1m1Bk = parcelRequire("1m1Bk");

var $4m08N = parcelRequire("4m08N");

var $ipNyZ = parcelRequire("ipNyZ");

var $jFkoH = parcelRequire("jFkoH");

var $3ZMgt = parcelRequire("3ZMgt");

var $b0HeS = parcelRequire("b0HeS");

var $3ReFG = parcelRequire("3ReFG");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $5193001d4b118f94$var$toPath(value) {
    if ((0, $ipNyZ.default)(value)) return (0, $1m1Bk.default)(value, (0, $b0HeS.default));
    return (0, $jFkoH.default)(value) ? [
        value
    ] : (0, $4m08N.default)((0, $3ZMgt.default)((0, $3ReFG.default)(value)));
}
var $5193001d4b118f94$export$2e2bcd8739ae039 = $5193001d4b118f94$var$toPath;

});
parcelRegister("1m1Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc91674437d06d9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0fc91674437d06d9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $0fc91674437d06d9$export$2e2bcd8739ae039 = $0fc91674437d06d9$var$arrayMap;

});

parcelRegister("jFkoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e511ab26a566b77a$export$2e2bcd8739ae039);

var $4Vy8R = parcelRequire("4Vy8R");

var $3iyEO = parcelRequire("3iyEO");
/** `Object#toString` result references. */ var $e511ab26a566b77a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e511ab26a566b77a$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $3iyEO.default)(value) && (0, $4Vy8R.default)(value) == $e511ab26a566b77a$var$symbolTag;
}
var $e511ab26a566b77a$export$2e2bcd8739ae039 = $e511ab26a566b77a$var$isSymbol;

});

parcelRegister("3ZMgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8c81fdca717b02$export$2e2bcd8739ae039);

var $FeEej = parcelRequire("FeEej");
/** Used to match property names within property paths. */ var $2e8c81fdca717b02$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2e8c81fdca717b02$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2e8c81fdca717b02$var$stringToPath = (0, $FeEej.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($2e8c81fdca717b02$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2e8c81fdca717b02$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $2e8c81fdca717b02$export$2e2bcd8739ae039 = $2e8c81fdca717b02$var$stringToPath;

});
parcelRegister("FeEej", function(module, exports) {

$parcel$export(module.exports, "default", () => $07bf31362d7e1b1a$export$2e2bcd8739ae039);

var $1IXEE = parcelRequire("1IXEE");
/** Used as the maximum memoize cache size. */ var $07bf31362d7e1b1a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $07bf31362d7e1b1a$var$memoizeCapped(func) {
    var result = (0, $1IXEE.default)(func, function(key) {
        if (cache.size === $07bf31362d7e1b1a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $07bf31362d7e1b1a$export$2e2bcd8739ae039 = $07bf31362d7e1b1a$var$memoizeCapped;

});
parcelRegister("1IXEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $14182caaedcb51a3$export$2e2bcd8739ae039);

var $a2sft = parcelRequire("a2sft");
/** Error message constants. */ var $14182caaedcb51a3$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $14182caaedcb51a3$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($14182caaedcb51a3$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($14182caaedcb51a3$var$memoize.Cache || (0, $a2sft.default));
    return memoized;
}
// Expose `MapCache`.
$14182caaedcb51a3$var$memoize.Cache = (0, $a2sft.default);
var $14182caaedcb51a3$export$2e2bcd8739ae039 = $14182caaedcb51a3$var$memoize;

});



parcelRegister("b0HeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $80413c2965269865$export$2e2bcd8739ae039);

var $jFkoH = parcelRequire("jFkoH");
/** Used as references for various `Number` constants. */ var $80413c2965269865$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $80413c2965269865$var$toKey(value) {
    if (typeof value == "string" || (0, $jFkoH.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$80413c2965269865$var$INFINITY ? "-0" : result;
}
var $80413c2965269865$export$2e2bcd8739ae039 = $80413c2965269865$var$toKey;

});

parcelRegister("3ReFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf1b3ba72ca37a4$export$2e2bcd8739ae039);

var $cQ3KP = parcelRequire("cQ3KP");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2cf1b3ba72ca37a4$var$toString(value) {
    return value == null ? "" : (0, $cQ3KP.default)(value);
}
var $2cf1b3ba72ca37a4$export$2e2bcd8739ae039 = $2cf1b3ba72ca37a4$var$toString;

});
parcelRegister("cQ3KP", function(module, exports) {

$parcel$export(module.exports, "default", () => $958d40e8870bd9ec$export$2e2bcd8739ae039);

var $7BbnC = parcelRequire("7BbnC");

var $1m1Bk = parcelRequire("1m1Bk");

var $ipNyZ = parcelRequire("ipNyZ");

var $jFkoH = parcelRequire("jFkoH");
/** Used as references for various `Number` constants. */ var $958d40e8870bd9ec$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $958d40e8870bd9ec$var$symbolProto = (0, $7BbnC.default) ? (0, $7BbnC.default).prototype : undefined, $958d40e8870bd9ec$var$symbolToString = $958d40e8870bd9ec$var$symbolProto ? $958d40e8870bd9ec$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $958d40e8870bd9ec$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $ipNyZ.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $1m1Bk.default)(value, $958d40e8870bd9ec$var$baseToString) + "";
    if ((0, $jFkoH.default)(value)) return $958d40e8870bd9ec$var$symbolToString ? $958d40e8870bd9ec$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$958d40e8870bd9ec$var$INFINITY ? "-0" : result;
}
var $958d40e8870bd9ec$export$2e2bcd8739ae039 = $958d40e8870bd9ec$var$baseToString;

});



parcelRegister("2c4D7", function(module, exports) {
"use strict";

var $f323f = parcelRequire("f323f");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $19904b2c9eea2be2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $19904b2c9eea2be2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $19904b2c9eea2be2$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $19904b2c9eea2be2$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $19904b2c9eea2be2$var$TYPE_STATICS = {};
$19904b2c9eea2be2$var$TYPE_STATICS[$f323f.ForwardRef] = $19904b2c9eea2be2$var$FORWARD_REF_STATICS;
$19904b2c9eea2be2$var$TYPE_STATICS[$f323f.Memo] = $19904b2c9eea2be2$var$MEMO_STATICS;
function $19904b2c9eea2be2$var$getStatics(component) {
    // React v16.11 and below
    if ($f323f.isMemo(component)) return $19904b2c9eea2be2$var$MEMO_STATICS;
     // React v16.12 and above
    return $19904b2c9eea2be2$var$TYPE_STATICS[component["$$typeof"]] || $19904b2c9eea2be2$var$REACT_STATICS;
}
var $19904b2c9eea2be2$var$defineProperty = Object.defineProperty;
var $19904b2c9eea2be2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $19904b2c9eea2be2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $19904b2c9eea2be2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $19904b2c9eea2be2$var$getPrototypeOf = Object.getPrototypeOf;
var $19904b2c9eea2be2$var$objectPrototype = Object.prototype;
function $19904b2c9eea2be2$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($19904b2c9eea2be2$var$objectPrototype) {
            var inheritedComponent = $19904b2c9eea2be2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $19904b2c9eea2be2$var$objectPrototype) $19904b2c9eea2be2$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $19904b2c9eea2be2$var$getOwnPropertyNames(sourceComponent);
        if ($19904b2c9eea2be2$var$getOwnPropertySymbols) keys = keys.concat($19904b2c9eea2be2$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $19904b2c9eea2be2$var$getStatics(targetComponent);
        var sourceStatics = $19904b2c9eea2be2$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$19904b2c9eea2be2$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $19904b2c9eea2be2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $19904b2c9eea2be2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $19904b2c9eea2be2$var$hoistNonReactStatics;

});
parcelRegister("f323f", function(module, exports) {
"use strict";

module.exports = (parcelRequire("78iim"));

});
parcelRegister("78iim", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $531778cc9a4d1268$export$2b8d127b894957b9, (v) => $531778cc9a4d1268$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $531778cc9a4d1268$export$cea3a54a6425200c, (v) => $531778cc9a4d1268$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $531778cc9a4d1268$export$a7c73072b1a182ae, (v) => $531778cc9a4d1268$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $531778cc9a4d1268$export$9f27bc3417b4524d, (v) => $531778cc9a4d1268$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $531778cc9a4d1268$export$db77ccec0bb4ccac, (v) => $531778cc9a4d1268$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $531778cc9a4d1268$export$8392c0c9d3dcbd35, (v) => $531778cc9a4d1268$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $531778cc9a4d1268$export$ffb0004e005737fa, (v) => $531778cc9a4d1268$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $531778cc9a4d1268$export$b624eff549462981, (v) => $531778cc9a4d1268$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $531778cc9a4d1268$export$7897aa7841a5380c, (v) => $531778cc9a4d1268$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $531778cc9a4d1268$export$602eac185826482c, (v) => $531778cc9a4d1268$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $531778cc9a4d1268$export$e2c29f18771995cb, (v) => $531778cc9a4d1268$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $531778cc9a4d1268$export$5f8d39834fd61797, (v) => $531778cc9a4d1268$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $531778cc9a4d1268$export$74bf444e3cd11ea5, (v) => $531778cc9a4d1268$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $531778cc9a4d1268$export$92387174baf9b227, (v) => $531778cc9a4d1268$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $531778cc9a4d1268$export$ec112efeb987d9c6, (v) => $531778cc9a4d1268$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $531778cc9a4d1268$export$b706b080d889d2c9, (v) => $531778cc9a4d1268$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $531778cc9a4d1268$export$5be5a87408f70ddc, (v) => $531778cc9a4d1268$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $531778cc9a4d1268$export$45a5e7f76e0caa8d, (v) => $531778cc9a4d1268$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $531778cc9a4d1268$export$455c2e768291efa6, (v) => $531778cc9a4d1268$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $531778cc9a4d1268$export$9522e17588c12572, (v) => $531778cc9a4d1268$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $531778cc9a4d1268$export$2110ac352bb060b9, (v) => $531778cc9a4d1268$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $531778cc9a4d1268$export$56885ab8b9c456ab, (v) => $531778cc9a4d1268$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $531778cc9a4d1268$export$d927fcb6adf8f9de, (v) => $531778cc9a4d1268$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $531778cc9a4d1268$export$b82d16f27459e05a, (v) => $531778cc9a4d1268$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $531778cc9a4d1268$export$522c17b4f5e123e8, (v) => $531778cc9a4d1268$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $531778cc9a4d1268$export$1aabd8a0274ecfd6, (v) => $531778cc9a4d1268$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $531778cc9a4d1268$export$9b621391a187a31a, (v) => $531778cc9a4d1268$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $531778cc9a4d1268$export$f5bbd400c2f4426f, (v) => $531778cc9a4d1268$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $531778cc9a4d1268$export$2b8d127b894957b9;
var $531778cc9a4d1268$export$cea3a54a6425200c;
var $531778cc9a4d1268$export$a7c73072b1a182ae;
var $531778cc9a4d1268$export$9f27bc3417b4524d;
var $531778cc9a4d1268$export$db77ccec0bb4ccac;
var $531778cc9a4d1268$export$8392c0c9d3dcbd35;
var $531778cc9a4d1268$export$ffb0004e005737fa;
var $531778cc9a4d1268$export$b624eff549462981;
var $531778cc9a4d1268$export$7897aa7841a5380c;
var $531778cc9a4d1268$export$602eac185826482c;
var $531778cc9a4d1268$export$e2c29f18771995cb;
var $531778cc9a4d1268$export$5f8d39834fd61797;
var $531778cc9a4d1268$export$74bf444e3cd11ea5;
var $531778cc9a4d1268$export$92387174baf9b227;
var $531778cc9a4d1268$export$ec112efeb987d9c6;
var $531778cc9a4d1268$export$b706b080d889d2c9;
var $531778cc9a4d1268$export$5be5a87408f70ddc;
var $531778cc9a4d1268$export$45a5e7f76e0caa8d;
var $531778cc9a4d1268$export$455c2e768291efa6;
var $531778cc9a4d1268$export$9522e17588c12572;
var $531778cc9a4d1268$export$2110ac352bb060b9;
var $531778cc9a4d1268$export$56885ab8b9c456ab;
var $531778cc9a4d1268$export$d927fcb6adf8f9de;
var $531778cc9a4d1268$export$b82d16f27459e05a;
var $531778cc9a4d1268$export$522c17b4f5e123e8;
var $531778cc9a4d1268$export$1aabd8a0274ecfd6;
var $531778cc9a4d1268$export$9b621391a187a31a;
var $531778cc9a4d1268$export$f5bbd400c2f4426f;
"use strict";
var $531778cc9a4d1268$var$b = "function" === typeof Symbol && Symbol.for, $531778cc9a4d1268$var$c = $531778cc9a4d1268$var$b ? Symbol.for("react.element") : 60103, $531778cc9a4d1268$var$d = $531778cc9a4d1268$var$b ? Symbol.for("react.portal") : 60106, $531778cc9a4d1268$var$e = $531778cc9a4d1268$var$b ? Symbol.for("react.fragment") : 60107, $531778cc9a4d1268$var$f = $531778cc9a4d1268$var$b ? Symbol.for("react.strict_mode") : 60108, $531778cc9a4d1268$var$g = $531778cc9a4d1268$var$b ? Symbol.for("react.profiler") : 60114, $531778cc9a4d1268$var$h = $531778cc9a4d1268$var$b ? Symbol.for("react.provider") : 60109, $531778cc9a4d1268$var$k = $531778cc9a4d1268$var$b ? Symbol.for("react.context") : 60110, $531778cc9a4d1268$var$l = $531778cc9a4d1268$var$b ? Symbol.for("react.async_mode") : 60111, $531778cc9a4d1268$var$m = $531778cc9a4d1268$var$b ? Symbol.for("react.concurrent_mode") : 60111, $531778cc9a4d1268$var$n = $531778cc9a4d1268$var$b ? Symbol.for("react.forward_ref") : 60112, $531778cc9a4d1268$var$p = $531778cc9a4d1268$var$b ? Symbol.for("react.suspense") : 60113, $531778cc9a4d1268$var$q = $531778cc9a4d1268$var$b ? Symbol.for("react.suspense_list") : 60120, $531778cc9a4d1268$var$r = $531778cc9a4d1268$var$b ? Symbol.for("react.memo") : 60115, $531778cc9a4d1268$var$t = $531778cc9a4d1268$var$b ? Symbol.for("react.lazy") : 60116, $531778cc9a4d1268$var$v = $531778cc9a4d1268$var$b ? Symbol.for("react.block") : 60121, $531778cc9a4d1268$var$w = $531778cc9a4d1268$var$b ? Symbol.for("react.fundamental") : 60117, $531778cc9a4d1268$var$x = $531778cc9a4d1268$var$b ? Symbol.for("react.responder") : 60118, $531778cc9a4d1268$var$y = $531778cc9a4d1268$var$b ? Symbol.for("react.scope") : 60119;
function $531778cc9a4d1268$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $531778cc9a4d1268$var$c:
                switch(a = a.type, a){
                    case $531778cc9a4d1268$var$l:
                    case $531778cc9a4d1268$var$m:
                    case $531778cc9a4d1268$var$e:
                    case $531778cc9a4d1268$var$g:
                    case $531778cc9a4d1268$var$f:
                    case $531778cc9a4d1268$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $531778cc9a4d1268$var$k:
                            case $531778cc9a4d1268$var$n:
                            case $531778cc9a4d1268$var$t:
                            case $531778cc9a4d1268$var$r:
                            case $531778cc9a4d1268$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $531778cc9a4d1268$var$d:
                return u;
        }
    }
}
function $531778cc9a4d1268$var$A(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$m;
}
$531778cc9a4d1268$export$2b8d127b894957b9 = $531778cc9a4d1268$var$l;
$531778cc9a4d1268$export$cea3a54a6425200c = $531778cc9a4d1268$var$m;
$531778cc9a4d1268$export$a7c73072b1a182ae = $531778cc9a4d1268$var$k;
$531778cc9a4d1268$export$9f27bc3417b4524d = $531778cc9a4d1268$var$h;
$531778cc9a4d1268$export$db77ccec0bb4ccac = $531778cc9a4d1268$var$c;
$531778cc9a4d1268$export$8392c0c9d3dcbd35 = $531778cc9a4d1268$var$n;
$531778cc9a4d1268$export$ffb0004e005737fa = $531778cc9a4d1268$var$e;
$531778cc9a4d1268$export$b624eff549462981 = $531778cc9a4d1268$var$t;
$531778cc9a4d1268$export$7897aa7841a5380c = $531778cc9a4d1268$var$r;
$531778cc9a4d1268$export$602eac185826482c = $531778cc9a4d1268$var$d;
$531778cc9a4d1268$export$e2c29f18771995cb = $531778cc9a4d1268$var$g;
$531778cc9a4d1268$export$5f8d39834fd61797 = $531778cc9a4d1268$var$f;
$531778cc9a4d1268$export$74bf444e3cd11ea5 = $531778cc9a4d1268$var$p;
$531778cc9a4d1268$export$92387174baf9b227 = function(a) {
    return $531778cc9a4d1268$var$A(a) || $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$l;
};
$531778cc9a4d1268$export$ec112efeb987d9c6 = $531778cc9a4d1268$var$A;
$531778cc9a4d1268$export$b706b080d889d2c9 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$k;
};
$531778cc9a4d1268$export$5be5a87408f70ddc = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$h;
};
$531778cc9a4d1268$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $531778cc9a4d1268$var$c;
};
$531778cc9a4d1268$export$455c2e768291efa6 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$n;
};
$531778cc9a4d1268$export$9522e17588c12572 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$e;
};
$531778cc9a4d1268$export$2110ac352bb060b9 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$t;
};
$531778cc9a4d1268$export$56885ab8b9c456ab = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$r;
};
$531778cc9a4d1268$export$d927fcb6adf8f9de = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$d;
};
$531778cc9a4d1268$export$b82d16f27459e05a = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$g;
};
$531778cc9a4d1268$export$522c17b4f5e123e8 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$f;
};
$531778cc9a4d1268$export$1aabd8a0274ecfd6 = function(a) {
    return $531778cc9a4d1268$var$z(a) === $531778cc9a4d1268$var$p;
};
$531778cc9a4d1268$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $531778cc9a4d1268$var$e || a === $531778cc9a4d1268$var$m || a === $531778cc9a4d1268$var$g || a === $531778cc9a4d1268$var$f || a === $531778cc9a4d1268$var$p || a === $531778cc9a4d1268$var$q || "object" === typeof a && null !== a && (a.$$typeof === $531778cc9a4d1268$var$t || a.$$typeof === $531778cc9a4d1268$var$r || a.$$typeof === $531778cc9a4d1268$var$h || a.$$typeof === $531778cc9a4d1268$var$k || a.$$typeof === $531778cc9a4d1268$var$n || a.$$typeof === $531778cc9a4d1268$var$w || a.$$typeof === $531778cc9a4d1268$var$x || a.$$typeof === $531778cc9a4d1268$var$y || a.$$typeof === $531778cc9a4d1268$var$v);
};
$531778cc9a4d1268$export$f5bbd400c2f4426f = $531778cc9a4d1268$var$z;

});



parcelRegister("cyKKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $924ceb94701ddb8e$export$2e2bcd8739ae039);

var $5EA90 = parcelRequire("5EA90");
/** Used to compose bitmasks for cloning. */ var $924ceb94701ddb8e$var$CLONE_DEEP_FLAG = 1, $924ceb94701ddb8e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $924ceb94701ddb8e$var$cloneDeep(value) {
    return (0, $5EA90.default)(value, $924ceb94701ddb8e$var$CLONE_DEEP_FLAG | $924ceb94701ddb8e$var$CLONE_SYMBOLS_FLAG);
}
var $924ceb94701ddb8e$export$2e2bcd8739ae039 = $924ceb94701ddb8e$var$cloneDeep;

});


parcelRegister("gXSZq", function(module, exports) {

var $i9bmW = parcelRequire("i9bmW");
module.exports = $i9bmW("i5W77").then(()=>parcelRequire("66wP8"));

});
parcelRegister("i9bmW", function(module, exports) {
"use strict";

function $d361e2e628e1967f$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kReb3")).resolve(id));
}
module.exports = $d361e2e628e1967f$var$load;

});


parcelRegister("jbmTD", function(module, exports) {

var $i9bmW = parcelRequire("i9bmW");
module.exports = $i9bmW("6tzgj").then(()=>parcelRequire("4wYKs"));

});


var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");
var $b20dc0166e51d3b8$exports = {};

$parcel$export($b20dc0166e51d3b8$exports, "createRoot", () => $b20dc0166e51d3b8$export$882461b6382ed46c, (v) => $b20dc0166e51d3b8$export$882461b6382ed46c = v);
$parcel$export($b20dc0166e51d3b8$exports, "hydrateRoot", () => $b20dc0166e51d3b8$export$757ceba2d55c277e, (v) => $b20dc0166e51d3b8$export$757ceba2d55c277e = v);
var $b20dc0166e51d3b8$export$882461b6382ed46c;
var $b20dc0166e51d3b8$export$757ceba2d55c277e;
"use strict";

var $idNu3 = parcelRequire("idNu3");
var $b20dc0166e51d3b8$var$i;
$b20dc0166e51d3b8$export$882461b6382ed46c = $idNu3.createRoot;
$b20dc0166e51d3b8$export$757ceba2d55c277e = $idNu3.hydrateRoot;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $iGccQ = parcelRequire("iGccQ");

var $50vd1 = parcelRequire("50vd1");
const $372b4e36b3f1ec1d$var$useOnline = ()=>{
    const [isOnline, setOnline] = (0, $50vd1.useState)(true);
    const Onlinehandler = ()=>{
        setOnline(true);
    };
    const Offlinehandler = ()=>{
        setOnline(false);
    };
    (0, $50vd1.useEffect)(()=>{
        window.addEventListener("online", Onlinehandler);
        window.addEventListener("offline", Offlinehandler);
        console.log("Online handler run");
        return ()=>{
            window.removeEventListener("online", Onlinehandler);
            window.removeEventListener("offline", Offlinehandler);
            console.log("Online handler return");
        };
    }, []);
    return isOnline;
};
var $372b4e36b3f1ec1d$export$2e2bcd8739ae039 = $372b4e36b3f1ec1d$var$useOnline;



var $kBOxH = parcelRequire("kBOxH");

var $gNObz = parcelRequire("gNObz");

var $iq6Qi = parcelRequire("iq6Qi");

var $iGccQ = parcelRequire("iGccQ");
var $42d9bf5af8b99c6f$exports = {};
$42d9bf5af8b99c6f$exports = new URL("Food-Plaza.b8835a43.png", import.meta.url).toString();



var $50vd1 = parcelRequire("50vd1");

var $8H118 = parcelRequire("8H118");

var $50vd1 = parcelRequire("50vd1");
const $b593617b461c7dad$var$CityContext = /*#__PURE__*/ (0, $50vd1.createContext)({
    city: {}
});
var $b593617b461c7dad$export$2e2bcd8739ae039 = $b593617b461c7dad$var$CityContext;



var $6eUyJ = parcelRequire("6eUyJ");
const $36973af6e1fd7c44$var$Title = ()=>{
    const [nearMe, setNearMe] = (0, $50vd1.useState)(false);
    // Location Context----------------------------------
    const { setLocation: setLocation } = (0, $50vd1.useContext)((0, $8H118.default));
    const { city: city } = (0, $50vd1.useContext)((0, $b593617b461c7dad$export$2e2bcd8739ae039));
    const handlerLocationNear = ()=>{
        navigator.geolocation.getCurrentPosition((position)=>{
            const { latitude: latitude, longitude: longitude } = position?.coords;
            setLocation({
                latitude: latitude,
                longitude: longitude
            });
            setNearMe(true);
        });
    };
    const handlerLocationDefault = ()=>{
        setLocation({
            latitude: 28.7040592,
            longitude: 77.1024901
        });
        setNearMe(false);
    };
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "title-box",
        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                to: "/",
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                    className: "logo",
                    alt: "logo",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($42d9bf5af8b99c6f$exports)))
                })
            }),
            nearMe ? /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                onClick: ()=>handlerLocationDefault(),
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                        children: "Default"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        className: "location-name",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                className: "fa-solid fa-location-dot",
                                style: {
                                    color: "#ff8800"
                                }
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: city
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                onClick: ()=>handlerLocationNear(),
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                        children: "Near Me!"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        className: "location-name",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                className: "fa-solid fa-location-dot",
                                style: {
                                    color: "#ff8800"
                                }
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: city
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $36973af6e1fd7c44$export$2e2bcd8739ae039 = $36973af6e1fd7c44$var$Title;



var $6eUyJ = parcelRequire("6eUyJ");
const $bc5dea09761a5f80$var$Header = ()=>{
    const [isLogin, setIsLogin] = (0, $50vd1.useState)(false);
    const [ismenu, setIsMenu] = (0, $50vd1.useState)(false);
    const isOnline = (0, $372b4e36b3f1ec1d$export$2e2bcd8739ae039)();
    const cartItem = (0, $kBOxH.useSelector)((store)=>{
        return store.cart.items;
    });
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iq6Qi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $36973af6e1fd7c44$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "nav-item-menu",
                        onClick: ()=>{
                            setIsMenu(true);
                        },
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                            className: "fa-solid fa-bars"
                        })
                    }),
                    ismenu && /*#__PURE__*/ (0, $iq6Qi.jsxs)("ul", {
                        className: "nav-items nav-items-small",
                        id: ismenu ? "nav-items-small-show" : "",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                className: "nav-item-close",
                                onClick: ()=>{
                                    setIsMenu(false);
                                },
                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                    className: "fa-solid fa-xmark"
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/search",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                className: "_1GTCc",
                                                viewBox: "5 -1 12 25",
                                                height: "17",
                                                width: "17",
                                                fill: "#686b78",
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                    d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Search"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/about",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                className: "_1GTCc",
                                                viewBox: "6 -1 12 25",
                                                height: "19",
                                                width: "19",
                                                fill: "#686b78",
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                    d: "M21.966903,13.2244898 C22.0156989,12.8231523 22.0408163,12.4145094 22.0408163,12 C22.0408163,11.8357822 22.036874,11.6724851 22.029079,11.5101984 L17.8574333,11.5102041 C17.8707569,11.6717062 17.877551,11.8350597 17.877551,12 C17.877551,12.4199029 17.8335181,12.8295214 17.749818,13.2244898 L21.966903,13.2244898 Z M21.5255943,15.1836735 L16.9414724,15.1836735 C15.8950289,16.8045422 14.0728218,17.877551 12,17.877551 C9.92717823,17.877551 8.1049711,16.8045422 7.05852762,15.1836735 L2.47440565,15.1836735 C3.80564362,19.168549 7.56739481,22.0408163 12,22.0408163 C16.4326052,22.0408163 20.1943564,19.168549 21.5255943,15.1836735 Z M21.7400381,9.55102041 C20.6468384,5.18931674 16.7006382,1.95918367 12,1.95918367 C7.2993618,1.95918367 3.3531616,5.18931674 2.25996187,9.55102041 L6.6553883,9.55102041 C7.58404845,7.5276442 9.62792376,6.12244898 12,6.12244898 C14.3720762,6.12244898 16.4159515,7.5276442 17.3446117,9.55102041 L21.7400381,9.55102041 Z M2.03309705,13.2244898 L6.25018203,13.2244898 C6.16648186,12.8295214 6.12244898,12.4199029 6.12244898,12 C6.12244898,11.8350597 6.1292431,11.6717062 6.14256675,11.5102041 L1.97092075,11.5102041 C1.96312595,11.6724851 1.95918367,11.8357822 1.95918367,12 C1.95918367,12.4145094 1.98430112,12.8231523 2.03309705,13.2244898 Z M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,15.9183673 C14.1640545,15.9183673 15.9183673,14.1640545 15.9183673,12 C15.9183673,9.83594547 14.1640545,8.08163265 12,8.08163265 C9.83594547,8.08163265 8.08163265,9.83594547 8.08163265,12 C8.08163265,14.1640545 9.83594547,15.9183673 12,15.9183673 Z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "About"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/contact",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                            className: "fa-regular fa-address-book"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Contact"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "cart",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                                    className: "CartIconNo",
                                                    children: cartItem.length
                                                }),
                                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                        id: "cart-no",
                                                        viewBox: "-1 0 37 32",
                                                        height: "20",
                                                        width: "20",
                                                        style: {
                                                            fill: "white"
                                                        },
                                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                            d: "M4.438 0l-2.598 5.11-1.84 26.124h34.909l-1.906-26.124-2.597-5.11z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Cart"
                                        })
                                    ]
                                })
                            }),
                            isLogin ? /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                onClick: ()=>{
                                    setIsLogin(false);
                                },
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("User logged in");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 0 12 24",
                                            height: "19",
                                            width: "18",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                d: "M11.9923172,11.2463768 C8.81761115,11.2463768 6.24400341,8.72878961 6.24400341,5.62318841 C6.24400341,2.5175872 8.81761115,0 11.9923172,0 C15.1670232,0 17.740631,2.5175872 17.740631,5.62318841 C17.740631,8.72878961 15.1670232,11.2463768 11.9923172,11.2463768 Z M11.9923172,9.27536232 C14.0542397,9.27536232 15.7257581,7.64022836 15.7257581,5.62318841 C15.7257581,3.60614845 14.0542397,1.97101449 11.9923172,1.97101449 C9.93039471,1.97101449 8.25887628,3.60614845 8.25887628,5.62318841 C8.25887628,7.64022836 9.93039471,9.27536232 11.9923172,9.27536232 Z M24,24 L0,24 L1.21786143,19.7101449 L2.38352552,15.6939891 C2.85911209,14.0398226 4.59284263,12.7536232 6.3530098,12.7536232 L17.6316246,12.7536232 C19.3874139,12.7536232 21.1256928,14.0404157 21.6011089,15.6939891 L22.9903494,20.5259906 C23.0204168,20.63057 23.0450458,20.7352884 23.0641579,20.8398867 L24,24 Z M21.1127477,21.3339312 L21.0851024,21.2122487 C21.0772161,21.1630075 21.0658093,21.1120821 21.0507301,21.0596341 L19.6614896,16.2276325 C19.4305871,15.4245164 18.4851476,14.7246377 17.6316246,14.7246377 L6.3530098,14.7246377 C5.4959645,14.7246377 4.55444948,15.4231177 4.32314478,16.2276325 L2.75521062,21.6811594 L2.65068631,22.0289855 L21.3185825,22.0289855 L21.1127477,21.3339312 Z"
                                            })
                                        }),
                                        "SignIn",
                                        isOnline ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                onClick: ()=>{
                                    setIsLogin(true);
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("User logged out");
                                },
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/",
                                    onClick: ()=>{
                                        setIsMenu(false);
                                        (0, $6eUyJ.handleScrollTop)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 0 12 24",
                                            height: "19",
                                            width: "18",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                d: "M11.9923172,11.2463768 C8.81761115,11.2463768 6.24400341,8.72878961 6.24400341,5.62318841 C6.24400341,2.5175872 8.81761115,0 11.9923172,0 C15.1670232,0 17.740631,2.5175872 17.740631,5.62318841 C17.740631,8.72878961 15.1670232,11.2463768 11.9923172,11.2463768 Z M11.9923172,9.27536232 C14.0542397,9.27536232 15.7257581,7.64022836 15.7257581,5.62318841 C15.7257581,3.60614845 14.0542397,1.97101449 11.9923172,1.97101449 C9.93039471,1.97101449 8.25887628,3.60614845 8.25887628,5.62318841 C8.25887628,7.64022836 9.93039471,9.27536232 11.9923172,9.27536232 Z M24,24 L0,24 L1.21786143,19.7101449 L2.38352552,15.6939891 C2.85911209,14.0398226 4.59284263,12.7536232 6.3530098,12.7536232 L17.6316246,12.7536232 C19.3874139,12.7536232 21.1256928,14.0404157 21.6011089,15.6939891 L22.9903494,20.5259906 C23.0204168,20.63057 23.0450458,20.7352884 23.0641579,20.8398867 L24,24 Z M21.1127477,21.3339312 L21.0851024,21.2122487 C21.0772161,21.1630075 21.0658093,21.1120821 21.0507301,21.0596341 L19.6614896,16.2276325 C19.4305871,15.4245164 18.4851476,14.7246377 17.6316246,14.7246377 L6.3530098,14.7246377 C5.4959645,14.7246377 4.55444948,15.4231177 4.32314478,16.2276325 L2.75521062,21.6811594 L2.65068631,22.0289855 L21.3185825,22.0289855 L21.1127477,21.3339312 Z"
                                            })
                                        }),
                                        "Logout",
                                        isOnline ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("ul", {
                        className: "nav-items",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                className: "nav-item-close",
                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                    className: "fa-solid fa-xmark"
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/search",
                                    onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                className: "_1GTCc",
                                                viewBox: "5 -1 12 25",
                                                height: "17",
                                                width: "17",
                                                fill: "#686b78",
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                    d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Search"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/about",
                                    onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                className: "_1GTCc",
                                                viewBox: "6 -1 12 25",
                                                height: "19",
                                                width: "19",
                                                fill: "#686b78",
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                    d: "M21.966903,13.2244898 C22.0156989,12.8231523 22.0408163,12.4145094 22.0408163,12 C22.0408163,11.8357822 22.036874,11.6724851 22.029079,11.5101984 L17.8574333,11.5102041 C17.8707569,11.6717062 17.877551,11.8350597 17.877551,12 C17.877551,12.4199029 17.8335181,12.8295214 17.749818,13.2244898 L21.966903,13.2244898 Z M21.5255943,15.1836735 L16.9414724,15.1836735 C15.8950289,16.8045422 14.0728218,17.877551 12,17.877551 C9.92717823,17.877551 8.1049711,16.8045422 7.05852762,15.1836735 L2.47440565,15.1836735 C3.80564362,19.168549 7.56739481,22.0408163 12,22.0408163 C16.4326052,22.0408163 20.1943564,19.168549 21.5255943,15.1836735 Z M21.7400381,9.55102041 C20.6468384,5.18931674 16.7006382,1.95918367 12,1.95918367 C7.2993618,1.95918367 3.3531616,5.18931674 2.25996187,9.55102041 L6.6553883,9.55102041 C7.58404845,7.5276442 9.62792376,6.12244898 12,6.12244898 C14.3720762,6.12244898 16.4159515,7.5276442 17.3446117,9.55102041 L21.7400381,9.55102041 Z M2.03309705,13.2244898 L6.25018203,13.2244898 C6.16648186,12.8295214 6.12244898,12.4199029 6.12244898,12 C6.12244898,11.8350597 6.1292431,11.6717062 6.14256675,11.5102041 L1.97092075,11.5102041 C1.96312595,11.6724851 1.95918367,11.8357822 1.95918367,12 C1.95918367,12.4145094 1.98430112,12.8231523 2.03309705,13.2244898 Z M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,15.9183673 C14.1640545,15.9183673 15.9183673,14.1640545 15.9183673,12 C15.9183673,9.83594547 14.1640545,8.08163265 12,8.08163265 C9.83594547,8.08163265 8.08163265,9.83594547 8.08163265,12 C8.08163265,14.1640545 9.83594547,15.9183673 12,15.9183673 Z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "About"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/contact",
                                    onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                            className: "fa-regular fa-address-book"
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Contact"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "cart",
                                    onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                                    className: "CartIconNo",
                                                    children: cartItem.length
                                                }),
                                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                                        id: "cart-no",
                                                        viewBox: "-1 0 37 32",
                                                        height: "20",
                                                        width: "20",
                                                        style: {
                                                            fill: "white"
                                                        },
                                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                            d: "M4.438 0l-2.598 5.11-1.84 26.124h34.909l-1.906-26.124-2.597-5.11z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            children: "Cart"
                                        })
                                    ]
                                })
                            }),
                            isLogin ? /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                onClick: ()=>{
                                    setIsLogin(false);
                                    (0, $6eUyJ.handleScrollTop)();
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("User logged in");
                                },
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/",
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 0 12 24",
                                            height: "19",
                                            width: "18",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                d: "M11.9923172,11.2463768 C8.81761115,11.2463768 6.24400341,8.72878961 6.24400341,5.62318841 C6.24400341,2.5175872 8.81761115,0 11.9923172,0 C15.1670232,0 17.740631,2.5175872 17.740631,5.62318841 C17.740631,8.72878961 15.1670232,11.2463768 11.9923172,11.2463768 Z M11.9923172,9.27536232 C14.0542397,9.27536232 15.7257581,7.64022836 15.7257581,5.62318841 C15.7257581,3.60614845 14.0542397,1.97101449 11.9923172,1.97101449 C9.93039471,1.97101449 8.25887628,3.60614845 8.25887628,5.62318841 C8.25887628,7.64022836 9.93039471,9.27536232 11.9923172,9.27536232 Z M24,24 L0,24 L1.21786143,19.7101449 L2.38352552,15.6939891 C2.85911209,14.0398226 4.59284263,12.7536232 6.3530098,12.7536232 L17.6316246,12.7536232 C19.3874139,12.7536232 21.1256928,14.0404157 21.6011089,15.6939891 L22.9903494,20.5259906 C23.0204168,20.63057 23.0450458,20.7352884 23.0641579,20.8398867 L24,24 Z M21.1127477,21.3339312 L21.0851024,21.2122487 C21.0772161,21.1630075 21.0658093,21.1120821 21.0507301,21.0596341 L19.6614896,16.2276325 C19.4305871,15.4245164 18.4851476,14.7246377 17.6316246,14.7246377 L6.3530098,14.7246377 C5.4959645,14.7246377 4.55444948,15.4231177 4.32314478,16.2276325 L2.75521062,21.6811594 L2.65068631,22.0289855 L21.3185825,22.0289855 L21.1127477,21.3339312 Z"
                                            })
                                        }),
                                        "SignIn",
                                        isOnline ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("li", {
                                onClick: ()=>{
                                    setIsLogin(true);
                                    (0, $6eUyJ.handleScrollTop)();
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("User logged out");
                                },
                                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                                    to: "/",
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 0 12 24",
                                            height: "19",
                                            width: "18",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("path", {
                                                d: "M11.9923172,11.2463768 C8.81761115,11.2463768 6.24400341,8.72878961 6.24400341,5.62318841 C6.24400341,2.5175872 8.81761115,0 11.9923172,0 C15.1670232,0 17.740631,2.5175872 17.740631,5.62318841 C17.740631,8.72878961 15.1670232,11.2463768 11.9923172,11.2463768 Z M11.9923172,9.27536232 C14.0542397,9.27536232 15.7257581,7.64022836 15.7257581,5.62318841 C15.7257581,3.60614845 14.0542397,1.97101449 11.9923172,1.97101449 C9.93039471,1.97101449 8.25887628,3.60614845 8.25887628,5.62318841 C8.25887628,7.64022836 9.93039471,9.27536232 11.9923172,9.27536232 Z M24,24 L0,24 L1.21786143,19.7101449 L2.38352552,15.6939891 C2.85911209,14.0398226 4.59284263,12.7536232 6.3530098,12.7536232 L17.6316246,12.7536232 C19.3874139,12.7536232 21.1256928,14.0404157 21.6011089,15.6939891 L22.9903494,20.5259906 C23.0204168,20.63057 23.0450458,20.7352884 23.0641579,20.8398867 L24,24 Z M21.1127477,21.3339312 L21.0851024,21.2122487 C21.0772161,21.1630075 21.0658093,21.1120821 21.0507301,21.0596341 L19.6614896,16.2276325 C19.4305871,15.4245164 18.4851476,14.7246377 17.6316246,14.7246377 L6.3530098,14.7246377 C5.4959645,14.7246377 4.55444948,15.4231177 4.32314478,16.2276325 L2.75521062,21.6811594 L2.65068631,22.0289855 L21.3185825,22.0289855 L21.1127477,21.3339312 Z"
                                            })
                                        }),
                                        "Logout",
                                        isOnline ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "header-margin"
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                className: "scroll-top",
                onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                    className: "fa-solid fa-arrow-up"
                })
            })
        ]
    });
};
var $bc5dea09761a5f80$export$2e2bcd8739ae039 = $bc5dea09761a5f80$var$Header;



var $iq6Qi = parcelRequire("iq6Qi");

var $iBNpp = parcelRequire("iBNpp");

var $50vd1 = parcelRequire("50vd1");

var $h7f4L = parcelRequire("h7f4L");

var $iGccQ = parcelRequire("iGccQ");

var $50vd1 = parcelRequire("50vd1");

var $c4Bdm = parcelRequire("c4Bdm");

var $8H118 = parcelRequire("8H118");

const $b0f5a0d002fb090b$var$useAllRestaurants = ()=>{
    const [allRestaurants, setAllRestaurants] = (0, $50vd1.useState)([]);
    const [filteredRestaurants, setFilteredRestaurants] = (0, $50vd1.useState)(null);
    console.log("Render()");
    const { location: location } = (0, $50vd1.useContext)((0, $8H118.default));
    const { setCity: setCity } = (0, $50vd1.useContext)((0, $b593617b461c7dad$export$2e2bcd8739ae039));
    (0, $50vd1.useEffect)(()=>{
        console.log("useEffect()");
        // API call
        getRestaurants();
    }, [
        location
    ]);
    const getRestaurants = async function() {
        try {
            const data = await fetch((0, $c4Bdm.FETCH_REST_URL) + "lat=" + location.latitude + "%26lng=" + location.longitude);
            const json = await data.json();
            const topBrand = json?.data?.cards?.find((res)=>res?.card?.card?.id?.includes("top_brands_for_you"));
            const allRests = json?.data?.cards?.find((res)=>res?.card?.card?.id?.includes("restaurant_grid_listing"));
            const allRestsTitle = json?.data?.cards?.find((res)=>res?.card?.card?.id?.includes("popular_restaurants_title"));
            const infoLink = json?.data?.cards?.find((res)=>res?.card?.card?.id?.includes("whats_on_your_mind"));
            const unService = json?.data?.cards?.find((res)=>res?.card?.card?.id?.includes("swiggy_not_present"));
            const set1 = new Set(topBrand?.card?.card?.gridElements?.infoWithStyle?.restaurants.map((item)=>item.info.id));
            const set2 = new Set(allRests?.card?.card?.gridElements?.infoWithStyle?.restaurants.map((item)=>item.info.id));
            const combinedSet = new Set([
                ...set1,
                ...set2
            ]);
            const allTotalRests = Array.from(combinedSet, (id)=>{
                const objInArray1 = topBrand?.card?.card?.gridElements?.infoWithStyle?.restaurants.find((item)=>item.info.id === id);
                const objInArray2 = allRests?.card?.card?.gridElements?.infoWithStyle?.restaurants.find((item)=>item.info.id === id);
                return objInArray1 || objInArray2;
            });
            const additionalRests = topBrand?.card?.card?.gridElements?.infoWithStyle?.restaurants.filter((item)=>!set2.has(item.info.id));
            setCity(json?.data?.cards[json?.data?.cards.length - 1]?.card?.card?.citySlug?.toUpperCase() || "");
            setAllRestaurants([
                infoLink?.card?.card?.header,
                infoLink?.card?.card?.gridElements?.infoWithStyle?.info,
                topBrand?.card?.card?.header,
                topBrand?.card?.card?.gridElements?.infoWithStyle?.restaurants,
                allRestsTitle?.card?.card,
                allTotalRests,
                unService?.card?.card,
                additionalRests || []
            ]);
            setFilteredRestaurants(allRests?.card?.card?.gridElements?.infoWithStyle?.restaurants //9 items
            );
        } catch (err) {
            console.log(err);
            setAllRestaurants(null);
        }
    };
    return [
        allRestaurants,
        filteredRestaurants,
        setFilteredRestaurants
    ];
};
var $b0f5a0d002fb090b$export$2e2bcd8739ae039 = $b0f5a0d002fb090b$var$useAllRestaurants;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $6eUyJ = parcelRequire("6eUyJ");
const $5702eac947f4449b$var$Search = ({ allRestaurants: allRestaurants, setFilteredRestaurants: setFilteredRestaurants, setShowExtraData: setShowExtraData })=>{
    const [searchText, setSearchText] = (0, $50vd1.useState)("");
    return /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
        id: "search-container",
        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("input", {
            type: "text",
            placeholder: "Search Restaurant",
            value: searchText,
            onChange: (e)=>{
                setSearchText(e.target.value);
                const data = (0, $6eUyJ.findRestaurants)(e.target.value, allRestaurants);
                setFilteredRestaurants(data);
                setShowExtraData(false);
            }
        })
    });
};
var $5702eac947f4449b$export$2e2bcd8739ae039 = $5702eac947f4449b$var$Search;




var $iq6Qi = parcelRequire("iq6Qi");

var $c4Bdm = parcelRequire("c4Bdm");
const $562589da38d1dc34$var$RestaurantCollections = (restaurantinfo)=>{
    const { imageId: imageId } = restaurantinfo;
    return /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
        className: "info-img-box",
        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
            className: "info-img",
            src: (0, $c4Bdm.IMG_INFO_URL) + imageId
        })
    });
};
var $562589da38d1dc34$export$2e2bcd8739ae039 = $562589da38d1dc34$var$RestaurantCollections;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $6eUyJ = parcelRequire("6eUyJ");
const $0d72e4f0ee2fea40$var$Filter = ({ Restaurant: Restaurant, setRestaurant: setRestaurant, setShowExtraData: setShowExtraData })=>{
    const [filter, setFilter] = (0, $50vd1.useState)("jack");
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iq6Qi.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurantsFast)(Restaurant, setRestaurant, "Fast", filter, setFilter);
                    setShowExtraData(false);
                },
                id: filter == "Fast" ? "filterSelected" : "",
                children: [
                    "Fast Delivery",
                    filter == "Fast" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurantsRating)(Restaurant, setRestaurant, "Rating", filter, setFilter, setShowExtraData);
                    setShowExtraData(false);
                },
                id: filter == "Rating" ? "filterSelected" : "",
                children: [
                    "Ratings 4.0+",
                    filter == "Rating" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurantsOffer)(Restaurant, setRestaurant, "Offer", filter, setFilter, setShowExtraData);
                    setShowExtraData(false);
                },
                id: filter == "Offer" ? "filterSelected" : "",
                children: [
                    "Offers",
                    filter == "Offer" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurantsVeg)(Restaurant, setRestaurant, "Veg", filter, setFilter, setShowExtraData);
                    setShowExtraData(false);
                },
                id: filter == "Veg" ? "filterSelected" : "",
                children: [
                    "Pure Veg",
                    filter == "Veg" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurantsLess300)(Restaurant, setRestaurant, "less300", filter, setFilter, setShowExtraData);
                    setShowExtraData(false);
                },
                id: filter == "less300" ? "filterSelected" : "",
                children: [
                    "Less then Rs.300",
                    filter == "less300" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                onClick: ()=>{
                    (0, $6eUyJ.findRestaurants300to600)(Restaurant, setRestaurant, "300to600", filter, setFilter, setShowExtraData);
                    setShowExtraData(false);
                },
                id: filter == "300to600" ? "filterSelected" : "",
                children: [
                    "Rs.300-Rs.600",
                    filter == "300to600" && /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-xmark"
                    })
                ]
            })
        ]
    });
};
var $0d72e4f0ee2fea40$export$2e2bcd8739ae039 = $0d72e4f0ee2fea40$var$Filter;



var $c4Bdm = parcelRequire("c4Bdm");

var $6eUyJ = parcelRequire("6eUyJ");
window.addEventListener("DOMContentLoaded", function() {
    window.scrollTo(0, 0);
});
const $594d770c49ddd620$var$Body = ()=>{
    const [allRestaurants, filteredRestaurants, setFilteredRestaurants] = (0, $b0f5a0d002fb090b$export$2e2bcd8739ae039)();
    const [againApiCall, setAgainApiCall] = (0, $50vd1.useState)(false);
    const [extraRestsData, setExtraRestsData] = (0, $50vd1.useState)(null);
    const [showExtraData, setShowExtraData] = (0, $50vd1.useState)(true);
    (0, $50vd1.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollPosition = window.scrollY;
            const viewportHeight = window.innerHeight;
            const documentHeight = document.body.scrollHeight;
            const distanceFromBottom = documentHeight - (scrollPosition + viewportHeight);
            if (!againApiCall && allRestaurants != null) {
                if (distanceFromBottom <= 400) {
                    setExtraRestsData([]);
                    setAgainApiCall(true);
                    setTimeout(()=>{
                        setExtraRestsData(allRestaurants[7]);
                    }, 2000);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        againApiCall,
        allRestaurants
    ]);
    const isOnline = (0, $372b4e36b3f1ec1d$export$2e2bcd8739ae039)();
    if (!isOnline) return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "offline-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                alt: "url img",
                src: (0, $c4Bdm.IMG_OFFLINE_URL)
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h2", {
                children: "Oops! You're Offline"
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: "Please check your internet connection and try again."
            })
        ]
    });
    if (!allRestaurants) return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "body-box res-not-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                src: (0, $c4Bdm.IMG_RESTAURANT_NOT_URL)
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                className: "",
                children: "Data Not Found."
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: "Something went wrong."
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                href: "/",
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                    children: "TRY AGAIN"
                })
            })
        ]
    });
    if (allRestaurants[6]) return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "body-box unservice-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                src: allRestaurants[6]?.imageLink
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                className: "",
                children: allRestaurants[6]?.title
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: "We don\u2019t have any services here till now."
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: "Try changing location."
            })
        ]
    });
    const scrollHandler = (idx, direction)=>{
        const box = document.querySelectorAll(".topBrand")[idx];
        if (direction == "left") box.scrollLeft += -(box.clientWidth - box.clientWidth * 0.15);
        else box.scrollLeft += box.clientWidth - box.clientWidth * 0.15;
    };
    return allRestaurants?.length == 0 ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $h7f4L.default), {}) : /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iq6Qi.Fragment), {
        children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
            className: "body-box-res body-box",
            children: [
                allRestaurants[0] != undefined ? /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    className: "main-header-box",
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("h2", {
                            className: "main-card-title",
                            children: [
                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                    children: allRestaurants[0]?.title
                                }),
                                /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                    className: "scr-btn",
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            onClick: (e)=>{
                                                scrollHandler(0, "left");
                                            },
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                                className: "fa-solid fa-arrow-left"
                                            })
                                        }),
                                        "\xa0\xa0",
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            onClick: (e)=>{
                                                scrollHandler(0, "right");
                                            },
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                                className: "fa-solid fa-arrow-right"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                            className: "topBrand",
                            children: [
                                allRestaurants[1].map((info)=>{
                                    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                                        to: "/collections/" + info?.action?.link?.split("=")[1]?.split("&")[0],
                                        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $562589da38d1dc34$export$2e2bcd8739ae039), {
                                            ...info
                                        })
                                    }, "collections" + info?.id);
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("hr", {
                            className: "topBrandHr"
                        })
                    ]
                }) : null,
                allRestaurants[2] != undefined ? /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    className: "main-header-box",
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("h2", {
                            className: "main-card-title",
                            children: [
                                /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                    children: allRestaurants[2]?.title
                                }),
                                /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            onClick: (e)=>{
                                                scrollHandler(1, "left");
                                            },
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                                className: "fa-solid fa-arrow-left"
                                            })
                                        }),
                                        "\xa0\xa0",
                                        /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                            onClick: (e)=>{
                                                scrollHandler(1, "right");
                                            },
                                            children: /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                                className: "fa-solid fa-arrow-right"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                            className: "topBrand",
                            children: allRestaurants[3].map((restaurant)=>{
                                return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                                    to: "/restaurant/" + restaurant.info.id,
                                    onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                    children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iBNpp.default), {
                                        ...restaurant.info
                                    })
                                }, "allres" + restaurant.info.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("hr", {
                            className: "topBrandHr"
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    className: "main-header-box",
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("h2", {
                            className: "main-card-title",
                            children: allRestaurants[4]?.title
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                            className: "main-header-filter",
                            children: [
                                /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $5702eac947f4449b$export$2e2bcd8739ae039), {
                                    allRestaurants: allRestaurants[5],
                                    setFilteredRestaurants: setFilteredRestaurants,
                                    setShowExtraData: setShowExtraData
                                }),
                                /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $0d72e4f0ee2fea40$export$2e2bcd8739ae039), {
                                    Restaurant: allRestaurants[5],
                                    setRestaurant: setFilteredRestaurants,
                                    setShowExtraData: setShowExtraData
                                })
                            ]
                        }),
                        filteredRestaurants?.length != 0 ? /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                            className: "main-card",
                            children: [
                                filteredRestaurants?.map((restaurant)=>{
                                    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                                        to: "/restaurant/" + restaurant?.info?.id,
                                        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iBNpp.default), {
                                            ...restaurant.info
                                        })
                                    }, "filter" + restaurant?.info?.id);
                                }),
                                showExtraData && (!extraRestsData ? null : extraRestsData.length == 0 ? Array(allRestaurants[7]?.length).fill("").map((elem, idx)=>{
                                    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                        className: "shimmer card",
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "img-box img-shimmer"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "box-shimmer big-shimmer"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "box-shimmer"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "box-shimmer"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                                className: "box-shimmer"
                                            })
                                        ]
                                    }, "shimmer-menu" + idx);
                                }) : extraRestsData?.map((restaurant)=>{
                                    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                                        to: "/restaurant/" + restaurant?.info?.id,
                                        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iBNpp.default), {
                                            ...restaurant.info
                                        })
                                    }, "filters" + restaurant?.info?.id);
                                }))
                            ]
                        }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                            className: "body-box search-empty",
                            children: [
                                /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                    children: "No Restaurant Found !!"
                                }),
                                /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                                    src: (0, $c4Bdm.IMG_NOT_FOUND_URL)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $594d770c49ddd620$export$2e2bcd8739ae039 = $594d770c49ddd620$var$Body;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $50vd1 = parcelRequire("50vd1");
const $2c531c3f3a631595$var$UserContext = /*#__PURE__*/ (0, $50vd1.createContext)({
    user: {
        name: "vicky",
        email: "vickyraj15@gmail.com"
    }
});
var $2c531c3f3a631595$export$2e2bcd8739ae039 = $2c531c3f3a631595$var$UserContext;
$2c531c3f3a631595$var$UserContext.displayName = "UserContext";


const $91ac86dcea840ad1$var$Footer = ()=>{
    // useContext --------------------------------
    const { user: user } = (0, $50vd1.useContext)((0, $2c531c3f3a631595$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        className: "footer-s",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                                        children: "Food Home"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        children: "\xa9 2024 Raj"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        children: "Pvt. Ltd"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                className: "social",
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {}),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                                                    href: "https://www.linkedin.com/in/vickyraj15/",
                                                    target: "_blank",
                                                    children: "LinkedIn"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {}),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                                                    href: "https://github.com/vickyraj15",
                                                    target: "_blank",
                                                    children: "GitHub"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {}),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                                                    href: "https://www.instagram.com/vickyraj9700/?hl=en/",
                                                    target: "_blank",
                                                    children: "Instagram"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        className: "footer-s2",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "Terms & Conditions"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "Help"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: "Careers"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                        children: [
                            "Created By \u2764\uFE0F ",
                            user.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                        children: [
                            "Email - ",
                            user.email
                        ]
                    })
                ]
            })
        ]
    });
};
var $91ac86dcea840ad1$export$2e2bcd8739ae039 = $91ac86dcea840ad1$var$Footer;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $iGccQ = parcelRequire("iGccQ");
var $4CHxl = parcelRequire("4CHxl");

var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");
class $13cc77c358b4a265$var$Profile extends (0, $50vd1.Component) {
    constructor(props){
        super(props);
        console.log("Class Cunstructor");
        this.state = {
            count: 0,
            count2: 10,
            userInfo: {
                name: "Akash Deep",
                login: "akashdeep023",
                bio: "WEB - DEVELOPER ( MERN STACK ) | |  JAVA | PYTHON | DSA  |",
                location: "PATNA, BIHAR",
                html_url: "https://github.com/akashdeep023",
                avatar_url: "https://avatars.githubusercontent.com/u/126412088?v=4",
                followers: 28,
                following: 5
            }
        };
    }
    async componentDidMount() {
        console.log("Class ComponentDidMount");
        const data = await fetch("https://api.github.com/users/akashdeep023");
        const json = await data.json();
        console.log(json);
        if (json.name) this.setState({
            userInfo: json
        });
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("Class ComponentDidUpdate");
        this.state.count, prevProps.count;
        this.state.count2, prevProps.count2;
    }
    componentWillUnmount() {
        console.log("Class ComponentWillUnmount");
    // clearInterval(this.timer);
    }
    render() {
        console.log("Class Render");
        return this.state.userInfo == null ? /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
            children: "Wait for data"
        }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                    children: "Profile Class Page"
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                    href: this.state.userInfo.html_url,
                    target: "_blank",
                    children: "Github Link"
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("h2", {
                    children: [
                        this.state.userInfo.name,
                        " (",
                        this.state.userInfo.login,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                    children: this.state.userInfo.bio
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                    children: this.state.userInfo.location
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("h3", {
                    children: [
                        "followers: ",
                        this.state.userInfo.followers || "--",
                        " || following: ",
                        this.state.userInfo.following || "--"
                    ]
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                    src: this.state.userInfo.avatar_url
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("br", {}),
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                    onClick: ()=>{
                        this.setState({
                            count: this.state.count + 1
                        });
                    },
                    children: [
                        "Count: ",
                        this.state.count
                    ]
                })
            ]
        });
    }
}
var $13cc77c358b4a265$export$2e2bcd8739ae039 = $13cc77c358b4a265$var$Profile;



var $b93fc11a707a1937$exports = {};
$b93fc11a707a1937$exports = new URL("Burger_Img.d05b1710.png", import.meta.url).toString();


class $cfd9e6ee70251d32$var$About extends (0, (/*@__PURE__*/$parcel$interopDefault($50vd1))).Component {
    constructor(props){
        super(props);
        console.log("About Constructor");
        this.state = {
            showProfile: false
        };
    }
    componentDidMount() {
        console.log("About ComponentDidMount");
    }
    componentDidUpdate(prevProps, prevState) {
        console.log("About ComponentDidUpdate");
    }
    componentWillUnmount() {
        console.log("About ComponentWillUnmount");
    }
    render() {
        console.log("About Render");
        return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
            className: "body-box about-page",
            children: [
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                            children: "About Page"
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $2c531c3f3a631595$export$2e2bcd8739ae039).Consumer, {
                            children: ({ user: user })=>/*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                                    children: [
                                        user.name,
                                        " - ",
                                        user.email
                                    ]
                                })
                        }),
                        this.state.showProfile ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                            to: "/about",
                            onClick: ()=>{
                                this.setState({
                                    showProfile: false
                                });
                            },
                            children: "Hide Profile"
                        }) : /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                            to: "profile",
                            onClick: ()=>{
                                this.setState({
                                    showProfile: true
                                });
                            },
                            children: "Show Profile"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                    children: this.state.showProfile ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $4CHxl.Outlet), {}) : /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                        className: "burger-img",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b93fc11a707a1937$exports)))
                    })
                })
            ]
        });
    }
}
var $cfd9e6ee70251d32$export$2e2bcd8739ae039 = $cfd9e6ee70251d32$var$About;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $iq6Qi = parcelRequire("iq6Qi");
parcelRequire("50vd1");
const $bfbb5dd317f46e12$var$Section = ({ title: title, description: description, isVisibal: isVisibal, setIsVisible: setIsVisible })=>{
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "section-box",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h2", {
                        className: "section-title",
                        children: title
                    }),
                    isVisibal ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iq6Qi.Fragment), {
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                            className: "section-btn",
                            onClick: ()=>setIsVisible(false),
                            children: "Hide"
                        })
                    }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                        className: "section-btn",
                        onClick: ()=>setIsVisible(true),
                        children: "Show"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                className: `section-des ${isVisibal ? "visible" : "hidden"}`,
                children: isVisibal && /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                            children: [
                                "\uD83D\uDC4BHello ",
                                description.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                            children: description.description
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                            children: [
                                description.icon,
                                /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                                    href: description.link,
                                    target: "_blank",
                                    children: description.social
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("br", {}),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                            children: description.subDescription
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                            children: description.msg
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                            children: "[vicky raj]"
                        })
                    ]
                })
            })
        ]
    });
};
var $bfbb5dd317f46e12$export$2e2bcd8739ae039 = $bfbb5dd317f46e12$var$Section;



var $c4Bdm = parcelRequire("c4Bdm");
const $154a73db6b247698$var$Contact = ()=>{
    // Lifting the state up ----------------------------------------------------------------
    const [isVisibal, setIsVisible] = (0, $50vd1.useState)("github");
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "body-box",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                className: "contact-info",
                children: "Contact"
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bfbb5dd317f46e12$export$2e2bcd8739ae039), {
                isVisibal: isVisibal == "github",
                setIsVisible: ()=>setIsVisible("github" == isVisibal ? "vicky" : "github"),
                title: "Github",
                description: (0, $c4Bdm.CONTACT_MSG).github
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bfbb5dd317f46e12$export$2e2bcd8739ae039), {
                isVisibal: isVisibal == "linkedin",
                setIsVisible: ()=>setIsVisible("linkedin" == isVisibal ? "vicky" : "linkedin"),
                title: "LinkedIn",
                description: (0, $c4Bdm.CONTACT_MSG).linkedIn
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bfbb5dd317f46e12$export$2e2bcd8739ae039), {
                isVisibal: isVisibal == "instagram",
                setIsVisible: ()=>setIsVisible("instagram" == isVisibal ? "vicky" : "instagram"),
                title: "Instagram",
                description: (0, $c4Bdm.CONTACT_MSG).instagram
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bfbb5dd317f46e12$export$2e2bcd8739ae039), {
                isVisibal: isVisibal == "facebook",
                setIsVisible: ()=>setIsVisible("facebook" == isVisibal ? "vicky" : "facebook"),
                title: "Facebook",
                description: (0, $c4Bdm.CONTACT_MSG).facebook
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bfbb5dd317f46e12$export$2e2bcd8739ae039), {
                isVisibal: isVisibal == "email",
                setIsVisible: ()=>setIsVisible("email" == isVisibal ? "vicky" : "email"),
                title: "Email Support",
                description: (0, $c4Bdm.CONTACT_MSG).email
            })
        ]
    });
};
var $154a73db6b247698$export$2e2bcd8739ae039 = $154a73db6b247698$var$Contact;



var $iq6Qi = parcelRequire("iq6Qi");

var $iGccQ = parcelRequire("iGccQ");
var $4CHxl = parcelRequire("4CHxl");

var $h7f4L = parcelRequire("h7f4L");

var $c4Bdm = parcelRequire("c4Bdm");

var $50vd1 = parcelRequire("50vd1");

var $c4Bdm = parcelRequire("c4Bdm");

var $8H118 = parcelRequire("8H118");
const $ef1f5510b32aa689$var$useRestaurant = (resId)=>{
    const [restaurant, setRestaurant] = (0, $50vd1.useState)([]);
    const { location: location } = (0, $50vd1.useContext)((0, $8H118.default));
    (0, $50vd1.useEffect)(()=>{
        getRestaurantMenu();
    }, []);
    const getRestaurantMenu = async ()=>{
        try {
            const data = await fetch((0, $c4Bdm.FETCH_MENU_URL) + resId + "%26lat=" + location.latitude + "%26lng=" + location.longitude);
            const json = await data.json();
            const restInfo = json?.data?.cards?.find((res)=>res?.card?.card["@type"]?.includes("food.v2.Restaurant"));
            const restOffer = json?.data?.cards?.find((res)=>res?.card?.card?.gridElements?.infoWithStyle["@type"]?.includes("food.v2.OfferInfoWithStyle"));
            const restMenus = json?.data?.cards?.find((res)=>res?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((menu)=>menu?.card?.card["@type"]?.includes("food.v2.ItemCategory")));
            setRestaurant({
                restInfo: restInfo,
                restOffer: restOffer,
                restMenus: restMenus
            });
        } catch (err) {
            console.log(err);
            setRestaurant(null);
        }
    };
    return restaurant;
};
var $ef1f5510b32aa689$export$2e2bcd8739ae039 = $ef1f5510b32aa689$var$useRestaurant;



var $iq6Qi = parcelRequire("iq6Qi");
parcelRequire("50vd1");

var $c4Bdm = parcelRequire("c4Bdm");
const $adf53db789c11cd9$var$RestaurantMenuProfile = (menuProfile)=>{
    const { name: name, cuisines: cuisines, areaName: areaName, sla: sla, avgRatingString: avgRatingString, totalRatingsString: totalRatingsString, costForTwoMessage: costForTwoMessage, cloudinaryImageId: cloudinaryImageId } = menuProfile;
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        id: "res-menu-box",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                id: "res-menu-name",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                                children: name
                            }),
                            " ",
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                children: cuisines?.join(", ")
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("p", {
                                children: [
                                    areaName,
                                    ", ",
                                    sla?.lastMileTravelString
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                                className: "rating",
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                        className: "fa-solid fa-star"
                                    }),
                                    avgRatingString || "-- --"
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                className: "rating-tot",
                                children: totalRatingsString || "0+ ratings"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "res-menu-price",
                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                            className: "fa-regular fa-handshake"
                        }),
                        " ",
                        sla?.slaString,
                        " ",
                        "\xa0\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                            className: "fa-solid fa-indian-rupee-sign"
                        }),
                        " ",
                        costForTwoMessage
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                id: "res-menu-img",
                src: (0, $c4Bdm.IMG_URL) + cloudinaryImageId
            })
        ]
    });
};
var $adf53db789c11cd9$export$2e2bcd8739ae039 = $adf53db789c11cd9$var$RestaurantMenuProfile;



var $iq6Qi = parcelRequire("iq6Qi");

var $c4Bdm = parcelRequire("c4Bdm");
const $ef009947ea36778e$var$RestaurantMenuOffer = (offers)=>{
    const { offerTag: offerTag, offerLogo: offerLogo, header: header, couponCode: couponCode, description: description } = offers;
    const idx = offers.idx;
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        id: "res-menu-offbox",
        children: [
            offerTag ? /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iq6Qi.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "res-menu-flat",
                        children: offerTag
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "res-menu-flath"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                                src: (0, $c4Bdm.OFFER_LOGO_URL) + offerLogo
                            }),
                            header
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        children: /*#__PURE__*/ (0, $iq6Qi.jsxs)("h5", {
                            children: [
                                couponCode,
                                " |\xa0",
                                description
                            ]
                        })
                    })
                ]
            })
        ]
    }, "offer" + idx);
};
var $ef009947ea36778e$export$2e2bcd8739ae039 = $ef009947ea36778e$var$RestaurantMenuOffer;



var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $c4Bdm = parcelRequire("c4Bdm");

var $kBOxH = parcelRequire("kBOxH");

var $iKDOx = parcelRequire("iKDOx");

var $gNObz = parcelRequire("gNObz");
function $6cc09d586f292802$var$RestaurantMenuInfo(card) {
    const { title: title, itemCards: itemCards, resCart: resCart } = card;
    const [showMenu, setShowMenu] = (0, $50vd1.useState)(true);
    const [showPopUp, setShowPopUp] = (0, $50vd1.useState)(false);
    const [popItem, setPopItem] = (0, $50vd1.useState)(null);
    // Redux Store --------------------------------
    const itemsCart = (0, $kBOxH.useSelector)((store)=>store.cart);
    const dispatch = (0, $kBOxH.useDispatch)();
    const addFoodItem = (item)=>{
        if (itemsCart?.restaurant?.id == undefined || itemsCart?.restaurant?.id == resCart?.id) {
            dispatch((0, $iKDOx.addToCart)({
                item: [
                    item,
                    1
                ],
                resCart: resCart
            }));
            (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Item added successfully");
        } else {
            setShowPopUp(true);
            setPopItem(item);
        }
    };
    const PopUp = ()=>{
        return /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iq6Qi.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                    children: "Items already in cart"
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                    children: "Your cart contains items from other restaurant. Would you like to reset your cart for adding items from this restaurant?"
                }),
                /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                            onClick: ()=>{
                                setShowPopUp(false);
                            },
                            children: "NO"
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                            onClick: ()=>{
                                dispatch((0, $iKDOx.addToCart)({
                                    item: [
                                        popItem,
                                        1
                                    ],
                                    resCart: resCart
                                }));
                                (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Item added successfully");
                                setShowPopUp(false);
                            },
                            children: "YES, START AFRESH"
                        })
                    ]
                })
            ]
        });
    };
    const increaseFoodItem = (i)=>{
        dispatch((0, $iKDOx.increaseCount)(i));
    };
    const removeFoodItem = (i)=>{
        dispatch((0, $iKDOx.decreaseCount)(i));
    };
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        id: "res-menu-cardb",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "res-menu-h",
                onClick: ()=>{
                    setShowMenu(showMenu ? false : true);
                },
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {
                        children: title + " (" + itemCards?.length + ")"
                    }),
                    showMenu ? /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-angle-up"
                    }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                        className: "fa-solid fa-angle-down"
                    })
                ]
            }),
            showMenu ? /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                children: itemCards?.map((cardb, index)=>{
                    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        id: "res-menu-cardele",
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                children: [
                                    cardb?.card?.info?.itemAttribute?.vegClassifier == "VEG" ? /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                        className: "fa-regular fa-circle-stop",
                                        id: "item-veg"
                                    }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("i", {
                                        className: "fa-regular fa-square-caret-up",
                                        id: "item-nonveg"
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h5", {
                                        children: cardb?.card?.info?.name
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        children: "\u20B9" + (cardb?.card?.info?.price ?? cardb?.card?.info?.defaultPrice) / 100
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        className: "card-head",
                                        children: cardb?.card?.info?.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                className: "menu-img-box",
                                children: [
                                    cardb?.card?.info?.imageId ? /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                                        className: "menu-img",
                                        src: (0, $c4Bdm.IMG_SMALL_URL) + cardb?.card?.info?.imageId
                                    }) : /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                                        className: "menu-img"
                                    }),
                                    itemsCart?.items?.filter((item)=>item[0]?.id == cardb?.card?.info?.id).length == 0 ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iq6Qi.Fragment), {
                                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                                            className: "cart-remove-btn item-add",
                                            id: "item-add",
                                            onClick: ()=>{
                                                addFoodItem(cardb?.card?.info);
                                            },
                                            children: "Add"
                                        })
                                    }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("span", {
                                        className: "cart-remove-btn",
                                        id: "item-add",
                                        children: [
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                                                onClick: ()=>{
                                                    removeFoodItem(cardb?.card?.info?.id);
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Item removed successfully");
                                                },
                                                children: "\u2212"
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("span", {
                                                children: itemsCart?.items?.find((item)=>item[0]?.id == cardb?.card?.info?.id)[1]
                                            }),
                                            /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                                                onClick: ()=>{
                                                    increaseFoodItem(cardb?.card?.info?.id);
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($gNObz))).success("Item added successfully");
                                                },
                                                children: "+"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "card" + index);
                })
            }) : null,
            showPopUp && /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                className: "popup-page",
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)(PopUp, {})
            })
        ]
    });
}
var $6cc09d586f292802$export$2e2bcd8739ae039 = $6cc09d586f292802$var$RestaurantMenuInfo;



var $kBOxH = parcelRequire("kBOxH");

var $6eUyJ = parcelRequire("6eUyJ");
const $dad90dc9629b40af$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $4CHxl.useParams)();
    const restaurant = (0, $ef1f5510b32aa689$export$2e2bcd8739ae039)(resId);
    const resCart = {
        name: restaurant?.restInfo?.card?.card?.info?.name,
        id: restaurant?.restInfo?.card?.card?.info?.id,
        areaName: restaurant?.restInfo?.card?.card?.info?.areaName,
        imgUrl: (0, $c4Bdm.IMG_URL) + restaurant?.restInfo?.card?.card?.info?.cloudinaryImageId,
        distance: restaurant?.restInfo?.card?.card?.info?.sla
    };
    const resAddedToCart = (0, $kBOxH.useSelector)((store)=>store?.cart);
    if (restaurant?.length == 0) return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $h7f4L.ShimmerMenu), {});
    return !restaurant || !resCart.name ? /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "body-box res-not-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                src: (0, $c4Bdm.IMG_RESTAURANT_NOT_URL)
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                className: "",
                children: "Restaurant Not Found."
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                children: "Something went wrong."
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                to: "/",
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                    children: "GO BACK"
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        id: "res-menu",
        className: "body-box",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $adf53db789c11cd9$export$2e2bcd8739ae039), {
                ...restaurant?.restInfo?.card?.card?.info
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "res-menu-off",
                children: restaurant?.restOffer?.card?.card?.gridElements?.infoWithStyle?.offers.map((offers, idx)=>{
                    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $ef009947ea36778e$export$2e2bcd8739ae039), {
                        ...offers?.info
                    }, "offers" + idx);
                })
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                id: "res-menu-cardbox",
                children: restaurant?.restMenus?.groupedCard?.cardGroupMap?.REGULAR?.cards?.map((cardbox, idx)=>{
                    return cardbox?.card?.card?.itemCards ? /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $6cc09d586f292802$export$2e2bcd8739ae039), {
                        ...cardbox?.card?.card,
                        resCart: resCart
                    }, "cardbox" + idx) : null;
                })
            }),
            resAddedToCart?.restaurant && /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "view-cart",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                        children: [
                            resAddedToCart?.items?.length,
                            " item added"
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                        to: "/cart",
                        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                            children: "VIEW CART"
                        })
                    })
                ]
            })
        ]
    });
};
var $dad90dc9629b40af$export$2e2bcd8739ae039 = $dad90dc9629b40af$var$RestaurantMenu;



var $iq6Qi = parcelRequire("iq6Qi");

var $iGccQ = parcelRequire("iGccQ");
var $4CHxl = parcelRequire("4CHxl");

var $c4Bdm = parcelRequire("c4Bdm");
const $fcce949e37a518ae$var$Error = ()=>{
    const { status: status, statusText: statusText } = (0, $4CHxl.useRouteError)();
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "error-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                        children: "Oops!!"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h2", {
                        children: "Something went wrong."
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("h3", {
                        children: status + " " + statusText
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.Link), {
                        to: "/",
                        children: "Back Home"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                    className: "error-img",
                    src: (0, $c4Bdm.IMG_ERROR_URL)
                })
            })
        ]
    });
};
var $fcce949e37a518ae$export$2e2bcd8739ae039 = $fcce949e37a518ae$var$Error;



var $iGccQ = parcelRequire("iGccQ");
var $4CHxl = parcelRequire("4CHxl");

var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");
const $67c724c1cefbf911$var$Profile = ()=>{
    const [count, setCount] = (0, $50vd1.useState)(0);
    const [user, setUser] = (0, $50vd1.useState)({
        name: "vicky raj",
        login: "VickyRaj15",
        bio: "WEB - DEVELOPER ( MERN STACK ) | |  JAVA | PYTHON | DSA  |",
        location: "PATNA, BIHAR",
        html_url: "https://github.com/VickyRaj15",
        avatar_url: "https://avatars.githubusercontent.com/u/126412088?v=4",
        followers: 28,
        following: 5
    });
    (0, $50vd1.useEffect)(()=>{
        console.log("Function useEffect");
        const getUserData = async ()=>{
            try {
                const data = await fetch("https://api.github.com/users/VickyRaj15");
                const json = await data.json();
                console.log(json);
                if (json.name) setUser(json);
            } catch (err) {
                console.log(err);
            }
        };
        getUserData();
    }, []);
    console.log("Function Render");
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "profile-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                children: "Profile Page"
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "profile-home",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("h3", {
                                children: [
                                    user.name,
                                    " (",
                                    user.login,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("h4", {
                                children: [
                                    "FOLLOWERS: ",
                                    user.followers || "--",
                                    " || FOLLOWING:",
                                    " ",
                                    user.following || "--"
                                ]
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {
                                children: user.bio
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("h4", {
                                children: user.location
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("a", {
                                href: user.html_url,
                                target: "_blank",
                                children: "Github Link"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                            src: user.avatar_url
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsxs)("button", {
                className: "countBtn",
                onClick: ()=>setCount(count + 1),
                children: [
                    "Count: ",
                    count
                ]
            })
        ]
    });
};
var $67c724c1cefbf911$export$2e2bcd8739ae039 = $67c724c1cefbf911$var$Profile;



var $iq6Qi = parcelRequire("iq6Qi");

var $jimHT = parcelRequire("jimHT");
const $b50fcb4ba23d9802$var$Login = ()=>/*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("h1", {
                children: "Welcome to Food Home"
            }),
            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $jimHT.Formik), {
                initialValues: {
                    email: "",
                    password: ""
                },
                validate: (values)=>{
                    const errors = {};
                    if (!values.email) errors.email = "Required";
                    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) errors.email = "Invalid email address";
                    return errors;
                },
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    setTimeout(()=>{
                        alert(JSON.stringify(values, null, 2));
                        setSubmitting(false);
                    }, 400);
                },
                children: ({ isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $jimHT.Form), {
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $jimHT.Field), {
                                type: "email",
                                name: "email"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $jimHT.ErrorMessage), {
                                name: "email",
                                component: "div"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $jimHT.Field), {
                                type: "password",
                                name: "password"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $jimHT.ErrorMessage), {
                                name: "password",
                                component: "div"
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("button", {
                                type: "submit",
                                disabled: isSubmitting,
                                children: "Submit"
                            })
                        ]
                    })
            })
        ]
    });
var $b50fcb4ba23d9802$export$2e2bcd8739ae039 = $b50fcb4ba23d9802$var$Login;




var $kBOxH = parcelRequire("kBOxH");

var $5Xyjr = parcelRequire("5Xyjr");

var $iKDOx = parcelRequire("iKDOx");
const $fefd8859657fdadc$var$store = (0, $5Xyjr.configureStore)({
    reducer: {
        cart: (0, $iKDOx.default)
    }
});
var $fefd8859657fdadc$export$2e2bcd8739ae039 = $fefd8859657fdadc$var$store;



var $h7f4L = parcelRequire("h7f4L");

var $iq6Qi = parcelRequire("iq6Qi");

var $50vd1 = parcelRequire("50vd1");

var $iGccQ = parcelRequire("iGccQ");

var $c4Bdm = parcelRequire("c4Bdm");

var $50vd1 = parcelRequire("50vd1");

var $c4Bdm = parcelRequire("c4Bdm");

var $8H118 = parcelRequire("8H118");
const $a124ca011dc4be79$var$useSearch = (query)=>{
    const [searchPreData, setSearchPreData] = (0, $50vd1.useState)([]);
    const [searchData, setSearchData] = (0, $50vd1.useState)(null);
    const { location: location } = (0, $50vd1.useContext)((0, $8H118.default));
    (0, $50vd1.useEffect)(()=>{
        getPreSearch();
    }, []);
    const getPreSearch = async function() {
        const data = await fetch((0, $c4Bdm.FETCH_PRE_SEARCH_URL) + "lat=" + location.latitude + "%26lng=" + location.longitude);
        const json = await data.json();
        setSearchPreData(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.info || []);
    };
    (0, $50vd1.useEffect)(()=>{
        getSearchData(query);
    }, [
        query
    ]);
    const getSearchData = async function(query) {
        if (query?.trim() == "") {
            setSearchData([]);
            return;
        }
        const data = await fetch((0, $c4Bdm.FETCH_SEARCH_URL) + "%26lat=" + location.latitude + "%26lng=" + location.longitude + "%26str=" + query);
        const json = await data.json();
        const selectedData = json?.data?.suggestions?.filter((resData)=>resData?.type == "RESTAURANT");
        setSearchData(selectedData || []);
    };
    return [
        searchData,
        searchPreData
    ];
};
var $a124ca011dc4be79$export$2e2bcd8739ae039 = $a124ca011dc4be79$var$useSearch;



var $6eUyJ = parcelRequire("6eUyJ");
function $9acaed16e08b759d$var$SearchBox() {
    const [search, setSearch] = (0, $50vd1.useState)("");
    const [searchData, searchPreData] = (0, $a124ca011dc4be79$export$2e2bcd8739ae039)(search);
    return /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
        className: "body-box search-page",
        children: [
            /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                className: "search-input",
                children: /*#__PURE__*/ (0, $iq6Qi.jsx)("input", {
                    type: "search",
                    value: search,
                    placeholder: "Search for restaurants",
                    onChange: (e)=>{
                        setSearch(e.target.value);
                    }
                })
            }),
            searchData?.length > 0 ? searchData?.map((item, idx)=>{
                return /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                    className: "search-list",
                    children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $iGccQ.Link), {
                        to: "/restaurant/" + item?.metadata?.split('"primaryRestaurantId":')[1]?.split(",")[0],
                        onClick: ()=>(0, $6eUyJ.handleScrollTop)(),
                        children: [
                            /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                                src: (0, $c4Bdm.IMG_SEARCH_URL) + item?.cloudinaryId
                            }),
                            /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        children: item?.text
                                    }),
                                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                                        children: item?.tagToDisplay
                                    })
                                ]
                            })
                        ]
                    })
                }, "searchItem" + idx);
            }) : search == "" ? /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                className: "search-pre-list",
                children: searchPreData?.map((item, idx)=>{
                    return /*#__PURE__*/ (0, $iq6Qi.jsx)("div", {
                        className: "search-pre-item",
                        children: /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                            src: (0, $c4Bdm.IMG_PRE_SEARCH_URL) + item?.imageId,
                            onClick: ()=>setSearch(item?.entityId?.split("=")[1]?.split("%20")?.join(" "))
                        })
                    }, "searchPreList" + idx);
                })
            }) : /*#__PURE__*/ (0, $iq6Qi.jsxs)("div", {
                className: "body-box search-empty",
                children: [
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("p", {
                        children: "No Restaurant"
                    }),
                    /*#__PURE__*/ (0, $iq6Qi.jsx)("img", {
                        src: (0, $c4Bdm.IMG_NOT_FOUND_SEARCH_URL)
                    })
                ]
            })
        ]
    });
}
var $9acaed16e08b759d$export$2e2bcd8739ae039 = $9acaed16e08b759d$var$SearchBox;



var $gNObz = parcelRequire("gNObz");

var $8H118 = parcelRequire("8H118");


const $6a5e9b706b084844$var$Cart = /*#__PURE__*/ (0, $50vd1.lazy)(()=>(parcelRequire("gXSZq")));

const $6a5e9b706b084844$var$RestaurantCollectionsInfo = /*#__PURE__*/ (0, $50vd1.lazy)(()=>(parcelRequire("jbmTD")));
const $6a5e9b706b084844$var$AppLayout = ()=>{
    const [user, setUser] = (0, $50vd1.useState)({
        name: "vicky raj",
        email: "vickyraj15@gmail.com"
    });
    const [location, setLocation] = (0, $50vd1.useState)({
        latitude: 28.7040592,
        longitude: 77.1024901
    });
    const [city, setCity] = (0, $50vd1.useState)("DELHI");
    return /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $kBOxH.Provider), {
        store: (0, $fefd8859657fdadc$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $2c531c3f3a631595$export$2e2bcd8739ae039).Provider, {
            value: {
                user: user,
                setUser: setUser
            },
            children: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $8H118.default).Provider, {
                value: {
                    location: location,
                    setLocation: setLocation
                },
                children: /*#__PURE__*/ (0, $iq6Qi.jsxs)((0, $b593617b461c7dad$export$2e2bcd8739ae039).Provider, {
                    value: {
                        city: city,
                        setCity: setCity
                    },
                    children: [
                        /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $gNObz.Toaster), {
                            position: "bottot-center",
                            reverseOrder: false,
                            gutter: 30,
                            containerClassName: "toaster-container",
                            toastOptions: {
                                className: "toaster-toast",
                                duration: 1500
                            }
                        }),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $bc5dea09761a5f80$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $4CHxl.Outlet), {}),
                        /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $91ac86dcea840ad1$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        })
    });
};
const $6a5e9b706b084844$var$appRouter = (0, $iGccQ.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $iq6Qi.jsx)($6a5e9b706b084844$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $fcce949e37a518ae$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $594d770c49ddd620$export$2e2bcd8739ae039), {})
            },
            {
                path: "/search",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $9acaed16e08b759d$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $cfd9e6ee70251d32$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        path: "profile",
                        element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $67c724c1cefbf911$export$2e2bcd8739ae039), {})
                    }
                ]
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $154a73db6b247698$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $50vd1.Suspense), {
                    fallback: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $h7f4L.default), {}),
                    children: /*#__PURE__*/ (0, $iq6Qi.jsx)($6a5e9b706b084844$var$Cart, {})
                })
            },
            {
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $dad90dc9629b40af$export$2e2bcd8739ae039), {})
            },
            {
                path: "/collections/:resId",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $50vd1.Suspense), {
                    fallback: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $h7f4L.default), {}),
                    children: /*#__PURE__*/ (0, $iq6Qi.jsx)($6a5e9b706b084844$var$RestaurantCollectionsInfo, {})
                })
            },
            {
                path: "/login",
                element: /*#__PURE__*/ (0, $iq6Qi.jsx)((0, $b50fcb4ba23d9802$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
const $6a5e9b706b084844$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($b20dc0166e51d3b8$exports))).createRoot(document.getElementById("root"));
$6a5e9b706b084844$var$root.render(/*#__PURE__*/ (0, $iq6Qi.jsx)((0, $iGccQ.RouterProvider), {
    router: $6a5e9b706b084844$var$appRouter
}));


//# sourceMappingURL=index.560b4c97.js.map
